/* eslint-disable */
// THE FILE WAS GENERATED BY SCRIPT

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  ClaimedStatusOrIntOrSalesAgentType: { input: any; output: any; }
  DepositVendorOrString: { input: any; output: any; }
  UnsetOrCardType: { input: any; output: any; }
  UnsetOrInt: { input: any; output: any; }
  UnsetOrDateTime: { input: any; output: any; }
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  abusiveClient: Maybe<AbusiveClient>;
  abusiveClients: Maybe<Array<Maybe<AbusiveClient>>>;
  abusiveClientsCount: Maybe<Scalars['Int']['output']>;
  account: Maybe<Account>;
  accounts: Maybe<Array<Maybe<Account>>>;
  accountsCount: Maybe<Scalars['Int']['output']>;
  activityLog: Maybe<ActivityLog>;
  activityLogs: Maybe<Array<Maybe<ActivityLog>>>;
  activityLogsCount: Maybe<Scalars['Int']['output']>;
  addressProposal: Maybe<AddressProposal>;
  agentCommissions: Maybe<AgentCommissions>;
  agentsCommissions: Maybe<AgentsCommissions>;
  alert: Maybe<Alert>;
  alerts: Maybe<Array<Maybe<Alert>>>;
  alertsCount: Maybe<Scalars['Int']['output']>;
  appointment: Maybe<Appointment>;
  appointments: Maybe<Array<Maybe<Appointment>>>;
  appointmentsByDay: Maybe<Array<Maybe<AppointmentsByDay>>>;
  appointmentsCount: Maybe<Scalars['Int']['output']>;
  appropTest: Maybe<AppropTest>;
  appropTests: Maybe<Array<Maybe<AppropTest>>>;
  appropTestsCount: Maybe<Scalars['Int']['output']>;
  article: Maybe<Article>;
  articles: Maybe<Array<Maybe<Article>>>;
  articlesCount: Maybe<Scalars['Int']['output']>;
  assets: Maybe<Array<Maybe<Assets>>>;
  blacklist: Maybe<Blacklist>;
  blacklists: Maybe<Array<Maybe<Blacklist>>>;
  blacklistsCount: Maybe<Scalars['Int']['output']>;
  bonusOffer: Maybe<BonusOffer>;
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookAllocation: Maybe<BookAllocation>;
  bookAllocations: Maybe<Array<Maybe<BookAllocation>>>;
  bookAllocationsCount: Maybe<Scalars['Int']['output']>;
  callLog: Maybe<CallLog>;
  callLogs: Maybe<Array<Maybe<CallLog>>>;
  callLogsCount: Maybe<Scalars['Int']['output']>;
  campaign: Maybe<Campaign>;
  campaigns: Maybe<Array<Maybe<Campaign>>>;
  campaignsCount: Maybe<Scalars['Int']['output']>;
  checkAgainstBlacklists: Maybe<Array<Maybe<Blacklist>>>;
  checkoutSearch: Maybe<Scalars['String']['output']>;
  client: Maybe<Client>;
  clientBrandAccounts: Maybe<Array<Maybe<Account>>>;
  clientNotice: Maybe<ClientNoticeType>;
  clientNoticeAcknowledgement: Maybe<ClientNoticeAcknowledgementType>;
  clientNoticeAcknowledgements: Maybe<Array<Maybe<ClientNoticeAcknowledgementType>>>;
  clientNoticeAcknowledgementsCount: Maybe<Array<Maybe<ClientNoticeAcknowledgementType>>>;
  clientNotices: Maybe<Array<Maybe<ClientNoticeType>>>;
  clientNoticesCount: Maybe<Array<Maybe<ClientNoticeType>>>;
  clientProperties: Maybe<ClientProperties>;
  clients: Maybe<Array<Maybe<Client>>>;
  clientsCount: Maybe<Scalars['Int']['output']>;
  closedPositions: Maybe<Array<Maybe<Trade>>>;
  closedPositionsCount: Maybe<Scalars['Int']['output']>;
  communication: Maybe<Communication>;
  communications: Maybe<Array<Maybe<Communication>>>;
  communicationsCount: Maybe<Scalars['Int']['output']>;
  competition: Maybe<Competition>;
  competitions: Maybe<Array<Maybe<Competition>>>;
  competitionsCount: Maybe<Scalars['Int']['output']>;
  competitionsLeaderboard: Maybe<CompetitionsLeaderboard>;
  competitionsLeaderboards: Maybe<Array<Maybe<CompetitionsLeaderboard>>>;
  competitionsLeaderboardsCount: Maybe<Scalars['Int']['output']>;
  config: Maybe<AppConfig>;
  copyTrading: Maybe<CopyTrading>;
  copyTradings: Maybe<Array<Maybe<CopyTrading>>>;
  copyTradingsCount: Maybe<Scalars['Int']['output']>;
  countryPaymentOption: Maybe<CountryPaymentOptionType>;
  countryPaymentOptions: Maybe<Array<Maybe<CountryPaymentOptionType>>>;
  countryPaymentOptionsCount: Maybe<Scalars['Int']['output']>;
  countryToAgentLanguageMappings: Maybe<Array<Maybe<CountryToAgentLanguageMapping>>>;
  countryToAgentLanguageMappingsCount: Maybe<Scalars['Int']['output']>;
  createAffiliateSingleSignOnLink: Maybe<AffiliateLink>;
  cryptoTransaction: Maybe<CryptoTransaction>;
  cryptoTransactions: Maybe<Array<Maybe<CryptoTransaction>>>;
  cryptoTransactionsCount: Maybe<Scalars['Int']['output']>;
  deposit: Maybe<Deposit>;
  deposits: Maybe<Array<Maybe<Deposit>>>;
  depositsCount: Maybe<Scalars['Int']['output']>;
  depositsTopVipCount: Maybe<Array<Maybe<ObjectTopVipCount>>>;
  document: Maybe<Document>;
  documents: Maybe<Array<Maybe<Document>>>;
  documentsCount: Maybe<Scalars['Int']['output']>;
  documentsForVideo: Maybe<Array<Maybe<DocumentDescription>>>;
  documentsTopVipCount: Maybe<Array<Maybe<ObjectTopVipCount>>>;
  documentTranslation: Maybe<DocumentTranslationType>;
  documentTranslations: Maybe<Array<Maybe<DocumentTranslationType>>>;
  documentTranslationsCount: Maybe<Scalars['Int']['output']>;
  dueDiligence: Maybe<DueDiligence>;
  dueDiligences: Maybe<Array<Maybe<DueDiligence>>>;
  dueDiligencesCount: Maybe<Scalars['Int']['output']>;
  dynamicWithdrawalFields: Maybe<DynamicWithdrawalFields>;
  emailInUse: Maybe<Scalars['Boolean']['output']>;
  emailThread: Maybe<Array<Maybe<Email>>>;
  emailThreads: Maybe<Array<Maybe<Email>>>;
  faq: Maybe<Array<Maybe<Faq>>>;
  findClient: Maybe<FindClient>;
  fxRates: Maybe<Settings>;
  getAffiliateCountries: Maybe<AffiliateCountriesType>;
  getAffiliatesCountries: Maybe<Array<Maybe<AffiliateCountriesType>>>;
  getAffiliatesCountriesCount: Maybe<Scalars['Int']['output']>;
  getAllowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  getBankTransferDetails: Maybe<BankTransferDetails>;
  getCopiersReport: Maybe<Array<Maybe<CopiersReport>>>;
  getDepositsReport: Maybe<Array<Maybe<DepositsReport>>>;
  getFTDReport: Maybe<Array<Maybe<FtdReport>>>;
  getFTDReportCount: Maybe<Scalars['Int']['output']>;
  getIbClientAccounts: Maybe<Array<Maybe<Account>>>;
  getIbClients: Maybe<Array<Maybe<SpoaRemoteClient>>>;
  getIbFromIbId: Maybe<Client>;
  getJMFinancialBankTransferDetails: Maybe<BankTransferDetails>;
  getMarkedUpRate: Maybe<Scalars['String']['output']>;
  getOrphanedCopytradingFollowers: Maybe<Array<Maybe<CopyTrading>>>;
  getOrphanedCopytradingFollowersCount: Maybe<Scalars['Int']['output']>;
  getReferrals: Maybe<Array<Maybe<ReferralDetailsTypeType>>>;
  getRegistrationsReport: Maybe<Array<Maybe<RegistrationsReport>>>;
  getRelatedIbs: Maybe<Array<Maybe<IbClientType>>>;
  getSalesAgentEmailForCallbackSupportQuery: Maybe<Scalars['String']['output']>;
  getThunderxPayOptions: Maybe<ThunderxPayOptionsType>;
  getTradesReport: Maybe<Array<Maybe<TradesReport>>>;
  getTransactionsCommissions: Maybe<Array<Maybe<TransactionsCommission>>>;
  getTransactionsCommissionsCount: Maybe<Scalars['Int']['output']>;
  getTransactionsCommissionSize: Maybe<Scalars['Float']['output']>;
  getTransactionsCommissionsSum: Maybe<Array<Maybe<TransactionsCommissionSum>>>;
  getVpsServicePassword: Maybe<VpsServicePasswordType>;
  ghostCopyTradings: Maybe<Array<Maybe<GhostCopyTrading>>>;
  ghostCopyTradingsCount: Maybe<Scalars['Int']['output']>;
  help2PayDepositBanks: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  help2PayPayoutBanks: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  job: Maybe<Job>;
  jobs: Maybe<Array<Maybe<Job>>>;
  jobsCount: Maybe<Scalars['Int']['output']>;
  leaderboardForCRM: Maybe<Array<Maybe<CompetitionsLeaderboard>>>;
  leaderboardTotalInfo: Maybe<CompetitionsLeaderboardTotalInfo>;
  listBonds: Maybe<Array<Maybe<BondType>>>;
  location: Maybe<Location>;
  locations: Maybe<Array<Maybe<Location>>>;
  locationsCount: Maybe<Scalars['Int']['output']>;
  manualExecutions: Maybe<Array<Maybe<ManualExecutionsType>>>;
  manualExecutionsCount: Maybe<Scalars['Int']['output']>;
  marketingEmail: Maybe<MarketingEmailType>;
  marketingEmails: Maybe<Array<Maybe<MarketingEmailType>>>;
  marketingEmailsCount: Maybe<Scalars['Int']['output']>;
  marketingEmailTemplates: Maybe<Array<Maybe<MarketingEmailTemplateType>>>;
  marketingEmailUnsubscribeGroups: Maybe<Array<Maybe<MarketingEmailUnsubscribeGroupType>>>;
  mobileApTest: Maybe<MobileApTest>;
  mobileConfig: Maybe<Config>;
  note: Maybe<Note>;
  notes: Maybe<Array<Maybe<Note>>>;
  notesCount: Maybe<Scalars['Int']['output']>;
  partnerCustomization: Maybe<PartnerCustomizationType>;
  partnersCustomization: Maybe<Array<Maybe<PartnerCustomizationType>>>;
  partnersCustomizationCount: Maybe<Scalars['Int']['output']>;
  partnersLoyalty: Maybe<PartnersLoyalty>;
  partnersLoyaltyAnalytics: Maybe<PartnersLoyaltyAnalytics>;
  paymentCardToken: Maybe<PaymentCardToken>;
  paymentCardTokens: Maybe<Array<Maybe<PaymentCardToken>>>;
  paymentCardTokensCount: Maybe<Scalars['Int']['output']>;
  paymentOption: Maybe<PaymentOptionType>;
  paymentOptions: Maybe<Array<Maybe<PaymentOptionType>>>;
  paymentOptionsCount: Maybe<Scalars['Int']['output']>;
  payretailersPaymentMethods: Maybe<Array<Maybe<PayretailersPaymentMethod>>>;
  pendingPositions: Maybe<Array<Maybe<Trade>>>;
  pendingPositionsCount: Maybe<Scalars['Int']['output']>;
  performanceFees: Maybe<Array<Maybe<PerformanceFee>>>;
  performanceFeesCount: Maybe<Scalars['Int']['output']>;
  periodsInEachCompany: Maybe<Array<Maybe<PeriodInEachCompanyType>>>;
  permission: Maybe<Permission>;
  permissions: Maybe<Array<Maybe<Permission>>>;
  permissionsCount: Maybe<Scalars['Int']['output']>;
  phoneVerification: Maybe<PhoneVerification>;
  phoneVerifications: Maybe<Array<Maybe<PhoneVerification>>>;
  pixel: Maybe<Pixel>;
  pixels: Maybe<Array<Maybe<Pixel>>>;
  pixelsCount: Maybe<Scalars['Int']['output']>;
  prize: Maybe<Prize>;
  prizes: Maybe<Array<Maybe<Prize>>>;
  prizesCount: Maybe<Scalars['Int']['output']>;
  profileChange: Maybe<ProfileChange>;
  profileChanges: Maybe<Array<Maybe<ProfileChange>>>;
  profileChangesCount: Maybe<Scalars['Int']['output']>;
  promocode: Maybe<Promocode>;
  promocodes: Maybe<Array<Maybe<Promocode>>>;
  promocodesCount: Maybe<Scalars['Int']['output']>;
  pspReport: Maybe<Array<Maybe<PspReport>>>;
  pushNotification: Maybe<PushNotificationType>;
  pushNotifications: Maybe<Array<Maybe<PushNotificationType>>>;
  pushNotificationsCount: Maybe<Scalars['Int']['output']>;
  rawSubscription: Maybe<RawSubscriptionType>;
  rawSubscriptions: Maybe<Array<Maybe<RawSubscriptionType>>>;
  role: Maybe<Role>;
  roles: Maybe<Array<Maybe<Role>>>;
  rolesCount: Maybe<Scalars['Int']['output']>;
  scripts: Maybe<Array<Maybe<Script>>>;
  searchIbs: Maybe<Scalars['String']['output']>;
  seminar: Maybe<Seminar>;
  seminars: Maybe<Array<Maybe<Seminar>>>;
  seminarsCount: Maybe<Scalars['Int']['output']>;
  shift: Maybe<Shift>;
  shifts: Maybe<Array<Maybe<Shift>>>;
  shiftsCount: Maybe<Scalars['Int']['output']>;
  strategiesStatistics: Maybe<Array<Maybe<StrategiesStatisticsType>>>;
  suitabilityTest: Maybe<SuitabilityTest>;
  suitabilityTests: Maybe<Array<Maybe<SuitabilityTest>>>;
  suitabilityTestsCount: Maybe<Scalars['Int']['output']>;
  tagCategories: Maybe<Array<Maybe<TagCategory>>>;
  tagCategoriesCount: Maybe<Scalars['Int']['output']>;
  tagCategory: Maybe<TagCategory>;
  trackEvent: Maybe<TrackEvent>;
  trackEvents: Maybe<Array<Maybe<TrackEvent>>>;
  trackEventsCount: Maybe<Scalars['Int']['output']>;
  tradingAlert: Maybe<TradingAlertType>;
  tradingAlerts: Maybe<Array<Maybe<TradingAlertType>>>;
  tradingAlertsCount: Maybe<Scalars['Int']['output']>;
  tradingCentralLink: Maybe<Scalars['String']['output']>;
  unapprovedIbAccounts: Maybe<Array<Maybe<Account>>>;
  unapprovedPAMMManagerAccounts: Maybe<Array<Maybe<Account>>>;
  user: Maybe<User>;
  users: Maybe<Array<Maybe<User>>>;
  usersCount: Maybe<Scalars['Int']['output']>;
  viewer: Maybe<Viewer>;
  vpsSubscription: Maybe<VpsSubscription>;
  vpsSubscriptions: Maybe<Array<Maybe<VpsSubscription>>>;
  walkthrough: Maybe<Walkthrough>;
  walkthroughs: Maybe<Array<Maybe<Walkthrough>>>;
  walkthroughsCount: Maybe<Scalars['Int']['output']>;
  whiteLabelConfig: Maybe<WhiteLabelConfig>;
  withdrawal: Maybe<Withdrawal>;
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
  withdrawalsTopVipCount: Maybe<Array<Maybe<ObjectTopVipCount>>>;
  workersActivity: Maybe<Array<Maybe<WorkersActivityType>>>;
  workersActivityCount: Maybe<Scalars['Int']['output']>;
};


export type RootQueryTypeAbusiveClientArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeAbusiveClientsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAbusiveClientsCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAccountArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeAccountsArgs = {
  hidden: InputMaybe<Scalars['Boolean']['input']>;
  hideInactiveArchived: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  includeDeleted: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  productIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rejected: InputMaybe<Scalars['Boolean']['input']>;
  remoteId: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeAccountsCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeActivityLogArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeActivityLogsArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeActivityLogsCountArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeAddressProposalArgs = {
  clientId: Scalars['Int']['input'];
};


export type RootQueryTypeAgentCommissionsArgs = {
  agentId: Scalars['Int']['input'];
  endDate: InputMaybe<Scalars['DateTime']['input']>;
  goodOnly: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<AgentCommissionsOrderByType>;
  orderDirection: InputMaybe<OrderDirection>;
  startDate: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeAgentsCommissionsArgs = {
  endDate: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<AgentsCommissionsOrderByType>;
  orderDirection: InputMaybe<OrderDirection>;
  startDate: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeAlertArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeAlertsArgs = {
  balanceFrom: InputMaybe<Scalars['Float']['input']>;
  balanceTo: InputMaybe<Scalars['Float']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositFrom: InputMaybe<Scalars['Float']['input']>;
  depositTo: InputMaybe<Scalars['Float']['input']>;
  lastLogin: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<AlertsOrderByType>;
  orderDirection: InputMaybe<OrderDirection>;
  postponeUntil: InputMaybe<Scalars['DateTime']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<AlertStatusesType>>>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  tradingStatuses: InputMaybe<Array<InputMaybe<TradingStatus>>>;
  types: InputMaybe<Array<InputMaybe<AlertReasonTypes>>>;
};


export type RootQueryTypeAlertsCountArgs = {
  balanceFrom: InputMaybe<Scalars['Float']['input']>;
  balanceTo: InputMaybe<Scalars['Float']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositFrom: InputMaybe<Scalars['Float']['input']>;
  depositTo: InputMaybe<Scalars['Float']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin: InputMaybe<Scalars['DateTime']['input']>;
  postponeUntil: InputMaybe<Scalars['DateTime']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<AlertStatusesType>>>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  tradingStatuses: InputMaybe<Array<InputMaybe<TradingStatus>>>;
  types: InputMaybe<Array<InputMaybe<AlertReasonTypes>>>;
};


export type RootQueryTypeAppointmentArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeAppointmentsArgs = {
  isDismissed: InputMaybe<Scalars['Boolean']['input']>;
  isNew: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<AppointmentsOrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  startFrom: InputMaybe<Scalars['DateTime']['input']>;
  startTo: InputMaybe<Scalars['DateTime']['input']>;
  userId: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootQueryTypeAppointmentsByDayArgs = {
  timezone: InputMaybe<Scalars['String']['input']>;
  userId: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootQueryTypeAppointmentsCountArgs = {
  isDismissed: InputMaybe<Scalars['Boolean']['input']>;
  isNew: InputMaybe<Scalars['Boolean']['input']>;
  startFrom: InputMaybe<Scalars['DateTime']['input']>;
  startTo: InputMaybe<Scalars['DateTime']['input']>;
  userId: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootQueryTypeAppropTestArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeAppropTestsArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  kycStatus: InputMaybe<KycStatus>;
  kycStatuses: InputMaybe<Array<InputMaybe<KycStatus>>>;
  lastUpdated: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<AppropTestStatus>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeAppropTestsCountArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  kycStatus: InputMaybe<KycStatus>;
  kycStatuses: InputMaybe<Array<InputMaybe<KycStatus>>>;
  lastUpdated: InputMaybe<Scalars['DateTime']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<AppropTestStatus>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeArticleArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeArticlesArgs = {
  createdAfter: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeArticlesCountArgs = {
  createdAfter: InputMaybe<Scalars['DateTime']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeBlacklistArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeBlacklistsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  types: InputMaybe<Array<InputMaybe<BlacklistTypeType>>>;
};


export type RootQueryTypeBlacklistsCountArgs = {
  types: InputMaybe<Array<InputMaybe<BlacklistTypeType>>>;
};


export type RootQueryTypeBonusOfferArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type RootQueryTypeBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type RootQueryTypeBookAllocationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeBookAllocationsArgs = {
  bookCategory: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeBookAllocationsCountArgs = {
  bookCategory: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCallLogArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCallLogsArgs = {
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  endedAt: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  maxDuration: InputMaybe<Scalars['Int']['input']>;
  maxScore: InputMaybe<Scalars['Float']['input']>;
  minDuration: InputMaybe<Scalars['Int']['input']>;
  minScore: InputMaybe<Scalars['Float']['input']>;
  monitoredOnly: InputMaybe<Scalars['Boolean']['input']>;
  monitoringAgent: InputMaybe<Scalars['Int']['input']>;
  needsComplianceCheck: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
  startedAt: InputMaybe<Scalars['DateTime']['input']>;
  userId: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeCallLogsCountArgs = {
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  endedAt: InputMaybe<Scalars['DateTime']['input']>;
  maxDuration: InputMaybe<Scalars['Int']['input']>;
  maxScore: InputMaybe<Scalars['Float']['input']>;
  minDuration: InputMaybe<Scalars['Int']['input']>;
  minScore: InputMaybe<Scalars['Float']['input']>;
  monitoredOnly: InputMaybe<Scalars['Boolean']['input']>;
  monitoringAgent: InputMaybe<Scalars['Int']['input']>;
  needsComplianceCheck: InputMaybe<Scalars['Boolean']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  startedAt: InputMaybe<Scalars['DateTime']['input']>;
  userId: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCampaignsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCampaignsCountArgs = {
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCheckAgainstBlacklistsArgs = {
  type: InputMaybe<BlacklistTypeEnum>;
  value: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCheckoutSearchArgs = {
  company: Company;
  download: InputMaybe<Scalars['Boolean']['input']>;
  fromDate: InputMaybe<Scalars['String']['input']>;
  link: InputMaybe<Scalars['String']['input']>;
  toDate: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeClientArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeClientBrandAccountsArgs = {
  clientId: Scalars['Int']['input'];
};


export type RootQueryTypeClientNoticeArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeClientNoticeAcknowledgementArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeClientNoticeAcknowledgementsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeClientNoticeAcknowledgementsCountArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeClientNoticesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeClientNoticesCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeClientPropertiesArgs = {
  memberId: Scalars['Int']['input'];
};


export type RootQueryTypeClientsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  aggregatedBalanceEurMax: InputMaybe<Scalars['Float']['input']>;
  aggregatedBalanceEurMin: InputMaybe<Scalars['Float']['input']>;
  attended: InputMaybe<Scalars['Boolean']['input']>;
  balanceCurrencyFilter: InputMaybe<BalanceCurrencyFilter>;
  binaryAPScoreLimit: InputMaybe<Scalars['Int']['input']>;
  birthdayFrom: InputMaybe<Scalars['DateTime']['input']>;
  birthdayTo: InputMaybe<Scalars['DateTime']['input']>;
  bookType: InputMaybe<BookTypeFilterType>;
  campaign: InputMaybe<Scalars['String']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  competitionId: InputMaybe<Scalars['Int']['input']>;
  conversionStatus: InputMaybe<ConversionStatus>;
  conversionStep: InputMaybe<ConversionStep>;
  convertedFrom: InputMaybe<Scalars['DateTime']['input']>;
  convertedTo: InputMaybe<Scalars['DateTime']['input']>;
  copyTrading: InputMaybe<CopyTradingFilterType>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  eventType: InputMaybe<TrackEventType>;
  forexAPScoreLimit: InputMaybe<Scalars['Int']['input']>;
  ftdFrom: InputMaybe<Scalars['DateTime']['input']>;
  ftdTo: InputMaybe<Scalars['DateTime']['input']>;
  hasActiveForexDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  hasInactiveForexDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  ibId: InputMaybe<Scalars['Float']['input']>;
  isConverted: InputMaybe<Scalars['Boolean']['input']>;
  isDepositor: InputMaybe<Scalars['Boolean']['input']>;
  isIbApproved: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: InputMaybe<JobTitleFilterType>;
  kycStatuses: InputMaybe<Array<InputMaybe<KycStatus>>>;
  language: InputMaybe<Language>;
  lastActivityFrom: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityTo: InputMaybe<Scalars['DateTime']['input']>;
  lastAttemptedCallFrom: InputMaybe<Scalars['DateTime']['input']>;
  lastAttemptedCallTo: InputMaybe<Scalars['DateTime']['input']>;
  lastEffectiveCallFrom: InputMaybe<Scalars['DateTime']['input']>;
  lastEffectiveCallTo: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginFrom: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginTo: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  masterIbOnly: InputMaybe<Scalars['Boolean']['input']>;
  missingPoiPor: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  netWorth: InputMaybe<NetWorthFilterType>;
  noEffectiveCall: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlineOnly: InputMaybe<Scalars['Boolean']['input']>;
  orderBy: InputMaybe<ClientsOrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  pammMMId: InputMaybe<Scalars['Float']['input']>;
  providedAgentPool: InputMaybe<Scalars['String']['input']>;
  providedPotentials: InputMaybe<Array<InputMaybe<PotentialLevel>>>;
  providedWalkthroughs: InputMaybe<Array<InputMaybe<WalkthroughType>>>;
  riskCategories: InputMaybe<Array<InputMaybe<RiskCategory>>>;
  salesAgentId: InputMaybe<Array<InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>>>;
  search: InputMaybe<Scalars['String']['input']>;
  searchPparams: InputMaybe<Scalars['String']['input']>;
  signedUpFrom: InputMaybe<Scalars['DateTime']['input']>;
  signedUpTo: InputMaybe<Scalars['DateTime']['input']>;
  subCampId: InputMaybe<Scalars['String']['input']>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  tagCategories: InputMaybe<Scalars['Int']['input']>;
  tags: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  trackEventAffiliateId: InputMaybe<Scalars['String']['input']>;
  trackEventIbId: InputMaybe<Scalars['String']['input']>;
  tradingStatuses: InputMaybe<Array<InputMaybe<TradingStatus>>>;
  underMonitoring: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeClientsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  aggregatedBalanceEurMax: InputMaybe<Scalars['Float']['input']>;
  aggregatedBalanceEurMin: InputMaybe<Scalars['Float']['input']>;
  attended: InputMaybe<Scalars['Boolean']['input']>;
  balanceCurrencyFilter: InputMaybe<BalanceCurrencyFilter>;
  binaryAPScoreLimit: InputMaybe<Scalars['Int']['input']>;
  birthdayFrom: InputMaybe<Scalars['DateTime']['input']>;
  birthdayTo: InputMaybe<Scalars['DateTime']['input']>;
  bookType: InputMaybe<BookTypeFilterType>;
  campaign: InputMaybe<Scalars['String']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  competitionId: InputMaybe<Scalars['Int']['input']>;
  conversionStatus: InputMaybe<ConversionStatus>;
  conversionStep: InputMaybe<ConversionStep>;
  convertedFrom: InputMaybe<Scalars['DateTime']['input']>;
  convertedTo: InputMaybe<Scalars['DateTime']['input']>;
  copyTrading: InputMaybe<CopyTradingFilterType>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  eventType: InputMaybe<TrackEventType>;
  forexAPScoreLimit: InputMaybe<Scalars['Int']['input']>;
  ftdFrom: InputMaybe<Scalars['DateTime']['input']>;
  ftdTo: InputMaybe<Scalars['DateTime']['input']>;
  hasActiveForexDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  hasInactiveForexDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  ibId: InputMaybe<Scalars['Float']['input']>;
  isConverted: InputMaybe<Scalars['Boolean']['input']>;
  isDepositor: InputMaybe<Scalars['Boolean']['input']>;
  isIbApproved: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: InputMaybe<JobTitleFilterType>;
  kycStatuses: InputMaybe<Array<InputMaybe<KycStatus>>>;
  language: InputMaybe<Language>;
  lastActivityFrom: InputMaybe<Scalars['DateTime']['input']>;
  lastActivityTo: InputMaybe<Scalars['DateTime']['input']>;
  lastAttemptedCallFrom: InputMaybe<Scalars['DateTime']['input']>;
  lastAttemptedCallTo: InputMaybe<Scalars['DateTime']['input']>;
  lastEffectiveCallFrom: InputMaybe<Scalars['DateTime']['input']>;
  lastEffectiveCallTo: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginFrom: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginTo: InputMaybe<Scalars['DateTime']['input']>;
  masterIbOnly: InputMaybe<Scalars['Boolean']['input']>;
  missingPoiPor: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  netWorth: InputMaybe<NetWorthFilterType>;
  noEffectiveCall: InputMaybe<Scalars['Boolean']['input']>;
  onlineOnly: InputMaybe<Scalars['Boolean']['input']>;
  pammMMId: InputMaybe<Scalars['Float']['input']>;
  providedAgentPool: InputMaybe<Scalars['String']['input']>;
  providedPotentials: InputMaybe<Array<InputMaybe<PotentialLevel>>>;
  providedWalkthroughs: InputMaybe<Array<InputMaybe<WalkthroughType>>>;
  riskCategories: InputMaybe<Array<InputMaybe<RiskCategory>>>;
  salesAgentId: InputMaybe<Array<InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>>>;
  search: InputMaybe<Scalars['String']['input']>;
  searchPparams: InputMaybe<Scalars['String']['input']>;
  signedUpFrom: InputMaybe<Scalars['DateTime']['input']>;
  signedUpTo: InputMaybe<Scalars['DateTime']['input']>;
  subCampId: InputMaybe<Scalars['String']['input']>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  tagCategories: InputMaybe<Scalars['Int']['input']>;
  tags: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  trackEventAffiliateId: InputMaybe<Scalars['String']['input']>;
  trackEventIbId: InputMaybe<Scalars['String']['input']>;
  tradingStatuses: InputMaybe<Array<InputMaybe<TradingStatus>>>;
  underMonitoring: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeClosedPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  login: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  server: Mt4ServerType;
};


export type RootQueryTypeClosedPositionsCountArgs = {
  login: Scalars['Int']['input'];
  server: Mt4ServerType;
};


export type RootQueryTypeCommunicationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCommunicationsArgs = {
  channels: InputMaybe<Array<InputMaybe<CommunicationChannelType>>>;
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  departments: InputMaybe<Array<InputMaybe<CommunicationDepartmentType>>>;
  excludeAutomatedEmails: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  types: InputMaybe<Array<InputMaybe<CommunicationTypeType>>>;
};


export type RootQueryTypeCommunicationsCountArgs = {
  channels: InputMaybe<Array<InputMaybe<CommunicationChannelType>>>;
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  departments: InputMaybe<Array<InputMaybe<CommunicationDepartmentType>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  excludeAutomatedEmails: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  types: InputMaybe<Array<InputMaybe<CommunicationTypeType>>>;
};


export type RootQueryTypeCompetitionArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCompetitionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeCompetitionsLeaderboardArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCompetitionsLeaderboardsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeCopyTradingArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCopyTradingsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeCopyTradingsCountArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeCountryPaymentOptionArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCountryPaymentOptionsArgs = {
  buildNumber: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  countries: InputMaybe<Array<InputMaybe<PaymentOptionCountry>>>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  platform: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeCreateAffiliateSingleSignOnLinkArgs = {
  accountId: Scalars['Int']['input'];
};


export type RootQueryTypeCryptoTransactionArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeCryptoTransactionsArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  forAffiliateAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletSwissMarketsMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletVanuatu: InputMaybe<Scalars['Boolean']['input']>;
  forBondAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBRFCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCLEANcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCryptoWallet: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeBDXAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forFiatWallet: InputMaybe<Scalars['Boolean']['input']>;
  forForexAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicTauroMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccountBDX: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5Account: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5DemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forGoldAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forJOLLYcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<CryptoTransactionStatusType>>>;
  type: InputMaybe<CryptoTransactionTypeType>;
};


export type RootQueryTypeCryptoTransactionsCountArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  forAffiliateAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletSwissMarketsMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletVanuatu: InputMaybe<Scalars['Boolean']['input']>;
  forBondAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBRFCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCLEANcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCryptoWallet: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeBDXAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forFiatWallet: InputMaybe<Scalars['Boolean']['input']>;
  forForexAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicTauroMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccountBDX: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5Account: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5DemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forGoldAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forJOLLYcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<CryptoTransactionStatusType>>>;
  type: InputMaybe<CryptoTransactionTypeType>;
};


export type RootQueryTypeDepositArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type RootQueryTypeDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type RootQueryTypeDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeDocumentsArgs = {
  assignee: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  hasPendingWithdrawals: InputMaybe<Scalars['Boolean']['input']>;
  isDepositor: InputMaybe<Scalars['Boolean']['input']>;
  kycStatus: InputMaybe<KycStatus>;
  kycStatuses: InputMaybe<Array<InputMaybe<KycStatus>>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchDocId: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<DocumentStatus>;
  statuses: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  tradingStatuses: InputMaybe<Array<InputMaybe<TradingStatus>>>;
  types: InputMaybe<Array<InputMaybe<DocumentType>>>;
};


export type RootQueryTypeDocumentsCountArgs = {
  assignee: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  expirationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  hasPendingWithdrawals: InputMaybe<Scalars['Boolean']['input']>;
  isDepositor: InputMaybe<Scalars['Boolean']['input']>;
  kycStatus: InputMaybe<KycStatus>;
  kycStatuses: InputMaybe<Array<InputMaybe<KycStatus>>>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchDocId: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<DocumentStatus>;
  statuses: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  tradingStatuses: InputMaybe<Array<InputMaybe<TradingStatus>>>;
  types: InputMaybe<Array<InputMaybe<DocumentType>>>;
};


export type RootQueryTypeDocumentTranslationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeDocumentTranslationsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeDocumentTranslationsCountArgs = {
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeDueDiligenceArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeDueDiligencesArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdated: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  status: InputMaybe<DueDiligenceStatusType>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
};


export type RootQueryTypeDueDiligencesCountArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated: InputMaybe<Scalars['DateTime']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  status: InputMaybe<DueDiligenceStatusType>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
};


export type RootQueryTypeDynamicWithdrawalFieldsArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
  vendorName: Scalars['String']['input'];
};


export type RootQueryTypeEmailInUseArgs = {
  checkConverted: Scalars['Boolean']['input'];
  company: InputMaybe<Company>;
  email: Scalars['String']['input'];
};


export type RootQueryTypeEmailThreadArgs = {
  messageId: Scalars['Int']['input'];
};


export type RootQueryTypeEmailThreadsArgs = {
  clientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type RootQueryTypeFindClientArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  remoteId: InputMaybe<Scalars['Int']['input']>;
  type: ClientSearchType;
};


export type RootQueryTypeGetAffiliateCountriesArgs = {
  clientId: Scalars['Int']['input'];
};


export type RootQueryTypeGetAffiliatesCountriesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeGetAffiliatesCountriesCountArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeGetAllowedLeveragesArgs = {
  accountId: Scalars['Int']['input'];
};


export type RootQueryTypeGetBankTransferDetailsArgs = {
  accountId: Scalars['Int']['input'];
  paymentMethod: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCopiersReportArgs = {
  company: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<CopiersReportOrderByType>;
  orderDirection: InputMaybe<OrderDirection>;
  reportDate: InputMaybe<Scalars['DateTime']['input']>;
  reportDateEnd: InputMaybe<Scalars['DateTime']['input']>;
  reportDateStart: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeGetDepositsReportArgs = {
  company: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<DepositsReportOrderByType>;
  orderDirection: InputMaybe<OrderDirection>;
  reportDate: InputMaybe<Scalars['DateTime']['input']>;
  reportDateEnd: InputMaybe<Scalars['DateTime']['input']>;
  reportDateStart: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeGetFtdReportArgs = {
  ftdDate: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<FtdReportOrderByType>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeGetFtdReportCountArgs = {
  ftdDate: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeGetIbClientAccountsArgs = {
  clientId: Scalars['Int']['input'];
};


export type RootQueryTypeGetIbFromIbIdArgs = {
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  ibId: Scalars['Int']['input'];
  isIbApproved: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeGetJmFinancialBankTransferDetailsArgs = {
  accountId: Scalars['Int']['input'];
};


export type RootQueryTypeGetMarkedUpRateArgs = {
  fromCurrency: Scalars['String']['input'];
  toCurrency: Scalars['String']['input'];
};


export type RootQueryTypeGetOrphanedCopytradingFollowersArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeGetOrphanedCopytradingFollowersCountArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeGetReferralsArgs = {
  referrerId: Scalars['Int']['input'];
};


export type RootQueryTypeGetRegistrationsReportArgs = {
  company: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<RegistrationsReportOrderByType>;
  orderDirection: InputMaybe<OrderDirection>;
  reportDate: InputMaybe<Scalars['DateTime']['input']>;
  reportDateEnd: InputMaybe<Scalars['DateTime']['input']>;
  reportDateStart: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeGetThunderxPayOptionsArgs = {
  country: Scalars['String']['input'];
};


export type RootQueryTypeGetTradesReportArgs = {
  company: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<TradesReportOrderByType>;
  orderDirection: InputMaybe<OrderDirection>;
  reportDate: InputMaybe<Scalars['DateTime']['input']>;
  reportDateEnd: InputMaybe<Scalars['DateTime']['input']>;
  reportDateStart: InputMaybe<Scalars['DateTime']['input']>;
  source: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetTransactionsCommissionsArgs = {
  agentId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  endDate: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<TransactionsCommissionsOrderByType>;
  orderDirection: InputMaybe<OrderDirection>;
  startDate: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeGetTransactionsCommissionsCountArgs = {
  agentId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  endDate: InputMaybe<Scalars['DateTime']['input']>;
  startDate: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeGetTransactionsCommissionsSumArgs = {
  agentId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  endDate: InputMaybe<Scalars['DateTime']['input']>;
  startDate: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeGetVpsServicePasswordArgs = {
  serviceId: Scalars['Int']['input'];
};


export type RootQueryTypeGhostCopyTradingsArgs = {
  copyingRemoteId: InputMaybe<Scalars['Int']['input']>;
  firstCopyingDate: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  lastCopyingDate: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  memberId: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  remoteId: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<GhostCopyTradingStatusType>;
};


export type RootQueryTypeGhostCopyTradingsCountArgs = {
  copyingRemoteId: InputMaybe<Scalars['Int']['input']>;
  firstCopyingDate: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  lastCopyingDate: InputMaybe<Scalars['DateTime']['input']>;
  memberId: InputMaybe<Scalars['Int']['input']>;
  remoteId: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<GhostCopyTradingStatusType>;
};


export type RootQueryTypeHelp2PayDepositBanksArgs = {
  currency: Scalars['String']['input'];
};


export type RootQueryTypeHelp2PayPayoutBanksArgs = {
  currency: Scalars['String']['input'];
};


export type RootQueryTypeJobArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeJobsArgs = {
  action: InputMaybe<JobAction>;
  createdBy: InputMaybe<Scalars['Int']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<JobStatus>;
  types: InputMaybe<Array<InputMaybe<JobType>>>;
};


export type RootQueryTypeLeaderboardForCrmArgs = {
  id: Scalars['Int']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  page: Scalars['Int']['input'];
};


export type RootQueryTypeLeaderboardTotalInfoArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeLocationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeLocationsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeManualExecutionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeMarketingEmailArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeMarketingEmailsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeMobileConfigArgs = {
  args: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeNoteArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeNotesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypePartnerCustomizationArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypePartnersCustomizationArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePartnersCustomizationCountArgs = {
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePartnersLoyaltyArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypePartnersLoyaltyAnalyticsArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypePaymentCardTokenArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypePaymentCardTokensArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<PaymentCardTokenStatus>;
};


export type RootQueryTypePaymentCardTokensCountArgs = {
  status: InputMaybe<PaymentCardTokenStatus>;
};


export type RootQueryTypePaymentOptionArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypePaymentOptionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  method: InputMaybe<PaymentOptionMethodsType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePaymentOptionsCountArgs = {
  method: InputMaybe<PaymentOptionMethodsType>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePendingPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  login: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  server: Mt4ServerType;
};


export type RootQueryTypePendingPositionsCountArgs = {
  login: Scalars['Int']['input'];
  server: Mt4ServerType;
};


export type RootQueryTypePerformanceFeesArgs = {
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePerformanceFeesCountArgs = {
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePeriodsInEachCompanyArgs = {
  clientId: Scalars['Int']['input'];
};


export type RootQueryTypePermissionArgs = {
  id: Scalars['String']['input'];
};


export type RootQueryTypePermissionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypePhoneVerificationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypePhoneVerificationsArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypePixelArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypePixelsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypePrizeArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypePrizesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePrizesCountArgs = {
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeProfileChangeArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeProfileChangesArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  priorityProfileChange: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<ProfileChangeStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  toOrFromCountry: InputMaybe<Country>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeProfileChangesCountArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  priorityProfileChange: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<ProfileChangeStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  toOrFromCountry: InputMaybe<Country>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypePromocodeArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypePromocodesArgs = {
  category: InputMaybe<PromocodeCategory>;
  depleted: InputMaybe<Scalars['Boolean']['input']>;
  expired: InputMaybe<Scalars['Boolean']['input']>;
  ftd: InputMaybe<PromocodeFtd>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  product: InputMaybe<PromocodeProductNameType>;
  single: InputMaybe<PromocodeSingle>;
  status: InputMaybe<PromocodeStatus>;
};


export type RootQueryTypePromocodesCountArgs = {
  category: InputMaybe<PromocodeCategory>;
  depleted: InputMaybe<Scalars['Boolean']['input']>;
  expired: InputMaybe<Scalars['Boolean']['input']>;
  ftd: InputMaybe<PromocodeFtd>;
  product: InputMaybe<PromocodeProductNameType>;
  single: InputMaybe<PromocodeSingle>;
  status: InputMaybe<PromocodeStatus>;
};


export type RootQueryTypePushNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypePushNotificationsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<PushNotificationsTypesType>;
};


export type RootQueryTypePushNotificationsCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  ignoreCache: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<PushNotificationsTypesType>;
};


export type RootQueryTypeRawSubscriptionArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeRawSubscriptionsArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  isCurrent: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  plan: InputMaybe<RawSubscriptionPlanType>;
};


export type RootQueryTypeRoleArgs = {
  id: Scalars['String']['input'];
  includeHidden: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeRolesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeSearchIbsArgs = {
  keyword: Scalars['String']['input'];
};


export type RootQueryTypeSeminarArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeSeminarsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeSeminarsCountArgs = {
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeShiftArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeShiftsArgs = {
  endDate: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  startDate: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeShiftsCountArgs = {
  endDate: InputMaybe<Scalars['DateTime']['input']>;
  ignoreCache: InputMaybe<Scalars['Boolean']['input']>;
  startDate: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeSuitabilityTestArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeSuitabilityTestsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeSuitabilityTestsCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeTagCategoriesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeTagCategoriesCountArgs = {
  search: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeTagCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeTrackEventArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeTrackEventsArgs = {
  attended: InputMaybe<Scalars['Boolean']['input']>;
  eventType: InputMaybe<TrackEventType>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
  subCampId: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeTrackEventsCountArgs = {
  attended: InputMaybe<Scalars['Boolean']['input']>;
  eventType: InputMaybe<TrackEventType>;
  search: InputMaybe<Scalars['String']['input']>;
  subCampId: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeTradingAlertArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeTradingAlertsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TradingAlertTypesType>;
};


export type RootQueryTypeTradingAlertsCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<TradingAlertTypesType>;
};


export type RootQueryTypeTradingCentralLinkArgs = {
  page: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeUnapprovedIbAccountsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeUnapprovedPammManagerAccountsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeUserArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeUsersArgs = {
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  isSalesAgent: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


export type RootQueryTypeUsersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeVpsSubscriptionArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeVpsSubscriptionsArgs = {
  deleted: InputMaybe<Scalars['Boolean']['input']>;
  memberId: InputMaybe<Scalars['Int']['input']>;
  planName: InputMaybe<Array<InputMaybe<VpsSubsciptionPlans>>>;
  status: InputMaybe<Array<InputMaybe<VpsSubscriptionStatuse>>>;
  type: InputMaybe<Array<InputMaybe<VpsSubscriptionType>>>;
};


export type RootQueryTypeWalkthroughArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeWalkthroughsArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
  createdBy: InputMaybe<Scalars['Int']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<WalkthroughType>;
  types: InputMaybe<Array<InputMaybe<WalkthroughType>>>;
};


export type RootQueryTypeWithdrawalArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type RootQueryTypeWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type RootQueryTypeWorkersActivityArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  workerName: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeWorkersActivityCountArgs = {
  workerName: InputMaybe<Scalars['String']['input']>;
};

/** Abusive Clients list */
export type AbusiveClient = {
  __typename?: 'AbusiveClient';
  /** Client's full name */
  clientName: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Abusive client ID */
  id: Maybe<Scalars['Int']['output']>;
  /** ips of clients */
  ips: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Which field to order the query results by */
export enum OrderBy {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Id = 'id',
  Threshold = 'threshold'
}

/** Which direction to order the query results */
export enum OrderDirection {
  Ascending = 'ascending',
  Descending = 'descending'
}

/** Account for a particular product */
export type Account = AffiliateAccount | AffiliateEquityFlowAccount | AffiliateLydianAccount | AffiliateMauritiusAccount | AffiliateSkyGroundAccount | AffiliateTauroMarketsAccount | AffiliateTauroMarketsMauritiusAccount | AffiliateVanuatuAccount | AipammAccount | AipammDemoAccount | AipammMauritiusAccount | AipammMauritiusDemoAccount | BdXcoin | BdXcoinMauritius | BdXcoinVanuatu | BitnukWalletMauritius | BitnukWalletSwissMarketsMauritius | BitnukWalletVanuatu | BondAccount | BondDemoAccount | BondMauritiusAccount | BondMauritiusDemoAccount | BondVanuatuAccount | BondVanuatuDemoAccount | BrFcoin | CentEquityFlowAccount | CentMauritiusAccount | CentTauroMarketsAccount | CentVanuatuAccount | CleaNcoin | CryptoWallet | CuboidAccount | CuboidDemoAccount | CuboidMauritiusAccount | CuboidMauritiusDemoAccount | CuboidVanuatuAccount | CuboidVanuatuDemoAccount | EmptyAccountType | ExchangeAccount | ExchangeBdxAccount | ExchangeMauritiusAccount | ExchangeVanuatuAccount | FiatWallet | ForexAccount | ForexAsiaAccount | ForexClassicAccount | ForexClassicDemoAccount | ForexClassicEquityFlowAccount | ForexClassicEquityFlowAsiaAccount | ForexClassicEquityFlowDemoAccount | ForexClassicLydianAccount | ForexClassicLydianDemoAccount | ForexClassicMauritiusAccount | ForexClassicMauritiusDemoAccount | ForexClassicSkyGroundAccount | ForexClassicSkyGroundDemoAccount | ForexClassicTauroMarketsAccount | ForexClassicTauroMarketsAsiaAccount | ForexClassicTauroMarketsDemoAccount | ForexClassicTauroMarketsMauritiusAccount | ForexClassicVanuatuAccount | ForexClassicVanuatuDemoAccount | ForexDemoAccount | ForexMauritiusAccount | ForexMauritiusAccountBdx | ForexMauritiusDemoAccount | ForexMt5Account | ForexMt5DemoAccount | ForexMt5MauritiusAccount | ForexMt5MauritiusDemoAccount | ForexMt5SvgTauromarketsAccount | ForexMt5SvgTauromarketsDemoAccount | ForexMt5TauromarketsAccount | ForexMt5TauromarketsDemoAccount | ForexMt5VanuatuAccount | ForexMt5VanuatuDemoAccount | ForexPremiumMauritiusAccount | ForexPremiumVanuatuAccount | ForexRawAccount | ForexRawBdSwissAccount | ForexRawBdSwissMauritiusAccount | ForexRawBdSwissVanuatuAccount | ForexRawEquityFlowAccount | ForexRawMauritiusAccount | ForexRawTauroMarketsAccount | ForexRawVanuatuAccount | ForexVanuatuAccount | ForexVanuatuDemoAccount | GoldAccount | GoldMauritiusAccount | GoldVanuatuAccount | IntroducingBrokerAccount | IntroducingBrokerBdSwissVanuatuAccount | IntroducingBrokerEquityFlowAccount | IntroducingBrokerMauritiusAccount | IntroducingBrokerSwissMarketsAccount | IntroducingBrokerSwissMarketsMauritiusAccount | IntroducingBrokerSwissMarketsVanuatuAccount | IntroducingBrokerTauroMarketsAccount | IntroducingBrokerTauroMarketsMauritiusAccount | JollYcoin | MamAccount | MamMauritiusAccount | MamsmMauritiusAccount | MamsmVanuatuAccount | MamVanuatuAccount | PammAccount | PammFundManagerAccount | PammFundManagerMauritiusAccount | PammFundManagerVanuatuAccount | PammMauritiusAccount | PammsmAccount | PammsmFundManagerAccount | PammsmFundManagerMauritiusAccount | PammsmFundManagerVanuatuAccount | PammsmMauritiusAccount | PammsmVanuatuAccount | PammTauroMarketsAccount | PammTauroMarketsManagerAccount | PammTauroMarketsMauritiusAccount | PammTauroMarketsMauritiusManagerAccount | PammTauroMarketsMt5Account | PammTauroMarketsMt5ManagerAccount | PammVanuatuAccount | PortfolioManagementAccount | PortfolioManagementMauritiusAccount | SmPrimeWalletBdSwissAccount | SmPrimeWalletBdSwissMauritiusAccount | SmPrimeWalletMauritiusAccount | SmPrimeWalletVanuatuAccount | SpotOptionAccount | SpotOptionDemoAccount | SpotOptionMauritiusAccount | SpotOptionMauritiusDemoAccount | SpotOptionVanuatuAccount | SpotOptionVanuatuDemoAccount | TradesmarterAccount | TradesmarterDemoAccount | TradesmarterMauritiusAccount | TradesmarterMauritiusDemoAccount | TradesmarterVanuatuAccount | TradesmarterVanuatuDemoAccount;

/** Affiliate Account */
export type AffiliateAccount = BaseAccount & BaseAffiliateAccount & {
  __typename?: 'AffiliateAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Affiliate ID on the external product */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** Affiliate is eligible for automatic affiliate commissions debiting */
  automaticCommissions: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Cellxpers ID on the external platform */
  cellxpertsId: Maybe<Scalars['Int']['output']>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  /** Last registration campaign record for this user */
  lastRegistrationCampaign: Maybe<RegistrationCampaign>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Fields we get from affiliate service */
  serviceFields: Maybe<AffiliateServiceFieldsType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Affiliate Account */
export type AffiliateAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Account */
export type AffiliateAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Account */
export type AffiliateAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Account */
export type AffiliateAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Account */
export type AffiliateAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Account */
export type AffiliateAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Account */
export type AffiliateAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Affiliate Account */
export type AffiliateAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Account */
export type AffiliateAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Active Brokeree Copy Trading offer details */
export type ActiveBrokereeCopyTradingOffer = {
  __typename?: 'ActiveBrokereeCopyTradingOffer';
  id: Maybe<Scalars['ID']['output']>;
  isUnsubscribePending: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export enum BonusOfferStatus {
  AutoApproved = 'autoApproved',
  ClientAccepted = 'clientAccepted',
  ClientRejected = 'clientRejected',
  Pending = 'pending',
  UserApproved = 'userApproved',
  UserRejected = 'userRejected'
}

export enum BonusOfferType {
  AdminBonus = 'adminBonus',
  OnBoard = 'onBoard',
  OnDeposit = 'onDeposit'
}

/** Manual or automatic bonus offer to a client */
export type BonusOffer = {
  __typename?: 'BonusOffer';
  /** Account for which the bonus was offered */
  account: Maybe<Account>;
  /** Amount of bonus offer in given currency */
  amount: Maybe<Scalars['Float']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency of bonus offer. Must be the same as account currency */
  currency: Maybe<Currency>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** The deposit the bonus was disbursed by, or NULL if the bonus was not disbursed */
  deposit: Maybe<Deposit>;
  /** Bonus Offer ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Promocode that triggered this bonus offer, if any */
  promoCode: Maybe<Scalars['String']['output']>;
  /** Status of bonus offer */
  status: Maybe<BonusOfferStatus>;
  /** Type of bonus offer */
  type: Maybe<BonusOfferType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** User rejection reason */
  userRejectionReason: Maybe<Scalars['String']['output']>;
};

/** Supported currencies */
export enum Currency {
  Bch = 'BCH',
  Btc = 'BTC',
  Chf = 'CHF',
  Cud = 'CUD',
  Dash = 'DASH',
  Dkk = 'DKK',
  Eth = 'ETH',
  Eur = 'EUR',
  Gbp = 'GBP',
  Ltc = 'LTC',
  Nok = 'NOK',
  Pln = 'PLN',
  Sek = 'SEK',
  Usd = 'USD'
}

/** Inward payment to client account */
export type Deposit = {
  __typename?: 'Deposit';
  /** Account where deposit was made */
  account: Maybe<Account>;
  /** Activity logs concerning this deposit */
  activityLogs: Maybe<Array<Maybe<ActivityLog>>>;
  /** Count of activity logs concerning this deposit */
  activityLogsCount: Maybe<Scalars['Int']['output']>;
  /** Amount of deposit, in chosen currency */
  amount: Maybe<Scalars['Float']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency of deposit */
  currency: Maybe<Currency>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposit ID */
  id: Maybe<Scalars['Int']['output']>;
  payment: Maybe<Payment>;
  /** Link to tokenized payment card, if a tokenized payment card was used */
  paymentCardToken: Maybe<PaymentCardToken>;
  paymentFields: Maybe<DepositPaymentFieldsType>;
  /** For bonus deposits, the promocode that triggered the bonus, if any */
  promoCode: Maybe<Scalars['String']['output']>;
  /** Rejection reason */
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** Rejection Reason Key */
  rejectionReasonKey: Maybe<DepositRejectionReasonCode>;
  /** Sales agent at the time of the deposit */
  salesAgent: Maybe<User>;
  showCancelPartialDeposit: Maybe<Scalars['Boolean']['output']>;
  /** Spreedly reference for this transaction */
  spreedlyTransactionToken: Maybe<Scalars['String']['output']>;
  /** Status of deposit */
  status: Maybe<DepositStatus>;
  statusDescription: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


/** Inward payment to client account */
export type DepositActivityLogsArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


/** Inward payment to client account */
export type DepositActivityLogsCountArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};

/** BDSwiss Holdings child companies */
export enum Company {
  BdSwiss = 'bdSwiss',
  BdSwissMauritius = 'bdSwissMauritius',
  BdSwissVanuatu = 'bdSwissVanuatu',
  BdxAccounts = 'bdxAccounts',
  Bitrace = 'bitrace',
  CleanCoinAccounts = 'cleanCoinAccounts',
  EquityFlow = 'equityFlow',
  Lydian = 'lydian',
  MakeYourDay = 'makeYourDay',
  SkyGround = 'skyGround',
  SwissMarkets = 'swissMarkets',
  SwissMarketsMauritius = 'swissMarketsMauritius',
  SwissMarketsVanuatu = 'swissMarketsVanuatu',
  TauroMarkets = 'tauroMarkets',
  TauroMarketsMauritius = 'tauroMarketsMauritius',
  ValutaMarketsAlias = 'valutaMarketsAlias'
}

export enum Country {
  Ad = 'ad',
  Ae = 'ae',
  Af = 'af',
  Ag = 'ag',
  Ai = 'ai',
  Al = 'al',
  Am = 'am',
  An = 'an',
  Ao = 'ao',
  Aq = 'aq',
  Ar = 'ar',
  As = 'as',
  At = 'at',
  Au = 'au',
  Aw = 'aw',
  Ax = 'ax',
  Az = 'az',
  Ba = 'ba',
  Bb = 'bb',
  Bd = 'bd',
  Be = 'be',
  Bf = 'bf',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bj = 'bj',
  Bl = 'bl',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Bq = 'bq',
  Br = 'br',
  Bs = 'bs',
  Bt = 'bt',
  Bv = 'bv',
  Bw = 'bw',
  By = 'by',
  Bz = 'bz',
  Ca = 'ca',
  Cc = 'cc',
  Cd = 'cd',
  Cf = 'cf',
  Cg = 'cg',
  Ch = 'ch',
  Ci = 'ci',
  Ck = 'ck',
  Cl = 'cl',
  Cm = 'cm',
  Cn = 'cn',
  Co = 'co',
  Cr = 'cr',
  Cu = 'cu',
  Cv = 'cv',
  Cw = 'cw',
  Cx = 'cx',
  Cy = 'cy',
  Cz = 'cz',
  De = 'de',
  Dj = 'dj',
  Dk = 'dk',
  Dm = 'dm',
  Do = 'do',
  Dz = 'dz',
  Ec = 'ec',
  Ee = 'ee',
  Eg = 'eg',
  Eh = 'eh',
  Er = 'er',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fj = 'fj',
  Fk = 'fk',
  Fm = 'fm',
  Fo = 'fo',
  Fr = 'fr',
  Ga = 'ga',
  Gb = 'gb',
  Gd = 'gd',
  Ge = 'ge',
  Gf = 'gf',
  Gg = 'gg',
  Gh = 'gh',
  Gi = 'gi',
  Gl = 'gl',
  Gm = 'gm',
  Gn = 'gn',
  Gp = 'gp',
  Gq = 'gq',
  Gr = 'gr',
  Gs = 'gs',
  Gt = 'gt',
  Gu = 'gu',
  Gw = 'gw',
  Gy = 'gy',
  Hk = 'hk',
  Hm = 'hm',
  Hn = 'hn',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Id = 'id',
  Ie = 'ie',
  Il = 'il',
  Im = 'im',
  In = 'in',
  Io = 'io',
  Iq = 'iq',
  Ir = 'ir',
  Is = 'is',
  It = 'it',
  Je = 'je',
  Jm = 'jm',
  Jo = 'jo',
  Jp = 'jp',
  Ke = 'ke',
  Kg = 'kg',
  Kh = 'kh',
  Ki = 'ki',
  Km = 'km',
  Kn = 'kn',
  Kp = 'kp',
  Kr = 'kr',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  Kz = 'kz',
  La = 'la',
  Lb = 'lb',
  Lc = 'lc',
  Li = 'li',
  Lk = 'lk',
  Lr = 'lr',
  Ls = 'ls',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Ly = 'ly',
  Ma = 'ma',
  Mc = 'mc',
  Md = 'md',
  Me = 'me',
  Mf = 'mf',
  Mg = 'mg',
  Mh = 'mh',
  Mk = 'mk',
  Ml = 'ml',
  Mm = 'mm',
  Mn = 'mn',
  Mo = 'mo',
  Mp = 'mp',
  Mq = 'mq',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  Mu = 'mu',
  Mv = 'mv',
  Mw = 'mw',
  Mx = 'mx',
  My = 'my',
  Mz = 'mz',
  Na = 'na',
  Nc = 'nc',
  Ne = 'ne',
  Nf = 'nf',
  Ng = 'ng',
  Ni = 'ni',
  Nl = 'nl',
  No = 'no',
  Np = 'np',
  Nr = 'nr',
  Nu = 'nu',
  Nz = 'nz',
  Om = 'om',
  Pa = 'pa',
  Pe = 'pe',
  Pf = 'pf',
  Pg = 'pg',
  Ph = 'ph',
  Pk = 'pk',
  Pl = 'pl',
  Pm = 'pm',
  Pn = 'pn',
  Pr = 'pr',
  Ps = 'ps',
  Pt = 'pt',
  Pw = 'pw',
  Py = 'py',
  Qa = 'qa',
  Re = 're',
  Ro = 'ro',
  Rs = 'rs',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sb = 'sb',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Sh = 'sh',
  Si = 'si',
  Sj = 'sj',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Sv = 'sv',
  Sx = 'sx',
  Sy = 'sy',
  Sz = 'sz',
  Tc = 'tc',
  Td = 'td',
  Tf = 'tf',
  Tg = 'tg',
  Th = 'th',
  Tj = 'tj',
  Tk = 'tk',
  Tl = 'tl',
  Tm = 'tm',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Tt = 'tt',
  Tv = 'tv',
  Tw = 'tw',
  Tz = 'tz',
  Ua = 'ua',
  Ug = 'ug',
  Um = 'um',
  Us = 'us',
  Uy = 'uy',
  Uz = 'uz',
  Va = 'va',
  Vc = 'vc',
  Ve = 've',
  Vg = 'vg',
  Vi = 'vi',
  Vn = 'vn',
  Vu = 'vu',
  Wf = 'wf',
  Ws = 'ws',
  Ye = 'ye',
  Yt = 'yt',
  Za = 'za',
  Zm = 'zm',
  Zw = 'zw'
}

/** Possible ActivityLog origins */
export enum ActivityLogOrigin {
  Client = 'client',
  Service = 'service',
  User = 'user'
}

export enum ActivityLogTypeType {
  AcceptedMarginBonusTnc = 'acceptedMarginBonusTnc',
  AcceptedTradableBonusTnc = 'acceptedTradableBonusTnc',
  AcceptOwnBonusOffer = 'acceptOwnBonusOffer',
  AddedBonusQualifiedAmount = 'addedBonusQualifiedAmount',
  AddedBonusQualifiedDeposit = 'addedBonusQualifiedDeposit',
  AddUser = 'addUser',
  AffiliateAddedManually = 'affiliateAddedManually',
  AffiliateClientNote = 'affiliateClientNote',
  AffiliateContractSent = 'affiliateContractSent',
  AffiliateDeleted = 'affiliateDeleted',
  AffiliateUpdated = 'affiliateUpdated',
  AlertResolved = 'alertResolved',
  AllClientsCheckedAgainstSanctions = 'allClientsCheckedAgainstSanctions',
  ApproveAdminBonusOffer = 'approveAdminBonusOffer',
  ApproveAppropTest = 'approveAppropTest',
  ApproveBonusDeposit = 'approveBonusDeposit',
  ApproveDocument = 'approveDocument',
  ApproveProfileChange = 'approveProfileChange',
  ApproveWithdrawal = 'approveWithdrawal',
  AssignClientAgent = 'assignClientAgent',
  AssignClientToAffiliate = 'assignClientToAffiliate',
  AssigneeDocument = 'assigneeDocument',
  AttemptedToIncompleteClientDeposit = 'attemptedToIncompleteClientDeposit',
  AutochartistEmails = 'autochartistEmails',
  BdxInvestmentChoiceFinal = 'bdxInvestmentChoiceFinal',
  BdxWaiverAccepted = 'bdxWaiverAccepted',
  BinaryWalkthroughDeleted = 'binaryWalkthroughDeleted',
  BinaryWalkthroughProvided = 'binaryWalkthroughProvided',
  Blacklist = 'blacklist',
  Call = 'call',
  CancelledOwnCryptoTransaction = 'cancelledOwnCryptoTransaction',
  CancelWithdrawal = 'cancelWithdrawal',
  ChangedAdvancedSettingsToFollowersVisibility = 'changedAdvancedSettingsToFollowersVisibility',
  ChangedClientPotentialLevel = 'changedClientPotentialLevel',
  ChangedCompany = 'changedCompany',
  ChangeSettings = 'changeSettings',
  ClaimClientAgent = 'claimClientAgent',
  ClaimedReward = 'claimedReward',
  ClientBonusAcknowledged = 'clientBonusAcknowledged',
  ClientBonusLowEquityWarning = 'clientBonusLowEquityWarning',
  ClientCancelledDeposit = 'clientCancelledDeposit',
  ClientCancelledSubscription = 'clientCancelledSubscription',
  ClientCancelledVpsSubscription = 'clientCancelledVPSSubscription',
  ClientChangedSubscription = 'clientChangedSubscription',
  ClientChangedVpsSubscription = 'clientChangedVPSSubscription',
  ClientCheckedAgainstSanctions = 'clientCheckedAgainstSanctions',
  ClientCompetition = 'clientCompetition',
  ClientCreateDepositMethodIssueVerification = 'clientCreateDepositMethodIssueVerification',
  ClientCreatedSubscription = 'clientCreatedSubscription',
  ClientCreatedVpsSubscription = 'clientCreatedVPSSubscription',
  ClientEnabledSwapFree = 'clientEnabledSwapFree',
  ClientExitCompetition = 'clientExitCompetition',
  ClientExpiredEligibilityToRedeemPrize = 'clientExpiredEligibilityToRedeemPrize',
  ClientHasDifferentIpCountry = 'clientHasDifferentIpCountry',
  ClientHasMoreThanThreeUnverifiedCards = 'clientHasMoreThanThreeUnverifiedCards',
  ClientHasSameLastnameAndDob = 'clientHasSameLastnameAndDob',
  ClientHasSamePhoneNumber = 'clientHasSamePhoneNumber',
  ClientLinked = 'clientLinked',
  ClientLoginSuccess = 'clientLoginSuccess',
  ClientLoginVerificationSent = 'clientLoginVerificationSent',
  ClientLowMarginWarning = 'clientLowMarginWarning',
  ClientManuallyVerified = 'clientManuallyVerified',
  ClientReactivatedSubscription = 'clientReactivatedSubscription',
  ClientRedeemedPrize = 'clientRedeemedPrize',
  ClientRequestCopyTrading = 'clientRequestCopyTrading',
  ClientSourceOfFundsRequested = 'clientSourceOfFundsRequested',
  ClientTerminatedVpsSubscription = 'clientTerminatedVPSSubscription',
  ClientThirdPartyDocsRequested = 'clientThirdPartyDocsRequested',
  ClientUnlinked = 'clientUnlinked',
  ClientUpdatedSubscriptionBillingInfo = 'clientUpdatedSubscriptionBillingInfo',
  ClientUpdatedVpsSubscriptionBillingInfo = 'clientUpdatedVPSSubscriptionBillingInfo',
  CompleteClientCryptoTransaction = 'completeClientCryptoTransaction',
  CompleteClientDeposit = 'completeClientDeposit',
  CompleteDeposit = 'completeDeposit',
  CompletedOwnCryptoTransaction = 'completedOwnCryptoTransaction',
  CompleteOwnDepositWithPct = 'completeOwnDepositWithPCT',
  ConfirmOwnEmail = 'confirmOwnEmail',
  CopiedContactInfo = 'copiedContactInfo',
  CreateAdminBonusOffer = 'createAdminBonusOffer',
  CreateBonusDeposit = 'createBonusDeposit',
  CreateClientByApi = 'createClientByApi',
  CreateCryptoTransaction = 'createCryptoTransaction',
  CreatedAccount = 'createdAccount',
  CreateDeposit = 'createDeposit',
  CreateDocument = 'createDocument',
  CreateDueDiligence = 'createDueDiligence',
  CreateLead = 'createLead',
  CreateOwnAppropTest = 'createOwnAppropTest',
  CreateOwnDocument = 'createOwnDocument',
  CreateOwnDueDiligence = 'createOwnDueDiligence',
  CreateOwnSuitabilityTest = 'createOwnSuitabilityTest',
  CreatePartnersAppendix = 'createPartnersAppendix',
  CreateWithdrawal = 'createWithdrawal',
  CreateWithdrawalRequest = 'createWithdrawalRequest',
  DeletedAccount = 'deletedAccount',
  DepartmentEmailTemplateSent = 'departmentEmailTemplateSent',
  DetachedFromIb = 'detachedFromIB',
  DisabledAllowSocialTrading = 'disabledAllowSocialTrading',
  DisabledCopyTradingKeepClientBonuses = 'disabledCopyTradingKeepClientBonuses',
  DisabledCopyTradingSkipClientReadonly = 'disabledCopyTradingSkipClientReadonly',
  DisabledTradableBonus = 'disabledTradableBonus',
  EditedAccount = 'editedAccount',
  EditUserInfo = 'editUserInfo',
  EnabledAllowSocialTrading = 'enabledAllowSocialTrading',
  EnabledCopyTradingKeepClientBonuses = 'enabledCopyTradingKeepClientBonuses',
  EnabledCopyTradingSkipClientReadonly = 'enabledCopyTradingSkipClientReadonly',
  EnabledTradableBonus = 'enabledTradableBonus',
  FailDeposit = 'failDeposit',
  FailOwnDepositWithPct = 'failOwnDepositWithPCT',
  HasTradingAcademyAccess = 'hasTradingAcademyAccess',
  HoldDeposit = 'holdDeposit',
  HoldOwnDepositWithPct = 'holdOwnDepositWithPCT',
  HoldWithdrawal = 'holdWithdrawal',
  IbSpoaAuthorization = 'ibSpoaAuthorization',
  KycDocumentsNotificationFinalReminderSent = 'kycDocumentsNotificationFinalReminderSent',
  KycDocumentsNotificationReminderSent = 'kycDocumentsNotificationReminderSent',
  KycDocumentsNotificationSent = 'kycDocumentsNotificationSent',
  LogInAsClient = 'logInAsClient',
  LogInAsUser = 'logInAsUser',
  MarkedPaymentMethodThirdPartyVerified = 'markedPaymentMethodThirdPartyVerified',
  Mt4WalkthroughDeleted = 'mt4WalkthroughDeleted',
  Mt4WalkthroughProvided = 'mt4WalkthroughProvided',
  NotCompleteDeposit = 'notCompleteDeposit',
  NotCompleteOwnDepositWithPct = 'notCompleteOwnDepositWithPCT',
  Note = 'note',
  PartnerLoyaltyActivated = 'partnerLoyaltyActivated',
  PendingWithdrawal = 'pendingWithdrawal',
  PhoneVerificationInvalidPhone = 'phoneVerificationInvalidPhone',
  ProcessWithdrawal = 'processWithdrawal',
  RanAccountGbgCheck = 'ranAccountGBGCheck',
  RanElectronicIdVerificationCheck = 'ranElectronicIdVerificationCheck',
  RanSkrillVerification = 'ranSkrillVerification',
  ReferralActivated = 'referralActivated',
  RefundDeposit = 'refundDeposit',
  Registered = 'registered',
  RegistrationRejectedUsCitizen = 'registrationRejectedUsCitizen',
  RejectAdminBonusOffer = 'rejectAdminBonusOffer',
  RejectAppropTest = 'rejectAppropTest',
  RejectBonusDeposit = 'rejectBonusDeposit',
  RejectDeposit = 'rejectDeposit',
  RejectDocument = 'rejectDocument',
  RejectedMarginBonusTnc = 'rejectedMarginBonusTnc',
  RejectedTradableBonusTnc = 'rejectedTradableBonusTnc',
  RejectOwnBonusOffer = 'rejectOwnBonusOffer',
  RejectProfileChange = 'rejectProfileChange',
  RejectWithdrawal = 'rejectWithdrawal',
  ReleaseDeposit = 'releaseDeposit',
  RemoveBonusOfAccount = 'removeBonusOfAccount',
  RemoveDocument = 'removeDocument',
  RequestedPhoneVerificationCode = 'requestedPhoneVerificationCode',
  RequestedRevealEmail = 'requestedRevealEmail',
  RequestedRevealPhone = 'requestedRevealPhone',
  RequestedUpdatedDocuments = 'requestedUpdatedDocuments',
  RequestTranslation = 'requestTranslation',
  ResetClientPassword = 'resetClientPassword',
  ResetOwnForexPassword = 'resetOwnForexPassword',
  ResetPasswordAttempt = 'resetPasswordAttempt',
  ResetPasswordSuccess = 'resetPasswordSuccess',
  RevertDeposit = 'revertDeposit',
  RevertDocument = 'revertDocument',
  RevertDueDiligence = 'revertDueDiligence',
  RevertWithdrawal = 'revertWithdrawal',
  SalesClientNote = 'salesClientNote',
  SendClientSecurityCode = 'sendClientSecurityCode',
  SendInvitation = 'sendInvitation',
  SetClientConversionStatus = 'setClientConversionStatus',
  SetClientKycStatus = 'setClientKycStatus',
  SetClientTradingStatus = 'setClientTradingStatus',
  SetClientType = 'setClientType',
  SetOptinMarketing = 'setOptinMarketing',
  SetOptInSms = 'setOptInSms',
  SignedDocument = 'signedDocument',
  SpoaAuthorization = 'spoaAuthorization',
  SubmitTranslation = 'submitTranslation',
  TicketCreatedUnresolved = 'ticketCreatedUnresolved',
  TicketResolved = 'ticketResolved',
  ToggleAdditionalBonus = 'toggleAdditionalBonus',
  ToggleAffiliateAutomatedCommissions = 'toggleAffiliateAutomatedCommissions',
  ToggleAllowAccountManually = 'toggleAllowAccountManually',
  ToggleAllowNewAccounts = 'toggleAllowNewAccounts',
  ToggleAllowTransfers = 'toggleAllowTransfers',
  ToggleAutochartist = 'toggleAutochartist',
  ToggleBdxCallCompleted = 'toggleBDXCallCompleted',
  ToggleCanGrantSpoa = 'toggleCanGrantSpoa',
  ToggleCanIbTransfer = 'toggleCanIbTransfer',
  ToggleCopyTrading = 'toggleCopyTrading',
  ToggleDormantReactivation = 'toggleDormantReactivation',
  ToggleEffectiveFtd = 'toggleEffectiveFTD',
  ToggleEmailConfirmed = 'toggleEmailConfirmed',
  ToggleFundManager = 'toggleFundManager',
  ToggleHasHotAssets = 'toggleHasHotAssets',
  ToggleHasOpenComplaint = 'toggleHasOpenComplaint',
  ToggleHasPortfolioManagement = 'toggleHasPortfolioManagement',
  ToggleHasRawAccount = 'toggleHasRawAccount',
  ToggleHasTelegram = 'toggleHasTelegram',
  ToggleHasVipAccount = 'toggleHasVipAccount',
  ToggleHideMasterStrategies = 'toggleHideMasterStrategies',
  ToggleHideWdMethods = 'toggleHideWDMethods',
  ToggleIgnoreAutoMigration = 'toggleIgnoreAutoMigration',
  ToggleIgnoreIbTermination = 'toggleIgnoreIbTermination',
  ToggleisDirectIb = 'toggleisDirectIB',
  ToggleIsPhoneVerified = 'toggleIsPhoneVerified',
  ToggleManualWithdrawals = 'toggleManualWithdrawals',
  TogglePasswordProtectedStrategies = 'togglePasswordProtectedStrategies',
  TogglePasswordStrategy = 'togglePasswordStrategy',
  TogglePreSurvey = 'togglePreSurvey',
  ToggleProvideCopyTrading = 'toggleProvideCopyTrading',
  ToggleShowMasterStrategies = 'toggleShowMasterStrategies',
  ToggleSurvey = 'toggleSurvey',
  ToggleTopVip = 'toggleTopVip',
  ToggleTradeCompanion = 'toggleTradeCompanion',
  ToggleTradingCentral = 'toggleTradingCentral',
  ToggleUnderMonitoring = 'toggleUnderMonitoring',
  ToggleWithdrawalApprovals = 'toggleWithdrawalApprovals',
  UnassignClientAgent = 'unassignClientAgent',
  UnclaimClientAgent = 'unclaimClientAgent',
  UnderReviewProfileChange = 'underReviewProfileChange',
  UpdateAccountChecks = 'updateAccountChecks',
  UpdateAccountName = 'updateAccountName',
  UpdateClientDetails = 'updateClientDetails',
  UpdatedLeverage = 'updatedLeverage',
  UpdateDocument = 'updateDocument',
  UpdateDueDiligence = 'updateDueDiligence',
  UpdateEconomicProfile = 'updateEconomicProfile',
  UpdateOwnDetails = 'updateOwnDetails',
  UpdateOwnEmail = 'updateOwnEmail',
  UpdateOwnPassword = 'updateOwnPassword',
  UpdatePartnersAppendix = 'updatePartnersAppendix',
  UpdatePerformanceFee = 'updatePerformanceFee',
  UpdatePromotionalCountries = 'updatePromotionalCountries',
  UpdateWithdrawal = 'updateWithdrawal',
  UserAcceptedDepositMethodIssueVerification = 'userAcceptedDepositMethodIssueVerification',
  UserAutochartistCoelationEmail = 'userAutochartistCoelationEmail',
  UserAutochartistPlugin = 'userAutochartistPlugin',
  UserCancelledDeposit = 'userCancelledDeposit',
  UserCancelledVpsSubscription = 'userCancelledVPSSubscription',
  UserChangedSubscription = 'userChangedSubscription',
  UserChangedVpsSubscription = 'userChangedVPSSubscription',
  UserClosedAllTrades = 'userClosedAllTrades',
  UserCreatedAccount = 'userCreatedAccount',
  UserEditedFundingDocument = 'userEditedFundingDocument',
  UserRejectedDepositMethodIssueVerification = 'userRejectedDepositMethodIssueVerification',
  UserTerminatedVpsSubscription = 'userTerminatedVPSSubscription',
  UserUpdateCopyTrading = 'userUpdateCopyTrading',
  UserUpdatedLastEffectiveCall = 'userUpdatedLastEffectiveCall',
  VerifiedPhone = 'verifiedPhone',
  WebsiteWalkthroughDeleted = 'websiteWalkthroughDeleted',
  WebsiteWalkthroughProvided = 'websiteWalkthroughProvided'
}

/** List of user departments and client */
export enum UserDepartmentAndClientType {
  Accounting = 'accounting',
  Administration = 'administration',
  Affiliate = 'affiliate',
  Bdx = 'bdx',
  BoAccountOpening = 'boAccountOpening',
  BoFunding = 'boFunding',
  BusinessDevelopment = 'businessDevelopment',
  BusinessIntelligence = 'businessIntelligence',
  CallMonitoring = 'callMonitoring',
  Client = 'client',
  ClientRelationsTraining = 'clientRelationsTraining',
  Complaints = 'complaints',
  Compliance = 'compliance',
  Contractor = 'contractor',
  CustomerRelations = 'customerRelations',
  Dealing = 'dealing',
  Development = 'development',
  DirectorOfOperations = 'directorOfOperations',
  HumanResources = 'humanResources',
  Investment = 'investment',
  It = 'it',
  Management = 'management',
  Marketing = 'marketing',
  Office = 'office',
  PartnershipOperations = 'partnershipOperations',
  PaymentSolutions = 'paymentSolutions',
  Portfolio = 'portfolio',
  ProjectManagement = 'projectManagement',
  Receiption = 'receiption',
  Retention = 'retention',
  Risk = 'risk',
  Sales = 'sales',
  SalesOperations = 'salesOperations',
  SeniorManagement = 'seniorManagement',
  Shareholder = 'shareholder',
  Support = 'support',
  System = 'system'
}

/** Log of an actions made either by a user or a client */
export type ActivityLog = AccountCheckLog | AgentLog | AllowNewAccountCreationLog | ClientTypeLog | ComplianceLog | ConversionStatusLog | DiffLog | DocumentTranslationsLog | GenericLog | KycStatusLog | Note | SpoaLog | TradingStatusLog | TransferFundsLog | UnderMonitoringLog | WithReasonLog;

/** Account Check log */
export type AccountCheckLog = BaseLogInterface & {
  __typename?: 'AccountCheckLog';
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** GBGCheckResult */
  gbgCheckResult: Maybe<Scalars['String']['output']>;
  /** GBGCheckStatus */
  gbgStatus: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** SkrillVerificationResult */
  skrillVerificationResult: Maybe<Scalars['String']['output']>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

export type BaseLogInterface = {
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** A BDSwiss client */
export type Client = {
  __typename?: 'Client';
  acceptedTermsSpoaBonus: Maybe<Scalars['Boolean']['output']>;
  acceptEuMigrationTerms: Maybe<Scalars['String']['output']>;
  accountChecks: Maybe<AccountChecks>;
  /** Accounts belonging to this client */
  accounts: Maybe<Array<Maybe<Account>>>;
  /** Count of accounts belonging to this client */
  accountsCount: Maybe<Scalars['Int']['output']>;
  /** Acknowledged Notices for this client */
  acknowledgedNotices: Maybe<Array<Maybe<ClientNoticeAcknowledgementType>>>;
  activeDepositedAmount: Maybe<Scalars['Float']['output']>;
  /** Activity logs concerning this client */
  activityLogs: Maybe<Array<Maybe<ActivityLog>>>;
  /** Count of activity logs concerning this client */
  activityLogsCount: Maybe<Scalars['Int']['output']>;
  additionalBonus: Maybe<Scalars['Boolean']['output']>;
  /** Client's address of residence */
  address: Maybe<ClientAddress>;
  /** Affiliate client note */
  affiliateClientNote: Maybe<Scalars['String']['output']>;
  /** Countries promoted by the affiliates */
  affiliateCountries: Maybe<Array<Maybe<AffiliateCountriesType>>>;
  /** Whether the affiliate has approved PAMM */
  affiliateHasApprovedPAMM: Maybe<Scalars['Boolean']['output']>;
  /** Remote ID of the affiliate client of the current client */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** Affiliate currency */
  affiliatePAMMCurrency: Maybe<Currency>;
  /** Acceptance of Minimum Age Limit */
  ageAcceptance: Maybe<YesNo>;
  /** Date of acceptance of Minimum Age Limit */
  ageAcceptanceDate: Maybe<Scalars['DateTime']['output']>;
  agentEffectiveFTD: Maybe<Scalars['Boolean']['output']>;
  aggregatedBalanceEur: Maybe<Scalars['Float']['output']>;
  /** Alert logs concerning this client */
  alerts: Maybe<Array<Maybe<Alert>>>;
  /** Count of alerts concerning this client */
  alertsCount: Maybe<Scalars['Int']['output']>;
  allowCopyTrading: Maybe<Scalars['Boolean']['output']>;
  allowedAccountTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allowNewAccounts: Maybe<Scalars['Boolean']['output']>;
  allowSocialTrading: Maybe<Scalars['Boolean']['output']>;
  allowSwapFree: Maybe<Scalars['Boolean']['output']>;
  allowTransfers: Maybe<Scalars['Boolean']['output']>;
  /** Appointments for this client */
  appointments: Maybe<Array<Maybe<Appointment>>>;
  /** Count of appointments for this client */
  appointmentsCount: Maybe<Scalars['Int']['output']>;
  /** Tests answers submitted by client */
  appropTests: Maybe<Array<Maybe<AppropTest>>>;
  /** Tests answers submitted by client count */
  appropTestsCount: Maybe<Scalars['Int']['output']>;
  /** Date that this client was assigned to the relevant Sales Agent */
  assignedToAgent: Maybe<Scalars['DateTime']['output']>;
  authToken: Maybe<Scalars['String']['output']>;
  /** AutoChartist Coelation email opt-in */
  autoChartistCoelationEmail: Maybe<Scalars['Boolean']['output']>;
  /** AutoChartist emails opt-in */
  autoChartistEmails: Maybe<Scalars['Boolean']['output']>;
  autoChartistEnabled: Maybe<Scalars['Boolean']['output']>;
  /** AutoChartist plugin */
  autoChartistPlugin: Maybe<Scalars['Boolean']['output']>;
  autogeneratedPassword: Maybe<Scalars['Boolean']['output']>;
  /** Used for Strategic Partners */
  bdswissPartner: Maybe<Scalars['String']['output']>;
  bdxAcceptedNDA: Maybe<Scalars['Boolean']['output']>;
  bdxCallCompleted: Maybe<Scalars['Boolean']['output']>;
  bdxInvestmentChoice: Maybe<Scalars['String']['output']>;
  bdxInvestmentChoiceFinal: Maybe<Scalars['String']['output']>;
  bdxWaiverAccepted: Maybe<Scalars['Boolean']['output']>;
  /** Date of birth */
  birthday: Maybe<Scalars['String']['output']>;
  blockedPhoneBirthdayReveal: Maybe<Scalars['Boolean']['output']>;
  /** Bonuses offered to this client */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered to this client */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bonusTerms: Maybe<Scalars['String']['output']>;
  /** Call logs concerning this client */
  calls: Maybe<Array<Maybe<CallLog>>>;
  /** Count of activity logs concerning this client */
  callsCount: Maybe<Scalars['Int']['output']>;
  canEditLeverage: Maybe<Scalars['Boolean']['output']>;
  canGrantSpoa: Maybe<Scalars['Boolean']['output']>;
  canIbTransfer: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if approp test should be available */
  canProcessAppropTest: Maybe<Scalars['Boolean']['output']>;
  /** Automatically computed flag whether the client can trade on real account */
  canTrade: Maybe<Scalars['Boolean']['output']>;
  clientAllowCopyTrading: Maybe<Scalars['Boolean']['output']>;
  /** Client accounts from all bdswiss brands */
  clientBrandAccounts: Maybe<Array<Maybe<Account>>>;
  clientCopyTrading: Maybe<Scalars['Boolean']['output']>;
  /** Client's type */
  clientType: Maybe<ClientType>;
  /** Communications for this client */
  communications: Maybe<Array<Maybe<Communication>>>;
  /** Count of activity logs concerning this client */
  communicationsCount: Maybe<Scalars['Int']['output']>;
  /** Company client belongs to */
  company: Maybe<Scalars['String']['output']>;
  /** Company frontend url */
  companyFrontEndUrl: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyRegistrationNumber: Maybe<Scalars['String']['output']>;
  /** Applicable competitions of this client */
  competitions: Maybe<Array<Maybe<Competition>>>;
  /** Applicable competitions of this client */
  competitionsCount: Maybe<Scalars['Int']['output']>;
  /** Client already in competition winners */
  competitionWinners: Maybe<Scalars['Boolean']['output']>;
  /** Client's sales status */
  conversionStatus: Maybe<ConversionStatus>;
  /** Client's conversion step */
  conversionStep: Maybe<ConversionStep>;
  /** Timestamp of client convertion from unregistered lead */
  convertedAt: Maybe<Scalars['DateTime']['output']>;
  /** JSON array with campaign cookie entries */
  cookiePath: Maybe<Scalars['String']['output']>;
  copyTradingKeepClientBonuses: Maybe<Scalars['Boolean']['output']>;
  copyTradingShareOffersWithAffiliateTree: Maybe<Scalars['Boolean']['output']>;
  copyTradingShowAffiliateTreeStrategies: Maybe<Scalars['Boolean']['output']>;
  copyTradingSkipClientReadonly: Maybe<Scalars['Boolean']['output']>;
  correspondenceAddress: Maybe<ClientAddress>;
  /** Created at */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Client custom domain */
  customDomain: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Total amount of money deposited by client */
  depositedAmount: Maybe<Scalars['Float']['output']>;
  /** Currency of deposited amount */
  depositedAmountCurrency: Maybe<Currency>;
  /** Deposit Method Issue Verifications for the client */
  depositMethodIssueVerifications: Maybe<Array<Maybe<DepositMethodIssueVerification>>>;
  /** Count of Deposit Method Issue Verification in "In review" status */
  depositMethodIssueVerificationsInReviewCount: Maybe<Scalars['Int']['output']>;
  /** Deposits made by this client */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made by this client */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** List of banks available dlocal by country */
  dlocalBanksList: Maybe<Array<Maybe<DlocalBanks>>>;
  /** KYC documents uploaded for this client */
  documents: Maybe<Array<Maybe<Document>>>;
  /** Count of KYC documents uploaded for this client */
  documentsCount: Maybe<Scalars['Int']['output']>;
  /** Document translations for this client */
  documentTranslations: Maybe<Array<Maybe<DocumentTranslationType>>>;
  /** Count of document translations for this client */
  documentTranslationsCount: Maybe<Scalars['Int']['output']>;
  dormantReactivation: Maybe<Scalars['Boolean']['output']>;
  /** Due diligence answers submitted by client */
  dueDiligences: Maybe<Array<Maybe<DueDiligence>>>;
  /** Due diligences submitted by client count */
  dueDiligencesCount: Maybe<Scalars['Int']['output']>;
  economicProfileDocs: Maybe<EconomicProfileDocs>;
  eIdVerificationApplicable: Maybe<Scalars['Boolean']['output']>;
  eIdVerificationResults: Maybe<Array<Maybe<ElectronicIdentityVerificationResultType>>>;
  eligibleBonus: Maybe<EligibleBonusTypeType>;
  /** Email address */
  email: Maybe<Scalars['String']['output']>;
  /** Whether the client confirmed his email */
  emailConfirmed: Maybe<Scalars['Boolean']['output']>;
  /** Pending email change waiting for a confirmation */
  emailPendingChange: Maybe<Scalars['String']['output']>;
  /** Acceptance of Customer Agreement */
  eulaAcceptance: Maybe<YesNo>;
  /** Date of acceptance of Customer Agreement */
  eulaAcceptanceDate: Maybe<Scalars['DateTime']['output']>;
  euMigration: Maybe<Scalars['Boolean']['output']>;
  /** External agent assigned to this client */
  externalAgent: Maybe<User>;
  /** Whether the client should be redirected elsewhere for document verification */
  externalVerificationUrl: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName: Maybe<Scalars['String']['output']>;
  fromCompany: Maybe<Company>;
  /** FTD Date for this client */
  ftdDate: Maybe<Scalars['DateTime']['output']>;
  fundManager: Maybe<Scalars['Boolean']['output']>;
  /** Client's gender */
  gender: Maybe<Gender>;
  /** General client note */
  generalClientNote: Maybe<Scalars['String']['output']>;
  /** General client withdrawal note */
  generalWithdrawalNote: Maybe<Scalars['String']['output']>;
  /** Last Login Country */
  getLastLoggedInCountry: Maybe<Country>;
  /** Global's Client Questionnaire */
  globalQuestionnaire: Maybe<GlobalQuestionnaire>;
  /** Has campaign */
  hasCampaign: Maybe<Scalars['Boolean']['output']>;
  hasDisabledWithdrawals: Maybe<Scalars['Boolean']['output']>;
  hasHotAssets: Maybe<Scalars['Boolean']['output']>;
  hasJMSharedDrive: Maybe<Scalars['Boolean']['output']>;
  hasOpenComplaint: Maybe<Scalars['Boolean']['output']>;
  hasPartnerAccount: Maybe<Scalars['Boolean']['output']>;
  hasPortfolioManagement: Maybe<Scalars['Boolean']['output']>;
  hasPreSurvey: Maybe<Scalars['Boolean']['output']>;
  hasRawAccount: Maybe<Scalars['Boolean']['output']>;
  hasSpotOptionCFD: Maybe<Scalars['Boolean']['output']>;
  hasSurvey: Maybe<Scalars['Boolean']['output']>;
  hasTelegram: Maybe<Scalars['Boolean']['output']>;
  hasTradingAcademyAccess: Maybe<Scalars['Boolean']['output']>;
  hasVipAccount: Maybe<Scalars['Boolean']['output']>;
  /** Existing Subscription Customer */
  hasVpsSubscription: Maybe<Scalars['Boolean']['output']>;
  hideWDMethods: Maybe<Scalars['Boolean']['output']>;
  ibId: Maybe<Scalars['String']['output']>;
  ibReferrerAccount: Maybe<BaseAccount>;
  /** Client ID */
  id: Maybe<Scalars['Int']['output']>;
  ignoreAutoMigration: Maybe<Scalars['Boolean']['output']>;
  ignoreIbTermination: Maybe<Scalars['Boolean']['output']>;
  isDirectIB: Maybe<Scalars['Boolean']['output']>;
  isEmailVerificationRequired: Maybe<Scalars['Boolean']['output']>;
  /** User's online status */
  isOnline: Maybe<Scalars['Boolean']['output']>;
  isParticipantOfSocialTrading: Maybe<Scalars['Boolean']['output']>;
  isPhoneVerificationRequired: Maybe<Scalars['Boolean']['output']>;
  /** Flag to Check telephone number is verified */
  isPhoneVerified: Maybe<Scalars['Boolean']['output']>;
  /** Whether user is in Agent Pool */
  isPool: Maybe<Scalars['Boolean']['output']>;
  /** Does Client have passwprd as per new requirement */
  isResetClientPassword: Maybe<Scalars['Boolean']['output']>;
  isTradableBonusPartner: Maybe<Scalars['Boolean']['output']>;
  kycDeadline: Maybe<Scalars['DateTime']['output']>;
  /** KYC Status */
  kycStatus: Maybe<KycStatus>;
  /** KYC Status */
  kycStatusDescription: Maybe<Scalars['String']['output']>;
  /** KYC Status Reason */
  kycStatusReason: Maybe<Scalars['String']['output']>;
  /** KYC Rejection Reason Code */
  kycStatusReasonCode: Maybe<KycRejectionReason>;
  /** KYC Status */
  kycStatusReasonDescription: Maybe<Scalars['String']['output']>;
  /** Client's language */
  language: Maybe<Language>;
  lastEffectiveCall: Maybe<Scalars['DateTime']['output']>;
  /** Last successful login */
  lastLogin: Maybe<Scalars['DateTime']['output']>;
  /** Last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** Date of the last note for the client */
  lastNote: Maybe<Scalars['DateTime']['output']>;
  /** Last registration campaign of this client */
  lastRegistrationCampaign: Maybe<Array<Maybe<Withdrawal>>>;
  lastUpdatedJMSharedDrive: Maybe<Scalars['DateTime']['output']>;
  /** Legacy test answers submitted by client */
  legacyAppropTest: Maybe<LegacyAppropTest>;
  licenseAcknowledgement: Maybe<Scalars['DateTime']['output']>;
  linkedPartnerClientId: Maybe<Scalars['Int']['output']>;
  linkedPartnerClientName: Maybe<Scalars['String']['output']>;
  linkedRetailClientId: Maybe<Scalars['Int']['output']>;
  linkedRetailClientName: Maybe<Scalars['String']['output']>;
  /** Client locale - used to set currency, language, timezone */
  locale: Maybe<Locale>;
  manuallyAllowedAccounts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Existing VPS PLan */
  manualVpsPlan: Maybe<Scalars['String']['output']>;
  manualWithdrawals: Maybe<Scalars['Boolean']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** MIFIR ID for this client */
  mifirId: Maybe<Scalars['String']['output']>;
  /** MIFIR Type for this client */
  mifirType: Maybe<Scalars['String']['output']>;
  migratedAt: Maybe<Scalars['DateTime']['output']>;
  /** Minimum amount of money the client can deposit */
  minimumDeposits: Maybe<Array<Maybe<MinimumDeposit>>>;
  missingDocuments: Maybe<Scalars['String']['output']>;
  missingEP: Maybe<Scalars['Boolean']['output']>;
  multipleRegulation: Maybe<Scalars['Boolean']['output']>;
  multiRegulationClientId: Maybe<Scalars['Int']['output']>;
  /** Client's nationality */
  nationality: Maybe<Nationality>;
  nationalityDescription: Maybe<Scalars['String']['output']>;
  /** Date of the next appointment of the client */
  nextAppointment: Maybe<Scalars['DateTime']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  nonDepositorUser: Maybe<Scalars['Boolean']['output']>;
  /** Notes about this client */
  notes: Maybe<Array<Maybe<Note>>>;
  /** Count of notes about this client */
  notesCount: Maybe<Scalars['Int']['output']>;
  oauthId: Maybe<Scalars['String']['output']>;
  /** True if member is ready to place (or already placed) the first trade. */
  onbooardingComplete: Maybe<Scalars['Boolean']['output']>;
  /** GDPR Opt In Marketing */
  optInMarketing: Maybe<Scalars['Boolean']['output']>;
  /** GDPR Opt In SMS */
  optInSms: Maybe<Scalars['Boolean']['output']>;
  /** Client originated from Mobile App */
  originatedFromMobile: Maybe<Scalars['Boolean']['output']>;
  originType: Maybe<Scalars['String']['output']>;
  /** Used for Strategic Partners */
  otherCompany: Maybe<Scalars['String']['output']>;
  pammMMAccount: Maybe<BaseAccount>;
  parentIbId: Maybe<Scalars['String']['output']>;
  partnerCustomizations: Maybe<Array<Maybe<PartnerCustomizationType>>>;
  partnerIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Partners loyalty data */
  partnersLoyalty: Maybe<Array<Maybe<PartnersLoyalty>>>;
  /** Partners Loyalty Analytics data from BI */
  partnersLoyaltyAnalytics: Maybe<Array<Maybe<PartnersLoyaltyAnalytics>>>;
  /** ID number */
  passportNumber: Maybe<Scalars['String']['output']>;
  /** Payment card tokens belonging to this client */
  paymentCardTokens: Maybe<Array<Maybe<PaymentCardToken>>>;
  /** Count of payment card tokens belonging to this client */
  paymentCardTokensCount: Maybe<Scalars['Int']['output']>;
  /** Payment methods used by the client */
  paymentMethods: Maybe<Array<Maybe<PaymentMethod>>>;
  /** Has pending Login Verification */
  pendingLoginVerification: Maybe<Scalars['Boolean']['output']>;
  /** Unread client messages for this client */
  pendingMessages: Maybe<Array<Maybe<ClientMessageType>>>;
  /** Pending Notices for this client */
  pendingNotices: Maybe<Array<Maybe<PendingClientNoticeType>>>;
  /** Pending Notices Count for this client */
  pendingNoticesCount: Maybe<Scalars['Int']['output']>;
  pendingUploadDocuments: Maybe<PendingUploadDocumentsType>;
  /** Periods in each company for this client */
  periodsInEachCompany: Maybe<Array<Maybe<PeriodInEachCompanyType>>>;
  /** Legal document identifying client such as Passport or National ID. */
  personalId: Maybe<PersonalIdType>;
  /** Contact telephone number */
  phone: Maybe<Scalars['String']['output']>;
  /** Client Potential Level */
  potentialLevel: Maybe<PotentialLevel>;
  /** Premier eligibility */
  premierEligibility: Maybe<Scalars['Boolean']['output']>;
  /** Previous names */
  previousNames: Maybe<Scalars['String']['output']>;
  /** Used for Strategic Partners */
  priority: Maybe<Scalars['String']['output']>;
  /** Acceptance of Privacy Policy */
  privacyAcceptance: Maybe<YesNo>;
  /** Date of acceptance of Privacy Policy */
  privacyAcceptanceDate: Maybe<Scalars['DateTime']['output']>;
  /** Profile changes submitted by client */
  profileChanges: Maybe<Array<Maybe<ProfileChange>>>;
  /** Count of profile changes submitted by client */
  profileChangesCount: Maybe<Scalars['Int']['output']>;
  /** Promotion code used during signup */
  promocode: Maybe<Scalars['String']['output']>;
  /** Extra properties of the member */
  properties: Maybe<ClientProperties>;
  referAndEarn: Maybe<Scalars['Boolean']['output']>;
  referralDetails: Maybe<ReferralDetailsType>;
  referredBy: Maybe<Client>;
  /** Registration date - but no earlier than 2/2/2016 */
  registration: Maybe<Scalars['DateTime']['output']>;
  /** Campaign the client registered with */
  registrationCampaigns: Maybe<Array<Maybe<RegistrationCampaign>>>;
  /** Count of campaigns the client registered with  */
  registrationCampaignsCount: Maybe<Scalars['Int']['output']>;
  /** Acceptance of Regulation */
  regulationAcceptance: Maybe<Scalars['DateTime']['output']>;
  /** Acceptance of Risk Disclaimer */
  riskAcceptance: Maybe<YesNo>;
  /** Date of acceptance of Risk Disclaimer */
  riskAcceptanceDate: Maybe<Scalars['DateTime']['output']>;
  /** Risk data */
  riskData: Maybe<ClientRiskData>;
  /** Sales agent assigned to this client */
  salesAgent: Maybe<User>;
  /** Sales client note */
  salesClientNote: Maybe<Scalars['String']['output']>;
  /** Secondary Emails */
  secondaryEmails: Maybe<SecondaryEmails>;
  /** Secondary Phones */
  secondaryPhones: Maybe<SecondaryPhones>;
  showAdvancedSettingsForSelf: Maybe<Scalars['Boolean']['output']>;
  showAdvancedSettingsToFollowers: Maybe<Scalars['Boolean']['output']>;
  showMasterStrategies: Maybe<Scalars['Boolean']['output']>;
  showPasswordProtectedStrategies: Maybe<Scalars['Boolean']['output']>;
  signableNoticeAckSignatures: Maybe<Array<Maybe<NoticeAcknowledgementSignatureType>>>;
  /** Swissmarkets: Signup step the client has completed */
  signupStep: Maybe<Scalars['String']['output']>;
  /** SkypeID */
  skypeId: Maybe<Scalars['String']['output']>;
  /** Solicitation Acceptance */
  solicitationAcceptance: Maybe<YesNo>;
  /** Date of Solicitation Acceptance */
  solicitationAcceptanceDate: Maybe<Scalars['DateTime']['output']>;
  /** SPOA Remote Client */
  spoaRemoteClient: Maybe<SpoaRemoteClient>;
  /** SPOA Remote ID */
  spoaRemoteId: Maybe<Scalars['Int']['output']>;
  /** Suitability test submitted by client */
  suitabilityTests: Maybe<Array<Maybe<SuitabilityTest>>>;
  /** Suitability tests submitted by client count */
  suitabilityTestsCount: Maybe<Scalars['Int']['output']>;
  /** Support agent assigned to this client */
  supportAgent: Maybe<User>;
  /** I18n Trading Status Reason */
  suspendStatusReasonDescription: Maybe<Scalars['String']['output']>;
  swapFree: Maybe<Scalars['Boolean']['output']>;
  /** Client tag */
  tags: Maybe<Array<Maybe<Tag>>>;
  terminationDate: Maybe<Scalars['DateTime']['output']>;
  /** Theme Preference */
  themePreference: Maybe<ThemePreference>;
  /** Used for Strategic Partners */
  title: Maybe<Scalars['String']['output']>;
  topVip: Maybe<Scalars['Boolean']['output']>;
  totalDeposits: Maybe<Array<Maybe<TotalDepositsType>>>;
  totalSubscriptions: Maybe<Array<Maybe<TotalDepositsType>>>;
  totalTransfers: Maybe<Array<Maybe<TotalDepositsType>>>;
  totalWithdrawals: Maybe<Array<Maybe<TotalDepositsType>>>;
  /** Track Events for client */
  trackEvents: Maybe<Array<Maybe<TrackEvent>>>;
  /** Track Events count for client */
  trackEventsCount: Maybe<Scalars['Int']['output']>;
  tradeCompanionEnabled: Maybe<Scalars['Boolean']['output']>;
  tradeCompanionNotificationClose: Maybe<Scalars['Boolean']['output']>;
  tradeCompanionTableauUser: Maybe<Scalars['String']['output']>;
  tradingCentralEnabled: Maybe<Scalars['Boolean']['output']>;
  tradingConfig: TradingConfigType;
  /** Trading Status */
  tradingStatus: Maybe<TradingStatus>;
  /** Trading Status Reason */
  tradingStatusReason: Maybe<Scalars['String']['output']>;
  /** Trading Status Reason Code */
  tradingStatusReasonCode: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Number of transactions made from / to this account */
  transactionsCount: Maybe<Scalars['Int']['output']>;
  underMonitoring: Maybe<Scalars['Boolean']['output']>;
  /** Under Monitoring Reason */
  underMonitoringReason: Maybe<Scalars['String']['output']>;
  /** Under Monitoring Reason Code */
  underMonitoringReasonCode: Maybe<UnderMonitoringReason>;
  /** Email address */
  unmaskedEmail: Maybe<Scalars['String']['output']>;
  /** Timestamp of last change to client record */
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userCopyTrading: Maybe<Scalars['Boolean']['output']>;
  verificationActions: Maybe<VerificationActionsType>;
  verificationStatus: Maybe<VerificationStatus>;
  /** Client applied for vps */
  vps: Maybe<Scalars['Boolean']['output']>;
  /** VPS Subscriptions belong to this client */
  vpsSubscriptions: Maybe<Array<Maybe<VpsSubscription>>>;
  /** Count of VPS Subscriptions made by this client */
  vpsSubscriptionsCount: Maybe<Scalars['Int']['output']>;
  /** Walkthroughs provided to client */
  walkthroughs: Maybe<Array<Maybe<Walkthrough>>>;
  /** Website */
  website: Maybe<Scalars['String']['output']>;
  /** WhiteLabel client belongs to */
  whiteLabel: Maybe<Scalars['String']['output']>;
  /** Whitelabel config */
  whiteLabelConfig: Maybe<WhiteLabelConfig>;
  withdrawalFromDepositFields: Maybe<WithdrawalFromDepositFieldsType>;
  /** Withdrawal requests made by this client */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made by this client */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
  workflow: Maybe<Array<Maybe<WorkflowEvent>>>;
};


/** A BDSwiss client */
export type ClientAccountsArgs = {
  hidden: InputMaybe<Scalars['Boolean']['input']>;
  hideInactiveArchived: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  includeDeleted: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  productIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rejected: InputMaybe<Scalars['Boolean']['input']>;
  remoteId: InputMaybe<Scalars['Int']['input']>;
};


/** A BDSwiss client */
export type ClientAccountsCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
};


/** A BDSwiss client */
export type ClientActivityLogsArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


/** A BDSwiss client */
export type ClientActivityLogsCountArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


/** A BDSwiss client */
export type ClientAlertsArgs = {
  balanceFrom: InputMaybe<Scalars['Float']['input']>;
  balanceTo: InputMaybe<Scalars['Float']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositFrom: InputMaybe<Scalars['Float']['input']>;
  depositTo: InputMaybe<Scalars['Float']['input']>;
  lastLogin: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<AlertsOrderByType>;
  orderDirection: InputMaybe<OrderDirection>;
  postponeUntil: InputMaybe<Scalars['DateTime']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<AlertStatusesType>>>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  tradingStatuses: InputMaybe<Array<InputMaybe<TradingStatus>>>;
  types: InputMaybe<Array<InputMaybe<AlertReasonTypes>>>;
};


/** A BDSwiss client */
export type ClientAppointmentsArgs = {
  isDismissed: InputMaybe<Scalars['Boolean']['input']>;
  isNew: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<AppointmentsOrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  startFrom: InputMaybe<Scalars['DateTime']['input']>;
  startTo: InputMaybe<Scalars['DateTime']['input']>;
  userId: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** A BDSwiss client */
export type ClientAppointmentsCountArgs = {
  isDismissed: InputMaybe<Scalars['Boolean']['input']>;
  isNew: InputMaybe<Scalars['Boolean']['input']>;
  startFrom: InputMaybe<Scalars['DateTime']['input']>;
  startTo: InputMaybe<Scalars['DateTime']['input']>;
  userId: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** A BDSwiss client */
export type ClientAppropTestsArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  kycStatus: InputMaybe<KycStatus>;
  kycStatuses: InputMaybe<Array<InputMaybe<KycStatus>>>;
  lastUpdated: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<AppropTestStatus>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
};


/** A BDSwiss client */
export type ClientAppropTestsCountArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  kycStatus: InputMaybe<KycStatus>;
  kycStatuses: InputMaybe<Array<InputMaybe<KycStatus>>>;
  lastUpdated: InputMaybe<Scalars['DateTime']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<AppropTestStatus>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
};


/** A BDSwiss client */
export type ClientBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** A BDSwiss client */
export type ClientBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** A BDSwiss client */
export type ClientCallsArgs = {
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  endedAt: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  maxDuration: InputMaybe<Scalars['Int']['input']>;
  maxScore: InputMaybe<Scalars['Float']['input']>;
  minDuration: InputMaybe<Scalars['Int']['input']>;
  minScore: InputMaybe<Scalars['Float']['input']>;
  monitoredOnly: InputMaybe<Scalars['Boolean']['input']>;
  monitoringAgent: InputMaybe<Scalars['Int']['input']>;
  needsComplianceCheck: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
  startedAt: InputMaybe<Scalars['DateTime']['input']>;
  userId: InputMaybe<Scalars['Int']['input']>;
};


/** A BDSwiss client */
export type ClientClientBrandAccountsArgs = {
  clientId: Scalars['Int']['input'];
};


/** A BDSwiss client */
export type ClientCommunicationsArgs = {
  channels: InputMaybe<Array<InputMaybe<CommunicationChannelType>>>;
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  departments: InputMaybe<Array<InputMaybe<CommunicationDepartmentType>>>;
  excludeAutomatedEmails: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  types: InputMaybe<Array<InputMaybe<CommunicationTypeType>>>;
};


/** A BDSwiss client */
export type ClientCommunicationsCountArgs = {
  channels: InputMaybe<Array<InputMaybe<CommunicationChannelType>>>;
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  departments: InputMaybe<Array<InputMaybe<CommunicationDepartmentType>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  excludeAutomatedEmails: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  types: InputMaybe<Array<InputMaybe<CommunicationTypeType>>>;
};


/** A BDSwiss client */
export type ClientDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** A BDSwiss client */
export type ClientDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** A BDSwiss client */
export type ClientDocumentsArgs = {
  assignee: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  hasPendingWithdrawals: InputMaybe<Scalars['Boolean']['input']>;
  isDepositor: InputMaybe<Scalars['Boolean']['input']>;
  kycStatus: InputMaybe<KycStatus>;
  kycStatuses: InputMaybe<Array<InputMaybe<KycStatus>>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchDocId: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<DocumentStatus>;
  statuses: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  tradingStatuses: InputMaybe<Array<InputMaybe<TradingStatus>>>;
  types: InputMaybe<Array<InputMaybe<DocumentType>>>;
};


/** A BDSwiss client */
export type ClientDocumentsCountArgs = {
  assignee: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  expirationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  expirationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  hasPendingWithdrawals: InputMaybe<Scalars['Boolean']['input']>;
  isDepositor: InputMaybe<Scalars['Boolean']['input']>;
  kycStatus: InputMaybe<KycStatus>;
  kycStatuses: InputMaybe<Array<InputMaybe<KycStatus>>>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchDocId: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<DocumentStatus>;
  statuses: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  tradingStatuses: InputMaybe<Array<InputMaybe<TradingStatus>>>;
  types: InputMaybe<Array<InputMaybe<DocumentType>>>;
};


/** A BDSwiss client */
export type ClientDocumentTranslationsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
};


/** A BDSwiss client */
export type ClientDocumentTranslationsCountArgs = {
  search: InputMaybe<Scalars['String']['input']>;
};


/** A BDSwiss client */
export type ClientDueDiligencesArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdated: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  status: InputMaybe<DueDiligenceStatusType>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
};


/** A BDSwiss client */
export type ClientDueDiligencesCountArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated: InputMaybe<Scalars['DateTime']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  status: InputMaybe<DueDiligenceStatusType>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
};


/** A BDSwiss client */
export type ClientHasCampaignArgs = {
  hasCampaignId: InputMaybe<Scalars['Int']['input']>;
};


/** A BDSwiss client */
export type ClientLastRegistrationCampaignArgs = {
  affiliateId: Scalars['Int']['input'];
};


/** A BDSwiss client */
export type ClientNotesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


/** A BDSwiss client */
export type ClientPartnersLoyaltyAnalyticsArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
};


/** A BDSwiss client */
export type ClientPaymentCardTokensArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<PaymentCardTokenStatus>;
};


/** A BDSwiss client */
export type ClientPaymentCardTokensCountArgs = {
  status: InputMaybe<PaymentCardTokenStatus>;
};


/** A BDSwiss client */
export type ClientPaymentMethodsArgs = {
  depositId: InputMaybe<Scalars['Int']['input']>;
};


/** A BDSwiss client */
export type ClientProfileChangesArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  priorityProfileChange: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<ProfileChangeStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  toOrFromCountry: InputMaybe<Country>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
};


/** A BDSwiss client */
export type ClientProfileChangesCountArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  priorityProfileChange: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<ProfileChangeStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  toOrFromCountry: InputMaybe<Country>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
};


/** A BDSwiss client */
export type ClientReferralDetailsArgs = {
  platform: InputMaybe<Scalars['String']['input']>;
};


/** A BDSwiss client */
export type ClientRegistrationCampaignsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


/** A BDSwiss client */
export type ClientSuitabilityTestsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


/** A BDSwiss client */
export type ClientSuitabilityTestsCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
};


/** A BDSwiss client */
export type ClientTrackEventsArgs = {
  attended: InputMaybe<Scalars['Boolean']['input']>;
  eventType: InputMaybe<TrackEventType>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  search: InputMaybe<Scalars['String']['input']>;
  subCampId: InputMaybe<Scalars['String']['input']>;
};


/** A BDSwiss client */
export type ClientTrackEventsCountArgs = {
  attended: InputMaybe<Scalars['Boolean']['input']>;
  eventType: InputMaybe<TrackEventType>;
  search: InputMaybe<Scalars['String']['input']>;
  subCampId: InputMaybe<Scalars['String']['input']>;
};


/** A BDSwiss client */
export type ClientTransactionsArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  depositStatus: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  depositVendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
  dpCreatedFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  dpCreatedToFilter: InputMaybe<Scalars['DateTime']['input']>;
  hasPartialRefunds: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
  withdrawalStatus: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  withdrawalTypes: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  withdrawalVendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** A BDSwiss client */
export type ClientTransactionsCountArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  depositStatus: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  depositVendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
  dpCreatedFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  dpCreatedToFilter: InputMaybe<Scalars['DateTime']['input']>;
  hasPartialRefunds: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<TransactionType>;
  withdrawalStatus: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  withdrawalTypes: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  withdrawalVendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** A BDSwiss client */
export type ClientVpsSubscriptionsCountArgs = {
  deleted: InputMaybe<Scalars['Boolean']['input']>;
  memberId: InputMaybe<Scalars['Int']['input']>;
  status: InputMaybe<Array<InputMaybe<VpsSubscriptionStatuse>>>;
  type: InputMaybe<Array<InputMaybe<VpsSubscriptionType>>>;
};


/** A BDSwiss client */
export type ClientWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** A BDSwiss client */
export type ClientWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type AccountChecks = {
  __typename?: 'AccountChecks';
  /** Client's categorization for internal purposes */
  clientCategory: Maybe<ClientCategory>;
  /** Client GBG */
  clientGBG: Maybe<ClientGbgType>;
  /** GBG Check Result */
  gbgCheckResult: Maybe<Scalars['String']['output']>;
  /** Client in in-house watchlists */
  inWatchlists: Maybe<YesNo>;
  /** Client in in-house watchlists date */
  inWatchlistsDate: Maybe<Scalars['DateTime']['output']>;
  /** Official Name */
  officialName: Maybe<Scalars['String']['output']>;
  /** 15 Days Policy Check */
  policy15Days: Maybe<YesNo>;
  /** Is client politically exposed person? */
  politicallyExposedPerson: Maybe<YesNo>;
  /** Client's risk categorization for internal purposes */
  riskCategory: Maybe<RiskCategory>;
  /** Client's risk sub categorization for internal purposes */
  riskSubCategory: Maybe<RiskSubCategory>;
  /** Is client in World-Check database? */
  worldCheck: Maybe<YesNo>;
};

/** List of client categories */
export enum ClientCategory {
  EligibleCounterparty = 'eligibleCounterparty',
  Professional = 'professional',
  Retail = 'retail'
}

/** List of client GBG Types */
export enum ClientGbgType {
  Alert = 'alert',
  Pass = 'pass',
  Refer = 'refer'
}

export enum YesNo {
  No = 'no',
  Yes = 'yes'
}

/** List of risk categories */
export enum RiskCategory {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  Normal = 'normal'
}

/** List of risk sub categories */
export enum RiskSubCategory {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

/** Client Notice Acknowledgements */
export type ClientNoticeAcknowledgementType = {
  __typename?: 'clientNoticeAcknowledgementType';
  /** Acknowledgement Type */
  acknowledgementType: Maybe<ClientNoticeAcknowlegdementTypeType>;
  /** Client */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  /** Notice */
  notice: Maybe<ClientNoticeType>;
};

/** Client Notice Acknowledgement Types */
export enum ClientNoticeAcknowlegdementTypeType {
  Accepted = 'accepted',
  Declined = 'declined',
  Dismissed = 'dismissed',
  RemindLater = 'remindLater',
  Seen = 'seen'
}

/** Client Notice */
export type ClientNoticeType = {
  __typename?: 'clientNoticeType';
  /** Notice Applicable Companies */
  applicableCompanies: Maybe<Array<Maybe<Company>>>;
  /** Notice Applicable Countries */
  applicableCountries: Maybe<Array<Maybe<Country>>>;
  /** Available Client Types */
  availableClientTypes: Maybe<Array<Maybe<ClientType>>>;
  /** Notice Content */
  content: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Client Notice ID */
  id: Maybe<Scalars['Int']['output']>;
  isContentHtml: Maybe<Scalars['Boolean']['output']>;
  localizationKey: Maybe<Scalars['String']['output']>;
  noticePeriod: Maybe<Scalars['String']['output']>;
  /** Internal Reference Code */
  referenceCode: Maybe<Scalars['String']['output']>;
  template: Maybe<PartnersAppendicesTypeType>;
  /** Notice Title */
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<ClientNoticeTypeType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Valid from date */
  validFromDate: Maybe<Scalars['DateTime']['output']>;
  validUntil: Maybe<Scalars['DateTime']['output']>;
  /** Values on partners appendices */
  values: Maybe<Scalars['String']['output']>;
  /** Notice Type Version */
  version: Maybe<Scalars['String']['output']>;
};

export enum ClientType {
  Affiliate = 'affiliate',
  AffiliateCorporate = 'affiliateCorporate',
  ColdLead = 'coldLead',
  Corporate = 'corporate',
  EligibleCounterParty = 'eligibleCounterParty',
  FundAgent = 'fundAgent',
  FundInvestor = 'fundInvestor',
  Hybrid = 'hybrid',
  Ib = 'ib',
  IbCorporate = 'ibCorporate',
  JointAccount = 'jointAccount',
  Merchant = 'merchant',
  Professional = 'professional',
  Retail = 'retail',
  StrategicPartner = 'strategicPartner',
  TestClient = 'testClient'
}

/** Partners Appendices Types */
export enum PartnersAppendicesTypeType {
  Cpa = 'cpa',
  Hybrid = 'hybrid',
  RevShare = 'revShare'
}

/** Client Notice Types */
export enum ClientNoticeTypeType {
  Informative = 'informative',
  Partners = 'partners',
  Popup = 'popup',
  TermsChange = 'termsChange'
}

export type ClientAddress = {
  __typename?: 'ClientAddress';
  /** Address: City */
  city: Maybe<Scalars['String']['output']>;
  /** Country */
  country: Maybe<Country>;
  countryDescription: Maybe<Scalars['String']['output']>;
  /** Address: House Number */
  houseNumber: Maybe<Scalars['String']['output']>;
  /** Address: Street */
  line1: Maybe<Scalars['String']['output']>;
  /** Country */
  oldCountry: Maybe<Country>;
  /** Region */
  region: Maybe<Scalars['String']['output']>;
  /** Postcode/ZIP code */
  zip: Maybe<Scalars['String']['output']>;
};

/** Affiliates' promoting countries */
export type AffiliateCountriesType = {
  __typename?: 'affiliateCountriesType';
  /** Client (affiliate) */
  client: Maybe<Client>;
  /** Countries that the affiliate promotes in */
  countriesPromoted: Maybe<Array<Maybe<Country>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum AlertsOrderByType {
  AffiliateUserName = 'affiliateUserName',
  Balance = 'balance',
  ClientEmail = 'clientEmail',
  ClientFullName = 'clientFullName',
  CreatedAt = 'createdAt',
  Id = 'id',
  LastLogin = 'lastLogin',
  MemberId = 'memberId',
  PostponeUntil = 'postponeUntil',
  TotalDeposits = 'totalDeposits'
}

/** List of alert status */
export enum AlertStatusesType {
  Active = 'active',
  PermanentlyResolved = 'permanentlyResolved',
  Postponed = 'postponed',
  Resolved = 'resolved'
}

/** List of trading statuses */
export enum TradingStatus {
  Active = 'active',
  Closed = 'closed',
  Depositor = 'depositor',
  Dormant = 'dormant',
  Inactive = 'inactive',
  NewAccount = 'newAccount',
  Registered = 'registered',
  Rejected = 'rejected',
  Suspended = 'suspended',
  Terminated = 'terminated'
}

/** List of alert Reason */
export enum AlertReasonTypes {
  Abusive = 'abusive',
  AutomatedWithdrawalInvalidAmount = 'automatedWithdrawalInvalidAmount',
  ClientCompletedDueDiligence = 'clientCompletedDueDiligence',
  ClientPepUsReportable = 'clientPepUsReportable',
  CrmBlacklisted = 'crmBlacklisted',
  DepositsExceedDeclaredAnnualIncome = 'depositsExceedDeclaredAnnualIncome',
  DocumentKycGoingToExpire = 'documentKYCGoingToExpire',
  DocumetsKycThresholdExpired = 'documetsKYCThresholdExpired',
  DormantAccountReactivation = 'dormantAccountReactivation',
  DueDiligence = 'dueDiligence',
  FundsFromThirdPartyAccount = 'fundsFromThirdPartyAccount',
  HeldDepositRefund = 'heldDepositRefund',
  IpMissmatch = 'ipMissmatch',
  KycClientBlacklisted = 'kycClientBlacklisted',
  KycGracePeriodOver = 'kycGracePeriodOver',
  KycGracePeriodOverRefund = 'kycGracePeriodOverRefund',
  MaxDepositLimitExceeded = 'maxDepositLimitExceeded',
  MissingKycNoDepositExeededTimeframe = 'missingKYCNoDepositExeededTimeframe',
  MissingKycTotalDeposit = 'missingKYCTotalDeposit',
  MissingKycWithDepositExeededTimeframe = 'missingKYCWithDepositExeededTimeframe',
  MoreThanThreeCreditCardsUsed = 'moreThanThreeCreditCardsUsed',
  PossibleDuplicateAffiliates = 'possibleDuplicateAffiliates',
  PossibleDuplicateClient = 'possibleDuplicateClient',
  PossibleDuplicateIBs = 'possibleDuplicateIBs',
  SuspendNoCardCopies = 'suspendNoCardCopies',
  SuspiciousActivity = 'suspiciousActivity',
  TotalDepositsExceedNetWorth = 'totalDepositsExceedNetWorth',
  UsReportableOpenPositions = 'usReportableOpenPositions',
  WorldCheck = 'worldCheck'
}

/** Alerts for compliance/backoffice */
export type Alert = {
  __typename?: 'Alert';
  activityLog: Maybe<Scalars['String']['output']>;
  /** Alert Details */
  amount: Maybe<Scalars['String']['output']>;
  /** Client ID */
  client: Maybe<Client>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  /** Alert Details */
  ip: Maybe<Scalars['String']['output']>;
  /** Alert Details */
  meta: Maybe<Scalars['String']['output']>;
  postponeUntil: Maybe<Scalars['DateTime']['output']>;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  /** User that resolved alert */
  resolvedBy: Maybe<User>;
  /** Status */
  status: Maybe<AlertStatusesType>;
  /** Alert Reason */
  type: Maybe<AlertReasonTypes>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** A BDSwiss staff member */
export type User = {
  __typename?: 'User';
  /** Activity logs concerning this user */
  activityLogs: Maybe<Array<Maybe<ActivityLog>>>;
  /** Count of activity logs concerning this user */
  activityLogsCount: Maybe<Scalars['Int']['output']>;
  /** Affiliate Associated Campaigns */
  affiliateAssociatedCampaigns: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Affiliate Manager's Associated Campaigns */
  affiliateManagerCampaigns: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** User's Allowed IPs For Password Auth */
  allowedIps: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Appointments for this user */
  appointments: Maybe<Array<Maybe<Appointment>>>;
  /** Count of appointments for this user */
  appointmentsCount: Maybe<Scalars['Int']['output']>;
  /** Sales Agent's Associated Campaigns */
  associatedCampaigns: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Sales Agent's Associated Campaigns */
  associatedSubCampaigns: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Avatar */
  avatar: Maybe<Scalars['String']['output']>;
  /** Bio */
  bio: Maybe<Scalars['String']['output']>;
  /** User associated companies */
  companies: Maybe<Array<Maybe<Company>>>;
  /** Pool countries */
  countries: Maybe<Array<Maybe<Country>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** User who created this record */
  createdBy: Maybe<User>;
  /** User's Department */
  department: Maybe<UserDepartmentType>;
  /** Department Role Type */
  departmentRoleType: Maybe<DepartmentRoleType>;
  /** Document Distribution Weight */
  documentDistributionWeight: Maybe<Scalars['Int']['output']>;
  /** Last document assignment timestamp */
  documentlastAssignedTimestamp: Maybe<Scalars['DateTime']['output']>;
  /** Document Total Weight */
  documentTotalWeight: Maybe<Scalars['Int']['output']>;
  /** User's email */
  email: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['DateTime']['output']>;
  /** First name */
  firstName: Maybe<Scalars['String']['output']>;
  /** For retention agent, client FTD maximum */
  ftdMax: Maybe<Scalars['Int']['output']>;
  /** For retention agent, client FTD minimum */
  ftdMin: Maybe<Scalars['Int']['output']>;
  googleAuthId: Maybe<Scalars['String']['output']>;
  /** User ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Is user active? */
  isActive: Maybe<Scalars['Boolean']['output']>;
  /** Is pool */
  isPool: Maybe<Scalars['Boolean']['output']>;
  /** Job title */
  jobTitle: Maybe<Scalars['String']['output']>;
  /** User languages */
  languages: Maybe<Array<Maybe<Language>>>;
  /** Last lead assignment timestamp */
  lastLeadAssignedTimestamp: Maybe<Scalars['Float']['output']>;
  /** Last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** Number of assigned clients */
  leadDistributionAssigned: Maybe<Scalars['Int']['output']>;
  /** Lead Distribution Weight */
  leadDistributionWeight: Maybe<Scalars['Int']['output']>;
  /** User's location */
  location: Maybe<Location>;
  /** User's location ID */
  locationId: Maybe<Scalars['Int']['output']>;
  /** User's Manager */
  manager: Maybe<User>;
  /** User's Manager ID */
  managerId: Maybe<Scalars['Int']['output']>;
  /** Phone */
  phone: Maybe<Scalars['String']['output']>;
  /** Roles assigned to this user */
  roles: Maybe<Array<Maybe<Role>>>;
  /** Count of roles assigned to this user */
  rolesCount: Maybe<Scalars['Int']['output']>;
  /** Sales Agent Type */
  salesAgentType: Maybe<SalesAgentType>;
  salesClientsCount: Maybe<Scalars['Int']['output']>;
  /** Selected Pools */
  selectedPools: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Skype */
  skype: Maybe<Scalars['String']['output']>;
  startDate: Maybe<Scalars['DateTime']['output']>;
  /** Telephony Provider */
  telephonyProvider: Maybe<TelephonyProviderType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** User who updates this record last */
  updatedBy: Maybe<User>;
  /** Username */
  username: Maybe<Scalars['String']['output']>;
};


/** A BDSwiss staff member */
export type UserActivityLogsArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


/** A BDSwiss staff member */
export type UserActivityLogsCountArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


/** A BDSwiss staff member */
export type UserAppointmentsArgs = {
  isDismissed: InputMaybe<Scalars['Boolean']['input']>;
  isNew: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<AppointmentsOrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  startFrom: InputMaybe<Scalars['DateTime']['input']>;
  startTo: InputMaybe<Scalars['DateTime']['input']>;
  userId: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** A BDSwiss staff member */
export type UserAppointmentsCountArgs = {
  isDismissed: InputMaybe<Scalars['Boolean']['input']>;
  isNew: InputMaybe<Scalars['Boolean']['input']>;
  startFrom: InputMaybe<Scalars['DateTime']['input']>;
  startTo: InputMaybe<Scalars['DateTime']['input']>;
  userId: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** A BDSwiss staff member */
export type UserRolesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};

/** Which field to order the query results by */
export enum AppointmentsOrderBy {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  End = 'end',
  Id = 'id',
  Start = 'start',
  Threshold = 'threshold'
}

/** Appointment to schedule calls or meetings with clients */
export type Appointment = {
  __typename?: 'Appointment';
  addToGoogleCalendar: Maybe<Scalars['Boolean']['output']>;
  /** Appointment category */
  category: Maybe<AppointmentCategoryType>;
  /** Client for whom the appointment is created */
  client: Maybe<Client>;
  /** Appointment color */
  color: Maybe<AppointmentColorType>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Appointment description */
  description: Maybe<Scalars['String']['output']>;
  /** Time when the appointment will end */
  end: Maybe<Scalars['DateTime']['output']>;
  fullDescription: Maybe<Scalars['String']['output']>;
  gcalId: Maybe<Scalars['String']['output']>;
  /** Appointment ID */
  id: Maybe<Scalars['Int']['output']>;
  isDismissed: Maybe<Scalars['Boolean']['output']>;
  isNew: Maybe<Scalars['Boolean']['output']>;
  /** Time when the appointment will start */
  start: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** User who created this appointment */
  user: Maybe<User>;
};

/** List of appointment categories */
export enum AppointmentCategoryType {
  Appointment = 'appointment',
  CallAgain = 'callAgain',
  CallBackBackOffice = 'callBackBackOffice',
  CallBackSupport = 'callBackSupport',
  ClosePositions = 'closePositions',
  ClosureOfAccount = 'closureOfAccount',
  ComplaintFollowUp = 'complaintFollowUp',
  CustomReminder = 'customReminder',
  CustomReminderBackOffice = 'customReminderBackOffice',
  DealingBackOffice = 'dealingBackOffice',
  DealingSupport = 'dealingSupport',
  Documents = 'documents',
  FollowUp = 'followUp',
  Funding = 'funding',
  NewsCall = 'newsCall',
  OneOnOne = 'oneOnOne',
  Other = 'other',
  Product = 'product',
  Production = 'production',
  ProofOfIdentity = 'proofOfIdentity',
  ProofOfIncome = 'proofOfIncome',
  ProofOfResidence = 'proofOfResidence',
  Qualify = 'qualify',
  Retain = 'retain',
  Trading = 'trading',
  UpSell = 'upSell',
  UpSellF = 'upSellF',
  Verification = 'verification',
  WebinarCall = 'webinarCall'
}

/** List of appointment colors */
export enum AppointmentColorType {
  Banana = 'banana',
  Basil = 'basil',
  Blueberry = 'blueberry',
  Flamingo = 'flamingo',
  Grape = 'grape',
  Graphite = 'graphite',
  Lavender = 'lavender',
  Peacock = 'peacock',
  Sage = 'sage',
  Tangerine = 'tangerine',
  Tomato = 'tomato'
}

/** List of user departments */
export enum UserDepartmentType {
  Accounting = 'accounting',
  Administration = 'administration',
  Affiliate = 'affiliate',
  Bdx = 'bdx',
  BoAccountOpening = 'boAccountOpening',
  BoFunding = 'boFunding',
  BusinessDevelopment = 'businessDevelopment',
  BusinessIntelligence = 'businessIntelligence',
  CallMonitoring = 'callMonitoring',
  ClientRelationsTraining = 'clientRelationsTraining',
  Complaints = 'complaints',
  Compliance = 'compliance',
  Contractor = 'contractor',
  CustomerRelations = 'customerRelations',
  Dealing = 'dealing',
  Development = 'development',
  DirectorOfOperations = 'directorOfOperations',
  HumanResources = 'humanResources',
  Investment = 'investment',
  It = 'it',
  Management = 'management',
  Marketing = 'marketing',
  Office = 'office',
  PartnershipOperations = 'partnershipOperations',
  PaymentSolutions = 'paymentSolutions',
  Portfolio = 'portfolio',
  ProjectManagement = 'projectManagement',
  Receiption = 'receiption',
  Retention = 'retention',
  Risk = 'risk',
  Sales = 'sales',
  SalesOperations = 'salesOperations',
  SeniorManagement = 'seniorManagement',
  Shareholder = 'shareholder',
  Support = 'support',
  System = 'system'
}

/** List of Department Role Types */
export enum DepartmentRoleType {
  AcquisitionManager = 'acquisitionManager',
  AssistantHead = 'assistantHead',
  BackOffice = 'backOffice',
  Ceo = 'CEO',
  Coo = 'COO',
  Cpo = 'CPO',
  Employee = 'employee',
  Head = 'head',
  PartnerManager = 'partnerManager',
  SalesAgent = 'salesAgent',
  SoftwareEngineer = 'softwareEngineer',
  SupportAdmin = 'supportAdmin',
  SupportAgent = 'supportAgent'
}

export enum Language {
  Aa = 'aa',
  Ab = 'ab',
  Af = 'af',
  Ak = 'ak',
  Am = 'am',
  An = 'an',
  Ar = 'ar',
  As = 'as',
  Av = 'av',
  Ay = 'ay',
  Az = 'az',
  Ba = 'ba',
  Be = 'be',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bm = 'bm',
  Bn = 'bn',
  Br = 'br',
  Bs = 'bs',
  Ca = 'ca',
  Ce = 'ce',
  Ch = 'ch',
  Co = 'co',
  Cr = 'cr',
  Cs = 'cs',
  Cv = 'cv',
  Cy = 'cy',
  Da = 'da',
  De = 'de',
  Dv = 'dv',
  Dz = 'dz',
  Ee = 'ee',
  El = 'el',
  En = 'en',
  EnGb = 'enGB',
  Eo = 'eo',
  Es = 'es',
  Et = 'et',
  Eu = 'eu',
  Fa = 'fa',
  Ff = 'ff',
  Fi = 'fi',
  Fj = 'fj',
  Fo = 'fo',
  Fr = 'fr',
  Fy = 'fy',
  Ga = 'ga',
  Gd = 'gd',
  Gl = 'gl',
  Gn = 'gn',
  Gu = 'gu',
  Gv = 'gv',
  Ha = 'ha',
  He = 'he',
  Hi = 'hi',
  Ho = 'ho',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Hy = 'hy',
  Hz = 'hz',
  Id = 'id',
  Ig = 'ig',
  Ii = 'ii',
  Ik = 'ik',
  Io = 'io',
  Is = 'is',
  It = 'it',
  Iu = 'iu',
  Ja = 'ja',
  Jv = 'jv',
  Ka = 'ka',
  Kg = 'kg',
  Ki = 'ki',
  Kj = 'kj',
  Kk = 'kk',
  Kl = 'kl',
  Km = 'km',
  Kn = 'kn',
  Ko = 'ko',
  Kr = 'kr',
  Ks = 'ks',
  Ku = 'ku',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  La = 'la',
  Lb = 'lb',
  Lg = 'lg',
  Li = 'li',
  Ln = 'ln',
  Lo = 'lo',
  Lt = 'lt',
  Lv = 'lv',
  Mg = 'mg',
  Mh = 'mh',
  Mi = 'mi',
  Mk = 'mk',
  Ml = 'ml',
  Mn = 'mn',
  Mo = 'mo',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  My = 'my',
  Na = 'na',
  Nb = 'nb',
  Nd = 'nd',
  Ne = 'ne',
  Ng = 'ng',
  Nl = 'nl',
  No = 'no',
  Nr = 'nr',
  Nv = 'nv',
  Ny = 'ny',
  Oc = 'oc',
  Oj = 'oj',
  Om = 'om',
  Or = 'or',
  Os = 'os',
  Pa = 'pa',
  Ph = 'ph',
  Pi = 'pi',
  Pl = 'pl',
  Ps = 'ps',
  Pt = 'pt',
  Qu = 'qu',
  Rn = 'rn',
  Ro = 'ro',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Sh = 'sh',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sq = 'sq',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Su = 'su',
  Sv = 'sv',
  Sw = 'sw',
  Ta = 'ta',
  Tg = 'tg',
  Th = 'th',
  Ti = 'ti',
  Tk = 'tk',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Ts = 'ts',
  Tt = 'tt',
  Tw = 'tw',
  Ty = 'ty',
  Ug = 'ug',
  Uk = 'uk',
  Ur = 'ur',
  Uz = 'uz',
  Ve = 've',
  Vi = 'vi',
  Vo = 'vo',
  Wa = 'wa',
  Wo = 'wo',
  Xh = 'xh',
  Yi = 'yi',
  Yo = 'yo',
  Za = 'za',
  Zh = 'zh',
  Zu = 'zu'
}

/** A BDSwiss staff member location */
export type Location = {
  __typename?: 'Location';
  /** Address of location */
  address: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Location ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Name of location */
  name: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** ACL Roles, with an array of allowed permissions */
export type Role = {
  __typename?: 'Role';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Description of this role */
  description: Maybe<Scalars['String']['output']>;
  /** Role ID */
  id: Maybe<Scalars['ID']['output']>;
  /** Name of role */
  name: Maybe<Scalars['String']['output']>;
  /** Permissions assigned to this role */
  permissions: Maybe<Array<Maybe<Permission>>>;
  /** Count of permissions assigned to this role */
  permissionsCount: Maybe<Scalars['Int']['output']>;
  restrictedTo: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Users that has this role */
  users: Maybe<Array<Maybe<User>>>;
};


/** ACL Roles, with an array of allowed permissions */
export type RolePermissionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};


/** ACL Roles, with an array of allowed permissions */
export type RoleUsersArgs = {
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  isSalesAgent: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};

/** ACL Permission string - eg. clients_r (user can see client records) */
export type Permission = {
  __typename?: 'Permission';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Describe this permission */
  description: Maybe<Scalars['String']['output']>;
  /** Permission ID */
  id: Maybe<Scalars['ID']['output']>;
  /** Name of this permission */
  name: Maybe<Scalars['String']['output']>;
  /** Roles that has this permission */
  roles: Maybe<Array<Maybe<Role>>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


/** ACL Permission string - eg. clients_r (user can see client records) */
export type PermissionRolesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};

/** List of Sales Agent Types */
export enum SalesAgentType {
  Conversion = 'conversion',
  Hybrid = 'hybrid',
  Retention = 'retention'
}

/** Telephony Provider Type */
export enum TelephonyProviderType {
  Didlogic = 'didlogic',
  Impactech = 'impactech'
}

/** List of KYC statuses */
export enum KycStatus {
  Approved = 'approved',
  Pending = 'pending',
  PendingAppropTest = 'pendingAppropTest',
  Rejected = 'rejected'
}

export enum AppropTestStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type AppropTest = {
  __typename?: 'AppropTest';
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  answers: Maybe<AppropTestAnswers>;
  /** Binary points of this approp test */
  binaryPoints: Maybe<Scalars['Int']['output']>;
  /** Client who submitted this approp test */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Forex points of this approp test */
  forexPoints: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** Rejection reason code */
  rejectionReasonCode: Maybe<AppropTestRejectionReasonCode>;
  /** Scoring result */
  scoreResult: Maybe<AppropTestScoringResult>;
  status: Maybe<AppropTestStatus>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type AppropTestAllowedLeveragesArgs = {
  accountId: Scalars['Int']['input'];
};

export type AppropTestAnswers = {
  __typename?: 'AppropTestAnswers';
  accountTurnover: Maybe<AccountTurnover>;
  acknowledgmentConfirmation: Maybe<Scalars['String']['output']>;
  annualIncome: Maybe<AppropTestAnnualIncome>;
  appropriatenessWarning: Maybe<Scalars['String']['output']>;
  attendedSeminarOrCourse: Maybe<AppropTestAttendedSeminarOrCourse>;
  attendedSeminarOrCourseBinary: Maybe<AttendedSeminarOrCourseBinary>;
  attendedSeminarOrCourseForex: Maybe<AttendedSeminarOrCourseForex>;
  binaryPast2YearsExperience: Maybe<AppropTestBinaryPast2YearsExperience>;
  buyFacebookCfdV2: Maybe<BuyFacebookCfdV2>;
  cfdTradingV2: Maybe<CfdTradingV2>;
  disposableIncomeV2: Maybe<DisposableIncomeV2>;
  educatedInFinancialTrading: Maybe<AppropTestEducatedInFinancialTrading>;
  educationLevel: Maybe<AppropTestEducationLevel>;
  educationLevelV2: Maybe<EducationLevelV2>;
  educationOptionInFinancialTrading: Maybe<AppropTestEducationOptionInFinancialTrading>;
  employerCategory: Maybe<AppropTestEmployerCategory>;
  employmentStatus: Maybe<AppropTestEmploymentStatus>;
  expectedDeposit: Maybe<AppropTestExpectedDeposit>;
  fieldOfStudyV2: Maybe<FieldOfStudyV2>;
  financialDemoPast2YearsExperience: Maybe<AppropTestFinancialDemoPast2YearsExp>;
  forexPast2YearsExperience: Maybe<AppropTestForexPast2YearsExperience>;
  haveTraded: Maybe<AppropTestHaveTraded>;
  haveTradedForexCfd: Maybe<AppropTestHaveTradedForexCfd>;
  haveTradingExperience: Maybe<AppropTestHaveTradingExperience>;
  howManyTimesHaveTraded: Maybe<AppropTestHowManyTimesHaveTraded>;
  ifLoseCapitalV2: Maybe<IfLoseCapitalV2>;
  initialInvestment: Maybe<InitialInvestment>;
  initialInvestmentV2: Maybe<InitialInvestmentV2>;
  isUsReportable: Maybe<AppropTestIsUsReportable>;
  jobTitle: Maybe<Scalars['String']['output']>;
  largerSizePositions: Maybe<AppropTestLargerSizePositions>;
  lostInvestment: Maybe<AppropTestLostInvestment>;
  maximumPositionV2: Maybe<MaximumPositionV2>;
  netWorth: Maybe<AppropTestNetWorth>;
  netWorthV2: Maybe<NetWorthV2>;
  past2YearsProductsBdswiss: Maybe<Scalars['String']['output']>;
  past2YearsProductsSwissMarkets: Maybe<Scalars['String']['output']>;
  past2YearsTradingExperienceV2: Maybe<Past2YearsTradingExperienceV2>;
  politicallyExposed: Maybe<PoliticallyExposed>;
  professionStatusV2: Maybe<ProfessionStatusV2>;
  relevantProfession: Maybe<RelevantProfession>;
  relevantQualificationsOrExperience: Maybe<RelevantQualificationsOrExperience>;
  riskUnderstanding: Maybe<RiskUnderstanding>;
  sourceOfFunds: Maybe<AppropTestSourceOfFunds>;
  stockDropsV2: Maybe<StockDropsV2>;
  tradingExperienceBinary: Maybe<TradingExperienceBinary>;
  tradingExperienceExchange: Maybe<TradingExperienceExchange>;
  tradingExperienceForex: Maybe<TradingExperienceForex>;
  tradingExperienceOTC: Maybe<TradingExperienceOtc>;
  tradingExperienceOTCSwissmarkets: Maybe<TradingExperienceOtcSwissmarkets>;
  tradingExperienceSharesBonds: Maybe<TradingExperienceSharesBonds>;
  tradingFrequencyLast12Months: Maybe<TradingFrequencyLast12Months>;
  tradingTransactionsLast12Months: Maybe<TradingTransactionsLast12Months>;
  tradingWithLeverageV2: Maybe<TradingWithLeverageV2>;
  transactionNumber: Maybe<TransactionNumber>;
  transactionPurpose: Maybe<TransactionPurpose>;
  transactionPurposeV2: Maybe<TransactionPurposeV2>;
  transactionsInCommoditiesV2: Maybe<TransactionsInCommoditiesV2>;
  transactionsInForexV2: Maybe<TransactionsInForexV2>;
  usTaxId: Maybe<Scalars['String']['output']>;
  volatileMarkets: Maybe<AppropTestVolatileMarkets>;
  warning: Maybe<AppropTestWarningAcceptance>;
  withLeverageCommoditiesV2: Maybe<WithLeverageCommoditiesV2>;
  withLeverageForexV2: Maybe<WithLeverageForexV2>;
};

export enum AccountTurnover {
  Between0And1k = 'between0And1k',
  Between0And5000 = 'between0And5000',
  Between1kAnd5k = 'between1kAnd5k',
  Between5000And25000 = 'between5000And25000',
  Between5kAnd50k = 'between5kAnd50k',
  MoreThan25000 = 'moreThan25000',
  MoreThan50k = 'moreThan50k'
}

export enum AppropTestAnnualIncome {
  Between100kAnd200k = 'between100kAnd200k',
  Between10kAnd50k = 'between10kAnd50k',
  Between50kAnd100k = 'between50kAnd100k',
  LessThan10k = 'lessThan10k',
  LessThan50k = 'lessThan50k',
  MoreThan100k = 'moreThan100k',
  MoreThan200k = 'moreThan200k'
}

export enum AppropTestAttendedSeminarOrCourse {
  No = 'no',
  Yes = 'yes'
}

export enum AttendedSeminarOrCourseBinary {
  No = 'no',
  Yes = 'yes'
}

export enum AttendedSeminarOrCourseForex {
  No = 'no',
  Yes = 'yes'
}

export enum AppropTestBinaryPast2YearsExperience {
  Between25to100 = 'between25to100',
  Over100 = 'over100',
  UpTo25 = 'upTo25'
}

export enum BuyFacebookCfdV2 {
  CannotSell = 'cannotSell',
  SellAtStockExchange = 'sellAtStockExchange',
  SellThroughBdswiss = 'sellThroughBdswiss'
}

export enum CfdTradingV2 {
  All = 'all',
  ComplexProducts = 'complexProducts',
  DoNotHaveOwnership = 'doNotHaveOwnership'
}

export enum DisposableIncomeV2 {
  Between200kAnd1k = 'between200kAnd1k',
  LessThan200 = 'lessThan200',
  MoreThan1k = 'moreThan1k'
}

export enum AppropTestEducatedInFinancialTrading {
  No = 'no',
  Yes = 'yes'
}

export enum AppropTestEducationLevel {
  BachelorDiplomaDegree = 'bachelorDiplomaDegree',
  DoctorateDegree = 'doctorateDegree',
  HighSchoolOrEquivalent = 'HighSchoolOrEquivalent',
  MasterDegree = 'masterDegree',
  None = 'none',
  OtherProfessionalQualifications = 'otherProfessionalQualifications',
  PrimaryEducation = 'primaryEducation',
  ProfessionalQualification = 'professionalQualification',
  SecondaryEducation = 'secondaryEducation',
  UniversityCollege = 'universityCollege',
  UniversityDegreeOrEquivalent = 'UniversityDegreeOrEquivalent'
}

export enum EducationLevelV2 {
  BachelorDiplomaDegree = 'bachelorDiplomaDegree',
  DoctorateDegree = 'doctorateDegree',
  HighSchoolOrEquivalent = 'HighSchoolOrEquivalent',
  MasterDegree = 'masterDegree',
  None = 'none',
  OtherProfessionalQualifications = 'otherProfessionalQualifications',
  PrimaryEducation = 'primaryEducation',
  ProfessionalQualification = 'professionalQualification',
  SecondaryEducation = 'secondaryEducation',
  UniversityCollege = 'universityCollege',
  UniversityDegreeOrEquivalent = 'UniversityDegreeOrEquivalent'
}

export enum AppropTestEducationOptionInFinancialTrading {
  HigherEducation = 'higherEducation',
  None = 'none',
  Other = 'other',
  SelfTaught = 'selfTaught'
}

export enum AppropTestEmployerCategory {
  Accountancy = 'accountancy',
  AdminSecretarial = 'adminSecretarial',
  Agriculture = 'agriculture',
  AirlineServices = 'airlineServices',
  ArmedForces = 'armedForces',
  ArmsArmamentsAmmunition = 'armsArmamentsAmmunition',
  Automotive = 'automotive',
  BarberHairdresser = 'barberHairdresser',
  BrokeringServices = 'brokeringServices',
  BusinessActivitiesLikelyToCauseEnvironmentalDamage = 'businessActivitiesLikelyToCauseEnvironmentalDamage',
  BusinessInvolvingPepMilitaryFigures = 'businessInvolvingPepMilitaryFigures',
  CallCentre = 'callCentre',
  CarDealerVehicleSellers = 'carDealerVehicleSellers',
  CashIncentiveBusiness = 'cashIncentiveBusiness',
  CasinoGamblingOperatorBusinessRelatedToGambling = 'casinoGamblingOperatorBusinessRelatedToGambling',
  Catering = 'catering',
  CateringHospitality = 'cateringHospitality',
  CharityVoluntaryWorkNgo = 'charityVoluntaryWorkNGO',
  CivilServant = 'civilServant',
  CompanyFormationServices = 'companyFormationServices',
  Compliance = 'compliance',
  CreativeMedia = 'creativeMedia',
  Education = 'education',
  EducationTraining = 'educationTraining',
  EmergencyServices = 'emergencyServices',
  EnergyMiningAgriculture = 'energyMiningAgriculture',
  Engineering = 'engineering',
  EngineeringAutomotiveManufacturing = 'engineeringAutomotiveManufacturing',
  Entertainment = 'entertainment',
  FactoryWorker = 'factoryWorker',
  FastFoodOutlet = 'fastFoodOutlet',
  FinancialServices = 'financialServices',
  FintechDigitalCurrencyBrokeringTrading = 'fintechDigitalCurrencyBrokeringTrading',
  FoodAndBeverage = 'foodAndBeverage',
  Gatekeepers = 'gatekeepers',
  Government = 'government',
  HealthcareSocialServices = 'healthcareSocialServices',
  HealthMedicine = 'healthMedicine',
  HighValueGoodsDealers = 'highValueGoodsDealers',
  HospitalityLeisureTourismBusinesses = 'hospitalityLeisureTourismBusinesses',
  HumanResources = 'humanResources',
  InformationTechnologies = 'informationTechnologies',
  InformationTechnologySector = 'informationTechnologySector',
  Insurance = 'insurance',
  InsuranceAccounting = 'insuranceAccounting',
  InsuranceAndRealEstate = 'insuranceAndRealEstate',
  InvestmentAdvisoryAssetManagementServices = 'investmentAdvisoryAssetManagementServices',
  InvestmentAndCommodityAdvisers = 'investmentAndCommodityAdvisers',
  Legal = 'legal',
  LeisureEntertainmentTourism = 'leisureEntertainmentTourism',
  LiveAnimalTesting = 'liveAnimalTesting',
  LocalCouncil = 'localCouncil',
  Manufacturing = 'manufacturing',
  MarketingPrAdvertising = 'marketingPrAdvertising',
  MediaMarketingAdvertisingPr = 'mediaMarketingAdvertisingPR',
  MilitaryEmergencyServicesSecurity = 'militaryEmergencyServicesSecurity',
  MineralOrOilExtractionAndMining = 'mineralOrOilExtractionAndMining',
  MoneyServiceBusinessMoneyRemittersAndMoneyExchangeHouses = 'moneyServiceBusinessMoneyRemittersAndMoneyExchangeHouses',
  NewOrInnovativeTypeOfBusiness = 'newOrInnovativeTypeOfBusiness',
  NonLicensedFinancialServicesBusiness = 'nonLicensedFinancialServicesBusiness',
  Other = 'other',
  OtherIndustry = 'otherIndustry',
  Pharmaceuticals = 'pharmaceuticals',
  PharmaceuticalsScience = 'pharmaceuticalsScience',
  Politics = 'politics',
  PreciousMetalsAndStonesJewellery = 'preciousMetalsAndStonesJewellery',
  PropertyConstructionRealEstateServices = 'propertyConstructionRealEstateServices',
  PropertyConstructionsTrades = 'propertyConstructionsTrades',
  PublicProcurement = 'publicProcurement',
  PubsNightClubsRestaurants = 'pubsNightClubsRestaurants',
  RecruitmentHr = 'recruitmentHr',
  RelegiousOrganizations = 'relegiousOrganizations',
  Retail = 'retail',
  RetailCommerce = 'retailCommerce',
  Sales = 'sales',
  Secretarial = 'secretarial',
  ShopManagerAssistant = 'shopManagerAssistant',
  SocialCareServices = 'socialCareServices',
  Sports = 'sports',
  SportTrainingSportManagement = 'sportTrainingSportManagement',
  SupraNationalOrganisations = 'supraNationalOrganisations',
  TaxiServices = 'taxiServices',
  Telecommunications = 'telecommunications',
  TransportationLogistics = 'transportationLogistics',
  TransportLogistics = 'transportLogistics',
  TravelAgencies = 'travelAgencies',
  TravellersChequesProviders = 'travellersChequesProviders',
  TrustServiceProviders = 'trustServiceProviders',
  UnlicensedMobilePhones = 'unlicensedMobilePhones',
  UtilityServices = 'utilityServices',
  VirtualAssetsCryptocurrencies = 'virtualAssetsCryptocurrencies'
}

export enum AppropTestEmploymentStatus {
  Employed = 'employed',
  NotWorking = 'notWorking',
  Retired = 'retired',
  SelfEmployed = 'selfEmployed',
  Student = 'student'
}

export enum AppropTestExpectedDeposit {
  Between10kAnd25k = 'between10kAnd25k',
  Between1kAnd10k = 'between1kAnd10k',
  Between2kAnd10k = 'between2kAnd10k',
  LessThan1k = 'lessThan1k',
  LessThan2k = 'lessThan2k',
  MoreThan10k = 'moreThan10k',
  MoreThan25k = 'moreThan25k'
}

export enum FieldOfStudyV2 {
  AccountingBanking = 'accountingBanking',
  Art = 'art',
  ComputerScience = 'computerScience',
  Medicine = 'medicine',
  Other = 'other'
}

export enum AppropTestFinancialDemoPast2YearsExp {
  Between25to100 = 'between25to100',
  Over100 = 'over100',
  UpTo25 = 'upTo25'
}

export enum AppropTestForexPast2YearsExperience {
  Between25to100 = 'between25to100',
  Over100 = 'over100',
  UpTo25 = 'upTo25'
}

export enum AppropTestHaveTraded {
  No = 'no',
  Yes = 'yes'
}

export enum AppropTestHaveTradedForexCfd {
  No = 'no',
  Yes = 'yes'
}

export enum AppropTestHaveTradingExperience {
  No = 'no',
  Yes = 'yes'
}

export enum AppropTestHowManyTimesHaveTraded {
  Between10And25 = 'between10And25',
  MoreThan25 = 'moreThan25',
  Never = 'never'
}

export enum IfLoseCapitalV2 {
  ContinueTrading = 'continueTrading',
  MostLikelyTradeAgain = 'mostLikelyTradeAgain',
  NeverTradeAgain = 'neverTradeAgain',
  TradeAgain = 'tradeAgain'
}

export enum InitialInvestment {
  Between0And2000 = 'between0And2000',
  Between0And250 = 'between0And250',
  Between0And5000 = 'between0And5000',
  Between10kAnd50k = 'between10kAnd50k',
  Between1kAnd5k = 'between1kAnd5k',
  Between250And1k = 'between250And1k',
  Between2kAnd20k = 'between2kAnd20k',
  Between5000And25000 = 'between5000And25000',
  Between5kAnd10k = 'between5kAnd10k',
  MoreThan20k = 'moreThan20k',
  MoreThan25000 = 'moreThan25000',
  MoreThan50k = 'moreThan50k',
  Multiple = 'multiple'
}

export enum InitialInvestmentV2 {
  Between0And2000 = 'between0And2000',
  Between0And250 = 'between0And250',
  Between0And5000 = 'between0And5000',
  Between10kAnd50k = 'between10kAnd50k',
  Between1kAnd5k = 'between1kAnd5k',
  Between250And1k = 'between250And1k',
  Between2kAnd20k = 'between2kAnd20k',
  Between5000And25000 = 'between5000And25000',
  Between5kAnd10k = 'between5kAnd10k',
  MoreThan20k = 'moreThan20k',
  MoreThan25000 = 'moreThan25000',
  MoreThan50k = 'moreThan50k',
  Multiple = 'multiple'
}

export enum AppropTestIsUsReportable {
  No = 'no',
  Yes = 'yes'
}

export enum AppropTestLargerSizePositions {
  False = 'false',
  True = 'true'
}

export enum AppropTestLostInvestment {
  False = 'false',
  True = 'true'
}

export enum MaximumPositionV2 {
  MaximumPosition500k = 'maximumPosition500k',
  MaximumPosition50k = 'maximumPosition50k',
  MaximumPosition5k = 'maximumPosition5k'
}

export enum AppropTestNetWorth {
  Between100kAnd200k = 'between100kAnd200k',
  Between20kAnd50k = 'between20kAnd50k',
  Between50kAnd100k = 'between50kAnd100k',
  LessThan20k = 'lessThan20k',
  LessThan50k = 'lessThan50k',
  MoreThan100k = 'moreThan100k',
  MoreThan200k = 'moreThan200k'
}

export enum NetWorthV2 {
  Between100kAnd200k = 'between100kAnd200k',
  Between20kAnd50k = 'between20kAnd50k',
  Between50kAnd100k = 'between50kAnd100k',
  LessThan20k = 'lessThan20k',
  LessThan50k = 'lessThan50k',
  MoreThan100k = 'moreThan100k',
  MoreThan200k = 'moreThan200k'
}

export enum Past2YearsTradingExperienceV2 {
  AtLeast2 = 'atLeast2',
  AttendedSeminars = 'attendedSeminars',
  NotTraded = 'notTraded',
  TradedOnMyOwn = 'tradedOnMyOwn',
  TradedWithAdvice = 'tradedWithAdvice',
  WorkedInFinancialIndustry = 'workedInFinancialIndustry'
}

export enum PoliticallyExposed {
  No = 'no',
  Yes = 'yes'
}

export enum ProfessionStatusV2 {
  ProfessionAccounting = 'professionAccounting',
  ProfessionOther = 'professionOther',
  ProfessionSciences = 'professionSciences',
  Retired = 'retired',
  Student = 'student'
}

export enum RelevantProfession {
  Accounting = 'accounting',
  Banking = 'banking',
  Legal = 'legal',
  OtherFinancialServices = 'otherFinancialServices',
  ProfessionNotRelevant = 'professionNotRelevant'
}

export enum RelevantQualificationsOrExperience {
  No = 'no',
  Yes = 'yes'
}

export enum RiskUnderstanding {
  No = 'no',
  Yes = 'yes'
}

export enum AppropTestSourceOfFunds {
  DividendProfits = 'dividendProfits',
  Employment = 'employment',
  Gift = 'gift',
  GiftFromFriendFamily = 'giftFromFriendFamily',
  Inheritance = 'inheritance',
  Investment = 'investment',
  LoanFromFinancialInstitutionBorrowings = 'loanFromFinancialInstitutionBorrowings',
  LoanFromThirdPartyBorrowings = 'loanFromThirdPartyBorrowings',
  Other = 'other',
  Pension = 'pension',
  ProfessionalEmployeeBenefitsEsop = 'professionalEmployeeBenefitsEsop',
  PropertyRentLeaseSaleConstruction = 'propertyRentLeaseSaleConstruction',
  RealEstate = 'realEstate',
  RevenueFromInvestmentTrading = 'revenueFromInvestmentTrading',
  Salary = 'salary',
  Savings = 'savings'
}

export enum StockDropsV2 {
  NotAffected = 'notAffected',
  OppositeDirection = 'oppositeDirection',
  SameDirection = 'sameDirection'
}

export enum TradingExperienceBinary {
  Between1And3years = 'between1And3years',
  Between4And7years = 'between4And7years',
  LessThan1year = 'lessThan1year',
  None = 'none',
  Over8years = 'over8years'
}

export enum TradingExperienceExchange {
  Between1And3years = 'between1And3years',
  Between4And7years = 'between4And7years',
  LessThan1year = 'lessThan1year',
  None = 'none',
  Over8years = 'over8years'
}

export enum TradingExperienceForex {
  Between1And3years = 'between1And3years',
  Between4And7years = 'between4And7years',
  LessThan1year = 'lessThan1year',
  None = 'none',
  Over8years = 'over8years'
}

export enum TradingExperienceOtc {
  Between1And3years = 'between1And3years',
  Between4And7years = 'between4And7years',
  LessThan1year = 'lessThan1year',
  None = 'none',
  Over8years = 'over8years'
}

export enum TradingExperienceOtcSwissmarkets {
  Between1And3years = 'between1And3years',
  Between4And7years = 'between4And7years',
  LessThan1year = 'lessThan1year',
  None = 'none',
  Over8years = 'over8years'
}

export enum TradingExperienceSharesBonds {
  Between1And3years = 'between1And3years',
  Between4And7years = 'between4And7years',
  LessThan1year = 'lessThan1year',
  None = 'none',
  Over8years = 'over8years'
}

export enum TradingFrequencyLast12Months {
  Between1And5 = 'between1And5',
  Between21And50 = 'between21And50',
  Between6And20 = 'between6And20',
  MoreThan50 = 'moreThan50',
  None = 'none'
}

export enum TradingTransactionsLast12Months {
  BetweenUsd100kAnd250k = 'betweenUSD100kAnd250k',
  BetweenUsd25kAnd100k = 'betweenUSD25kAnd100k',
  LessThanUsd25k = 'lessThanUSD25k',
  None = 'none',
  OverUsd250k = 'overUSD250k'
}

export enum TradingWithLeverageV2 {
  IncreaseProfits = 'increaseProfits',
  None = 'none',
  RiskFree = 'riskFree'
}

export enum TransactionNumber {
  Between0And5PerMonth = 'between0And5PerMonth',
  Between6And50PerMonth = 'between6And50PerMonth',
  MoreThan50PerMonth = 'moreThan50PerMonth'
}

export enum TransactionPurpose {
  Hedging = 'hedging',
  IntradayTrading = 'intradayTrading',
  LongTermInvestments = 'longTermInvestments',
  Other = 'other',
  Speculative = 'speculative',
  StrategyProvider = 'strategyProvider'
}

export enum TransactionPurposeV2 {
  Hedging = 'hedging',
  IntradayTrading = 'intradayTrading',
  LongTermInvestments = 'longTermInvestments',
  Other = 'other',
  Speculative = 'speculative',
  StrategyProvider = 'strategyProvider'
}

export enum TransactionsInCommoditiesV2 {
  Between50kAnd250k = 'between50kAnd250k',
  Between5kAnd50k = 'between5kAnd50k',
  LessThan5k = 'lessThan5k',
  MoreThan250k = 'moreThan250k',
  None = 'none'
}

export enum TransactionsInForexV2 {
  Between50kAnd250k = 'between50kAnd250k',
  Between5kAnd50k = 'between5kAnd50k',
  LessThan5k = 'lessThan5k',
  MoreThan250k = 'moreThan250k',
  None = 'none'
}

export enum AppropTestVolatileMarkets {
  False = 'false',
  True = 'true'
}

export enum AppropTestWarningAcceptance {
  Accept = 'accept',
  NotAccept = 'notAccept'
}

export enum WithLeverageCommoditiesV2 {
  Between11And25 = 'between11And25',
  Between1And10 = 'between1And10',
  Between26And40 = 'between26And40',
  MoreThan40 = 'moreThan40',
  None = 'none'
}

export enum WithLeverageForexV2 {
  Between11And25 = 'between11And25',
  Between1And10 = 'between1And10',
  Between26And40 = 'between26And40',
  MoreThan40 = 'moreThan40',
  None = 'none'
}

/** One of the possible approp test rejection reason codes */
export enum AppropTestRejectionReasonCode {
  InsufficientTradingExp = 'insufficientTradingExp',
  Other = 'other',
  PoliticallyExposed = 'politicallyExposed',
  UsReportable = 'usReportable'
}

export enum AppropTestScoringResult {
  AdvancedUnderstanding = 'advancedUnderstanding',
  BasicUnderstanding = 'basicUnderstanding',
  CannotTrade = 'cannotTrade',
  ProductNotSuitableLeverage100 = 'productNotSuitableLeverage100',
  ProductNotSuitableLeverage50 = 'productNotSuitableLeverage50'
}

/** Log of a call between agent and client */
export type CallLog = {
  __typename?: 'CallLog';
  client: Maybe<Client>;
  /** Company client belongs to at the time of the call */
  company: Maybe<Scalars['String']['output']>;
  /** When the call was initiated */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  disposition: Maybe<Scalars['String']['output']>;
  /** Total call duration excluding ring time */
  durationBillable: Maybe<Scalars['Int']['output']>;
  /** Total call duration including ring time */
  durationTotal: Maybe<Scalars['Int']['output']>;
  /** When the call ended */
  endedAt: Maybe<Scalars['DateTime']['output']>;
  /** Call Log ID */
  id: Maybe<Scalars['Int']['output']>;
  isMonitored: Maybe<Scalars['Boolean']['output']>;
  monitoring: Maybe<Scalars['String']['output']>;
  monitoringAgent: Maybe<User>;
  needsComplianceCheck: Maybe<Scalars['Boolean']['output']>;
  /** Notes for the call by the agent */
  notes: Maybe<Scalars['String']['output']>;
  /** Phone number called */
  phoneNumber: Maybe<Scalars['String']['output']>;
  provider: Maybe<TelephonyProviderType>;
  /** Link to the recording of the conversation */
  recording: Maybe<Scalars['String']['output']>;
  /** When the call started */
  startedAt: Maybe<Scalars['DateTime']['output']>;
  user: Maybe<User>;
};

/** List of communication channels */
export enum CommunicationChannelType {
  Call = 'call',
  ClientNotice = 'clientNotice',
  Email = 'email',
  MarketingNotification = 'marketingNotification',
  PushNotification = 'pushNotification',
  Sms = 'sms'
}

/** List of communication channels */
export enum CommunicationDepartmentType {
  Accounting = 'accounting',
  Administration = 'administration',
  Affiliate = 'affiliate',
  Bdx = 'bdx',
  BoAccountOpening = 'boAccountOpening',
  BoFunding = 'boFunding',
  BusinessDevelopment = 'businessDevelopment',
  BusinessIntelligence = 'businessIntelligence',
  CallMonitoring = 'callMonitoring',
  ClientRelationsTraining = 'clientRelationsTraining',
  Complaints = 'complaints',
  Compliance = 'compliance',
  Contractor = 'contractor',
  CustomerRelations = 'customerRelations',
  Dealing = 'dealing',
  Development = 'development',
  DirectorOfOperations = 'directorOfOperations',
  HumanResources = 'humanResources',
  Investment = 'investment',
  It = 'it',
  Management = 'management',
  Marketing = 'marketing',
  Office = 'office',
  PartnershipOperations = 'partnershipOperations',
  PaymentSolutions = 'paymentSolutions',
  Portfolio = 'portfolio',
  ProjectManagement = 'projectManagement',
  Receiption = 'receiption',
  Retention = 'retention',
  Risk = 'risk',
  Sales = 'sales',
  SalesOperations = 'salesOperations',
  SeniorManagement = 'seniorManagement',
  Shareholder = 'shareholder',
  Support = 'support',
  System = 'system'
}

/** List of communication types */
export enum CommunicationTypeType {
  AccountApproved = 'accountApproved',
  AccountSuspended = 'accountSuspended',
  AppropTestPending = 'appropTestPending',
  BonusLowEquityWarning = 'bonusLowEquityWarning',
  Call = 'call',
  ClientNotice = 'clientNotice',
  DepositApproved = 'depositApproved',
  DepositDeclined = 'depositDeclined',
  DepositOnHold = 'depositOnHold',
  Email = 'email',
  KycApproved = 'kycApproved',
  KycRejected = 'kycRejected',
  KycUploadDocuments = 'kycUploadDocuments',
  MarginCall = 'marginCall',
  MarketingNotification = 'marketingNotification',
  MarketingPush = 'marketingPush',
  PoiMissing = 'poiMissing',
  PoiRejected = 'poiRejected',
  PorMissing = 'porMissing',
  PorRejected = 'porRejected',
  WithdrawalApproved = 'withdrawalApproved',
  WithdrawalRejected = 'withdrawalRejected'
}

/** Communication with client */
export type Communication = {
  __typename?: 'Communication';
  /** Communication Channel */
  channels: Maybe<Array<Maybe<CommunicationChannelType>>>;
  /** Client ID */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Communication Department */
  department: Maybe<CommunicationDepartmentType>;
  /** Communication foreign table id */
  foreignId: Maybe<Scalars['Int']['output']>;
  /** Communication foreign table */
  foreignTable: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  /** Communication Details */
  meta: Maybe<Scalars['String']['output']>;
  /** Communication Summary */
  summary: Maybe<Scalars['String']['output']>;
  /** Communication Title */
  title: Maybe<Scalars['String']['output']>;
  /** Communication Type */
  type: Maybe<CommunicationTypeType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Competition event */
export type Competition = {
  __typename?: 'Competition';
  acceptPreviousWinners: Maybe<Scalars['Boolean']['output']>;
  allowedAffiliates: Maybe<Scalars['String']['output']>;
  applicableClientTypes: Maybe<Array<Maybe<ClientType>>>;
  applicableCompanies: Maybe<Array<Maybe<Company>>>;
  applicableCountries: Maybe<Array<Maybe<Country>>>;
  competitionWinner: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  endDate: Maybe<Scalars['DateTime']['output']>;
  excludedAffiliates: Maybe<Scalars['String']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  leaderboard: Maybe<Array<Maybe<Leaderboard>>>;
  limitedSymbols: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  participantsCount: Maybe<Scalars['Int']['output']>;
  prizes: Maybe<Scalars['String']['output']>;
  rules: Maybe<Scalars['String']['output']>;
  startDate: Maybe<Scalars['DateTime']['output']>;
  termsLink: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


/** Competition event */
export type CompetitionLeaderboardArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  clientId: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['Int']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  rank: Maybe<Scalars['Int']['output']>;
  roi: Maybe<Scalars['Float']['output']>;
};

export enum ConversionStatus {
  Abusive = 'abusive',
  CallAgain = 'callAgain',
  CheckNumber = 'checkNumber',
  Churn = 'churn',
  DoNotCall = 'doNotCall',
  Duplicate = 'duplicate',
  EmailContact = 'emailContact',
  Interested = 'interested',
  LeadLanguageBarrier = 'lead_language_barrier',
  Mobile = 'mobile',
  Nec60Days = 'nec60Days',
  NoAnswer = 'noAnswer',
  None = 'none',
  NotInterested = 'notInterested',
  Onboarding = 'onboarding',
  Pamm = 'pamm',
  Reassigned = 'reassigned',
  TopVipClient = 'topVipClient',
  UnregisteredLead = 'unregisteredLead',
  VipClient = 'vipClient',
  VoiceMail = 'voiceMail'
}

export enum ConversionStep {
  Converted = 'converted',
  Lead = 'lead'
}

/** Client request about issue with deposit method */
export type DepositMethodIssueVerification = {
  __typename?: 'DepositMethodIssueVerification';
  accountId: Maybe<Scalars['Int']['output']>;
  clientId: Maybe<Scalars['Int']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  fileUrl: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  internalRemark: Maybe<Scalars['String']['output']>;
  meta: Maybe<Scalars['String']['output']>;
  paymentMethodOptionId: Maybe<Scalars['String']['output']>;
  processStatus: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Parameters Account Type-SubType Component */
export type AccountTypeSubTypeFilter = {
  /** Account Subtype contained in the filter */
  accountSubType: InputMaybe<Scalars['String']['input']>;
  /** Account type contained in the filter */
  accountType: InputMaybe<Scalars['String']['input']>;
};

/** One of the possible deposit statuses */
export enum DepositStatus {
  Authorized = 'authorized',
  AwaitingPayment = 'awaitingPayment',
  Cancelled = 'cancelled',
  Chargeback = 'chargeback',
  Completed = 'completed',
  Failed = 'failed',
  Held = 'held',
  Incomplete = 'incomplete',
  PartiallyReversed = 'partiallyReversed',
  Pending = 'pending',
  Processing = 'processing',
  Rejected = 'rejected',
  Reversed = 'reversed'
}

/** dlocal Banks available to client */
export type DlocalBanks = {
  __typename?: 'dlocalBanks';
  code: Maybe<Scalars['String']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  paymentType: Maybe<Scalars['String']['output']>;
};

/** One of the possible document statuses */
export enum DocumentStatus {
  Accepted = 'accepted',
  AutoVerificationAccepted = 'autoVerificationAccepted',
  AutoVerificationError = 'autoVerificationError',
  AutoVerificationReceived = 'autoVerificationReceived',
  AutoVerificationRejected = 'autoVerificationRejected',
  AutoVerificationSent = 'autoVerificationSent',
  FailedSentForVerification = 'failedSentForVerification',
  NotProcessed = 'notProcessed',
  Pending = 'pending',
  PendingTranslation = 'pendingTranslation',
  Rejected = 'rejected'
}

export enum DocumentType {
  Address = 'address',
  AffiliateContract = 'affiliateContract',
  ApprovalRejectionForm = 'approvalRejectionForm',
  BankCard = 'bankCard',
  BankPaymentDetails = 'bankPaymentDetails',
  BankStatement = 'bankStatement',
  BankStatementPof = 'bankStatementPOF',
  BankStatementPor = 'bankStatementPOR',
  BtcEthPop = 'btcEthPop',
  BusinessLicense = 'businessLicense',
  CardCopies = 'cardCopies',
  CardCopiesBack = 'cardCopiesBack',
  CardStatement = 'cardStatement',
  CertificateOfGoodStanding = 'certificateOfGoodStanding',
  CertificateOfIncorporation = 'certificateOfIncorporation',
  CertificateOfShareholders = 'certificateOfShareholders',
  CoinbasePop = 'coinbasePop',
  CompaniesRegistryExtract = 'companiesRegistryExtract',
  DrivingLicenseBack = 'drivingLicenseBack',
  DrivingLicenseFront = 'drivingLicenseFront',
  DueDiligence = 'dueDiligence',
  IBagreement = 'iBagreement',
  IdBack = 'idBack',
  IdFront = 'idFront',
  IdTranslation = 'idTranslation',
  JointAccountForm = 'jointAccountForm',
  LimitedPowerOfAttorney = 'limitedPowerOfAttorney',
  MemorandumArticlesOfAssociation = 'memorandumArticlesOfAssociation',
  Other = 'other',
  OtherPof = 'otherPOF',
  Passport = 'passport',
  Payslip = 'payslip',
  PrivateWallet = 'privateWallet',
  ProfessionalApplication = 'professionalApplication',
  PromotionalMaterial = 'promotionalMaterial',
  ProofOfAddressTranslation = 'proofOfAddressTranslation',
  ProofOfResidence = 'proofOfResidence',
  ProofOfSignature = 'proofOfSignature',
  ResidencePermit = 'residencePermit',
  ResidencePermitVisa = 'residencePermitVisa',
  RevocationOfPoaSpoa = 'revocationOfPoaSpoa',
  SpecialPowerOfAttorney = 'specialPowerOfAttorney',
  SwiftCopyPaymentAdvice = 'swiftCopyPaymentAdvice',
  TaxStatement = 'taxStatement',
  ThirdPartyAuthorizationLetter = 'thirdPartyAuthorizationLetter',
  ThirdPartyIdPassport = 'thirdPartyIdPassport',
  ThirdPartyWc = 'thirdPartyWc',
  UtilityBill = 'utilityBill',
  VirtualCard = 'virtualCard',
  WorldcheckResults = 'worldcheckResults'
}

/** KYC document provided by client */
export type Document = {
  __typename?: 'Document';
  /** Activity logs concerning this document */
  activityLogs: Maybe<Array<Maybe<ActivityLog>>>;
  /** Count of activity logs concerning this document */
  activityLogsCount: Maybe<Scalars['Int']['output']>;
  /** User assigned to document */
  assignee: Maybe<User>;
  autoProcessingResult: Maybe<Scalars['String']['output']>;
  cardNumber: Maybe<Scalars['String']['output']>;
  /** Client who uploaded this document */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Document Processing Time duration */
  docProcessingTime: Maybe<Scalars['Int']['output']>;
  expiration: Maybe<Scalars['DateTime']['output']>;
  /** Description of document */
  fileDescription: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  filePath: Maybe<Scalars['String']['output']>;
  /** Document ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Pending withdrawals related to client that uploaded this document */
  pendingWithdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  queuePosition: Maybe<Scalars['Int']['output']>;
  /** Rejection reason */
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** Rejection reason code */
  rejectionReasonCode: Maybe<DocumentRejectionReasonCode>;
  rejectionReasonDescription: Maybe<Scalars['String']['output']>;
  relatesTo: Maybe<Scalars['Int']['output']>;
  /** Status of this document */
  status: Maybe<DocumentStatus>;
  statusDescription: Maybe<Scalars['String']['output']>;
  translation: Maybe<DocumentTranslationType>;
  /** Type of document */
  type: Maybe<DocumentType>;
  typeDescription: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** URL where document is stored */
  url: Maybe<Scalars['String']['output']>;
};


/** KYC document provided by client */
export type DocumentActivityLogsArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


/** KYC document provided by client */
export type DocumentActivityLogsCountArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};

/** Withdrawal requests for this user */
export type Withdrawal = {
  __typename?: 'Withdrawal';
  /** Account withdrawal is requested from */
  account: Maybe<Account>;
  /** Activity logs concerning this withdrawal */
  activityLogs: Maybe<Array<Maybe<ActivityLog>>>;
  /** Count of activity logs concerning this withdrawal */
  activityLogsCount: Maybe<Scalars['Int']['output']>;
  amount: Maybe<Scalars['Float']['output']>;
  /** Comments for specific withdrawal */
  comments: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency of withdrawal */
  currency: Maybe<Currency>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  depositVendor: Maybe<Scalars['String']['output']>;
  /** Withdrawal ID */
  id: Maybe<Scalars['Int']['output']>;
  meta: Maybe<Scalars['String']['output']>;
  paymentFields: Maybe<WithdrawalPaymentFieldsType>;
  paymentVendor: Maybe<WithdrawalPaymentVendorsType>;
  pendingFundingDocuments: Maybe<Array<Maybe<Document>>>;
  /** Pending reason code */
  pendingReasonCode: Maybe<WithdrawalPendingReasonCode>;
  queuePosition: Maybe<Scalars['Int']['output']>;
  receipt: Maybe<Scalars['String']['output']>;
  /** Rejection reason */
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** Rejection reason code */
  rejectionReasonCode: Maybe<WithdrawalRejectionReasonCode>;
  rejectionReasonDescription: Maybe<Scalars['String']['output']>;
  /** Sales agent at the time of the withdrawal */
  salesAgent: Maybe<User>;
  /** Status of this withdrawal */
  status: Maybe<WithdrawalStatus>;
  statusDescription: Maybe<Scalars['String']['output']>;
  trackUser: Maybe<TrackUser>;
  /** Destination account for transfer */
  transferToAccount: Maybe<Account>;
  /** Type of this withdrawal */
  type: Maybe<WithdrawalType>;
  typeDescription: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** User handling this withdrawal */
  user: Maybe<User>;
  withdrawalReason: Maybe<WithdrawalReasonsType>;
  withdrawalReasonText: Maybe<Scalars['String']['output']>;
};


/** Withdrawal requests for this user */
export type WithdrawalActivityLogsArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


/** Withdrawal requests for this user */
export type WithdrawalActivityLogsCountArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};

export type WithdrawalPaymentFieldsType = {
  __typename?: 'WithdrawalPaymentFieldsType';
  accountNumber: Maybe<Scalars['String']['output']>;
  bank: Maybe<Scalars['String']['output']>;
  bankAccountArea: Maybe<Scalars['String']['output']>;
  bankAccountCity: Maybe<Scalars['String']['output']>;
  bankAccountHolderName: Maybe<Scalars['String']['output']>;
  bankAccountName: Maybe<Scalars['String']['output']>;
  bankAccountNumber: Maybe<Scalars['String']['output']>;
  bankAccountProvince: Maybe<Scalars['String']['output']>;
  bankAccountType: Maybe<Scalars['String']['output']>;
  bankBranch: Maybe<Scalars['String']['output']>;
  bankCode: Maybe<Scalars['String']['output']>;
  bankCodeString: Maybe<Scalars['String']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  beneficiaryAddress: Maybe<Scalars['String']['output']>;
  beneficiaryEmail: Maybe<Scalars['String']['output']>;
  beneficiaryFirstName: Maybe<Scalars['String']['output']>;
  beneficiaryLastName: Maybe<Scalars['String']['output']>;
  beneficiaryPhone: Maybe<Scalars['String']['output']>;
  branchCode: Maybe<Scalars['String']['output']>;
  card: Maybe<Scalars['String']['output']>;
  cardExpiryMonth: Maybe<Scalars['Int']['output']>;
  cardExpiryYear: Maybe<Scalars['Int']['output']>;
  cardHolderName: Maybe<Scalars['String']['output']>;
  cardNumber: Maybe<Scalars['String']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  cryptoAmount: Maybe<Scalars['Float']['output']>;
  cryptoCurrency: Maybe<Scalars['String']['output']>;
  cryptoNetwork: Maybe<Scalars['String']['output']>;
  deliveryAdditionalInstructions: Maybe<Scalars['String']['output']>;
  deliveryAddressCity: Maybe<Scalars['String']['output']>;
  deliveryAddressCountry: Maybe<Scalars['String']['output']>;
  deliveryAddressLine1: Maybe<Scalars['String']['output']>;
  deliveryAddressLine2: Maybe<Scalars['String']['output']>;
  deliveryAddressRegion: Maybe<Scalars['String']['output']>;
  deliveryAddressZipCode: Maybe<Scalars['String']['output']>;
  destinationTag: Maybe<Scalars['String']['output']>;
  document: Maybe<Scalars['String']['output']>;
  documentType: Maybe<Scalars['String']['output']>;
  emailOrEWalletNumber: Maybe<Scalars['String']['output']>;
  enovipayPayoutCryptoNetwork: Maybe<Scalars['String']['output']>;
  exchangeAmount: Maybe<Scalars['Float']['output']>;
  exchangeRate: Maybe<Scalars['Float']['output']>;
  goldValue: Maybe<Scalars['Float']['output']>;
  iban: Maybe<Scalars['String']['output']>;
  nameOfBank: Maybe<Scalars['String']['output']>;
  paymentOption: Maybe<Scalars['String']['output']>;
  personalId: Maybe<Scalars['String']['output']>;
  provider: Maybe<Scalars['String']['output']>;
  swiftCode: Maybe<Scalars['String']['output']>;
  taxId: Maybe<Scalars['String']['output']>;
  termsAndConditions: Maybe<Scalars['String']['output']>;
  transferToAccount: Maybe<Scalars['Float']['output']>;
  vendorAccountEmail: Maybe<Scalars['String']['output']>;
  vendorAccountId: Maybe<Scalars['String']['output']>;
  walletAddress: Maybe<Scalars['String']['output']>;
  walletAddressConfirmation: Maybe<Scalars['String']['output']>;
  walletResponsibilityConfirmation: Maybe<Scalars['String']['output']>;
  withdrawalFee: Maybe<Scalars['Float']['output']>;
  withdrawalNetAmount: Maybe<Scalars['Float']['output']>;
};

export enum WithdrawalPaymentVendorsType {
  Astropay = 'astropay',
  B2bpay = 'b2bpay',
  BankTransfer = 'bankTransfer',
  Bch = 'BCH',
  BitnukCryptoWithdraw = 'bitnukCryptoWithdraw',
  BitnukSellCrypto = 'bitnukSellCrypto',
  BridgerPay = 'bridgerPay',
  Btc = 'BTC',
  Btcproxy = 'btcproxy',
  CardpayVndBankTransfer = 'cardpayVndBankTransfer',
  Coinpayments = 'coinpayments',
  CreditDebitCard = 'creditDebitCard',
  Cryptocurrency = 'cryptocurrency',
  Dinpay = 'dinpay',
  Directa24 = 'directa24',
  Divepay = 'divepay',
  Dusupay = 'dusupay',
  Easyeft = 'easyeft',
  Echelonpay = 'echelonpay',
  EnovipayCryptoPayout = 'enovipayCryptoPayout',
  EnovipayRefund = 'enovipayRefund',
  Eth = 'ETH',
  Fasapay = 'fasapay',
  Funtopay = 'funtopay',
  Gigadat = 'gigadat',
  Globepay = 'globepay',
  GoldDelivery = 'goldDelivery',
  Help2pay = 'help2pay',
  Localpay = 'localpay',
  Lydian = 'lydian',
  Mifinity = 'mifinity',
  Neteller = 'neteller',
  NetellerSkrill = 'netellerSkrill',
  NganLuong = 'nganLuong',
  PammWithdrawal = 'pammWithdrawal',
  PaymentAsia = 'paymentAsia',
  Paypal = 'paypal',
  PayRetailers = 'payRetailers',
  Paytrust = 'paytrust',
  Qiwi = 'qiwi',
  Rpnpay = 'rpnpay',
  Skrill = 'skrill',
  Thunderxpay = 'thunderxpay',
  WebMoney = 'webMoney',
  Zotapay = 'zotapay'
}

/** One of the possible withdrawal pending reason codes */
export enum WithdrawalPendingReasonCode {
  BankCardStatement = 'bankCardStatement',
  BankPersonalInfoStatement = 'bankPersonalInfoStatement',
  Iban = 'iban',
  IdentificationDocument = 'identificationDocument',
  Other = 'other',
  ProofOfPayment = 'proofOfPayment',
  WalletSceenshot = 'walletSceenshot'
}

/** One of the possible withdrawal rejection reason codes */
export enum WithdrawalRejectionReasonCode {
  ActiveBonus = 'activeBonus',
  ChargebackFraud = 'chargebackFraud',
  ClientRequest = 'clientRequest',
  DuplicateRequest = 'duplicateRequest',
  EWallet = 'eWallet',
  FailedEmailRespond = 'failedEmailRespond',
  InsufficientFreeMargin = 'insufficientFreeMargin',
  InsufficientFunds = 'insufficientFunds',
  InvalidBankDetail = 'invalidBankDetail',
  MissingKycDoc = 'missingKycDoc',
  MissingProofAddress = 'missingProofAddress',
  MissingProofOfId = 'missingProofOfId',
  Other = 'other',
  ResubmitBankAccount = 'resubmitBankAccount',
  ResubmitCreditCard = 'resubmitCreditCard',
  ResubmitNetellerAccount = 'resubmitNetellerAccount',
  ResubmitSkrillAccount = 'resubmitSkrillAccount',
  ResubmitToDepositMethod = 'resubmitToDepositMethod',
  ResubmitWallet = 'resubmitWallet',
  SmallerThanWithdrawalFees = 'smallerThanWithdrawalFees',
  ThirdPartyFirst = 'thirdPartyFirst',
  WithdrawProfits = 'withdrawProfits'
}

/** One of the possible withdrawal statuses */
export enum WithdrawalStatus {
  Accepted = 'accepted',
  NotProcessed = 'notProcessed',
  OnHold = 'onHold',
  PartiallyReversed = 'partiallyReversed',
  Pending = 'pending',
  Processing = 'processing',
  Rejected = 'rejected',
  Reversed = 'reversed'
}

export type TrackUser = {
  __typename?: 'TrackUser';
  /** Platform */
  browser: Maybe<Scalars['String']['output']>;
  /** Client */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Platform */
  device: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Deposit linked */
  objectDeposit: Maybe<Deposit>;
  /** Type */
  objectType: Maybe<Scalars['String']['output']>;
  /** Withdrawal linked */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Platform */
  operatingSystem: Maybe<Scalars['String']['output']>;
  /** Platform */
  platform: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** One of the possible withdrawal types */
export enum WithdrawalType {
  AdjustmentCorrection = 'adjustmentCorrection',
  BalanceDeduction = 'balanceDeduction',
  Bonus = 'bonus',
  CancellationOfProfits = 'cancellationOfProfits',
  CopyTradingMonthlyFee = 'copyTradingMonthlyFee',
  CreditBonus = 'creditBonus',
  Fees = 'fees',
  InactivityFee = 'inactivityFee',
  ManagedAccountFee = 'managedAccountFee',
  PerformanceFee = 'performanceFee',
  ReturnedFunds = 'returnedFunds',
  Transfer = 'transfer',
  Transferb2b = 'transferb2b',
  TransferWithdrawalCommisions = 'transferWithdrawalCommisions',
  Withdrawal = 'withdrawal',
  WithdrawalCommisions = 'withdrawalCommisions'
}

export enum WithdrawalReasonsType {
  Help = 'help',
  MobileApp = 'mobileApp',
  Other = 'other',
  Profit = 'profit',
  TradingPlatform = 'tradingPlatform',
  TradingWithOtherBroker = 'tradingWithOtherBroker'
}

/** One of the possible document rejection reason codes */
export enum DocumentRejectionReasonCode {
  AddressMismatch = 'addressMismatch',
  DuplicateDocument = 'duplicateDocument',
  ExpiredDoc = 'expiredDoc',
  FailedVerification = 'failedVerification',
  NameMismatch = 'nameMismatch',
  NotAcceptableDocType = 'notAcceptableDocType',
  NotAcceptableInfo = 'notAcceptableInfo',
  NotFullPageOfDoc = 'notFullPageOfDoc',
  Other = 'other',
  RelevantDocument = 'relevantDocument',
  SensibleInfoVisible = 'sensibleInfoVisible',
  UnclearDoc = 'unclearDoc'
}

/** Document Translations for compliance/backoffice */
export type DocumentTranslationType = {
  __typename?: 'DocumentTranslationType';
  /** Client ID */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Document type details */
  document: Maybe<Document>;
  id: Maybe<Scalars['ID']['output']>;
  /** Document Translation Details */
  meta: Maybe<Scalars['String']['output']>;
  /** Document Translation Type */
  translationType: Maybe<TranslationTypeTypes>;
  /** User assigned to translate document */
  translator: Maybe<User>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** User document translation */
  user: Maybe<User>;
};

/** List of document Translation Types */
export enum TranslationTypeTypes {
  CorporateTranslation = 'corporateTranslation',
  OtherTranslation = 'otherTranslation',
  PoiTranslation = 'poiTranslation',
  PorTranslation = 'porTranslation'
}

/** List of due diligence status types */
export enum DueDiligenceStatusType {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
  UnderReview = 'underReview'
}

/** Due Diligence */
export type DueDiligence = {
  __typename?: 'DueDiligence';
  answers: Maybe<DueDiligenceAnswers>;
  /** Client ID */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  rejectionCode: Maybe<Scalars['String']['output']>;
  rejectionReason: Maybe<Scalars['String']['output']>;
  status: Maybe<DueDiligenceStatusType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type DueDiligenceAnswers = {
  __typename?: 'DueDiligenceAnswers';
  existingClients: Maybe<ExistingClients>;
  existingClientsDescription: Maybe<Scalars['String']['output']>;
  existingClientsUpload: Maybe<Scalars['String']['output']>;
  promoteProducts: Maybe<Array<Maybe<PromoteProducts>>>;
  promoteProductsBusinessPlan: Maybe<Scalars['String']['output']>;
  promoteProductsDescription: Maybe<Scalars['String']['output']>;
  promoteProductsLinks: Maybe<Scalars['String']['output']>;
  relevantLicenses: Maybe<RelevantLicenses>;
  relevantLicensesDescription: Maybe<Scalars['String']['output']>;
  relevantLicensesUpload: Maybe<Scalars['String']['output']>;
  servicesOffer: Maybe<Array<Maybe<ServicesOffer>>>;
  servicesOfferDescription: Maybe<Scalars['String']['output']>;
  servicesOfferUpload: Maybe<Scalars['String']['output']>;
  termsConditions: Maybe<Array<Maybe<TermsConditions>>>;
  yearsOfExperience: Maybe<YearsOfExperience>;
};

export enum ExistingClients {
  No = 'no',
  Yes = 'yes'
}

export enum PromoteProducts {
  GroupsChats = 'groupsChats',
  Other = 'other',
  Seminars = 'seminars',
  SocialMediaAccounts = 'socialMediaAccounts',
  Webinars = 'webinars',
  Websites = 'websites'
}

export enum RelevantLicenses {
  No = 'no',
  Yes = 'yes'
}

export enum ServicesOffer {
  Education = 'education',
  FundManagementServices = 'fundManagementServices',
  Other = 'other',
  Referrals = 'referrals',
  Signals = 'signals',
  TradingSoftwares = 'tradingSoftwares'
}

export enum TermsConditions {
  AgreedTerms1 = 'agreedTerms1',
  AgreedTerms2 = 'agreedTerms2'
}

export enum YearsOfExperience {
  FiveToTenYears = 'fiveToTenYears',
  MoreThanTenYears = 'moreThanTenYears',
  NoExperience = 'noExperience',
  OneToFiveYears = 'oneToFiveYears'
}

export type EconomicProfileDocs = {
  __typename?: 'EconomicProfileDocs';
  identityOfTheThirdParty: Maybe<Document>;
  proofsOfIdentityFiamlRegulations: Maybe<Document>;
  relationshipThirdParty: Maybe<Document>;
};

export type ElectronicIdentityVerificationResultType = {
  __typename?: 'ElectronicIdentityVerificationResultType';
  /** Address Reliability Description */
  addressReliability: Maybe<Scalars['String']['output']>;
  /** Client */
  client: Maybe<Client>;
  /** Creation Time */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Serial Id */
  id: Maybe<Scalars['Int']['output']>;
  /** Identity Reliability Description */
  identityReliability: Maybe<Scalars['String']['output']>;
  /** Unprocessed Validation Result */
  rawResult: Maybe<Scalars['String']['output']>;
  /** User that requested the verification */
  requestedBy: Maybe<User>;
};

export type EligibleBonusTypeType = {
  __typename?: 'eligibleBonusTypeType';
  daysLeft: Maybe<Scalars['Float']['output']>;
  daysRemainingNotification: Maybe<Scalars['Float']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  maxAmount: Maybe<Scalars['Float']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
};

export enum Gender {
  Female = 'female',
  Male = 'male',
  Other = 'other'
}

export type GlobalQuestionnaire = {
  __typename?: 'GlobalQuestionnaire';
  /** Estimated amount to deposit */
  approxExpectedDeposit: Maybe<Scalars['String']['output']>;
  /** Approximate Net Worth */
  approxNetWorth: Maybe<Scalars['String']['output']>;
  /** Approximate Yearly Income */
  approxYearlyIncome: Maybe<Scalars['String']['output']>;
  commercialRationaleForBusinessRelationship: Maybe<Scalars['String']['output']>;
  employmentStatus: Maybe<Scalars['String']['output']>;
  initialIntendedContribution: Maybe<Scalars['String']['output']>;
  /** Job Title/Position */
  jobTitle: Maybe<Scalars['String']['output']>;
  /** Nature of transactions */
  natureOfTransactions: Maybe<Scalars['String']['output']>;
  /** Nature of transactions Clarification */
  natureOfTransactionsClarify: Maybe<Scalars['String']['output']>;
  nomineeStatus: Maybe<YesNo>;
  /** Origin of funds */
  originOfFunds: Maybe<Scalars['String']['output']>;
  /** Politically Exposed Person */
  politicallyExposed: Maybe<YesNo>;
  /** Politically Exposed Person Reason */
  politicallyExposedReason: Maybe<Scalars['String']['output']>;
  relevantTradingEducationExperience: Maybe<Scalars['String']['output']>;
  riskAwarenessOfCfdTrading: Maybe<YesNo>;
  riskToleranceForCfd: Maybe<Scalars['String']['output']>;
  /** Source of Funds */
  sourceOfFunds: Maybe<Scalars['String']['output']>;
  /** Source of funds Clarification */
  sourceOfFundsClarify: Maybe<Scalars['String']['output']>;
  /** Country/Jurisdiction of Tax Residence */
  taxJurisdictionCountry: Maybe<Country>;
  /** Taxpayer Identification Number (TIN) */
  tin: Maybe<Scalars['String']['output']>;
  /** Tin Clarification */
  tinClarify: Maybe<Scalars['String']['output']>;
  /** If TIN is not available, please enter reason:  */
  tinReason: Maybe<Scalars['String']['output']>;
  /** Purpose of transactions */
  transactionPurpose: Maybe<Scalars['String']['output']>;
  /** Transaction purpose Clarification */
  transactionPurposeClarify: Maybe<Scalars['String']['output']>;
  /** US Citizen/Resident */
  usCitizen: Maybe<YesNo>;
};

/** One of the possible kyc rejection reason */
export enum KycRejectionReason {
  AdditionalDocumentation = 'additionalDocumentation',
  BankStatement = 'bankStatement',
  CopiesOfCreditDebitCards = 'copiesOfCreditDebitCards',
  Other = 'other',
  ProofOfAddress = 'proofOfAddress',
  RenewedProofOfIdentification = 'renewedProofOfIdentification',
  ResubmissionOfAppTest = 'resubmissionOfAppTest',
  UpdatedKycDocuments = 'updatedKycDocuments'
}

export type LegacyAppropTest = {
  __typename?: 'LegacyAppropTest';
  /** Client's annual income (EUR) */
  annualIncome: Maybe<AnnualIncome>;
  /** Average transaction size (EUR) */
  avgTransactionSize: Maybe<AvgTransactionSize>;
  /** Employer Name */
  employer: Maybe<Scalars['String']['output']>;
  /** Organization category/type */
  employerCategory: Maybe<EmployerCategory>;
  /** Employment Status */
  employmentStatus: Maybe<EmploymentStatus>;
  /** Expected amount of money client intends to deposit */
  expectedDeposit: Maybe<ExpectedDeposit>;
  /** Expected tunover of the client's account */
  expectedTurnover: Maybe<ExpectedTurnover>;
  /** Experience trading Exchange traded derivatives (past 3 years) */
  experienceExchange: Maybe<ExperienceFrequency>;
  /** The method of how the client gained trading experience (past 3 years) */
  experienceMethod: Maybe<ExperienceMethod>;
  /** Experience trading OTC derivatives (past 3 years) */
  experienceOtc: Maybe<ExperienceFrequency>;
  /** Experience trading Shares and Bonds (past 3 years) */
  experienceShares: Maybe<ExperienceFrequency>;
  /** Previous work experience, trading experience or relevant qualification */
  isExperienced: Maybe<YesNo>;
  /** Is client a US reportable person for tax purposes/a tax payer? */
  isUsReportable: Maybe<YesNo>;
  /** Client's estimated net worth (EUR) */
  netWorth: Maybe<NetWorth>;
  /** Title in the organization */
  positionTitle: Maybe<Scalars['String']['output']>;
  /** Source of client's funds */
  sourceOfFunds: Maybe<SourceOfFunds>;
  /** Source of client's funds (Other) */
  sourceOfFundsOther: Maybe<Scalars['String']['output']>;
  /** Reason why client wishes to trade with us */
  tradingPurpose: Maybe<TradingPurpose>;
  /** Reason why client wishes to trade with us (Other) */
  tradingPurposeOther: Maybe<Scalars['String']['output']>;
};

/** List of annual incomes */
export enum AnnualIncome {
  Above500k = 'above500k',
  Between100kAnd249k = 'between100kAnd249k',
  Between20kAnd49k = 'between20kAnd49k',
  Between250kAnd500k = 'between250kAnd500k',
  Between50kAnd99k = 'between50kAnd99k',
  LessThan20k = 'lessThan20k'
}

/** List of averageg transaction sizes */
export enum AvgTransactionSize {
  Gt1000Eur = 'gt1000Eur',
  Lt1000Eur = 'lt1000Eur',
  Lt10Eur = 'lt10Eur',
  Lt499Eur = 'lt499Eur',
  Lt99Eur = 'lt99Eur'
}

/** List of employer categories */
export enum EmployerCategory {
  Accountancy = 'accountancy',
  AdminSecretarial = 'adminSecretarial',
  CateringHospitality = 'cateringHospitality',
  ConstructionRealestate = 'constructionRealestate',
  CreativeMedia = 'creativeMedia',
  Education = 'education',
  EmergencyServices = 'emergencyServices',
  Engineering = 'engineering',
  FinancialServices = 'financialServices',
  HealthMedicine = 'healthMedicine',
  HumanResources = 'humanResources',
  Insurance = 'insurance',
  Legal = 'legal',
  LeisureTourism = 'leisureTourism',
  Manufacturing = 'manufacturing',
  MarketingPrAdvertising = 'marketingPrAdvertising',
  Military = 'military',
  Other = 'other',
  Pharmaceuticals = 'pharmaceuticals',
  Retail = 'retail',
  Sales = 'sales',
  SocialcareServices = 'socialcareServices',
  Telecommunications = 'telecommunications',
  TransportLogistics = 'transportLogistics'
}

/** List of employment statuses */
export enum EmploymentStatus {
  Employed = 'employed',
  Retired = 'retired',
  SelfEmployed = 'selfEmployed',
  Student = 'student',
  Unemployed = 'unemployed'
}

/** List of expected deposits */
export enum ExpectedDeposit {
  Above500k = 'above500k',
  Between100kAnd249k = 'between100kAnd249k',
  Between20kAnd49k = 'between20kAnd49k',
  Between250kAnd500k = 'between250kAnd500k',
  Between50kAnd99k = 'between50kAnd99k',
  LessThan20k = 'lessThan20k'
}

/** List of expected turnovers */
export enum ExpectedTurnover {
  Above500k = 'above500k',
  Between100kAnd249k = 'between100kAnd249k',
  Between20kAnd49k = 'between20kAnd49k',
  Between250kAnd500k = 'between250kAnd500k',
  Between50kAnd99k = 'between50kAnd99k',
  LessThan20k = 'lessThan20k'
}

/** List of experience frequencies */
export enum ExperienceFrequency {
  Frequently = 'frequently',
  RarelyNever = 'rarelyNever',
  Sometimes = 'sometimes'
}

/** List of experience methods */
export enum ExperienceMethod {
  MakeMyOwnDecisions = 'makeMyOwnDecisions',
  UsedManagedFunds = 'usedManagedFunds'
}

/** List of net worths */
export enum NetWorth {
  Above500k = 'above500k',
  Between100kAnd249k = 'between100kAnd249k',
  Between20kAnd49k = 'between20kAnd49k',
  Between250kAnd500k = 'between250kAnd500k',
  Between50kAnd99k = 'between50kAnd99k',
  LessThan20k = 'lessThan20k',
  None = 'none'
}

/** List of sources of funds */
export enum SourceOfFunds {
  AssetSellingIncome = 'assetSellingIncome',
  BusinessIncome = 'businessIncome',
  Employment = 'employment',
  Inheritance = 'inheritance',
  Investment = 'investment',
  Other = 'other',
  Realestate = 'realestate',
  RentingPropertyIncome = 'rentingPropertyIncome',
  Savings = 'savings'
}

/** List of trading purposes */
export enum TradingPurpose {
  Other = 'other',
  Profitability = 'profitability',
  StrategicInvestment = 'strategicInvestment',
  TradingPurposes = 'tradingPurposes'
}

export enum Locale {
  Ar = 'ar',
  Cs = 'cs',
  Da = 'da',
  De = 'de',
  El = 'el',
  En = 'en',
  Es = 'es',
  Fi = 'fi',
  Fr = 'fr',
  Hi = 'hi',
  Hu = 'hu',
  Id = 'id',
  It = 'it',
  Ja = 'ja',
  Ko = 'ko',
  Mn = 'mn',
  Ms = 'ms',
  Nl = 'nl',
  No = 'no',
  Ph = 'ph',
  Pl = 'pl',
  Pt = 'pt',
  Ro = 'ro',
  Ru = 'ru',
  Sv = 'sv',
  Th = 'th',
  Tr = 'tr',
  Vi = 'vi',
  Zh = 'zh'
}

export type MinimumDeposit = {
  __typename?: 'MinimumDeposit';
  /** Amount of minimum deposit */
  amount: Scalars['Float']['output'];
  /** Currency of minimum deposit */
  currency: Maybe<Currency>;
};

export enum Nationality {
  Afghan = 'afghan',
  Alandish = 'alandish',
  Albanian = 'albanian',
  Algerian = 'algerian',
  American = 'american',
  AmericanSamoan = 'americanSamoan',
  Andorran = 'andorran',
  Angolan = 'angolan',
  Anguillan = 'anguillan',
  Antarctic = 'antarctic',
  AntiguanBarbudan = 'antiguanBarbudan',
  Argentinean = 'argentinean',
  Armenian = 'armenian',
  Aruban = 'aruban',
  Australian = 'australian',
  Austrian = 'austrian',
  Azerbaijani = 'azerbaijani',
  Bahamian = 'bahamian',
  Bahraini = 'bahraini',
  Bangladeshi = 'bangladeshi',
  Barbadian = 'barbadian',
  Belarusian = 'belarusian',
  Belgian = 'belgian',
  Belizean = 'belizean',
  Beninese = 'beninese',
  Bermudan = 'bermudan',
  Bhutanese = 'bhutanese',
  Bolivian = 'bolivian',
  BonaireSintEustatiusAndSaba = 'bonaireSintEustatiusAndSaba',
  BosnianHerzegovinian = 'bosnianHerzegovinian',
  BouvetIsland = 'bouvetIsland',
  Brazilian = 'brazilian',
  British = 'british',
  BritishIndianOceanTerritory = 'britishIndianOceanTerritory',
  BritishVirginIslands = 'britishVirginIslands',
  Bruneian = 'bruneian',
  Bulgarian = 'bulgarian',
  Burkinabe = 'burkinabe',
  Burundian = 'burundian',
  Cambodian = 'cambodian',
  Cameroonian = 'cameroonian',
  Canadian = 'canadian',
  CapeVerdian = 'capeVerdian',
  Caymanian = 'caymanian',
  CentralAfrican = 'centralAfrican',
  Chadian = 'chadian',
  Chilean = 'chilean',
  Chinese = 'chinese',
  ChristmasIsland = 'christmasIsland',
  Cocossian = 'cocossian',
  Colombian = 'colombian',
  Comoran = 'comoran',
  Congo = 'congo',
  Congolese = 'congolese',
  CookIslander = 'cookIslander',
  CostaRican = 'costaRican',
  Croatian = 'croatian',
  Cuban = 'cuban',
  Curacaoan = 'curacaoan',
  Cypriot = 'cypriot',
  Czech = 'czech',
  Danish = 'danish',
  Djibouti = 'djibouti',
  Dominica = 'dominica',
  Dominican = 'dominican',
  Dutch = 'dutch',
  Ecuadorean = 'ecuadorean',
  Egyptian = 'egyptian',
  Emirian = 'emirian',
  EquatorialGuinean = 'equatorialGuinean',
  Eritrean = 'eritrean',
  Estonian = 'estonian',
  Ethiopian = 'ethiopian',
  FalklandIslander = 'falklandIslander',
  Faroese = 'Faroese',
  Fijian = 'fijian',
  Filipino = 'filipino',
  Finnish = 'finnish',
  French = 'french',
  FrenchGuianese = 'frenchGuianese',
  FrenchPolynesian = 'frenchPolynesian',
  FrenchSouthernTerritories = 'frenchSouthernTerritories',
  Gabonese = 'gabonese',
  Gambian = 'gambian',
  Georgian = 'georgian',
  German = 'german',
  Ghanaian = 'ghanaian',
  Gibraltar = 'gibraltar',
  Greek = 'greek',
  Greenlander = 'greenlander',
  Grenadian = 'grenadian',
  Guadeloupean = 'guadeloupean',
  Guamanian = 'guamanian',
  Guatemalan = 'guatemalan',
  Guernsey = 'guernsey',
  GuineaBissau = 'guineaBissau',
  Guinean = 'guinean',
  Guyanese = 'guyanese',
  Haitian = 'haitian',
  HeardAndMcDonaldIslander = 'heardAndMcDonaldIslander',
  HeardIslandAndMcDonaldIslands = 'heardIslandAndMcDonaldIslands',
  Honduran = 'honduran',
  HongKonger = 'hongKonger',
  Hungarian = 'hungarian',
  Icelander = 'icelander',
  Indian = 'indian',
  Indonesian = 'indonesian',
  Iranian = 'iranian',
  Iraqi = 'iraqi',
  Irish = 'irish',
  Israeli = 'israeli',
  Italian = 'italian',
  Ivorian = 'ivorian',
  Jamaican = 'jamaican',
  Japanese = 'japanese',
  Jersey = 'jersey',
  Jordanian = 'jordanian',
  Kazakhstani = 'kazakhstani',
  Kenyan = 'kenyan',
  Kirghiz = 'kirghiz',
  Kiribati = 'kiribati',
  KittianNevisian = 'kittianNevisian',
  Kosovar = 'kosovar',
  Kuwaiti = 'kuwaiti',
  Laotian = 'laotian',
  Latvian = 'latvian',
  Lebanese = 'lebanese',
  Lesotho = 'lesotho',
  Liberian = 'liberian',
  Libyan = 'libyan',
  Liechtensteiner = 'liechtensteiner',
  Lithuanian = 'lithuanian',
  Luxembourger = 'luxembourger',
  Macanese = 'macanese',
  Macedonian = 'macedonian',
  Mahoran = 'mahoran',
  Malagasy = 'malagasy',
  Malawian = 'malawian',
  Malaysian = 'malaysian',
  Maldivan = 'maldivan',
  Malian = 'malian',
  Maltese = 'maltese',
  Manx = 'manx',
  Mariana = 'mariana',
  Marshallese = 'marshallese',
  Martinican = 'martinican',
  Mauritanian = 'mauritanian',
  Mauritian = 'mauritian',
  Mexican = 'mexican',
  Micronesian = 'micronesian',
  Moldovan = 'moldovan',
  Monacan = 'monacan',
  Mongolian = 'mongolian',
  Montenegrin = 'montenegrin',
  Montserratian = 'montserratian',
  Moroccan = 'moroccan',
  Motswana = 'motswana',
  Mozambican = 'mozambican',
  Myanmarese = 'myanmarese',
  Namibian = 'namibian',
  Nauruan = 'nauruan',
  Nepalese = 'nepalese',
  NetherlandsAntilles = 'netherlandsAntilles',
  NewCaledonian = 'newCaledonian',
  NewZealander = 'newZealander',
  Nicaraguan = 'nicaraguan',
  Nigerian = 'nigerian',
  Nigerien = 'nigerien',
  Niuean = 'niuean',
  NorfolkIslander = 'norfolkIslander',
  NorthKorean = 'northKorean',
  Norwegian = 'norwegian',
  Omani = 'omani',
  Pakistani = 'pakistani',
  Palauan = 'palauan',
  Palestinian = 'palestinian',
  Panamanian = 'panamanian',
  PapuaNewGuinean = 'papuaNewGuinean',
  Paraguayan = 'paraguayan',
  Peruvian = 'peruvian',
  PitcairnIslander = 'pitcairnIslander',
  Polish = 'polish',
  Portuguese = 'portuguese',
  PuertoRican = 'puertoRican',
  Qatari = 'qatari',
  Reunion = 'reunion',
  Romanian = 'romanian',
  Russian = 'russian',
  Rwandan = 'rwandan',
  Sahrawi = 'sahrawi',
  SaintBarthelemy = 'saintBarthelemy',
  SaintHelenian = 'saintHelenian',
  SaintLucian = 'saintLucian',
  SaintMartinIslander = 'saintMartinIslander',
  SaintPierrais = 'saintPierrais',
  SaintVincentian = 'saintVincentian',
  Salvadoran = 'salvadoran',
  Sammarinese = 'sammarinese',
  Samoan = 'samoan',
  SaoTomean = 'saoTomean',
  SaudiArabian = 'saudiArabian',
  Senegalese = 'senegalese',
  Serbian = 'serbian',
  Seychellois = 'seychellois',
  SierraLeonean = 'sierraLeonean',
  Singaporean = 'singaporean',
  SintMaarten = 'sintMaarten',
  Slovak = 'slovak',
  Slovene = 'slovene',
  SolomonIslander = 'solomonIslander',
  Somali = 'somali',
  SouthAfrican = 'southAfrican',
  SouthGeorgiaAndTheSouthSandwichIslands = 'southGeorgiaAndTheSouthSandwichIslands',
  SouthKorean = 'southKorean',
  SouthSudanese = 'southSudanese',
  Spanish = 'spanish',
  SriLankan = 'sriLankan',
  Sudanese = 'sudanese',
  Surinamer = 'surinamer',
  SvalbardAndJanMayen = 'svalbardAndJanMayen',
  Swazi = 'swazi',
  Swedish = 'swedish',
  Swiss = 'swiss',
  Syrian = 'syrian',
  Taiwanese = 'taiwanese',
  Tajikistani = 'tajikistani',
  Tanzanian = 'tanzanian',
  Thai = 'thai',
  Timorese = 'timorese',
  Togolese = 'togolese',
  Tokelauan = 'tokelauan',
  Tongan = 'tongan',
  Trinidadian = 'trinidadian',
  Tunisian = 'tunisian',
  Turkish = 'turkish',
  Turkmen = 'turkmen',
  TurksAndCaicosIslands = 'turksAndCaicosIslands',
  Tuvaluan = 'tuvaluan',
  Ugandan = 'ugandan',
  Ukrainian = 'ukrainian',
  UnitedStatesMinorOutlyingIslands = 'unitedStatesMinorOutlyingIslands',
  Uruguayan = 'uruguayan',
  UsVirginIslands = 'usVirginIslands',
  Uzbekistani = 'uzbekistani',
  Vanuatu = 'vanuatu',
  Vatican = 'vatican',
  Venezuelan = 'venezuelan',
  Vietnamese = 'vietnamese',
  WillisFutuna = 'willisFutuna',
  Yemeni = 'yemeni',
  Zambian = 'zambian',
  Zimbabwean = 'zimbabwean'
}

/** Note abount a client */
export type Note = BaseLogInterface & {
  __typename?: 'Note';
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  /** Note content */
  content: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Diff of content */
  diff: Maybe<Scalars['String']['output']>;
  /** Uploaded file name */
  fileName: Maybe<Scalars['String']['output']>;
  /** Uploaded file url */
  fileUrl: Maybe<Scalars['String']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

export type ProfileChange = {
  __typename?: 'ProfileChange';
  answers: Maybe<ProfileChangeAnswers>;
  /** Client who submitted this change change */
  client: Maybe<Client>;
  comments: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  rejectionReason: Maybe<Scalars['String']['output']>;
  shouldLogout: Maybe<ShouldLogout>;
  status: Maybe<ProfileChangeStatus>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type ProfileChangeAnswers = {
  __typename?: 'ProfileChangeAnswers';
  address: Maybe<ClientAddress>;
  birthday: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<Gender>;
  globalQuestionnaire: Maybe<GlobalQuestionnaire>;
  language: Maybe<Language>;
  lastName: Maybe<Scalars['String']['output']>;
  mifirId: Maybe<Scalars['String']['output']>;
  mifirType: Maybe<Scalars['String']['output']>;
  nationality: Maybe<Nationality>;
  nickname: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  secondaryEmails: Maybe<SecondaryEmails>;
  secondaryPhones: Maybe<SecondaryPhones>;
};

export type SecondaryEmails = {
  __typename?: 'SecondaryEmails';
  /** Secondary Emails: Secondary Email 1 */
  secondaryEmail1: Maybe<Scalars['String']['output']>;
  /** Secondary Emails: Secondary Email 2 */
  secondaryEmail2: Maybe<Scalars['String']['output']>;
  /** Secondary Emails: Secondary Email 3 */
  secondaryEmail3: Maybe<Scalars['String']['output']>;
};

export type SecondaryPhones = {
  __typename?: 'SecondaryPhones';
  /** Secondary Phones: Secondary Phone 1 */
  secondaryPhone1: Maybe<Scalars['String']['output']>;
};

export type ShouldLogout = {
  __typename?: 'ShouldLogout';
  reason: Maybe<Scalars['String']['output']>;
  terminateSession: Maybe<Scalars['Boolean']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export enum ProfileChangeStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
  UnderReview = 'underReview'
}

/** Possible types of ActivityLog objects */
export enum ActivityLogObjectType {
  Account = 'account',
  AppropTest = 'appropTest',
  Blacklist = 'blacklist',
  BonusOffer = 'bonusOffer',
  CryptoTransaction = 'cryptoTransaction',
  Deposit = 'deposit',
  Document = 'document',
  DueDiligence = 'dueDiligence',
  ProfileChange = 'profileChange',
  SuitabilityTest = 'suitabilityTest',
  User = 'user',
  Withdrawal = 'withdrawal'
}

/** Possible ActivityLog types */
export enum ActivityLogType {
  AcceptedMarginBonusTnc = 'acceptedMarginBonusTnc',
  AcceptedTradableBonusTnc = 'acceptedTradableBonusTnc',
  AcceptOwnBonusOffer = 'acceptOwnBonusOffer',
  AddedBonusQualifiedAmount = 'addedBonusQualifiedAmount',
  AddedBonusQualifiedDeposit = 'addedBonusQualifiedDeposit',
  AddUser = 'addUser',
  AffiliateAddedManually = 'affiliateAddedManually',
  AffiliateClientNote = 'affiliateClientNote',
  AffiliateContractSent = 'affiliateContractSent',
  AffiliateDeleted = 'affiliateDeleted',
  AffiliateUpdated = 'affiliateUpdated',
  AlertResolved = 'alertResolved',
  AllClientsCheckedAgainstSanctions = 'allClientsCheckedAgainstSanctions',
  ApproveAdminBonusOffer = 'approveAdminBonusOffer',
  ApproveAppropTest = 'approveAppropTest',
  ApproveBonusDeposit = 'approveBonusDeposit',
  ApproveDocument = 'approveDocument',
  ApproveProfileChange = 'approveProfileChange',
  ApproveWithdrawal = 'approveWithdrawal',
  AssignClientAgent = 'assignClientAgent',
  AssignClientToAffiliate = 'assignClientToAffiliate',
  AssigneeDocument = 'assigneeDocument',
  AttemptedToIncompleteClientDeposit = 'attemptedToIncompleteClientDeposit',
  AutochartistEmails = 'autochartistEmails',
  BdxInvestmentChoiceFinal = 'bdxInvestmentChoiceFinal',
  BdxWaiverAccepted = 'bdxWaiverAccepted',
  BinaryWalkthroughDeleted = 'binaryWalkthroughDeleted',
  BinaryWalkthroughProvided = 'binaryWalkthroughProvided',
  Blacklist = 'blacklist',
  Call = 'call',
  CancelledOwnCryptoTransaction = 'cancelledOwnCryptoTransaction',
  CancelWithdrawal = 'cancelWithdrawal',
  ChangedAdvancedSettingsToFollowersVisibility = 'changedAdvancedSettingsToFollowersVisibility',
  ChangedClientPotentialLevel = 'changedClientPotentialLevel',
  ChangedCompany = 'changedCompany',
  ChangeSettings = 'changeSettings',
  ClaimClientAgent = 'claimClientAgent',
  ClaimedReward = 'claimedReward',
  ClientBonusAcknowledged = 'clientBonusAcknowledged',
  ClientBonusLowEquityWarning = 'clientBonusLowEquityWarning',
  ClientCancelledDeposit = 'clientCancelledDeposit',
  ClientCancelledSubscription = 'clientCancelledSubscription',
  ClientCancelledVpsSubscription = 'clientCancelledVPSSubscription',
  ClientChangedSubscription = 'clientChangedSubscription',
  ClientChangedVpsSubscription = 'clientChangedVPSSubscription',
  ClientCheckedAgainstSanctions = 'clientCheckedAgainstSanctions',
  ClientCompetition = 'clientCompetition',
  ClientCreateDepositMethodIssueVerification = 'clientCreateDepositMethodIssueVerification',
  ClientCreatedSubscription = 'clientCreatedSubscription',
  ClientCreatedVpsSubscription = 'clientCreatedVPSSubscription',
  ClientEnabledSwapFree = 'clientEnabledSwapFree',
  ClientExitCompetition = 'clientExitCompetition',
  ClientExpiredEligibilityToRedeemPrize = 'clientExpiredEligibilityToRedeemPrize',
  ClientHasDifferentIpCountry = 'clientHasDifferentIpCountry',
  ClientHasMoreThanThreeUnverifiedCards = 'clientHasMoreThanThreeUnverifiedCards',
  ClientHasSameLastnameAndDob = 'clientHasSameLastnameAndDob',
  ClientHasSamePhoneNumber = 'clientHasSamePhoneNumber',
  ClientLinked = 'clientLinked',
  ClientLoginSuccess = 'clientLoginSuccess',
  ClientLoginVerificationSent = 'clientLoginVerificationSent',
  ClientLowMarginWarning = 'clientLowMarginWarning',
  ClientManuallyVerified = 'clientManuallyVerified',
  ClientReactivatedSubscription = 'clientReactivatedSubscription',
  ClientRedeemedPrize = 'clientRedeemedPrize',
  ClientRequestCopyTrading = 'clientRequestCopyTrading',
  ClientSourceOfFundsRequested = 'clientSourceOfFundsRequested',
  ClientTerminatedVpsSubscription = 'clientTerminatedVPSSubscription',
  ClientThirdPartyDocsRequested = 'clientThirdPartyDocsRequested',
  ClientUnlinked = 'clientUnlinked',
  ClientUpdatedSubscriptionBillingInfo = 'clientUpdatedSubscriptionBillingInfo',
  ClientUpdatedVpsSubscriptionBillingInfo = 'clientUpdatedVPSSubscriptionBillingInfo',
  CompleteClientCryptoTransaction = 'completeClientCryptoTransaction',
  CompleteClientDeposit = 'completeClientDeposit',
  CompleteDeposit = 'completeDeposit',
  CompletedOwnCryptoTransaction = 'completedOwnCryptoTransaction',
  CompleteOwnDepositWithPct = 'completeOwnDepositWithPCT',
  ConfirmOwnEmail = 'confirmOwnEmail',
  CopiedContactInfo = 'copiedContactInfo',
  CreateAdminBonusOffer = 'createAdminBonusOffer',
  CreateBonusDeposit = 'createBonusDeposit',
  CreateClientByApi = 'createClientByApi',
  CreateCryptoTransaction = 'createCryptoTransaction',
  CreatedAccount = 'createdAccount',
  CreateDeposit = 'createDeposit',
  CreateDocument = 'createDocument',
  CreateDueDiligence = 'createDueDiligence',
  CreateLead = 'createLead',
  CreateOwnAppropTest = 'createOwnAppropTest',
  CreateOwnDocument = 'createOwnDocument',
  CreateOwnDueDiligence = 'createOwnDueDiligence',
  CreateOwnSuitabilityTest = 'createOwnSuitabilityTest',
  CreatePartnersAppendix = 'createPartnersAppendix',
  CreateWithdrawal = 'createWithdrawal',
  CreateWithdrawalRequest = 'createWithdrawalRequest',
  DeletedAccount = 'deletedAccount',
  DepartmentEmailTemplateSent = 'departmentEmailTemplateSent',
  DetachedFromIb = 'detachedFromIB',
  DisabledAllowSocialTrading = 'disabledAllowSocialTrading',
  DisabledCopyTradingKeepClientBonuses = 'disabledCopyTradingKeepClientBonuses',
  DisabledCopyTradingSkipClientReadonly = 'disabledCopyTradingSkipClientReadonly',
  DisabledTradableBonus = 'disabledTradableBonus',
  EditedAccount = 'editedAccount',
  EditUserInfo = 'editUserInfo',
  EnabledAllowSocialTrading = 'enabledAllowSocialTrading',
  EnabledCopyTradingKeepClientBonuses = 'enabledCopyTradingKeepClientBonuses',
  EnabledCopyTradingSkipClientReadonly = 'enabledCopyTradingSkipClientReadonly',
  EnabledTradableBonus = 'enabledTradableBonus',
  FailDeposit = 'failDeposit',
  FailOwnDepositWithPct = 'failOwnDepositWithPCT',
  HasTradingAcademyAccess = 'hasTradingAcademyAccess',
  HoldDeposit = 'holdDeposit',
  HoldOwnDepositWithPct = 'holdOwnDepositWithPCT',
  HoldWithdrawal = 'holdWithdrawal',
  IbSpoaAuthorization = 'ibSpoaAuthorization',
  KycDocumentsNotificationFinalReminderSent = 'kycDocumentsNotificationFinalReminderSent',
  KycDocumentsNotificationReminderSent = 'kycDocumentsNotificationReminderSent',
  KycDocumentsNotificationSent = 'kycDocumentsNotificationSent',
  LogInAsClient = 'logInAsClient',
  LogInAsUser = 'logInAsUser',
  MarkedPaymentMethodThirdPartyVerified = 'markedPaymentMethodThirdPartyVerified',
  Mt4WalkthroughDeleted = 'mt4WalkthroughDeleted',
  Mt4WalkthroughProvided = 'mt4WalkthroughProvided',
  NotCompleteDeposit = 'notCompleteDeposit',
  NotCompleteOwnDepositWithPct = 'notCompleteOwnDepositWithPCT',
  Note = 'note',
  PartnerLoyaltyActivated = 'partnerLoyaltyActivated',
  PendingWithdrawal = 'pendingWithdrawal',
  PhoneVerificationInvalidPhone = 'phoneVerificationInvalidPhone',
  ProcessWithdrawal = 'processWithdrawal',
  RanAccountGbgCheck = 'ranAccountGBGCheck',
  RanElectronicIdVerificationCheck = 'ranElectronicIdVerificationCheck',
  RanSkrillVerification = 'ranSkrillVerification',
  ReferralActivated = 'referralActivated',
  RefundDeposit = 'refundDeposit',
  Registered = 'registered',
  RegistrationRejectedUsCitizen = 'registrationRejectedUsCitizen',
  RejectAdminBonusOffer = 'rejectAdminBonusOffer',
  RejectAppropTest = 'rejectAppropTest',
  RejectBonusDeposit = 'rejectBonusDeposit',
  RejectDeposit = 'rejectDeposit',
  RejectDocument = 'rejectDocument',
  RejectedMarginBonusTnc = 'rejectedMarginBonusTnc',
  RejectedTradableBonusTnc = 'rejectedTradableBonusTnc',
  RejectOwnBonusOffer = 'rejectOwnBonusOffer',
  RejectProfileChange = 'rejectProfileChange',
  RejectWithdrawal = 'rejectWithdrawal',
  ReleaseDeposit = 'releaseDeposit',
  RemoveBonusOfAccount = 'removeBonusOfAccount',
  RemoveDocument = 'removeDocument',
  RequestedPhoneVerificationCode = 'requestedPhoneVerificationCode',
  RequestedRevealEmail = 'requestedRevealEmail',
  RequestedRevealPhone = 'requestedRevealPhone',
  RequestedUpdatedDocuments = 'requestedUpdatedDocuments',
  RequestTranslation = 'requestTranslation',
  ResetClientPassword = 'resetClientPassword',
  ResetOwnForexPassword = 'resetOwnForexPassword',
  ResetPasswordAttempt = 'resetPasswordAttempt',
  ResetPasswordSuccess = 'resetPasswordSuccess',
  RevertDeposit = 'revertDeposit',
  RevertDocument = 'revertDocument',
  RevertDueDiligence = 'revertDueDiligence',
  RevertWithdrawal = 'revertWithdrawal',
  SalesClientNote = 'salesClientNote',
  SendClientSecurityCode = 'sendClientSecurityCode',
  SendInvitation = 'sendInvitation',
  SetClientConversionStatus = 'setClientConversionStatus',
  SetClientKycStatus = 'setClientKycStatus',
  SetClientTradingStatus = 'setClientTradingStatus',
  SetClientType = 'setClientType',
  SetOptinMarketing = 'setOptinMarketing',
  SetOptInSms = 'setOptInSms',
  SignedDocument = 'signedDocument',
  SpoaAuthorization = 'spoaAuthorization',
  SubmitTranslation = 'submitTranslation',
  TicketCreatedUnresolved = 'ticketCreatedUnresolved',
  TicketResolved = 'ticketResolved',
  ToggleAdditionalBonus = 'toggleAdditionalBonus',
  ToggleAffiliateAutomatedCommissions = 'toggleAffiliateAutomatedCommissions',
  ToggleAllowAccountManually = 'toggleAllowAccountManually',
  ToggleAllowNewAccounts = 'toggleAllowNewAccounts',
  ToggleAllowTransfers = 'toggleAllowTransfers',
  ToggleAutochartist = 'toggleAutochartist',
  ToggleBdxCallCompleted = 'toggleBDXCallCompleted',
  ToggleCanGrantSpoa = 'toggleCanGrantSpoa',
  ToggleCanIbTransfer = 'toggleCanIbTransfer',
  ToggleCopyTrading = 'toggleCopyTrading',
  ToggleDormantReactivation = 'toggleDormantReactivation',
  ToggleEffectiveFtd = 'toggleEffectiveFTD',
  ToggleEmailConfirmed = 'toggleEmailConfirmed',
  ToggleFundManager = 'toggleFundManager',
  ToggleHasHotAssets = 'toggleHasHotAssets',
  ToggleHasOpenComplaint = 'toggleHasOpenComplaint',
  ToggleHasPortfolioManagement = 'toggleHasPortfolioManagement',
  ToggleHasRawAccount = 'toggleHasRawAccount',
  ToggleHasTelegram = 'toggleHasTelegram',
  ToggleHasVipAccount = 'toggleHasVipAccount',
  ToggleHideMasterStrategies = 'toggleHideMasterStrategies',
  ToggleHideWdMethods = 'toggleHideWDMethods',
  ToggleIgnoreAutoMigration = 'toggleIgnoreAutoMigration',
  ToggleIgnoreIbTermination = 'toggleIgnoreIbTermination',
  ToggleisDirectIb = 'toggleisDirectIB',
  ToggleIsPhoneVerified = 'toggleIsPhoneVerified',
  ToggleManualWithdrawals = 'toggleManualWithdrawals',
  TogglePasswordProtectedStrategies = 'togglePasswordProtectedStrategies',
  TogglePasswordStrategy = 'togglePasswordStrategy',
  TogglePreSurvey = 'togglePreSurvey',
  ToggleProvideCopyTrading = 'toggleProvideCopyTrading',
  ToggleShowMasterStrategies = 'toggleShowMasterStrategies',
  ToggleSurvey = 'toggleSurvey',
  ToggleTopVip = 'toggleTopVip',
  ToggleTradeCompanion = 'toggleTradeCompanion',
  ToggleTradingCentral = 'toggleTradingCentral',
  ToggleUnderMonitoring = 'toggleUnderMonitoring',
  ToggleWithdrawalApprovals = 'toggleWithdrawalApprovals',
  UnassignClientAgent = 'unassignClientAgent',
  UnclaimClientAgent = 'unclaimClientAgent',
  UnderReviewProfileChange = 'underReviewProfileChange',
  UpdateAccountChecks = 'updateAccountChecks',
  UpdateAccountName = 'updateAccountName',
  UpdateClientDetails = 'updateClientDetails',
  UpdatedLeverage = 'updatedLeverage',
  UpdateDocument = 'updateDocument',
  UpdateDueDiligence = 'updateDueDiligence',
  UpdateEconomicProfile = 'updateEconomicProfile',
  UpdateOwnDetails = 'updateOwnDetails',
  UpdateOwnEmail = 'updateOwnEmail',
  UpdateOwnPassword = 'updateOwnPassword',
  UpdatePartnersAppendix = 'updatePartnersAppendix',
  UpdatePerformanceFee = 'updatePerformanceFee',
  UpdatePromotionalCountries = 'updatePromotionalCountries',
  UpdateWithdrawal = 'updateWithdrawal',
  UserAcceptedDepositMethodIssueVerification = 'userAcceptedDepositMethodIssueVerification',
  UserAutochartistCoelationEmail = 'userAutochartistCoelationEmail',
  UserAutochartistPlugin = 'userAutochartistPlugin',
  UserCancelledDeposit = 'userCancelledDeposit',
  UserCancelledVpsSubscription = 'userCancelledVPSSubscription',
  UserChangedSubscription = 'userChangedSubscription',
  UserChangedVpsSubscription = 'userChangedVPSSubscription',
  UserClosedAllTrades = 'userClosedAllTrades',
  UserCreatedAccount = 'userCreatedAccount',
  UserEditedFundingDocument = 'userEditedFundingDocument',
  UserRejectedDepositMethodIssueVerification = 'userRejectedDepositMethodIssueVerification',
  UserTerminatedVpsSubscription = 'userTerminatedVPSSubscription',
  UserUpdateCopyTrading = 'userUpdateCopyTrading',
  UserUpdatedLastEffectiveCall = 'userUpdatedLastEffectiveCall',
  VerifiedPhone = 'verifiedPhone',
  WebsiteWalkthroughDeleted = 'websiteWalkthroughDeleted',
  WebsiteWalkthroughProvided = 'websiteWalkthroughProvided'
}

/** Push Notification Type */
export type PartnerCustomizationType = {
  __typename?: 'partnerCustomizationType';
  accountTypeCustomizations: Maybe<AccountTypesCustomizationType>;
  affiliateId: Maybe<Scalars['String']['output']>;
  autochartist: Maybe<AutochartistCustomization>;
  bonus: Maybe<BonusCustomization>;
  campaignId: Maybe<Scalars['String']['output']>;
  classicDefaultMT4Server: Maybe<Server>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  depositorSalesAgent: Maybe<User>;
  gdcDisabled: Maybe<Scalars['Boolean']['output']>;
  ibId: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  initialDemoDeposit: Maybe<Scalars['Float']['output']>;
  leverageCustomizations: Maybe<Array<Maybe<LeverageCustomization>>>;
  minDepositCustomizations: Maybe<Array<Maybe<MinDepositCustomization>>>;
  nonDepositorSalesAgent: Maybe<User>;
  spoa: Maybe<SpoaCustomization>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type AccountTypesCustomizationType = {
  __typename?: 'AccountTypesCustomizationType';
  accountSubTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AutochartistCustomization = {
  __typename?: 'AutochartistCustomization';
  activateFor: Maybe<Scalars['String']['output']>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  network: Maybe<Scalars['String']['output']>;
};

export type BonusCustomization = {
  __typename?: 'BonusCustomization';
  enabled: Maybe<Scalars['Boolean']['output']>;
  startDate: Maybe<Scalars['DateTime']['output']>;
};

/** Supported servers for new accounts */
export enum Server {
  Demo = 'demo',
  MlDemo01 = 'mlDemo01',
  MlReal01 = 'mlReal01',
  Real01 = 'real01',
  Real02 = 'real02',
  Real03 = 'real03',
  Real04 = 'real04',
  Real05 = 'real05',
  SvgReal01 = 'svgReal01',
  TmmReal01 = 'tmmReal01'
}

export type LeverageCustomization = {
  __typename?: 'LeverageCustomization';
  accountSubType: Maybe<Scalars['String']['output']>;
  leverage: Maybe<Scalars['Int']['output']>;
};

export type MinDepositCustomization = {
  __typename?: 'MinDepositCustomization';
  accountSubType: Maybe<Scalars['String']['output']>;
  amount: Maybe<Scalars['Int']['output']>;
};

export type SpoaCustomization = {
  __typename?: 'SpoaCustomization';
  enabled: Maybe<Scalars['Boolean']['output']>;
  network: Maybe<Scalars['String']['output']>;
};

/** Partners Loyalty */
export type PartnersLoyalty = {
  __typename?: 'PartnersLoyalty';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  memberId: Maybe<Scalars['Int']['output']>;
  redeemedPrizes: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Partners Loyalty analytics */
export type PartnersLoyaltyAnalytics = {
  __typename?: 'PartnersLoyaltyAnalytics';
  clients90days: Maybe<Scalars['Int']['output']>;
  completed: Maybe<Scalars['Boolean']['output']>;
  currentPrize: Maybe<Scalars['String']['output']>;
  currentPrizeThreshold: Maybe<Scalars['Int']['output']>;
  eligible: Maybe<Scalars['Boolean']['output']>;
  eligiblePrizes: Maybe<Scalars['String']['output']>;
  memberId: Maybe<Scalars['Int']['output']>;
  /** Partners Loyalty Eligibility data from BI */
  partnersLoyaltyEligibility: Maybe<Array<Maybe<PartnersLoyaltyEligibility>>>;
  performancePercentage: Maybe<Scalars['Int']['output']>;
  totalClients: Maybe<Scalars['Int']['output']>;
  turnoverUsd: Maybe<Scalars['String']['output']>;
  turnoverUsdLastYear: Maybe<Scalars['Int']['output']>;
};


/** Partners Loyalty analytics */
export type PartnersLoyaltyAnalyticsPartnersLoyaltyEligibilityArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
};

/** Partners Loyalty eligibility */
export type PartnersLoyaltyEligibility = {
  __typename?: 'PartnersLoyaltyEligibility';
  eligibilityDate: Maybe<Scalars['DateTime']['output']>;
  endEligibilityDate: Maybe<Scalars['DateTime']['output']>;
  memberId: Maybe<Scalars['Int']['output']>;
  prizeId: Maybe<Scalars['Int']['output']>;
};

export enum PaymentCardTokenStatus {
  Errored = 'errored',
  Expired = 'expired',
  Removed = 'removed',
  Unused = 'unused',
  Valid = 'valid'
}

/** Tokenized version of a client's credit or debit card */
export type PaymentCardToken = {
  __typename?: 'PaymentCardToken';
  /** First six digits of the card number */
  bin: Maybe<Scalars['String']['output']>;
  /** Card brand - eg. mastercard/visa */
  brand: Maybe<Scalars['String']['output']>;
  /** Card category */
  category: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Month of card expiry date */
  expiryMonth: Maybe<Scalars['Int']['output']>;
  /** Year of card expiry date - eg. 2020 */
  expiryYear: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  /** IP address of the cardholder, when card first tokenized */
  ip: Maybe<Scalars['String']['output']>;
  /** Did the cardholders IP address appear on the Neutrino blocklist? */
  ipBlocklisted: Maybe<Scalars['Boolean']['output']>;
  /** Raw blocklist information */
  ipBlocklistInfo: Maybe<Scalars['String']['output']>;
  /** Did the cardholders IP address match the card issuer's country? */
  ipMatchesCountry: Maybe<Scalars['Boolean']['output']>;
  /** Card issuer eg. Bank of Austria */
  issuer: Maybe<Scalars['String']['output']>;
  /** Last four digits of the card number */
  lastFour: Maybe<Scalars['String']['output']>;
  meta: Maybe<Scalars['String']['output']>;
  /** Status of this specific token */
  status: Maybe<PaymentCardTokenStatus>;
  /** Token from Spreedly/Wirecard */
  token: Maybe<Scalars['String']['output']>;
  /** Type of the card - credit, debit or charge card */
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Vendor */
  vendor: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  confirmed: Maybe<Scalars['Boolean']['output']>;
  details: Maybe<Scalars['String']['output']>;
  fundingCategory: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  meta: Maybe<Scalars['String']['output']>;
  pendingNotes: Maybe<Scalars['String']['output']>;
  pendingUpload: Maybe<PendingUploadDocumentsTypeType>;
  relatedDocumentIds: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type PendingUploadDocumentsTypeType = {
  __typename?: 'pendingUploadDocumentsTypeType';
  allowUpload: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

/** Client message type */
export type ClientMessageType = {
  __typename?: 'clientMessageType';
  /** Client message ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Client message metadata serialized */
  metadata: Maybe<Scalars['String']['output']>;
  type: Maybe<ClientMessageTypeType>;
};

/** Client Message Types */
export enum ClientMessageTypeType {
  WelcomeAccountCreated = 'welcome_account_created'
}

/** Pending Client Notice */
export type PendingClientNoticeType = {
  __typename?: 'pendingClientNoticeType';
  /** Acknowledgements */
  acknowledgements: Maybe<Array<Maybe<ClientNoticeAcknowledgementType>>>;
  /** Notice Applicable Companies */
  applicableCompanies: Maybe<Array<Maybe<Company>>>;
  /** Notice Applicable Countries */
  applicableCountries: Maybe<Array<Maybe<Country>>>;
  /** Available Client Types */
  availableClientTypes: Maybe<Array<Maybe<ClientType>>>;
  /** Notice Content */
  content: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Client Notice ID */
  id: Maybe<Scalars['Int']['output']>;
  isContentHtml: Maybe<Scalars['Boolean']['output']>;
  localizationKey: Maybe<Scalars['String']['output']>;
  noticePeriod: Maybe<Scalars['String']['output']>;
  /** Internal Reference Code */
  referenceCode: Maybe<Scalars['String']['output']>;
  template: Maybe<PartnersAppendicesTypeType>;
  /** Notice Title */
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<ClientNoticeTypeType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Valid from date */
  validFromDate: Maybe<Scalars['DateTime']['output']>;
  validUntil: Maybe<Scalars['DateTime']['output']>;
  /** Values on partners appendices */
  values: Maybe<Scalars['String']['output']>;
  /** Notice Type Version */
  version: Maybe<Scalars['String']['output']>;
};

export type PendingUploadDocumentsType = {
  __typename?: 'pendingUploadDocumentsType';
  general: Maybe<PendingUploadDocumentsTypeType>;
  partner: Maybe<PendingUploadDocumentsTypeType>;
  personal: Maybe<PendingUploadDocumentsTypeType>;
  poi: Maybe<PendingUploadDocumentsTypeType>;
  por: Maybe<PendingUploadDocumentsTypeType>;
};

export type PeriodInEachCompanyType = {
  __typename?: 'periodInEachCompanyType';
  company: Maybe<Company>;
  dateFrom: Maybe<Scalars['DateTime']['output']>;
  dateTo: Maybe<Scalars['DateTime']['output']>;
  entity: Maybe<Scalars['String']['output']>;
};

export type PersonalIdType = {
  __typename?: 'PersonalIdType';
  documentNumber: Maybe<Scalars['String']['output']>;
  documentType: PersonalIdDocumentType;
};

/** Type of document provided as ID */
export enum PersonalIdDocumentType {
  Concat = 'concat',
  Dss_10InvestorShare = 'dss_10_investor_share',
  Intc = 'intc',
  Lei = 'lei',
  Mic = 'mic',
  NationalId = 'national_id',
  Nid = 'nid',
  PersonalNumber = 'personal_number',
  Pid = 'pid',
  Tin = 'tin'
}

/** One of the possible potential level */
export enum PotentialLevel {
  HighPotential = 'highPotential',
  LowPotential = 'lowPotential',
  MediumPotential = 'mediumPotential'
}

/** Member properties */
export type ClientProperties = {
  __typename?: 'ClientProperties';
  /** Merchant's destination crypto wallet */
  destinationWallet: Maybe<Scalars['String']['output']>;
  /** Unique ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Merchant's unique IPN */
  ipn: Maybe<Scalars['String']['output']>;
};

export type ReferralDetailsType = {
  __typename?: 'ReferralDetailsType';
  activatedReferralAwards: Maybe<ActivatedRewardsType>;
  awards: Maybe<Scalars['String']['output']>;
  conditions: Maybe<Scalars['String']['output']>;
  countReferrals: Maybe<Scalars['Int']['output']>;
  link: Maybe<Scalars['String']['output']>;
  referrals: Maybe<Array<Maybe<ReferralDetailsTypeType>>>;
  rewardsObj: Maybe<RewardsType>;
};

export type ActivatedRewardsType = {
  __typename?: 'ActivatedRewardsType';
  activatedAt: Maybe<Scalars['DateTime']['output']>;
  amount: Maybe<Scalars['Int']['output']>;
  claimedAt: Maybe<Scalars['DateTime']['output']>;
};

export type ReferralDetailsTypeType = {
  __typename?: 'ReferralDetailsTypeType';
  amountReferral: Maybe<Scalars['Float']['output']>;
  amountReferrer: Maybe<Scalars['Float']['output']>;
  conditions: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  meta: Maybe<Scalars['String']['output']>;
  referralId: Maybe<Scalars['Int']['output']>;
  referrerId: Maybe<Scalars['Int']['output']>;
  registrationDate: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<ReferralStatuses>;
};

export enum ReferralStatuses {
  Activated = 'activated',
  ActivationOverdue = 'activationOverdue',
  Claimed = 'claimed',
  ClientDeclined = 'clientDeclined',
  Deposited = 'deposited',
  PendingActivation = 'pendingActivation',
  Verified = 'verified'
}

export type RewardsType = {
  __typename?: 'RewardsType';
  claimedRewards: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  pendingRewards: Maybe<Scalars['Float']['output']>;
};

export type RegistrationCampaign = {
  __typename?: 'RegistrationCampaign';
  /** The affiliate that the campaign came from. */
  affiliate: Maybe<Client>;
  /** Affiliate client ID */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** MyAffiliates username */
  affiliateUserName: Maybe<Scalars['String']['output']>;
  /** AppsFlyer SiteID */
  appsFlyerSiteId: Maybe<Scalars['String']['output']>;
  /** Campaign */
  campaign: Maybe<Campaign>;
  /** Campaign id */
  campaignId: Maybe<Scalars['String']['output']>;
  /** Primary key into campaign */
  id: Maybe<Scalars['Int']['output']>;
  partnerCustomization: Maybe<PartnerCustomizationType>;
  /** Subcampaign id aka p parameter */
  subCampaignId: Maybe<Scalars['String']['output']>;
};

/** An internally managed advertising campaign */
export type Campaign = {
  __typename?: 'Campaign';
  /** Allowed Account Types */
  accountTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  accountTypesVisibilityRules: AccountTypesVisibilityRulesType;
  /** MT4 Affiliate Group */
  affiliateGroup: Maybe<Scalars['String']['output']>;
  /** Clients under this campaign skip phone verification step */
  avoidPhoneVerification: Maybe<Scalars['Boolean']['output']>;
  /** Budget reserved for this campaign */
  budget: Maybe<Scalars['Int']['output']>;
  /** Affiliate associated with this campaign */
  clientId: Maybe<Scalars['Int']['output']>;
  /** How long should the cookie persist? In seconds */
  cookieTimeout: Maybe<Scalars['Int']['output']>;
  /** Targeted country for campaign */
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Email verification needed for clients under this campaign */
  emailVerification: Maybe<Scalars['Boolean']['output']>;
  /** End date of campaign */
  end: Maybe<Scalars['DateTime']['output']>;
  ftdBonusCap: Maybe<Scalars['Float']['output']>;
  ftdBonusMinimumDeposits: Maybe<Array<Maybe<FtdBonusMinimumDeposit>>>;
  ftdBonusMinimumDepositsRAW: Maybe<Array<Maybe<FtdBonusMinimumDeposit>>>;
  ftdBonusMinimumDepositsVIP: Maybe<Array<Maybe<FtdBonusMinimumDeposit>>>;
  /** FtdBonus Percentage */
  ftdBonusPercentage: Maybe<Scalars['Int']['output']>;
  /** FtdBonus Percentage RAW */
  ftdBonusPercentageRAW: Maybe<Scalars['Int']['output']>;
  /** FtdBonus Percentage VIP */
  ftdBonusPercentageVIP: Maybe<Scalars['Int']['output']>;
  /** Global Deposit Limit */
  globalBonusLimit: Maybe<Scalars['Int']['output']>;
  /** Campaign ID */
  id: Maybe<Scalars['Int']['output']>;
  isMt4ClassicVisible: Maybe<Scalars['Boolean']['output']>;
  isMt4RawVisible: Maybe<Scalars['Boolean']['output']>;
  isMt4VipVisible: Maybe<Scalars['Boolean']['output']>;
  isMt5ClassicVisible: Maybe<Scalars['Boolean']['output']>;
  isMt5RawVisible: Maybe<Scalars['Boolean']['output']>;
  isMt5VipVisible: Maybe<Scalars['Boolean']['output']>;
  isTwoFactorAuthenticationEnabled: Scalars['Boolean']['output'];
  /** Kyc threshold in EUR */
  kycThreshold: Maybe<Scalars['Int']['output']>;
  /** If manual manual withdrawals enabled */
  manualWithdrawals: Maybe<Scalars['Boolean']['output']>;
  maxBonusCap: Maybe<Scalars['Float']['output']>;
  minimumDeposits: Maybe<Array<Maybe<MinimumDeposit>>>;
  /** Minimum Deposit per Account Type */
  minimumDepositsAccountType: Maybe<Array<Maybe<MinimumDepositAccountType>>>;
  /** If should create MT5 account on signup */
  mt5AccountOnSignup: Maybe<Scalars['Boolean']['output']>;
  /** Title of campaign */
  name: Maybe<Scalars['String']['output']>;
  /** Don't call this client */
  noCall: Maybe<Scalars['Boolean']['output']>;
  /** Ratio No call to call */
  noCallRatio: Maybe<Scalars['Int']['output']>;
  /** Array of tracking pixels, and when to fire them */
  pixels: Maybe<Array<Maybe<Pixel>>>;
  /** Count of pixels linked to campaign */
  pixelsCount: Maybe<Scalars['Int']['output']>;
  /** Promo Code */
  promoCode: Maybe<Scalars['String']['output']>;
  /** RAW Deposit Minimum */
  rawDepositMinimum: Maybe<Scalars['Int']['output']>;
  redepositBonusMinimumDeposits: Maybe<Array<Maybe<RedepositBonusMinimumDeposit>>>;
  redepositBonusMinimumDepositsRAW: Maybe<Array<Maybe<RedepositBonusMinimumDeposit>>>;
  redepositBonusMinimumDepositsVIP: Maybe<Array<Maybe<RedepositBonusMinimumDeposit>>>;
  /** Redeposit Bonus Percentage */
  redepositBonusPercentage: Maybe<Scalars['Int']['output']>;
  /** Redeposit Bonus Percentage RAW */
  redepositBonusPercentageRAW: Maybe<Scalars['Int']['output']>;
  /** Redeposit Bonus Percentage VIP */
  redepositBonusPercentageVIP: Maybe<Scalars['Int']['output']>;
  /** Redirect client to web trader on ftd */
  redirectWebTraderFtd: Maybe<Scalars['Boolean']['output']>;
  /** Show client welcome page on signup */
  showWelcomePage: Maybe<Scalars['Boolean']['output']>;
  /** Spotoptions Campaign ID */
  spotCampaignId: Maybe<Scalars['Int']['output']>;
  /** Start date of campaign */
  start: Maybe<Scalars['DateTime']['output']>;
  /** Campaign type */
  type: Maybe<CampaignType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** *** NOT SURE *** Is verification required? */
  verifyRequired: Maybe<Scalars['Boolean']['output']>;
  /** VIP Deposit Minimum */
  vipDepositMinimum: Maybe<Scalars['Int']['output']>;
};


/** An internally managed advertising campaign */
export type CampaignPixelsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
};

export type AccountTypesVisibilityRulesType = {
  __typename?: 'AccountTypesVisibilityRulesType';
  isMt4ClassicVisible: Maybe<Scalars['Boolean']['output']>;
  isMt4RawVisible: Maybe<Scalars['Boolean']['output']>;
  isMt4VipVisible: Maybe<Scalars['Boolean']['output']>;
  isMt5ClassicVisible: Maybe<Scalars['Boolean']['output']>;
  isMt5RawVisible: Maybe<Scalars['Boolean']['output']>;
  isMt5VipVisible: Maybe<Scalars['Boolean']['output']>;
};

export type FtdBonusMinimumDeposit = {
  __typename?: 'FtdBonusMinimumDeposit';
  /** Amount of minimum deposit */
  amount: Scalars['Float']['output'];
  /** Currency of minimum deposit */
  currency: Maybe<Currency>;
};

export type MinimumDepositAccountType = {
  __typename?: 'MinimumDepositAccountType';
  /** Account Type of minimum deposit */
  accountType: Scalars['String']['output'];
  /** Amount of minimum deposit */
  amount: Scalars['Float']['output'];
};

/** A tracking pixel, to be fired at a certain lifecycle event */
export type Pixel = {
  __typename?: 'Pixel';
  /** URL to call, should be appended with querystring created from tracking params */
  baseUrl: Maybe<Scalars['String']['output']>;
  /** Campaign linked with this pixel */
  campaign: Maybe<Campaign>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** When should this pixel be fired? Eg. registration event */
  eventName: Maybe<EventName>;
  /** Unique ID field - but might be imported UUID? In which case String type */
  id: Maybe<Scalars['Int']['output']>;
  /** Pixel name, Eg. VIP */
  name: Maybe<Scalars['String']['output']>;
  /** Key value pairs of tracking parameters */
  params: Maybe<Array<Maybe<TrackingParameter>>>;
  /** Forex, Binary or what product for this pixel */
  productName: Maybe<ProductNameType>;
  /** The key for the subcampaign to look for on the cookie path */
  subcampaignKeyName: Maybe<Scalars['String']['output']>;
  /** Client or Server side pixel? */
  type: Maybe<PixelType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** The key for the user id to look for on the cookie path */
  userIdKeyName: Maybe<Scalars['String']['output']>;
};

export enum EventName {
  Deposit = 'deposit',
  Register = 'register'
}

/** A key/value pair to be passed as part of a tracking pixel - eg. ?account_id=123 */
export type TrackingParameter = {
  __typename?: 'TrackingParameter';
  /** Name of the tracking param. Eg. account_id */
  key: Scalars['String']['output'];
  /** Type of the tracking param. */
  type: TrackingParameterType;
  /** Value of the tracking param. Eg.123 */
  value: Maybe<Scalars['String']['output']>;
};

export enum TrackingParameterType {
  Static = 'static'
}

/** List of campaign product names */
export enum ProductNameType {
  AffiliateAccount = 'AffiliateAccount',
  AffiliateEquityFlowAccount = 'AffiliateEquityFlowAccount',
  AffiliateLydianAccount = 'AffiliateLydianAccount',
  AffiliateMauritiusAccount = 'AffiliateMauritiusAccount',
  AffiliateSkyGroundAccount = 'AffiliateSkyGroundAccount',
  AffiliateTauroMarketsAccount = 'AffiliateTauroMarketsAccount',
  AffiliateTauroMarketsMauritiusAccount = 'AffiliateTauroMarketsMauritiusAccount',
  AffiliateVanuatuAccount = 'AffiliateVanuatuAccount',
  AipammAccount = 'AIPAMMAccount',
  AipammDemoAccount = 'AIPAMMDemoAccount',
  AipammMauritiusAccount = 'AIPAMMMauritiusAccount',
  AipammMauritiusDemoAccount = 'AIPAMMMauritiusDemoAccount',
  BdXcoin = 'BDXcoin',
  BdXcoinMauritius = 'BDXcoinMauritius',
  BdXcoinVanuatu = 'BDXcoinVanuatu',
  BitnukWalletMauritius = 'BitnukWalletMauritius',
  BitnukWalletSwissMarketsMauritius = 'BitnukWalletSwissMarketsMauritius',
  BitnukWalletVanuatu = 'BitnukWalletVanuatu',
  BondAccount = 'BondAccount',
  BondDemoAccount = 'BondDemoAccount',
  BondMauritiusAccount = 'BondMauritiusAccount',
  BondMauritiusDemoAccount = 'BondMauritiusDemoAccount',
  BondVanuatuAccount = 'BondVanuatuAccount',
  BondVanuatuDemoAccount = 'BondVanuatuDemoAccount',
  BrFcoin = 'BRFcoin',
  CentEquityFlowAccount = 'CentEquityFlowAccount',
  CentMauritiusAccount = 'CentMauritiusAccount',
  CentTauroMarketsAccount = 'CentTauroMarketsAccount',
  CentVanuatuAccount = 'CentVanuatuAccount',
  CleaNcoin = 'CLEANcoin',
  CryptoWallet = 'CryptoWallet',
  CuboidAccount = 'CuboidAccount',
  CuboidDemoAccount = 'CuboidDemoAccount',
  CuboidMauritiusAccount = 'CuboidMauritiusAccount',
  CuboidMauritiusDemoAccount = 'CuboidMauritiusDemoAccount',
  CuboidVanuatuAccount = 'CuboidVanuatuAccount',
  CuboidVanuatuDemoAccount = 'CuboidVanuatuDemoAccount',
  ExchangeAccount = 'ExchangeAccount',
  ExchangeBdxAccount = 'ExchangeBDXAccount',
  ExchangeMauritiusAccount = 'ExchangeMauritiusAccount',
  ExchangeVanuatuAccount = 'ExchangeVanuatuAccount',
  FiatWallet = 'FiatWallet',
  ForexAccount = 'ForexAccount',
  ForexAsiaAccount = 'ForexAsiaAccount',
  ForexClassicAccount = 'ForexClassicAccount',
  ForexClassicDemoAccount = 'ForexClassicDemoAccount',
  ForexClassicEquityFlowAccount = 'ForexClassicEquityFlowAccount',
  ForexClassicEquityFlowAsiaAccount = 'ForexClassicEquityFlowAsiaAccount',
  ForexClassicEquityFlowDemoAccount = 'ForexClassicEquityFlowDemoAccount',
  ForexClassicLydianAccount = 'ForexClassicLydianAccount',
  ForexClassicLydianDemoAccount = 'ForexClassicLydianDemoAccount',
  ForexClassicMauritiusAccount = 'ForexClassicMauritiusAccount',
  ForexClassicMauritiusDemoAccount = 'ForexClassicMauritiusDemoAccount',
  ForexClassicSkyGroundAccount = 'ForexClassicSkyGroundAccount',
  ForexClassicSkyGroundDemoAccount = 'ForexClassicSkyGroundDemoAccount',
  ForexClassicTauroMarketsAccount = 'ForexClassicTauroMarketsAccount',
  ForexClassicTauroMarketsAsiaAccount = 'ForexClassicTauroMarketsAsiaAccount',
  ForexClassicTauroMarketsDemoAccount = 'ForexClassicTauroMarketsDemoAccount',
  ForexClassicTauroMarketsMauritiusAccount = 'ForexClassicTauroMarketsMauritiusAccount',
  ForexClassicVanuatuAccount = 'ForexClassicVanuatuAccount',
  ForexClassicVanuatuDemoAccount = 'ForexClassicVanuatuDemoAccount',
  ForexDemoAccount = 'ForexDemoAccount',
  ForexMauritiusAccount = 'ForexMauritiusAccount',
  ForexMauritiusAccountBdx = 'ForexMauritiusAccountBDX',
  ForexMauritiusDemoAccount = 'ForexMauritiusDemoAccount',
  ForexMt5Account = 'ForexMT5Account',
  ForexMt5DemoAccount = 'ForexMT5DemoAccount',
  ForexMt5MauritiusAccount = 'ForexMT5MauritiusAccount',
  ForexMt5MauritiusDemoAccount = 'ForexMT5MauritiusDemoAccount',
  ForexMt5SvgTauromarketsAccount = 'ForexMT5SVGTauromarketsAccount',
  ForexMt5SvgTauromarketsDemoAccount = 'ForexMT5SVGTauromarketsDemoAccount',
  ForexMt5TauromarketsAccount = 'ForexMT5TauromarketsAccount',
  ForexMt5TauromarketsDemoAccount = 'ForexMT5TauromarketsDemoAccount',
  ForexMt5VanuatuAccount = 'ForexMT5VanuatuAccount',
  ForexMt5VanuatuDemoAccount = 'ForexMT5VanuatuDemoAccount',
  ForexPremiumMauritiusAccount = 'ForexPremiumMauritiusAccount',
  ForexPremiumVanuatuAccount = 'ForexPremiumVanuatuAccount',
  ForexRawAccount = 'ForexRawAccount',
  ForexRawBdSwissAccount = 'ForexRawBDSwissAccount',
  ForexRawBdSwissMauritiusAccount = 'ForexRawBDSwissMauritiusAccount',
  ForexRawBdSwissVanuatuAccount = 'ForexRawBDSwissVanuatuAccount',
  ForexRawEquityFlowAccount = 'ForexRawEquityFlowAccount',
  ForexRawMauritiusAccount = 'ForexRawMauritiusAccount',
  ForexRawTauroMarketsAccount = 'ForexRawTauroMarketsAccount',
  ForexRawVanuatuAccount = 'ForexRawVanuatuAccount',
  ForexVanuatuAccount = 'ForexVanuatuAccount',
  ForexVanuatuDemoAccount = 'ForexVanuatuDemoAccount',
  GoldAccount = 'GoldAccount',
  GoldMauritiusAccount = 'GoldMauritiusAccount',
  GoldVanuatuAccount = 'GoldVanuatuAccount',
  IntroducingBrokerAccount = 'IntroducingBrokerAccount',
  IntroducingBrokerBdSwissVanuatuAccount = 'IntroducingBrokerBDSwissVanuatuAccount',
  IntroducingBrokerEquityFlowAccount = 'IntroducingBrokerEquityFlowAccount',
  IntroducingBrokerMauritiusAccount = 'IntroducingBrokerMauritiusAccount',
  IntroducingBrokerSwissMarketsAccount = 'IntroducingBrokerSwissMarketsAccount',
  IntroducingBrokerSwissMarketsMauritiusAccount = 'IntroducingBrokerSwissMarketsMauritiusAccount',
  IntroducingBrokerSwissMarketsVanuatuAccount = 'IntroducingBrokerSwissMarketsVanuatuAccount',
  IntroducingBrokerTauroMarketsAccount = 'IntroducingBrokerTauroMarketsAccount',
  IntroducingBrokerTauroMarketsMauritiusAccount = 'IntroducingBrokerTauroMarketsMauritiusAccount',
  JollYcoin = 'JOLLYcoin',
  MamAccount = 'MAMAccount',
  MamMauritiusAccount = 'MAMMauritiusAccount',
  MamsmMauritiusAccount = 'MAMSMMauritiusAccount',
  MamsmVanuatuAccount = 'MAMSMVanuatuAccount',
  MamVanuatuAccount = 'MAMVanuatuAccount',
  PammAccount = 'PAMMAccount',
  PammFundManagerAccount = 'PAMMFundManagerAccount',
  PammFundManagerMauritiusAccount = 'PAMMFundManagerMauritiusAccount',
  PammFundManagerVanuatuAccount = 'PAMMFundManagerVanuatuAccount',
  PammMauritiusAccount = 'PAMMMauritiusAccount',
  PammsmAccount = 'PAMMSMAccount',
  PammsmFundManagerAccount = 'PAMMSMFundManagerAccount',
  PammsmFundManagerMauritiusAccount = 'PAMMSMFundManagerMauritiusAccount',
  PammsmFundManagerVanuatuAccount = 'PAMMSMFundManagerVanuatuAccount',
  PammsmMauritiusAccount = 'PAMMSMMauritiusAccount',
  PammsmVanuatuAccount = 'PAMMSMVanuatuAccount',
  PammTauroMarketsAccount = 'PAMMTauroMarketsAccount',
  PammTauroMarketsManagerAccount = 'PAMMTauroMarketsManagerAccount',
  PammTauroMarketsMauritiusAccount = 'PAMMTauroMarketsMauritiusAccount',
  PammTauroMarketsMauritiusManagerAccount = 'PAMMTauroMarketsMauritiusManagerAccount',
  PammTauroMarketsMt5Account = 'PAMMTauroMarketsMT5Account',
  PammTauroMarketsMt5ManagerAccount = 'PAMMTauroMarketsMT5ManagerAccount',
  PammVanuatuAccount = 'PAMMVanuatuAccount',
  PortfolioManagementAccount = 'PortfolioManagementAccount',
  PortfolioManagementMauritiusAccount = 'PortfolioManagementMauritiusAccount',
  SmPrimeWalletBdSwissAccount = 'SMPrimeWalletBDSwissAccount',
  SmPrimeWalletBdSwissMauritiusAccount = 'SMPrimeWalletBDSwissMauritiusAccount',
  SmPrimeWalletMauritiusAccount = 'SMPrimeWalletMauritiusAccount',
  SmPrimeWalletVanuatuAccount = 'SMPrimeWalletVanuatuAccount',
  SpotOptionAccount = 'SpotOptionAccount',
  SpotOptionDemoAccount = 'SpotOptionDemoAccount',
  SpotOptionMauritiusAccount = 'SpotOptionMauritiusAccount',
  SpotOptionMauritiusDemoAccount = 'SpotOptionMauritiusDemoAccount',
  SpotOptionVanuatuAccount = 'SpotOptionVanuatuAccount',
  SpotOptionVanuatuDemoAccount = 'SpotOptionVanuatuDemoAccount',
  TradesmarterAccount = 'TradesmarterAccount',
  TradesmarterDemoAccount = 'TradesmarterDemoAccount',
  TradesmarterMauritiusAccount = 'TradesmarterMauritiusAccount',
  TradesmarterMauritiusDemoAccount = 'TradesmarterMauritiusDemoAccount',
  TradesmarterVanuatuAccount = 'TradesmarterVanuatuAccount',
  TradesmarterVanuatuDemoAccount = 'TradesmarterVanuatuDemoAccount'
}

export enum PixelType {
  Post = 'post'
}

export type RedepositBonusMinimumDeposit = {
  __typename?: 'RedepositBonusMinimumDeposit';
  /** Amount of minimum deposit */
  amount: Scalars['Float']['output'];
  /** Currency of minimum deposit */
  currency: Maybe<Currency>;
};

export enum CampaignType {
  Affiliate = 'affiliate',
  CellxpertComparisonWebsite = 'cellxpertComparisonWebsite',
  CellxpertEducation = 'cellxpertEducation',
  CellxpertLeads = 'cellxpertLeads',
  CellxpertMobile = 'cellxpertMobile',
  CellxpertSignals = 'cellxpertSignals',
  CellxpertTradingCup = 'cellxpertTradingCup',
  CellxpertYoutube = 'cellxpertYoutube',
  FtdRetarget = 'ftdRetarget',
  Ib = 'ib',
  ReferAFriend = 'referAFriend',
  Regular = 'regular'
}

export type ClientRiskData = {
  __typename?: 'clientRiskData';
  clientIndustry: Maybe<Scalars['String']['output']>;
  clientType: Scalars['String']['output'];
  countryOfJurisdiction: Maybe<Scalars['String']['output']>;
  fundingCategory: Maybe<Scalars['String']['output']>;
  initialIntendedContribution: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  sourceOfFunds: Maybe<Scalars['String']['output']>;
};

/** Client Signable Notice Acknowledment Signature */
export type NoticeAcknowledgementSignatureType = {
  __typename?: 'noticeAcknowledgementSignatureType';
  /** Notice Signature Signed Date */
  dateSigned: Maybe<Scalars['String']['output']>;
  /** Notice Identifier */
  noticeId: Maybe<Scalars['String']['output']>;
  /** Notice Signature */
  signature: Maybe<Scalars['String']['output']>;
};

/** The remote client that will be authorized by the SPOA */
export type SpoaRemoteClient = {
  __typename?: 'SPOARemoteClient';
  accounts: Maybe<Array<Maybe<Account>>>;
  /** First name */
  firstName: Maybe<Scalars['String']['output']>;
  /** Client ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Last name */
  lastName: Maybe<Scalars['String']['output']>;
};

/** Suitability Test */
export type SuitabilityTest = {
  __typename?: 'SuitabilityTest';
  answers: Maybe<SuitabilityTestAnswers>;
  /** Client ID */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  portfolioPoints: Maybe<Scalars['Int']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  rejectionCode: Maybe<Scalars['String']['output']>;
  rejectionReason: Maybe<Scalars['String']['output']>;
  scoreResult: Maybe<Scalars['String']['output']>;
  status: Maybe<SuitabilityTestStatusType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type SuitabilityTestAnswers = {
  __typename?: 'SuitabilityTestAnswers';
  characterizeInvestment: Maybe<Scalars['String']['output']>;
  disposableIncome: Maybe<Scalars['String']['output']>;
  educationSuitabilityTest: Maybe<EducationSuitabilityTest>;
  fieldOfStudySuitabilityTest: Maybe<FieldOfStudySuitabilityTest>;
  incomeSources: Maybe<Scalars['String']['output']>;
  investmentFrequency: Maybe<Scalars['String']['output']>;
  mostSpecific: Maybe<Scalars['String']['output']>;
  past2YearsTradingExperienceSuitabilityTest: Maybe<Past2YearsTradingExperienceSuitabilityTest>;
  percentageInvestmentAvailable: Maybe<Scalars['String']['output']>;
  primaryInvestmentGoal: Maybe<Scalars['String']['output']>;
  primaryInvestmentTerm: Maybe<Scalars['String']['output']>;
  riskWillingness: Maybe<Scalars['String']['output']>;
  termsConditions: Maybe<Array<Maybe<TermsConditionsSuitabilityTest>>>;
  transactionsInCommoditiesSuitabilityTest: Maybe<TransactionsInCommoditiesSuitabilityTest>;
  transactionsInForexSuitabilityTest: Maybe<TransactionsInForexSuitabilityTest>;
  wealth: Maybe<Scalars['String']['output']>;
  withLeverageCommoditiesSuitabilityTest: Maybe<WithLeverageCommoditiesSuitabilityTest>;
  withLeverageForexSuitabilityTest: Maybe<WithLeverageForexSuitabilityTest>;
};

export enum EducationSuitabilityTest {
  BachelorDiplomaDegree = 'bachelorDiplomaDegree',
  DoctorateDegree = 'doctorateDegree',
  HighSchoolOrEquivalent = 'HighSchoolOrEquivalent',
  MasterDegree = 'masterDegree',
  None = 'none',
  OtherProfessionalQualifications = 'otherProfessionalQualifications',
  PrimaryEducation = 'primaryEducation',
  ProfessionalQualification = 'professionalQualification',
  SecondaryEducation = 'secondaryEducation',
  UniversityCollege = 'universityCollege',
  UniversityDegreeOrEquivalent = 'UniversityDegreeOrEquivalent'
}

export enum FieldOfStudySuitabilityTest {
  AccountingBanking = 'accountingBanking',
  Art = 'art',
  ComputerScience = 'computerScience',
  Medicine = 'medicine',
  Other = 'other'
}

export enum Past2YearsTradingExperienceSuitabilityTest {
  AtLeast2 = 'atLeast2',
  AttendedSeminars = 'attendedSeminars',
  NotTraded = 'notTraded',
  TradedOnMyOwn = 'tradedOnMyOwn',
  TradedWithAdvice = 'tradedWithAdvice',
  WorkedInFinancialIndustry = 'workedInFinancialIndustry'
}

export enum TermsConditionsSuitabilityTest {
  AgreedTerms1 = 'agreedTerms1',
  AgreedTerms2 = 'agreedTerms2'
}

export enum TransactionsInCommoditiesSuitabilityTest {
  Between50kAnd250k = 'between50kAnd250k',
  Between5kAnd50k = 'between5kAnd50k',
  LessThan5k = 'lessThan5k',
  MoreThan250k = 'moreThan250k',
  None = 'none'
}

export enum TransactionsInForexSuitabilityTest {
  Between50kAnd250k = 'between50kAnd250k',
  Between5kAnd50k = 'between5kAnd50k',
  LessThan5k = 'lessThan5k',
  MoreThan250k = 'moreThan250k',
  None = 'none'
}

export enum WithLeverageCommoditiesSuitabilityTest {
  Between11And25 = 'between11And25',
  Between1And10 = 'between1And10',
  Between26And40 = 'between26And40',
  MoreThan40 = 'moreThan40',
  None = 'none'
}

export enum WithLeverageForexSuitabilityTest {
  Between11And25 = 'between11And25',
  Between1And10 = 'between1And10',
  Between26And40 = 'between26And40',
  MoreThan40 = 'moreThan40',
  None = 'none'
}

/** List of suitability test status types */
export enum SuitabilityTestStatusType {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
  UnderReview = 'underReview'
}

export type Tag = {
  __typename?: 'Tag';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Tag ID */
  id: Maybe<Scalars['Int']['output']>;
  /** tag name */
  name: Maybe<Scalars['String']['output']>;
  /** Tag Category */
  tagCategory: Maybe<TagCategory>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** User who added the tag */
  user: Maybe<User>;
};

/** Tag Category for clients */
export type TagCategory = {
  __typename?: 'tagCategory';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Tag Category ID */
  id: Maybe<Scalars['Int']['output']>;
  /** tag category name */
  name: Maybe<Scalars['String']['output']>;
  /** Tags belonging to this category */
  tags: Maybe<Array<Maybe<Tag>>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Theme Preference options */
export enum ThemePreference {
  Dark = 'dark',
  Light = 'light'
}

/** Total deposits per currency */
export type TotalDepositsType = {
  __typename?: 'totalDepositsType';
  /** Amount */
  amount: Maybe<Scalars['Float']['output']>;
  /** Currency */
  currency: Maybe<Currency>;
};

export enum TrackEventType {
  Seminars = 'seminars',
  Webinars = 'webinars'
}

/** Track events for marketing & BI */
export type TrackEvent = {
  __typename?: 'TrackEvent';
  /** Client attend event */
  attended: Maybe<Scalars['Boolean']['output']>;
  /** Event campaign */
  campaign: Maybe<Scalars['String']['output']>;
  /** Client ID */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Event already converted client */
  existing: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  /** Event Tracking Details */
  meta: Maybe<Scalars['String']['output']>;
  /** Event p_params Details */
  pParams: Maybe<Scalars['String']['output']>;
  /** Event code */
  subCampId: Maybe<Scalars['String']['output']>;
  /** Type of track event */
  trackEventType: Maybe<TrackEventType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type TradingConfigType = {
  __typename?: 'tradingConfigType';
  /** Favourite assets */
  favourites: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum TransactionType {
  Deposit = 'deposit',
  Subscription = 'subscription',
  Transfer = 'transfer',
  Withdrawal = 'withdrawal'
}

/** Transactions of this client */
export type Transaction = {
  __typename?: 'Transaction';
  account: Maybe<Account>;
  /** Activity logs concerning this transaction */
  activityLogs: Maybe<Array<Maybe<ActivityLog>>>;
  amount: Maybe<Scalars['Float']['output']>;
  category: Maybe<Scalars['String']['output']>;
  comments: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  depositDetails: Maybe<Scalars['String']['output']>;
  depositPaymentFields: Maybe<DepositPaymentFieldsType>;
  depositVendor: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  memberId: Maybe<Scalars['Int']['output']>;
  meta: Maybe<Scalars['String']['output']>;
  paymentFields: Maybe<WithdrawalPaymentFieldsType>;
  productReceipt: Maybe<Scalars['String']['output']>;
  receipt: Maybe<Scalars['String']['output']>;
  showCancelPartialDeposit: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['String']['output']>;
  statusDescription: Maybe<Scalars['String']['output']>;
  trackUser: Maybe<Scalars['String']['output']>;
  transactionType: Maybe<Scalars['String']['output']>;
  transferAccount: Maybe<TransferAccountType>;
  vendor: Maybe<Scalars['String']['output']>;
  withdrawalPendingReason: Maybe<Scalars['String']['output']>;
  withdrawalQueuePosition: Maybe<Scalars['Int']['output']>;
  withdrawalRejectionReason: Maybe<Scalars['String']['output']>;
  withdrawalRejectionReasonText: Maybe<Scalars['String']['output']>;
  withdrawalType: Maybe<Scalars['String']['output']>;
};


/** Transactions of this client */
export type TransactionActivityLogsArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};

export type DepositPaymentFieldsType = {
  __typename?: 'DepositPaymentFieldsType';
  /** Account holder name */
  bankAccountHolderName: Maybe<Scalars['String']['output']>;
  /** Account Bank Name */
  bankName: Maybe<Scalars['String']['output']>;
  /** Date Received in the bank */
  dateReceived: Maybe<Scalars['DateTime']['output']>;
  /** Account number/IBAN */
  iban: Maybe<Scalars['String']['output']>;
  /** Account swift code */
  swiftCode: Maybe<Scalars['String']['output']>;
  transferToAccount: Maybe<Scalars['Float']['output']>;
};

/** Transactions of this client to Account */
export type TransferAccountType = {
  __typename?: 'transferAccountType';
  accountName: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  memberId: Maybe<Scalars['Int']['output']>;
  remoteId: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** One of the possible under monitoring reason */
export enum UnderMonitoringReason {
  CardCopiesRequired = 'cardCopiesRequired',
  Compliance = 'compliance',
  DuplicateLead = 'duplicateLead',
  NumberFailedTransactions = 'numberFailedTransactions',
  Other = 'other',
  PepOrUs = 'pepOrUs',
  SameDepositMethodForDifferentProfiles = 'sameDepositMethodForDifferentProfiles',
  SuspiciousTradingBehavior = 'suspiciousTradingBehavior',
  ThirdPartyDeposits = 'thirdPartyDeposits'
}

export type VerificationActionsType = {
  __typename?: 'verificationActionsType';
  /** Block Deposit Action */
  blockDeposit: Maybe<Scalars['Boolean']['output']>;
  /** Forced Verification */
  forcedVerification: Maybe<Scalars['String']['output']>;
};

/** A BDSwiss client verification status */
export type VerificationStatus = {
  __typename?: 'verificationStatus';
  /** A BDSwiss client's appropriateness test verification status */
  appropriatenessTest: Maybe<VerificationStatusField>;
  /** A BDSwiss client's POI documents verification status */
  documentPOIUpload: VerificationStatusField;
  /** A BDSwiss client's POR documents verification status */
  documentPORUpload: VerificationStatusField;
  /** A BDSwiss client's economic profile verification status */
  economicProfile: VerificationStatusField;
  /** A BDSwiss client's KYC verification status */
  KYCStatus: VerificationStatusKycStatus;
  /** A BDSwiss client's profile verification status */
  profile: VerificationStatusField;
};

/** A BDSwiss client verification status field */
export type VerificationStatusField = {
  __typename?: 'verificationStatusField';
  message: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

/** A BDSwiss client KYC status */
export type VerificationStatusKycStatus = {
  __typename?: 'verificationStatusKYCStatus';
  message: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Subscribe to VPS service */
export type VpsSubscription = {
  __typename?: 'VpsSubscription';
  activatedAt: Maybe<Scalars['DateTime']['output']>;
  billingCycle: Maybe<VpsSubscriptionBillingCycle>;
  billingInfo: Maybe<BillingInfo>;
  /** VPS Subscription owner */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deactivatedAt: Maybe<Scalars['DateTime']['output']>;
  domain: Maybe<Scalars['String']['output']>;
  failedPaymentDate: Maybe<Scalars['DateTime']['output']>;
  /** VPS Subscription ID */
  id: Maybe<Scalars['Int']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  isExpired: Maybe<Scalars['Boolean']['output']>;
  lastPaymentFailed: Maybe<Scalars['Boolean']['output']>;
  meta: Maybe<Scalars['String']['output']>;
  nextPaymentDate: Maybe<Scalars['DateTime']['output']>;
  note: Maybe<Scalars['String']['output']>;
  params: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<VpsSubscriptionPaymentMethod>;
  planName: Maybe<VpsSubsciptionPlans>;
  serviceId: Maybe<Scalars['String']['output']>;
  /** VPS Subscription Status */
  status: Maybe<VpsSubscriptionStatuse>;
  suspendReason: Maybe<Scalars['String']['output']>;
  /** VPS Subscription Type */
  type: Maybe<VpsSubscriptionType>;
  vms: Maybe<Scalars['String']['output']>;
};

export enum VpsSubscriptionBillingCycle {
  Monthly = 'monthly'
}

/** Billing Info Type */
export type BillingInfo = {
  __typename?: 'BillingInfo';
  address1: Maybe<Scalars['String']['output']>;
  cardType: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  lastFourDigits: Maybe<Scalars['Int']['output']>;
  month: Maybe<Scalars['Int']['output']>;
  year: Maybe<Scalars['Int']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export enum VpsSubscriptionPaymentMethod {
  Banktransfer = 'banktransfer',
  Card = 'card',
  Paypal = 'paypal'
}

export enum VpsSubsciptionPlans {
  Advanced = 'advanced',
  Basic = 'basic',
  Pro = 'pro'
}

export enum VpsSubscriptionStatuse {
  Active = 'active',
  Deleted = 'deleted',
  Failed = 'failed',
  New = 'new',
  Pending = 'pending',
  Suspended = 'suspended'
}

export enum VpsSubscriptionType {
  Free = 'free',
  Paid = 'paid'
}

/** Record of walkthrough given to clients by servicing sales agent */
export type Walkthrough = {
  __typename?: 'Walkthrough';
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  /** Walkthrough ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Type of walkthrough */
  type: Maybe<WalkthroughType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** One of the possible walkthrough types */
export enum WalkthroughType {
  BinaryWalkThrough = 'binaryWalkThrough',
  Mt4WalkThrough = 'mt4WalkThrough',
  WebsiteWalkThrough = 'websiteWalkThrough'
}

/** white label config */
export type WhiteLabelConfig = {
  __typename?: 'whiteLabelConfig';
  /** available payment system providers */
  availablePsps: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** disabled payment system providers */
  disabledPsps: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WithdrawalFromDepositFieldsType = {
  __typename?: 'WithdrawalFromDepositFieldsType';
  fields: Maybe<WithdrawalPaymentFieldsType>;
  vendor: Maybe<Scalars['String']['output']>;
};

/** Workflow element item */
export type WorkflowEvent = {
  __typename?: 'WorkflowEvent';
  action: Action;
  hook: Hook;
};

/** Action union type */
export type Action = AlertAction | ClearAction | ContinueAction | CtaAction | ExpressKycAction | OpenScreenAction | SwitchAccountAction | ToastAction;

/** Alert action */
export type AlertAction = {
  __typename?: 'AlertAction';
  /** Alert type */
  alertType: AlertTypeEnum;
  /** action id */
  id: Maybe<Scalars['String']['output']>;
  /** alert message */
  message: Scalars['String']['output'];
  /** negative button action */
  negativeButton: Maybe<ActionButton>;
  /** positive button action */
  positiveButton: ActionButton;
  /** alert title */
  title: Maybe<Scalars['String']['output']>;
};

export enum AlertTypeEnum {
  Error = 'ERROR',
  Notice = 'NOTICE',
  Warning = 'WARNING'
}

/** Action button */
export type ActionButton = {
  __typename?: 'ActionButton';
  /** Button action */
  action: Maybe<Action>;
  /** Button id */
  id: Scalars['ID']['output'];
  /** Button title */
  title: Scalars['String']['output'];
};

/** Clear action */
export type ClearAction = {
  __typename?: 'ClearAction';
  /** Remove CTA from client */
  ctaKey: Maybe<Scalars['String']['output']>;
};

/** Continue action */
export type ContinueAction = {
  __typename?: 'ContinueAction';
  /** dummy id */
  dummyField: Maybe<Scalars['Boolean']['output']>;
};

/** CTA action */
export type CtaAction = {
  __typename?: 'CTAAction';
  /** action to perform */
  button: ActionButton;
  /** CTA icon URL */
  iconUrl: Maybe<Scalars['String']['output']>;
  /** CTA level */
  level: Maybe<ScreensEnum>;
  /** CTA message */
  messageText: Maybe<Scalars['String']['output']>;
};

/** Possible screens */
export enum ScreensEnum {
  Error = 'ERROR',
  Notice = 'NOTICE',
  Warning = 'WARNING'
}

/** Trigger Express KYC */
export type ExpressKycAction = {
  __typename?: 'ExpressKYCAction';
  /** dummy id */
  dummyField: Maybe<Scalars['Boolean']['output']>;
};

/** Open screen action */
export type OpenScreenAction = {
  __typename?: 'OpenScreenAction';
  /** screen */
  screen: Screen;
};

/** Screen type */
export type Screen = {
  __typename?: 'Screen';
  /** Screen params */
  params: Maybe<Array<Maybe<ScreenParam>>>;
  /** Screen type */
  screenId: Maybe<ScreenId>;
};

/** Screen param type */
export type ScreenParam = {
  __typename?: 'ScreenParam';
  /** Screen params key */
  key: Scalars['ID']['output'];
  /** Screen params payload (json) */
  value: Maybe<Scalars['String']['output']>;
};

/** Possible screens */
export enum ScreenId {
  ApTest = 'AP_TEST',
  DayOfBirth = 'DAY_OF_BIRTH',
  Deposit = 'DEPOSIT',
  DocumentUpload = 'DOCUMENT_UPLOAD',
  EconomicProfile = 'ECONOMIC_PROFILE',
  Mifir = 'MIFIR',
  NationalId = 'NATIONAL_ID',
  OnboardingWizard = 'ONBOARDING_WIZARD',
  Profile = 'PROFILE',
  SpanishAlert = 'SPANISH_ALERT',
  Support = 'SUPPORT',
  VerificationPage = 'VERIFICATION_PAGE',
  Withdraw = 'WITHDRAW'
}

/** Switch account action */
export type SwitchAccountAction = {
  __typename?: 'SwitchAccountAction';
  /** login account to switch */
  login: Scalars['Int']['output'];
};

/** Toast action */
export type ToastAction = {
  __typename?: 'ToastAction';
  /** Toast level */
  toastLevel: ToastLevel;
  /** Toast message */
  toastMessage: Scalars['String']['output'];
  /** Toast title */
  toastTitle: Maybe<Scalars['String']['output']>;
};

/** Possible toast level type */
export enum ToastLevel {
  Danger = 'DANGER',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

/** Triggered after some mutations */
export type Hook = {
  __typename?: 'Hook';
  /** Filter for hook */
  filter: Maybe<HookFilter>;
  /** Hook uniq id */
  key: Scalars['ID']['output'];
  /** Hook params */
  params: Maybe<Array<Maybe<HookParam>>>;
};

/** Hook filter types */
export type HookFilter = {
  __typename?: 'HookFilter';
  /** Hook filter login */
  login: Maybe<Scalars['Int']['output']>;
  /** Filter by platform: mt4 or mt5 */
  tradingPlatform: Maybe<Platform>;
  /** Filter by server type: real or demo */
  tradingServerType: ServerType;
};

export enum Platform {
  Any = 'ANY',
  Mt4 = 'MT4',
  Mt5 = 'MT5'
}

export enum ServerType {
  Any = 'ANY',
  Demo = 'DEMO',
  Real = 'REAL'
}

/** Hook param type */
export type HookParam = {
  __typename?: 'HookParam';
  /** Hook params key */
  key: Scalars['ID']['output'];
  /** Hook params payload (json) */
  value: Maybe<Scalars['String']['output']>;
  /** Hook param weight */
  weight: Scalars['Int']['output'];
};

/** Agent log */
export type AgentLog = BaseLogInterface & {
  __typename?: 'AgentLog';
  /** Agent Type */
  agentType: Maybe<AgentType>;
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Agent Type */
export enum AgentType {
  ExternalAgent = 'externalAgent',
  SalesAgent = 'salesAgent',
  SupportAgent = 'supportAgent'
}

/** Allow Account Creation log */
export type AllowNewAccountCreationLog = BaseLogInterface & {
  __typename?: 'AllowNewAccountCreationLog';
  /** Toggle Allow New Accounts */
  allowNewAccounts: Maybe<Scalars['Boolean']['output']>;
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Conversion status log */
export type ClientTypeLog = BaseLogInterface & {
  __typename?: 'ClientTypeLog';
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  /** Conversion status */
  clientType: Maybe<ClientType>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Compliance log */
export type ComplianceLog = BaseLogInterface & {
  __typename?: 'ComplianceLog';
  /** Account Name */
  accountName: Maybe<Scalars['String']['output']>;
  /** Alert Type */
  alertType: Maybe<Scalars['String']['output']>;
  /** Edit account fields */
  args: Maybe<Scalars['String']['output']>;
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Marketing in/out status */
  marketingInOut: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Other affected user ids */
  otherUsers: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Other affected users */
  otherUsersCount: Maybe<Scalars['String']['output']>;
  /** Reason */
  reason: Maybe<Scalars['String']['output']>;
  /** Rejection Reason Code */
  rejectionReasonCode: Maybe<Scalars['String']['output']>;
  /** Account Name */
  remoteId: Maybe<Scalars['String']['output']>;
  /** SMS in/out status */
  smsInOut: Maybe<Scalars['Boolean']['output']>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Conversion status log */
export type ConversionStatusLog = BaseLogInterface & {
  __typename?: 'ConversionStatusLog';
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Conversion status */
  status: Maybe<ConversionStatus>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Diff log */
export type DiffLog = BaseLogInterface & {
  __typename?: 'DiffLog';
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Metadata */
  meta: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Document Translations Log */
export type DocumentTranslationsLog = BaseLogInterface & {
  __typename?: 'DocumentTranslationsLog';
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ID Of Document Translated */
  documentId: Maybe<Scalars['Int']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Translation Details */
  translationDetails: Maybe<Scalars['String']['output']>;
  /** Type Of Document Translated */
  translationType: Maybe<TranslationTypeTypes>;
  /** Translator Full Name */
  translator: Maybe<User>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Generic activity log */
export type GenericLog = BaseLogInterface & {
  __typename?: 'GenericLog';
  accountName: Maybe<Scalars['String']['output']>;
  action: Maybe<Scalars['String']['output']>;
  allowManuallyAccount: Maybe<Scalars['Boolean']['output']>;
  assignee: Maybe<User>;
  automaticAffiliateCommissions: Maybe<Scalars['Boolean']['output']>;
  bdxInvestmentChoiceFinal: Maybe<Scalars['String']['output']>;
  bdxWaiverAccepted: Maybe<Scalars['Boolean']['output']>;
  /** Toggle IB Can Transfer */
  canIbTransfer: Maybe<Scalars['Boolean']['output']>;
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  /** Client's Account Name */
  clientAccountName: Maybe<Scalars['String']['output']>;
  clientRequestCopyTrading: Maybe<Scalars['Boolean']['output']>;
  competitionId: Maybe<Scalars['String']['output']>;
  competitionName: Maybe<Scalars['String']['output']>;
  content: Maybe<Scalars['String']['output']>;
  copyTradingMethod: Maybe<Scalars['String']['output']>;
  copyTradingPercentage: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  details: Maybe<Scalars['String']['output']>;
  dormantReactivation: Maybe<Scalars['Boolean']['output']>;
  dueDiligenceStatus: Maybe<Scalars['String']['output']>;
  effectiveFTD: Maybe<Scalars['Boolean']['output']>;
  emailConfirmed: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Fund Manager */
  fundManager: Maybe<Scalars['Boolean']['output']>;
  globalQuestionnaire: Maybe<Scalars['Boolean']['output']>;
  hasDisabledWithdrawals: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Client Has Hot Assets */
  hasHotAssets: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Client Has Open Complaint */
  hasOpenComplaint: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Client Has Portfolio Management */
  hasPortfolioManagement: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Client Has Pre Survey */
  hasPreSurvey: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Client Has Raw Account */
  hasRawAccount: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Client Has Survey */
  hasSurvey: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Client Has Telegram */
  hasTelegram: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Trading Academy Access */
  hasTradingAcademyAccess: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Client Has VIP Account */
  hasVipAccount: Maybe<Scalars['Boolean']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Toggle Ignore IB Termination */
  ignoreIbTermination: Maybe<Scalars['Boolean']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Toggle Client Is Direct IB */
  isDirectIB: Maybe<Scalars['Boolean']['output']>;
  isPhoneVerified: Maybe<Scalars['Boolean']['output']>;
  lastActiveDate: Maybe<Scalars['String']['output']>;
  manuallyAccountType: Maybe<Scalars['String']['output']>;
  manualWithdrawals: Maybe<Scalars['Boolean']['output']>;
  meta: Maybe<Scalars['String']['output']>;
  newPlan: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Client's Old Account Name */
  oldAccountName: Maybe<Scalars['String']['output']>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  partnerClientId: Maybe<Scalars['Int']['output']>;
  partnerClientName: Maybe<Scalars['String']['output']>;
  /** Performance Fee */
  performanceFee: Maybe<Scalars['Float']['output']>;
  potentialType: Maybe<Scalars['String']['output']>;
  previousBDXInvestmentChoice: Maybe<Scalars['String']['output']>;
  prize: Maybe<Scalars['String']['output']>;
  /** Provide Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  providerRemoteId: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  retailClientId: Maybe<Scalars['Int']['output']>;
  retailClientName: Maybe<Scalars['String']['output']>;
  showMasterStrategies: Maybe<Scalars['Boolean']['output']>;
  statusAndNotes: Maybe<Scalars['String']['output']>;
  toggleAutochartist: Maybe<Scalars['Boolean']['output']>;
  toggleAutochartistCoelationEmail: Maybe<Scalars['Boolean']['output']>;
  toggleAutochartistEmails: Maybe<Scalars['Boolean']['output']>;
  toggleAutochartistPlugin: Maybe<Scalars['Boolean']['output']>;
  toggleBDXCallCompleted: Maybe<Scalars['Boolean']['output']>;
  toggleCopyTrading: Maybe<Scalars['Boolean']['output']>;
  toggleHideWDMethods: Maybe<Scalars['Boolean']['output']>;
  toggleTradeCompanion: Maybe<Scalars['Boolean']['output']>;
  topVip: Maybe<Scalars['Boolean']['output']>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
  userUpdateCopyTrading: Maybe<Scalars['Boolean']['output']>;
  verificationType: Maybe<Scalars['String']['output']>;
};

/** KYC status log */
export type KycStatusLog = BaseLogInterface & {
  __typename?: 'KycStatusLog';
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** KYC status */
  status: Maybe<KycStatus>;
  /** KYC rejection reason */
  statusReason: Maybe<Scalars['String']['output']>;
  /** KYC rejection reason code */
  statusReasonCode: Maybe<Scalars['String']['output']>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Toggle Can Grant Spoa Log */
export type SpoaLog = BaseLogInterface & {
  __typename?: 'SpoaLog';
  /** Client accepted Bonus Terms and Conditions */
  acceptedSpoaBonusTerms: Maybe<Scalars['Boolean']['output']>;
  /** Toggle Can Grant Spoa */
  canGrantSpoa: Maybe<Scalars['Boolean']['output']>;
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Granted / Revoked word */
  spoaAuthorization: Maybe<Scalars['Boolean']['output']>;
  /** Client first name that has granted /revoked SPOA to ib */
  spoaClientFName: Maybe<Scalars['String']['output']>;
  /** Client that has granted /revoked SPOA to ib */
  spoaClientID: Maybe<Scalars['Int']['output']>;
  /** Client last name that has granted /revoked SPOA to ib */
  spoaClientLName: Maybe<Scalars['String']['output']>;
  spoaForce: Maybe<Scalars['Boolean']['output']>;
  /** Client first name that has granted /revoked SPOA to ib */
  spoaIbFName: Maybe<Scalars['String']['output']>;
  /** Client that has granted /revoked SPOA to ib */
  spoaIbID: Maybe<Scalars['Int']['output']>;
  /** Client last name that has granted /revoked SPOA to ib */
  spoaIbLName: Maybe<Scalars['String']['output']>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Trading status log */
export type TradingStatusLog = BaseLogInterface & {
  __typename?: 'TradingStatusLog';
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Trading status */
  status: Maybe<TradingStatus>;
  /** Trading status reason */
  statusReason: Maybe<Scalars['String']['output']>;
  /** Trading status reason code */
  statusReasonCode: Maybe<Scalars['String']['output']>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Transfer Funds log */
export type TransferFundsLog = BaseLogInterface & {
  __typename?: 'TransferFundsLog';
  /** Toggle Transfer Funds */
  allowTransferFunds: Maybe<Scalars['Boolean']['output']>;
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Toggle Under Monitoring log */
export type UnderMonitoringLog = BaseLogInterface & {
  __typename?: 'UnderMonitoringLog';
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** Toggle Under Monitoring */
  underMonitoring: Maybe<Scalars['Boolean']['output']>;
  /** Under Monitoring reason */
  underMonitoringReason: Maybe<Scalars['String']['output']>;
  /** Under Monitoring reason code */
  underMonitoringReasonCode: Maybe<Scalars['String']['output']>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

/** Activity log with a reason */
export type WithReasonLog = BaseLogInterface & {
  __typename?: 'withReasonLog';
  /** Client linked with ActivityLog */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** ActivityLog ID */
  id: Maybe<Scalars['Int']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  ipCountry: Maybe<Scalars['String']['output']>;
  /** Account linked with ActivityLog */
  objectAccount: Maybe<Account>;
  /** Approp test linked with ActivityLog */
  objectAppropTest: Maybe<AppropTest>;
  /** Bonus offer linked with ActivityLog */
  objectBonusOffer: Maybe<BonusOffer>;
  /** Deposit linked with ActivityLog */
  objectDeposit: Maybe<Deposit>;
  /** Document linked with ActivityLog */
  objectDocument: Maybe<Document>;
  /** Profile change linked with ActivityLog */
  objectProfileChange: Maybe<ProfileChange>;
  /** Type of assigned ActivityLog object */
  objectType: Maybe<ActivityLogObjectType>;
  /** User linked with ActivityLog */
  objectUser: Maybe<User>;
  /** Withdrawal linked with ActivityLog */
  objectWithdrawal: Maybe<Withdrawal>;
  /** Origin of ActivityLog */
  origin: Maybe<ActivityLogOrigin>;
  /** Rejection Reason Code */
  pendingCode: Maybe<Scalars['String']['output']>;
  /** Reason */
  reason: Maybe<Scalars['String']['output']>;
  /** Rejection Reason Code */
  rejectionCode: Maybe<Scalars['String']['output']>;
  /** Type of ActivityLog */
  type: Maybe<ActivityLogType>;
  /** User who created ActivityLog */
  user: Maybe<User>;
};

export type Payment = {
  __typename?: 'Payment';
  details: Maybe<Scalars['String']['output']>;
  meta: Maybe<Scalars['String']['output']>;
  /** Raw receipt from product (i.e. Spotoption/forex) */
  productReceipt: Maybe<Scalars['String']['output']>;
  /** Raw response from payment gateway */
  receipt: Maybe<Scalars['String']['output']>;
  /** Source account for transfer */
  transferFromAccount: Maybe<Account>;
  /** Name of payment gateway */
  vendor: Maybe<Scalars['DepositVendorOrString']['output']>;
};

/** One of the possible deposit rejection reason codes */
export enum DepositRejectionReasonCode {
  AccountClosure = 'accountClosure',
  ArchivedAccount = 'archivedAccount',
  DaysPassed = 'daysPassed',
  Fraud = 'fraud',
  InsufficientFunds = 'insufficientFunds',
  NotAcceptableCountry = 'notAcceptableCountry',
  Other = 'other',
  PerCompliance = 'perCompliance',
  PerRequest = 'perRequest',
  Underage = 'underage'
}

export enum BookType {
  ABook = 'a_book',
  BBook = 'b_book'
}

/** Provider account/client info */
export type BrokereeMasterProviderOfAgent = {
  __typename?: 'BrokereeMasterProviderOfAgent';
  accountRemoteId: Maybe<Scalars['Int']['output']>;
  clientFullName: Maybe<Scalars['String']['output']>;
  clientId: Maybe<Scalars['ID']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Main trading account of Brokeree Provider */
export type ConnectedBrokereeProviderAccount = {
  __typename?: 'ConnectedBrokereeProviderAccount';
  /** ID of the account */
  id: Maybe<Scalars['Int']['output']>;
  /** MT id of the account */
  remoteId: Maybe<Scalars['Int']['output']>;
};

/** Copy Trading data */
export type CopyTrading = {
  __typename?: 'CopyTrading';
  /** Selected client account */
  account: Maybe<Account>;
  /** Selected account details */
  accountCopying: Maybe<PartnerDetails>;
  /** Client ID */
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Selected account details */
  ibAccountCopying: Maybe<PartnerDetails>;
  id: Maybe<Scalars['ID']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  /** Requested start coyping date from user */
  startCopyingDate: Maybe<Scalars['DateTime']['output']>;
  /** Requested start copying date from client */
  startRequestedDate: Maybe<Scalars['DateTime']['output']>;
  /** Requested stop copying date from user */
  stopCopyingDate: Maybe<Scalars['DateTime']['output']>;
  /** Requested stop copying date from client */
  stopRequestedDate: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type PartnerDetails = {
  __typename?: 'PartnerDetails';
  accountId: Maybe<Scalars['Int']['output']>;
  accountName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['Int']['output']>;
};

/** PAMM Offers */
export type PammOfferType = {
  __typename?: 'PammOfferType';
  /** PAMM offer followers count */
  activeInvestmentCount: Maybe<Scalars['Int']['output']>;
  /** PAMM offer currency */
  currency: Maybe<Scalars['String']['output']>;
  /** PAMM offer ID */
  id: Maybe<Scalars['Int']['output']>;
  /** PAMM offer manager */
  manager: Maybe<Account>;
  /** PAMM offer manager ID */
  managerId: Maybe<Scalars['Int']['output']>;
  /** PAMM Manager name */
  managerName: Maybe<Scalars['String']['output']>;
  /** PAMM offer name */
  name: Maybe<Scalars['String']['output']>;
  /** PAMM offer settings */
  settings: Maybe<PammOfferSettingsType>;
  /** ID of the PAMM Manager account */
  skygroundAccountId: Maybe<Scalars['Int']['output']>;
  /** PAMM offer total deposit sum */
  totalDepositSum: Maybe<Scalars['Float']['output']>;
  /** PAMM offer number of investors */
  totalInvestments: Maybe<Scalars['Int']['output']>;
};

/** PAMM Offer settings */
export type PammOfferSettingsType = {
  __typename?: 'PammOfferSettingsType';
  /** PAMM offer agent chain */
  agentChain: Maybe<Array<Maybe<AgentSpecificationType>>>;
  /** PAMM Offer settings min deposit */
  minDeposit: Maybe<Scalars['Int']['output']>;
  /** PAMM Offer settings min investment */
  minInitialInvestment: Maybe<Scalars['Int']['output']>;
  /** PAMM Offer settings min withdrawal */
  minWithdrawal: Maybe<Scalars['Int']['output']>;
  /** PAMM Offer settings performance fees */
  performanceFees: Maybe<PammOfferSettingsPerformanceFeeType>;
  /** PAMM Offer settings trading interval */
  tradingInterval: Maybe<PammOfferSettingsTradingIntervalType>;
};

/** Agent specification in the agent chain for PAMM */
export type AgentSpecificationType = {
  __typename?: 'AgentSpecificationType';
  /** Agent ID */
  agentId: Maybe<Scalars['Int']['output']>;
  /** Agent client */
  client: Maybe<Client>;
};

/** PAMM Offer performance fees settings */
export type PammOfferSettingsPerformanceFeeType = {
  __typename?: 'PammOfferSettingsPerformanceFeeType';
  levels: Maybe<Array<Maybe<PammOfferPerformanceFeeLevelType>>>;
  mode: Maybe<Scalars['String']['output']>;
};

/** PAMM Offer performance fees level settings */
export type PammOfferPerformanceFeeLevelType = {
  __typename?: 'PammOfferPerformanceFeeLevelType';
  level: Maybe<Scalars['Int']['output']>;
  value: Maybe<Scalars['Int']['output']>;
};

/** PAMM Offer trading interval settings */
export type PammOfferSettingsTradingIntervalType = {
  __typename?: 'PammOfferSettingsTradingIntervalType';
  /** PAMM offer trading interval count */
  count: Maybe<Scalars['Int']['output']>;
  /** PAMM offer trading interval type */
  type: Maybe<Scalars['String']['output']>;
};

/** Subscriptions to client account */
export type Subscription = {
  __typename?: 'Subscription';
  /** Account where deposit was made */
  account: Maybe<Account>;
  /** Activity logs concerning this deposit */
  activityLogs: Maybe<Array<Maybe<ActivityLog>>>;
  /** Count of activity logs concerning this deposit */
  activityLogsCount: Maybe<Scalars['Int']['output']>;
  /** Amount of deposit, in chosen currency */
  amount: Maybe<Scalars['Float']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency of deposit */
  currency: Maybe<Currency>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposit ID */
  id: Maybe<Scalars['Int']['output']>;
  payment: Maybe<Payment>;
  /** Link to tokenized payment card, if a tokenized payment card was used */
  paymentCardToken: Maybe<PaymentCardToken>;
  paymentFields: Maybe<DepositPaymentFieldsType>;
  /** For bonus deposits, the promocode that triggered the bonus, if any */
  promoCode: Maybe<Scalars['String']['output']>;
  /** Rejection reason */
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** Rejection Reason Key */
  rejectionReasonKey: Maybe<DepositRejectionReasonCode>;
  /** Sales agent at the time of the deposit */
  salesAgent: Maybe<User>;
  showCancelPartialDeposit: Maybe<Scalars['Boolean']['output']>;
  /** Spreedly reference for this transaction */
  spreedlyTransactionToken: Maybe<Scalars['String']['output']>;
  /** Status of deposit */
  status: Maybe<DepositStatus>;
  statusDescription: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


/** Subscriptions to client account */
export type SubscriptionActivityLogsArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


/** Subscriptions to client account */
export type SubscriptionActivityLogsCountArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  appropTestId: InputMaybe<Scalars['Int']['input']>;
  bdxWaiverAccepted: InputMaybe<Scalars['Boolean']['input']>;
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  company: InputMaybe<Company>;
  country: InputMaybe<Country>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeNullClientId: InputMaybe<Scalars['Boolean']['input']>;
  isClientPage: InputMaybe<Scalars['Boolean']['input']>;
  isNotification: InputMaybe<Scalars['Boolean']['input']>;
  origins: InputMaybe<Array<InputMaybe<ActivityLogOrigin>>>;
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  searchType: InputMaybe<Scalars['String']['input']>;
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleBDXCallCompleted: InputMaybe<Scalars['Boolean']['input']>;
  toggleTradeCompanion: InputMaybe<Scalars['Boolean']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  type: InputMaybe<ActivityLogTypeType>;
  types: InputMaybe<Array<InputMaybe<ActivityLogTypeType>>>;
  userDepartment: InputMaybe<UserDepartmentAndClientType>;
  userId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};

/** Withdrawable Payment Methods */
export type WithdrawablePaymentMethod = {
  __typename?: 'WithdrawablePaymentMethod';
  /** Account Number */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Total Amount of the grouped transactions */
  amount: Maybe<Scalars['Float']['output']>;
  /** Total Amount left of the grouped transactions */
  amountLeft: Maybe<Scalars['Float']['output']>;
  /** Bank Code */
  bankCode: Maybe<Scalars['String']['output']>;
  /** Card Holder name in case of card transactions */
  cardHolderName: Maybe<Scalars['String']['output']>;
  /** Card Number in case of card transactions */
  cardNumber: Maybe<Scalars['String']['output']>;
  /** Bank Code */
  cryptoCurrency: Maybe<Scalars['String']['output']>;
  /** Currency of the transactions */
  currency: Maybe<Currency>;
  /** Details of the method */
  details: Maybe<Scalars['String']['output']>;
  /** IBAN */
  iban: Maybe<Scalars['String']['output']>;
  /** ID of the method */
  id: Maybe<Scalars['String']['output']>;
  /** order */
  order: Maybe<Scalars['Int']['output']>;
  /** Payment Option */
  paymentOption: Maybe<Scalars['String']['output']>;
  /** Provider */
  provider: Maybe<Scalars['String']['output']>;
  /** Swift */
  swiftCode: Maybe<Scalars['String']['output']>;
  /** Withdrawal vendor */
  vendor: Maybe<WithdrawalPaymentVendorsType>;
  /** Skrill email */
  vendorAccountEmail: Maybe<Scalars['String']['output']>;
  /** Fasapay Id */
  vendorAccountId: Maybe<Scalars['String']['output']>;
};

export type BaseAffiliateAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Affiliate ID on the external product */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** Affiliate is eligible for automatic affiliate commissions debiting */
  automaticCommissions: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Cellxpers ID on the external platform */
  cellxpertsId: Maybe<Scalars['Int']['output']>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  /** Last registration campaign record for this user */
  lastRegistrationCampaign: Maybe<RegistrationCampaign>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Fields we get from affiliate service */
  serviceFields: Maybe<AffiliateServiceFieldsType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseAffiliateAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseAffiliateAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseAffiliateAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseAffiliateAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseAffiliateAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAffiliateAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseAffiliateAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAffiliateAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAffiliateAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAffiliateAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAffiliateAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseAffiliateAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseAffiliateAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseAffiliateAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseAffiliateAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Fields we get from affiliate service */
export type AffiliateServiceFieldsType = {
  __typename?: 'AffiliateServiceFieldsType';
  /** Status for this account */
  affiliateStatus: Maybe<Scalars['String']['output']>;
  /** Parent Affiliate ID on the external product */
  parentAffiliateId: Maybe<Scalars['String']['output']>;
};

/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccount = BaseAccount & BaseAffiliateAccount & {
  __typename?: 'AffiliateEquityFlowAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Affiliate ID on the external product */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** Affiliate is eligible for automatic affiliate commissions debiting */
  automaticCommissions: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Cellxpers ID on the external platform */
  cellxpertsId: Maybe<Scalars['Int']['output']>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  /** Last registration campaign record for this user */
  lastRegistrationCampaign: Maybe<RegistrationCampaign>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Fields we get from affiliate service */
  serviceFields: Maybe<AffiliateServiceFieldsType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Equity Flow Account */
export type AffiliateEquityFlowAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Affiliate Lydian Account */
export type AffiliateLydianAccount = BaseAccount & BaseAffiliateAccount & {
  __typename?: 'AffiliateLydianAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Affiliate ID on the external product */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** Affiliate is eligible for automatic affiliate commissions debiting */
  automaticCommissions: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Cellxpers ID on the external platform */
  cellxpertsId: Maybe<Scalars['Int']['output']>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  /** Last registration campaign record for this user */
  lastRegistrationCampaign: Maybe<RegistrationCampaign>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Fields we get from affiliate service */
  serviceFields: Maybe<AffiliateServiceFieldsType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Lydian Account */
export type AffiliateLydianAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Affiliate Account */
export type AffiliateMauritiusAccount = BaseAccount & BaseAffiliateAccount & {
  __typename?: 'AffiliateMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Affiliate ID on the external product */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** Affiliate is eligible for automatic affiliate commissions debiting */
  automaticCommissions: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Cellxpers ID on the external platform */
  cellxpertsId: Maybe<Scalars['Int']['output']>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  /** Last registration campaign record for this user */
  lastRegistrationCampaign: Maybe<RegistrationCampaign>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Fields we get from affiliate service */
  serviceFields: Maybe<AffiliateServiceFieldsType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Account */
export type AffiliateMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccount = BaseAccount & BaseAffiliateAccount & {
  __typename?: 'AffiliateSkyGroundAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Affiliate ID on the external product */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** Affiliate is eligible for automatic affiliate commissions debiting */
  automaticCommissions: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Cellxpers ID on the external platform */
  cellxpertsId: Maybe<Scalars['Int']['output']>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  /** Last registration campaign record for this user */
  lastRegistrationCampaign: Maybe<RegistrationCampaign>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Fields we get from affiliate service */
  serviceFields: Maybe<AffiliateServiceFieldsType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate SkyGround Account */
export type AffiliateSkyGroundAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccount = BaseAccount & BaseAffiliateAccount & {
  __typename?: 'AffiliateTauroMarketsAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Affiliate ID on the external product */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** Affiliate is eligible for automatic affiliate commissions debiting */
  automaticCommissions: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Cellxpers ID on the external platform */
  cellxpertsId: Maybe<Scalars['Int']['output']>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  /** Last registration campaign record for this user */
  lastRegistrationCampaign: Maybe<RegistrationCampaign>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Fields we get from affiliate service */
  serviceFields: Maybe<AffiliateServiceFieldsType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Tauro Markets Account */
export type AffiliateTauroMarketsAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccount = BaseAccount & BaseAffiliateAccount & {
  __typename?: 'AffiliateTauroMarketsMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Affiliate ID on the external product */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** Affiliate is eligible for automatic affiliate commissions debiting */
  automaticCommissions: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Cellxpers ID on the external platform */
  cellxpertsId: Maybe<Scalars['Int']['output']>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  /** Last registration campaign record for this user */
  lastRegistrationCampaign: Maybe<RegistrationCampaign>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Fields we get from affiliate service */
  serviceFields: Maybe<AffiliateServiceFieldsType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Tauro Markets Mauritius Account */
export type AffiliateTauroMarketsMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Affiliate Account */
export type AffiliateVanuatuAccount = BaseAccount & BaseAffiliateAccount & {
  __typename?: 'AffiliateVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Affiliate ID on the external product */
  affiliateId: Maybe<Scalars['Int']['output']>;
  /** Affiliate is eligible for automatic affiliate commissions debiting */
  automaticCommissions: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Cellxpers ID on the external platform */
  cellxpertsId: Maybe<Scalars['Int']['output']>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  /** Last registration campaign record for this user */
  lastRegistrationCampaign: Maybe<RegistrationCampaign>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Fields we get from affiliate service */
  serviceFields: Maybe<AffiliateServiceFieldsType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Affiliate Account */
export type AffiliateVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** AI Account */
export type AipammAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'AIPAMMAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** AI Account */
export type AipammAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** AI Account */
export type AipammAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** AI Account */
export type AipammAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** AI Account */
export type AipammAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** AI Account */
export type AipammAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Account */
export type AipammAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Account */
export type AipammAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Account */
export type AipammAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Account */
export type AipammAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Account */
export type AipammAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** AI Account */
export type AipammAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Account */
export type AipammAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseForexAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseForexAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseForexAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseForexAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseForexAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseForexAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseForexAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex-only account subtype (basic/black/bonus) */
export enum AccountSubtype {
  Aff001 = 'aff001',
  Aff002 = 'aff002',
  Ai = 'ai',
  Basic = 'basic',
  Black = 'black',
  Bonds = 'bonds',
  Bonus = 'bonus',
  Cent = 'cent',
  Classic = 'classic',
  IbWallet = 'ib_wallet',
  InvestPlus = 'invest_plus',
  Master = 'master',
  Mt5Raw = 'mt5Raw',
  Mt5Std = 'mt5Std',
  Mt5StdDemo = 'mt5StdDemo',
  Mt5Vip = 'mt5Vip',
  Premium = 'premium',
  Raw = 'raw',
  RawGrow = 'raw_grow',
  RawPro = 'raw_pro',
  RawTrial = 'raw_trial',
  ScSub = 'sc_sub',
  Sub = 'sub',
  Swiss11 = 'swiss11',
  Swiss4 = 'swiss4',
  Swiss5 = 'swiss5',
  Swiss8 = 'swiss8'
}

/** Bonus entry */
export type Bonus = {
  __typename?: 'Bonus';
  amount: Maybe<Scalars['Float']['output']>;
  bonusLost: Maybe<Scalars['Boolean']['output']>;
  lotsTraded: Maybe<Scalars['Float']['output']>;
  requiredLots: Maybe<Scalars['Int']['output']>;
};

/** Member Competition entry */
export type MemberCompetition = {
  __typename?: 'MemberCompetition';
  acceptTerms: Maybe<Scalars['String']['output']>;
  accountId: Maybe<Scalars['Int']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  competitionDetails: Maybe<Competition>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  exitDate: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  memberId: Maybe<Scalars['Int']['output']>;
  startDate: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CopyTradingStrategy = {
  __typename?: 'CopyTradingStrategy';
  accountName: Maybe<Scalars['String']['output']>;
  providerAccountId: Maybe<Scalars['Int']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
};

/** List of trading position statuses */
export enum TradingPositionStatus {
  All = 'all',
  Closed = 'closed',
  Open = 'open',
  Pending = 'pending'
}

/** Parameters of Forex Position */
export type ForexPosition = {
  __typename?: 'ForexPosition';
  /** Closed through API */
  closedThroughApi: Maybe<Scalars['Boolean']['output']>;
  /** Close rate */
  closeRate: Maybe<Scalars['Float']['output']>;
  /** Close time */
  closeTime: Maybe<Scalars['DateTime']['output']>;
  /** Close Uuid */
  closeUuid: Maybe<Scalars['String']['output']>;
  /** Trading command */
  command: Maybe<ForexCommand>;
  /** Comment */
  comment: Maybe<Scalars['String']['output']>;
  /** Commission */
  commission: Maybe<Scalars['Float']['output']>;
  /** Investment (margin) */
  investment: Maybe<Scalars['Float']['output']>;
  /** Leverage */
  leverage: Maybe<Scalars['Int']['output']>;
  /** Opened through API */
  openedThroughApi: Maybe<Scalars['Boolean']['output']>;
  /** Open rate */
  openRate: Maybe<Scalars['Float']['output']>;
  /** Open time */
  openTime: Maybe<Scalars['DateTime']['output']>;
  /** Open Uuid */
  openUuid: Maybe<Scalars['String']['output']>;
  /** Profit */
  profit: Maybe<Scalars['Float']['output']>;
  /** Specific source of the forex position/trade */
  source: Maybe<PositionSource>;
  /** Stop Loss */
  stopLoss: Maybe<Scalars['Float']['output']>;
  /** Swaps */
  swaps: Maybe<Scalars['Float']['output']>;
  /** Trading symbol */
  symbol: Maybe<Scalars['String']['output']>;
  /** Take Profit */
  takeProfit: Maybe<Scalars['Float']['output']>;
  /** Trading ticket */
  ticket: Maybe<Scalars['Int']['output']>;
  /** Trading volume */
  volume: Maybe<Scalars['Float']['output']>;
  /** VolumeEUR */
  volumeEUR: Maybe<Scalars['Float']['output']>;
};

/** List of forex commands */
export enum ForexCommand {
  Balance = 'balance',
  Buy = 'buy',
  BuyLimit = 'buyLimit',
  BuyStop = 'buyStop',
  Credit = 'credit',
  Sell = 'sell',
  SellLimit = 'sellLimit',
  SellStop = 'sellStop'
}

/** Specific source of the forex position/trade */
export type PositionSource = {
  __typename?: 'PositionSource';
  /** Source RemoteID */
  remoteId: Maybe<Scalars['Int']['output']>;
  /** Source Ticket */
  ticket: Maybe<Scalars['Int']['output']>;
  /** Position source type */
  type: PositionSourceType;
};

/** Position source type */
export enum PositionSourceType {
  BrokereeCopyTrading = 'BrokereeCopyTrading',
  LegacyCopyTrading = 'LegacyCopyTrading'
}

/** Live margin info of the user */
export type ForexMarginInfo = {
  __typename?: 'ForexMarginInfo';
  balance: Maybe<Scalars['Float']['output']>;
  equity: Maybe<Scalars['Float']['output']>;
  freeMargin: Maybe<Scalars['Float']['output']>;
  level: Maybe<Scalars['Float']['output']>;
  leverage: Maybe<Scalars['Int']['output']>;
  margin: Maybe<Scalars['Float']['output']>;
};

export enum Mt4Servers {
  Demo = 'demo',
  MlDemo01 = 'mlDemo01',
  MlReal01 = 'mlReal01',
  Real01 = 'real01',
  Real02 = 'real02',
  Real03 = 'real03',
  Real04 = 'real04',
  Real05 = 'real05',
  SvgReal01 = 'svgReal01',
  TmmReal01 = 'tmmReal01'
}

export type SymbolOverrides = {
  __typename?: 'SymbolOverrides';
  marginDivider: Maybe<Scalars['Float']['output']>;
  symbol: Maybe<Scalars['String']['output']>;
};

/** AI Demo Account */
export type AipammDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'AIPAMMDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** AI Demo Account */
export type AipammDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** AI Demo Account */
export type AipammDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** AI Demo Account */
export type AipammDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** AI Demo Account */
export type AipammDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** AI Demo Account */
export type AipammDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Demo Account */
export type AipammDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Demo Account */
export type AipammDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Demo Account */
export type AipammDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Demo Account */
export type AipammDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Demo Account */
export type AipammDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** AI Demo Account */
export type AipammDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Demo Account */
export type AipammDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** AI Account */
export type AipammMauritiusAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'AIPAMMMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** AI Account */
export type AipammMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** AI Account */
export type AipammMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** AI Account */
export type AipammMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** AI Account */
export type AipammMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** AI Account */
export type AipammMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Account */
export type AipammMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Account */
export type AipammMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Account */
export type AipammMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Account */
export type AipammMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Account */
export type AipammMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Account */
export type AipammMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** AI Account */
export type AipammMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Account */
export type AipammMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** AI Demo Account */
export type AipammMauritiusDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'AIPAMMMauritiusDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** AI Demo Account */
export type AipammMauritiusDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** BDXcoin */
export type BdXcoin = BaseAccount & BaseCryptoCoinAccount & {
  __typename?: 'BDXcoin';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance in Fiat */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonus Balance in Fiat */
  bonusBalance: Maybe<Scalars['Float']['output']>;
  /** Bonus FX Balance in Fiat */
  bonusFXBalance: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Coins for this account */
  coins: Maybe<Scalars['Float']['output']>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Deposit Wallet Address To Credit Coins */
  depositWalletAddress: Maybe<Scalars['String']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Wallet Address To Credit Coins */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** BDXcoin */
export type BdXcoinBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDXcoin */
export type BdXcoinBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDXcoin */
export type BdXcoinCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDXcoin */
export type BdXcoinCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDXcoin */
export type BdXcoinCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDXcoin */
export type BdXcoinDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDXcoin */
export type BdXcoinTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** BDXcoin */
export type BdXcoinWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDXcoin */
export type BdXcoinWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseCryptoCoinAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance in Fiat */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonus Balance in Fiat */
  bonusBalance: Maybe<Scalars['Float']['output']>;
  /** Bonus FX Balance in Fiat */
  bonusFXBalance: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Coins for this account */
  coins: Maybe<Scalars['Float']['output']>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Deposit Wallet Address To Credit Coins */
  depositWalletAddress: Maybe<Scalars['String']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Wallet Address To Credit Coins */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseCryptoCoinAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseCryptoCoinAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseCryptoCoinAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseCryptoCoinAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseCryptoCoinAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoCoinAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseCryptoCoinAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoCoinAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoCoinAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoCoinAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoCoinAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoCoinAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseCryptoCoinAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseCryptoCoinAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseCryptoCoinAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** BDXcoin */
export type BdXcoinMauritius = BaseAccount & BaseCryptoCoinAccount & {
  __typename?: 'BDXcoinMauritius';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance in Fiat */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonus Balance in Fiat */
  bonusBalance: Maybe<Scalars['Float']['output']>;
  /** Bonus FX Balance in Fiat */
  bonusFXBalance: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Coins for this account */
  coins: Maybe<Scalars['Float']['output']>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Deposit Wallet Address To Credit Coins */
  depositWalletAddress: Maybe<Scalars['String']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Wallet Address To Credit Coins */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** BDXcoin */
export type BdXcoinMauritiusBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDXcoin */
export type BdXcoinMauritiusBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDXcoin */
export type BdXcoinMauritiusCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDXcoin */
export type BdXcoinMauritiusCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDXcoin */
export type BdXcoinMauritiusCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinMauritiusCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDXcoin */
export type BdXcoinMauritiusDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinMauritiusDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinMauritiusSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinMauritiusTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinMauritiusTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinMauritiusTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDXcoin */
export type BdXcoinMauritiusTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** BDXcoin */
export type BdXcoinMauritiusWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDXcoin */
export type BdXcoinMauritiusWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** BDXcoin */
export type BdXcoinVanuatu = BaseAccount & BaseCryptoCoinAccount & {
  __typename?: 'BDXcoinVanuatu';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance in Fiat */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonus Balance in Fiat */
  bonusBalance: Maybe<Scalars['Float']['output']>;
  /** Bonus FX Balance in Fiat */
  bonusFXBalance: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Coins for this account */
  coins: Maybe<Scalars['Float']['output']>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Deposit Wallet Address To Credit Coins */
  depositWalletAddress: Maybe<Scalars['String']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Wallet Address To Credit Coins */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** BDXcoin */
export type BdXcoinVanuatuBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDXcoin */
export type BdXcoinVanuatuBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDXcoin */
export type BdXcoinVanuatuCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDXcoin */
export type BdXcoinVanuatuCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDXcoin */
export type BdXcoinVanuatuCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinVanuatuCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDXcoin */
export type BdXcoinVanuatuDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinVanuatuDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinVanuatuSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinVanuatuTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinVanuatuTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDXcoin */
export type BdXcoinVanuatuTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDXcoin */
export type BdXcoinVanuatuTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** BDXcoin */
export type BdXcoinVanuatuWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDXcoin */
export type BdXcoinVanuatuWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritius = BaseAccount & BaseBitnukWalletAccount & {
  __typename?: 'BitnukWalletMauritius';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Crypto Wallet Address */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal Fee */
  withdrawalFee: Maybe<Scalars['Float']['output']>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bitnuk Wallet [Mauritius] */
export type BitnukWalletMauritiusWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseBitnukWalletAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Crypto Wallet Address */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal Fee */
  withdrawalFee: Maybe<Scalars['Float']['output']>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseBitnukWalletAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseBitnukWalletAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseBitnukWalletAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseBitnukWalletAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseBitnukWalletAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBitnukWalletAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseBitnukWalletAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBitnukWalletAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBitnukWalletAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBitnukWalletAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBitnukWalletAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBitnukWalletAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseBitnukWalletAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseBitnukWalletAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseBitnukWalletAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritius = BaseAccount & BaseBitnukWalletAccount & {
  __typename?: 'BitnukWalletSwissMarketsMauritius';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Crypto Wallet Address */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal Fee */
  withdrawalFee: Maybe<Scalars['Float']['output']>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bitnuk WalletSwissMarkets [Mauritius] */
export type BitnukWalletSwissMarketsMauritiusWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatu = BaseAccount & BaseBitnukWalletAccount & {
  __typename?: 'BitnukWalletVanuatu';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Crypto Wallet Address */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal Fee */
  withdrawalFee: Maybe<Scalars['Float']['output']>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bitnuk Wallet [Vanuatu] */
export type BitnukWalletVanuatuWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Bond Account */
export type BondAccount = BaseAccount & BaseBondAccount & BaseForexAccount & {
  __typename?: 'BondAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  /** Coupons paid for bonds on this account */
  coupons: Maybe<Array<Maybe<CouponType>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Bond Account */
export type BondAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Account */
export type BondAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Account */
export type BondAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Account */
export type BondAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Account */
export type BondAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Account */
export type BondAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Account */
export type BondAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Account */
export type BondAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Account */
export type BondAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Account */
export type BondAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Bond Account */
export type BondAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Account */
export type BondAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseBondAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  /** Coupons paid for bonds on this account */
  coupons: Maybe<Array<Maybe<CouponType>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseBondAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseBondAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseBondAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseBondAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseBondAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBondAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseBondAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBondAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBondAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseBondAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseBondAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseBondAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBondAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBondAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseBondAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseBondAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseBondAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseBondAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Coupon payment */
export type CouponType = {
  __typename?: 'CouponType';
  /** Amount that was paid */
  amount: Maybe<Scalars['Float']['output']>;
  /** Bond symbol on MT4 */
  bond: Maybe<Scalars['String']['output']>;
  /** Date coupon was paid */
  date: Maybe<Scalars['DateTime']['output']>;
  /** Ticket on MT4 */
  ticket: Maybe<Scalars['Int']['output']>;
};

/** Bond Demo Account */
export type BondDemoAccount = BaseAccount & BaseBondAccount & BaseForexAccount & {
  __typename?: 'BondDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  /** Coupons paid for bonds on this account */
  coupons: Maybe<Array<Maybe<CouponType>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Bond Demo Account */
export type BondDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Demo Account */
export type BondDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Demo Account */
export type BondDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Demo Account */
export type BondDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Demo Account */
export type BondDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Demo Account */
export type BondDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Demo Account */
export type BondDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Demo Account */
export type BondDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Demo Account */
export type BondDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Demo Account */
export type BondDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Bond Demo Account */
export type BondDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Demo Account */
export type BondDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Bond Account */
export type BondMauritiusAccount = BaseAccount & BaseBondAccount & BaseForexAccount & {
  __typename?: 'BondMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  /** Coupons paid for bonds on this account */
  coupons: Maybe<Array<Maybe<CouponType>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Bond Account */
export type BondMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Account */
export type BondMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Account */
export type BondMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Account */
export type BondMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Account */
export type BondMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Account */
export type BondMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Account */
export type BondMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Account */
export type BondMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Account */
export type BondMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Account */
export type BondMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Bond Account */
export type BondMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Account */
export type BondMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Bond Demo Account */
export type BondMauritiusDemoAccount = BaseAccount & BaseBondAccount & BaseForexAccount & {
  __typename?: 'BondMauritiusDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  /** Coupons paid for bonds on this account */
  coupons: Maybe<Array<Maybe<CouponType>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Demo Account */
export type BondMauritiusDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Bond Account */
export type BondVanuatuAccount = BaseAccount & BaseBondAccount & BaseForexAccount & {
  __typename?: 'BondVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  /** Coupons paid for bonds on this account */
  coupons: Maybe<Array<Maybe<CouponType>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Bond Account */
export type BondVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Account */
export type BondVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Account */
export type BondVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Account */
export type BondVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Account */
export type BondVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Account */
export type BondVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Account */
export type BondVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Account */
export type BondVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Account */
export type BondVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Account */
export type BondVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Account */
export type BondVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Bond Account */
export type BondVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Account */
export type BondVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Bond Demo Account */
export type BondVanuatuDemoAccount = BaseAccount & BaseBondAccount & BaseForexAccount & {
  __typename?: 'BondVanuatuDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  /** Coupons paid for bonds on this account */
  coupons: Maybe<Array<Maybe<CouponType>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Bond Demo Account */
export type BondVanuatuDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** BRFcoin */
export type BrFcoin = BaseAccount & BaseCryptoCoinAccount & {
  __typename?: 'BRFcoin';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance in Fiat */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonus Balance in Fiat */
  bonusBalance: Maybe<Scalars['Float']['output']>;
  /** Bonus FX Balance in Fiat */
  bonusFXBalance: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Coins for this account */
  coins: Maybe<Scalars['Float']['output']>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Deposit Wallet Address To Credit Coins */
  depositWalletAddress: Maybe<Scalars['String']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Wallet Address To Credit Coins */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** BRFcoin */
export type BrFcoinBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BRFcoin */
export type BrFcoinBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BRFcoin */
export type BrFcoinCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BRFcoin */
export type BrFcoinCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BRFcoin */
export type BrFcoinCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BRFcoin */
export type BrFcoinCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BRFcoin */
export type BrFcoinDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BRFcoin */
export type BrFcoinDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BRFcoin */
export type BrFcoinSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BRFcoin */
export type BrFcoinTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BRFcoin */
export type BrFcoinTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BRFcoin */
export type BrFcoinTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BRFcoin */
export type BrFcoinTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** BRFcoin */
export type BrFcoinWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BRFcoin */
export type BrFcoinWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Cent Equity Flow */
export type CentEquityFlowAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'CentEquityFlowAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent Equity Flow */
export type CentEquityFlowAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Cent [Mauritius] */
export type CentMauritiusAccount = BaseAccount & BaseForexAccount & BdSwissForexMt4AccountType & {
  __typename?: 'CentMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent [Mauritius] */
export type CentMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BdSwissForexMt4AccountType = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BdSwissForexMt4AccountTypeBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BdSwissForexMt4AccountTypeBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BdSwissForexMt4AccountTypeCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BdSwissForexMt4AccountTypeCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BdSwissForexMt4AccountTypeCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BdSwissForexMt4AccountTypeCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BdSwissForexMt4AccountTypeDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BdSwissForexMt4AccountTypeDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BdSwissForexMt4AccountTypeForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BdSwissForexMt4AccountTypeForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BdSwissForexMt4AccountTypeHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BdSwissForexMt4AccountTypeSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BdSwissForexMt4AccountTypeTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BdSwissForexMt4AccountTypeTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BdSwissForexMt4AccountTypeTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BdSwissForexMt4AccountTypeTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BdSwissForexMt4AccountTypeWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BdSwissForexMt4AccountTypeWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Cent Tauro Markets */
export type CentTauroMarketsAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'CentTauroMarketsAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent Tauro Markets */
export type CentTauroMarketsAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Cent [Vanuatu] */
export type CentVanuatuAccount = BaseAccount & BaseForexAccount & BdSwissForexMt4AccountType & {
  __typename?: 'CentVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cent [Vanuatu] */
export type CentVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** CLEANcoin */
export type CleaNcoin = BaseAccount & BaseCryptoCoinAccount & {
  __typename?: 'CLEANcoin';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance in Fiat */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonus Balance in Fiat */
  bonusBalance: Maybe<Scalars['Float']['output']>;
  /** Bonus FX Balance in Fiat */
  bonusFXBalance: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Coins for this account */
  coins: Maybe<Scalars['Float']['output']>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Deposit Wallet Address To Credit Coins */
  depositWalletAddress: Maybe<Scalars['String']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Wallet Address To Credit Coins */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** CLEANcoin */
export type CleaNcoinBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** CLEANcoin */
export type CleaNcoinBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** CLEANcoin */
export type CleaNcoinCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** CLEANcoin */
export type CleaNcoinCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** CLEANcoin */
export type CleaNcoinCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CLEANcoin */
export type CleaNcoinCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** CLEANcoin */
export type CleaNcoinDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CLEANcoin */
export type CleaNcoinDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CLEANcoin */
export type CleaNcoinSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CLEANcoin */
export type CleaNcoinTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CLEANcoin */
export type CleaNcoinTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CLEANcoin */
export type CleaNcoinTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** CLEANcoin */
export type CleaNcoinTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** CLEANcoin */
export type CleaNcoinWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** CLEANcoin */
export type CleaNcoinWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** CryptoWallet */
export type CryptoWallet = BaseAccount & BaseCryptoWalletAccount & {
  __typename?: 'CryptoWallet';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Crypto balance for this account */
  cryptoBalance: Maybe<Scalars['Float']['output']>;
  /** Transactions of this account */
  cryptoTransactions: Maybe<Array<Maybe<CryptoTransaction>>>;
  /** Total transactions for this account */
  cryptoTransactionsCount: Maybe<Scalars['Int']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** CryptoWallet */
export type CryptoWalletBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** CryptoWallet */
export type CryptoWalletBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** CryptoWallet */
export type CryptoWalletCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** CryptoWallet */
export type CryptoWalletCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** CryptoWallet */
export type CryptoWalletCryptoTransactionsArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  forAffiliateAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletSwissMarketsMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletVanuatu: InputMaybe<Scalars['Boolean']['input']>;
  forBondAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBRFCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCLEANcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCryptoWallet: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeBDXAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forFiatWallet: InputMaybe<Scalars['Boolean']['input']>;
  forForexAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicTauroMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccountBDX: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5Account: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5DemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forGoldAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forJOLLYcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<CryptoTransactionStatusType>>>;
  type: InputMaybe<CryptoTransactionTypeType>;
};


/** CryptoWallet */
export type CryptoWalletCryptoTransactionsCountArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  forAffiliateAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletSwissMarketsMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletVanuatu: InputMaybe<Scalars['Boolean']['input']>;
  forBondAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBRFCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCLEANcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCryptoWallet: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeBDXAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forFiatWallet: InputMaybe<Scalars['Boolean']['input']>;
  forForexAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicTauroMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccountBDX: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5Account: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5DemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forGoldAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forJOLLYcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<CryptoTransactionStatusType>>>;
  type: InputMaybe<CryptoTransactionTypeType>;
};


/** CryptoWallet */
export type CryptoWalletCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CryptoWallet */
export type CryptoWalletCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** CryptoWallet */
export type CryptoWalletDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CryptoWallet */
export type CryptoWalletDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CryptoWallet */
export type CryptoWalletSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CryptoWallet */
export type CryptoWalletTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CryptoWallet */
export type CryptoWalletTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** CryptoWallet */
export type CryptoWalletTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** CryptoWallet */
export type CryptoWalletTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** CryptoWallet */
export type CryptoWalletWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** CryptoWallet */
export type CryptoWalletWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseCryptoWalletAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Crypto balance for this account */
  cryptoBalance: Maybe<Scalars['Float']['output']>;
  /** Transactions of this account */
  cryptoTransactions: Maybe<Array<Maybe<CryptoTransaction>>>;
  /** Total transactions for this account */
  cryptoTransactionsCount: Maybe<Scalars['Int']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseCryptoWalletAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseCryptoWalletAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseCryptoWalletAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseCryptoWalletAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseCryptoWalletAccountCryptoTransactionsArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  forAffiliateAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletSwissMarketsMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletVanuatu: InputMaybe<Scalars['Boolean']['input']>;
  forBondAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBRFCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCLEANcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCryptoWallet: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeBDXAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forFiatWallet: InputMaybe<Scalars['Boolean']['input']>;
  forForexAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicTauroMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccountBDX: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5Account: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5DemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forGoldAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forJOLLYcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<CryptoTransactionStatusType>>>;
  type: InputMaybe<CryptoTransactionTypeType>;
};


export type BaseCryptoWalletAccountCryptoTransactionsCountArgs = {
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  forAffiliateAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAffiliateVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forAIPAMMMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBDXCoinVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletSwissMarketsMauritius: InputMaybe<Scalars['Boolean']['input']>;
  forBitnukWalletVanuatu: InputMaybe<Scalars['Boolean']['input']>;
  forBondAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBondVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forBRFCoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCentVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCLEANcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCryptoWallet: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forCuboidVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeBDXAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forExchangeVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forFiatWallet: InputMaybe<Scalars['Boolean']['input']>;
  forForexAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicTauroMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexClassicVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexEquityFlowDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexLydianDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusAccountBDX: InputMaybe<Scalars['Boolean']['input']>;
  forForexMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5Account: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5DemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5MauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexMT5VanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexPremiumVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawBDSwissVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexRawVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexSkyGroundDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsAsiaAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexTauroMarketsDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forForexVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forGoldAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerEquityFlowAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forIntroducingBrokerSwissMarketsVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forJOLLYcoinAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forMAMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMFundManagerVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMManagerAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMSMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forPAMMVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletBDSwissMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSMPrimeWalletVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forSpotOptionVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterMauritiusAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterMauritiusDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradesmarterVanuatuAccount: InputMaybe<Scalars['Boolean']['input']>;
  forTradeSmarterVanuatuDemoAccount: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<CryptoTransactionStatusType>>>;
  type: InputMaybe<CryptoTransactionTypeType>;
};


export type BaseCryptoWalletAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoWalletAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseCryptoWalletAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoWalletAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoWalletAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoWalletAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoWalletAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCryptoWalletAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseCryptoWalletAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseCryptoWalletAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseCryptoWalletAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** One of the possible crypto trx statuses */
export enum CryptoTransactionStatusType {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Held = 'held',
  Incomplete = 'incomplete',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** One of the possible transaction types */
export enum CryptoTransactionTypeType {
  Buy = 'buy',
  Sell = 'sell',
  TransferIn = 'transferIn',
  TransferOut = 'transferOut'
}

/** Transactions to and from crypto wallets */
export type CryptoTransaction = {
  __typename?: 'CryptoTransaction';
  /** Account where transaction was made */
  account: Maybe<Account>;
  /** Amount of transaction, in chosen currency */
  amount: Maybe<Scalars['Float']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency of transaction */
  currency: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  destinationWallet: Maybe<Scalars['String']['output']>;
  /** Transaction ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Merchant */
  merchant: Maybe<Client>;
  /** Status of transaction */
  status: Maybe<CryptoTransactionStatusType>;
  /** Status of transaction */
  type: Maybe<CryptoTransactionTypeType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Cuboid Account */
export type CuboidAccount = BaseAccount & BaseCuboidAccount & {
  __typename?: 'CuboidAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Cuboid ID on the external product */
  cuboidId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  cuboidPositions: Maybe<Array<Maybe<CuboidPosition>>>;
  /** Positions of this account */
  cuboidPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Cuboid Account */
export type CuboidAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Account */
export type CuboidAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Account */
export type CuboidAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Account */
export type CuboidAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Account */
export type CuboidAccountCuboidPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Account */
export type CuboidAccountCuboidPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Account */
export type CuboidAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account */
export type CuboidAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Account */
export type CuboidAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account */
export type CuboidAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account */
export type CuboidAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account */
export type CuboidAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account */
export type CuboidAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account */
export type CuboidAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Account */
export type CuboidAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Cuboid Account */
export type CuboidAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Account */
export type CuboidAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseCuboidAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Cuboid ID on the external product */
  cuboidId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  cuboidPositions: Maybe<Array<Maybe<CuboidPosition>>>;
  /** Positions of this account */
  cuboidPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseCuboidAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseCuboidAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseCuboidAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseCuboidAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseCuboidAccountCuboidPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseCuboidAccountCuboidPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseCuboidAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCuboidAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseCuboidAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCuboidAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCuboidAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCuboidAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCuboidAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseCuboidAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseCuboidAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseCuboidAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseCuboidAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Parameters of Cuboid Position */
export type CuboidPosition = {
  __typename?: 'CuboidPosition';
  /** Asset Id */
  assetId: Maybe<Scalars['Int']['output']>;
  /** Currency */
  currency: Maybe<Scalars['String']['output']>;
  /** Expiry Time */
  expiryTime: Maybe<Scalars['DateTime']['output']>;
  /** Failure Time */
  failureTime: Maybe<Scalars['DateTime']['output']>;
  /** Failure Value */
  failureValue: Maybe<Scalars['Float']['output']>;
  /** Investment */
  investment: Maybe<Scalars['Float']['output']>;
  /** Lower Bound */
  lowerBound: Maybe<Scalars['Float']['output']>;
  /** Order Id */
  orderId: Maybe<Scalars['String']['output']>;
  /** Payout */
  payout: Maybe<Scalars['Float']['output']>;
  /** Resulted Price */
  resultedPrice: Maybe<Scalars['Float']['output']>;
  /** Start Time */
  startTime: Maybe<Scalars['DateTime']['output']>;
  /** Status */
  status: Maybe<Scalars['String']['output']>;
  /** Upper Bound */
  upperBound: Maybe<Scalars['Float']['output']>;
  /** Username */
  username: Maybe<Scalars['String']['output']>;
};

/** Cuboid Demo Account */
export type CuboidDemoAccount = BaseAccount & BaseCuboidAccount & {
  __typename?: 'CuboidDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Cuboid ID on the external product */
  cuboidId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  cuboidPositions: Maybe<Array<Maybe<CuboidPosition>>>;
  /** Positions of this account */
  cuboidPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountCuboidPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountCuboidPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Demo Account */
export type CuboidDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccount = BaseAccount & BaseCuboidAccount & {
  __typename?: 'CuboidMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Cuboid ID on the external product */
  cuboidId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  cuboidPositions: Maybe<Array<Maybe<CuboidPosition>>>;
  /** Positions of this account */
  cuboidPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountCuboidPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountCuboidPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Account [Mauritius] */
export type CuboidMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccount = BaseAccount & BaseCuboidAccount & {
  __typename?: 'CuboidMauritiusDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Cuboid ID on the external product */
  cuboidId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  cuboidPositions: Maybe<Array<Maybe<CuboidPosition>>>;
  /** Positions of this account */
  cuboidPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountCuboidPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountCuboidPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Demo Account [Mauritius] */
export type CuboidMauritiusDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccount = BaseAccount & BaseCuboidAccount & {
  __typename?: 'CuboidVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Cuboid ID on the external product */
  cuboidId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  cuboidPositions: Maybe<Array<Maybe<CuboidPosition>>>;
  /** Positions of this account */
  cuboidPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountCuboidPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountCuboidPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Account [Vanuatu] */
export type CuboidVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccount = BaseAccount & BaseCuboidAccount & {
  __typename?: 'CuboidVanuatuDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Cuboid ID on the external product */
  cuboidId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  cuboidPositions: Maybe<Array<Maybe<CuboidPosition>>>;
  /** Positions of this account */
  cuboidPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountCuboidPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountCuboidPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Cuboid Demo Account [Vanuatu] */
export type CuboidVanuatuDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Empty account type */
export type EmptyAccountType = BaseAccount & {
  __typename?: 'EmptyAccountType';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Empty account type */
export type EmptyAccountTypeBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Empty account type */
export type EmptyAccountTypeBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Empty account type */
export type EmptyAccountTypeCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty account type */
export type EmptyAccountTypeCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty account type */
export type EmptyAccountTypeCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Empty account type */
export type EmptyAccountTypeCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Empty account type */
export type EmptyAccountTypeDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Empty account type */
export type EmptyAccountTypeDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Empty account type */
export type EmptyAccountTypeSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Empty account type */
export type EmptyAccountTypeTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Empty account type */
export type EmptyAccountTypeTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Empty account type */
export type EmptyAccountTypeTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Empty account type */
export type EmptyAccountTypeTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Empty account type */
export type EmptyAccountTypeWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Empty account type */
export type EmptyAccountTypeWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Exchange Account */
export type ExchangeAccount = BaseAccount & BaseExchangeAccount & {
  __typename?: 'ExchangeAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Additional data for Exchange accounts */
  balanceInfo: Maybe<ExchangeFields>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Exchange Account */
export type ExchangeAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Exchange Account */
export type ExchangeAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Exchange Account */
export type ExchangeAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Exchange Account */
export type ExchangeAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Exchange Account */
export type ExchangeAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Exchange Account */
export type ExchangeAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseExchangeAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Additional data for Exchange accounts */
  balanceInfo: Maybe<ExchangeFields>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseExchangeAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseExchangeAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseExchangeAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseExchangeAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseExchangeAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseExchangeAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseExchangeAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseExchangeAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseExchangeAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseExchangeAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseExchangeAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseExchangeAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseExchangeAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseExchangeAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseExchangeAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Additional fields from the exchange service */
export type ExchangeFields = {
  __typename?: 'ExchangeFields';
  availableBalance: Maybe<Scalars['Float']['output']>;
  balance: Maybe<Scalars['Int']['output']>;
  heldBalance: Maybe<Scalars['Float']['output']>;
};

/** Exchange Account */
export type ExchangeBdxAccount = BaseAccount & BaseExchangeAccount & {
  __typename?: 'ExchangeBDXAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Additional data for Exchange accounts */
  balanceInfo: Maybe<ExchangeFields>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Exchange Account */
export type ExchangeBdxAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Exchange Account */
export type ExchangeBdxAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Exchange Account */
export type ExchangeBdxAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Exchange Account */
export type ExchangeBdxAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Exchange Account */
export type ExchangeBdxAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeBdxAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeBdxAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeBdxAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeBdxAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeBdxAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeBdxAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeBdxAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeBdxAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Exchange Account */
export type ExchangeBdxAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeBdxAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Exchange Account */
export type ExchangeMauritiusAccount = BaseAccount & BaseExchangeAccount & {
  __typename?: 'ExchangeMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Additional data for Exchange accounts */
  balanceInfo: Maybe<ExchangeFields>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Exchange Account */
export type ExchangeVanuatuAccount = BaseAccount & BaseExchangeAccount & {
  __typename?: 'ExchangeVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Additional data for Exchange accounts */
  balanceInfo: Maybe<ExchangeFields>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Exchange Account */
export type ExchangeVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** FiatWallet */
export type FiatWallet = BaseAccount & BaseFiatWalletAccount & {
  __typename?: 'FiatWallet';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** FiatWallet */
export type FiatWalletBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** FiatWallet */
export type FiatWalletBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** FiatWallet */
export type FiatWalletCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** FiatWallet */
export type FiatWalletCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** FiatWallet */
export type FiatWalletCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** FiatWallet */
export type FiatWalletCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** FiatWallet */
export type FiatWalletDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** FiatWallet */
export type FiatWalletDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** FiatWallet */
export type FiatWalletSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** FiatWallet */
export type FiatWalletTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** FiatWallet */
export type FiatWalletTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** FiatWallet */
export type FiatWalletTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** FiatWallet */
export type FiatWalletTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** FiatWallet */
export type FiatWalletWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** FiatWallet */
export type FiatWalletWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseFiatWalletAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseFiatWalletAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseFiatWalletAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseFiatWalletAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseFiatWalletAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseFiatWalletAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseFiatWalletAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseFiatWalletAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseFiatWalletAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseFiatWalletAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseFiatWalletAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseFiatWalletAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseFiatWalletAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseFiatWalletAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseFiatWalletAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseFiatWalletAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Account */
export type ForexAccount = BaseAccount & BaseForexAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Account */
export type ForexAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Account */
export type ForexAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Account */
export type ForexAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Account */
export type ForexAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Account */
export type ForexAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account */
export type ForexAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account */
export type ForexAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account */
export type ForexAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account */
export type ForexAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account */
export type ForexAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account */
export type ForexAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account */
export type ForexAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account */
export type ForexAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account */
export type ForexAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account */
export type ForexAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account */
export type ForexAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Account */
export type ForexAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account */
export type ForexAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Account [Asia] */
export type ForexAsiaAccount = BaseAccount & BaseForexAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexAsiaAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Asia] */
export type ForexAsiaAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Account */
export type ForexClassicAccount = BaseAccount & BaseForexAccount & SwissMarketsForexMt4AccountType & {
  __typename?: 'ForexClassicAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Account */
export type ForexClassicAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Account */
export type ForexClassicAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Account */
export type ForexClassicAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Account */
export type ForexClassicAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Account */
export type ForexClassicAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account */
export type ForexClassicAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Account */
export type ForexClassicAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account */
export type ForexClassicAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account */
export type ForexClassicAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Account */
export type ForexClassicAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Account */
export type ForexClassicAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Account */
export type ForexClassicAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account */
export type ForexClassicAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account */
export type ForexClassicAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account */
export type ForexClassicAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Account */
export type ForexClassicAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Account */
export type ForexClassicAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Account */
export type ForexClassicAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type SwissMarketsForexMt4AccountType = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type SwissMarketsForexMt4AccountTypeBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type SwissMarketsForexMt4AccountTypeBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type SwissMarketsForexMt4AccountTypeCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type SwissMarketsForexMt4AccountTypeCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type SwissMarketsForexMt4AccountTypeCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type SwissMarketsForexMt4AccountTypeCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type SwissMarketsForexMt4AccountTypeDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type SwissMarketsForexMt4AccountTypeDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type SwissMarketsForexMt4AccountTypeForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type SwissMarketsForexMt4AccountTypeForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type SwissMarketsForexMt4AccountTypeHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type SwissMarketsForexMt4AccountTypeSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type SwissMarketsForexMt4AccountTypeTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type SwissMarketsForexMt4AccountTypeTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type SwissMarketsForexMt4AccountTypeTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type SwissMarketsForexMt4AccountTypeTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type SwissMarketsForexMt4AccountTypeWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type SwissMarketsForexMt4AccountTypeWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Demo Account */
export type ForexClassicDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Demo Account */
export type ForexClassicDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicEquityFlowAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicEquityFlowAsiaAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Equity Flow Account [Asia] */
export type ForexClassicEquityFlowAsiaAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicEquityFlowDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Equity Flow Account */
export type ForexClassicEquityFlowDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Lydian Account */
export type ForexClassicLydianAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicLydianAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicLydianDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Lydian Account */
export type ForexClassicLydianDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccount = BaseAccount & BaseForexAccount & SwissMarketsForexMt4AccountType & {
  __typename?: 'ForexClassicMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Account [Mauritius] */
export type ForexClassicMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccount = BaseAccount & BaseForexAccount & SwissMarketsForexMt4AccountType & {
  __typename?: 'ForexClassicMauritiusDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Demo Account [Mauritius] */
export type ForexClassicMauritiusDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicSkyGroundAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic SkyGround Account */
export type ForexClassicSkyGroundAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicSkyGroundDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo SkyGround Account */
export type ForexClassicSkyGroundDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicTauroMarketsAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicTauroMarketsAsiaAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Tauro Markets Account [Asia] */
export type ForexClassicTauroMarketsAsiaAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicTauroMarketsDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexClassicTauroMarketsMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Tauro Markets Account */
export type ForexClassicTauroMarketsMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccount = BaseAccount & BaseForexAccount & SwissMarketsForexMt4AccountType & {
  __typename?: 'ForexClassicVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Account [Vanuatu] */
export type ForexClassicVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccount = BaseAccount & BaseForexAccount & SwissMarketsForexMt4AccountType & {
  __typename?: 'ForexClassicVanuatuDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Classic Demo Account [Vanuatu] */
export type ForexClassicVanuatuDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Demo Account */
export type ForexDemoAccount = BaseAccount & BaseForexAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Demo Account */
export type ForexDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Demo Account */
export type ForexDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Demo Account */
export type ForexDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Demo Account */
export type ForexDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Demo Account */
export type ForexDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account */
export type ForexDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo Account */
export type ForexDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account */
export type ForexDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account */
export type ForexDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo Account */
export type ForexDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo Account */
export type ForexDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo Account */
export type ForexDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account */
export type ForexDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account */
export type ForexDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account */
export type ForexDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo Account */
export type ForexDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Demo Account */
export type ForexDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo Account */
export type ForexDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Account [Mauritius] */
export type ForexMauritiusAccount = BaseAccount & BaseForexAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdx = BaseAccount & BaseForexAccount & BaseForexBdxAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexMauritiusAccountBDX';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Lots to trade in order to withdraw bonus */
  lotsToTrade: Maybe<Scalars['Float']['output']>;
  /** Lots traded so far */
  lotsTraded: Maybe<Scalars['Float']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Mauritius] */
export type ForexMauritiusAccountBdxWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseForexBdxAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Lots to trade in order to withdraw bonus */
  lotsToTrade: Maybe<Scalars['Float']['output']>;
  /** Lots traded so far */
  lotsTraded: Maybe<Scalars['Float']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseForexBdxAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseForexBdxAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseForexBdxAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseForexBdxAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseForexBdxAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexBdxAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexBdxAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexBdxAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexBdxAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexBdxAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexBdxAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexBdxAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexBdxAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexBdxAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexBdxAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexBdxAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseForexBdxAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexBdxAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccount = BaseAccount & BaseForexAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexMauritiusDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo Account [Mauritius] */
export type ForexMauritiusDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex MT5 Account */
export type ForexMt5Account = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexMT5Account';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex MT5 Account */
export type ForexMt5AccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account */
export type ForexMt5AccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account */
export type ForexMt5AccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account */
export type ForexMt5AccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account */
export type ForexMt5AccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account */
export type ForexMt5AccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account */
export type ForexMt5AccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account */
export type ForexMt5AccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account */
export type ForexMt5AccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account */
export type ForexMt5AccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account */
export type ForexMt5AccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account */
export type ForexMt5AccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account */
export type ForexMt5AccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account */
export type ForexMt5AccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account */
export type ForexMt5AccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account */
export type ForexMt5AccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex MT5 Account */
export type ForexMt5AccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account */
export type ForexMt5AccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex MT5 Demo Account */
export type ForexMt5DemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexMT5DemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Demo Account */
export type ForexMt5DemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexMT5MauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Mauritius] */
export type ForexMt5MauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexMT5MauritiusDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Demo Account [Mauritius] */
export type ForexMt5MauritiusDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexMT5SVGTauromarketsAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG] */
export type ForexMt5SvgTauromarketsAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexMT5SVGTauromarketsDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets][SVG][DEMO] */
export type ForexMt5SvgTauromarketsDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexMT5TauromarketsAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets] */
export type ForexMt5TauromarketsAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexMT5TauromarketsDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Tauromarkets][DEMO] */
export type ForexMt5TauromarketsDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexMT5VanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Account [Vanuatu] */
export type ForexMt5VanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'ForexMT5VanuatuDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex MT5 Demo Account [Vanuatu] */
export type ForexMt5VanuatuDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccount = BaseAccount & BaseForexAccount & BaseForexPremiumAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexPremiumMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  leverageChangedBasedOnEquity: Maybe<Scalars['Boolean']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Premium Account [Mauritius] */
export type ForexPremiumMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseForexPremiumAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  leverageChangedBasedOnEquity: Maybe<Scalars['Boolean']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseForexPremiumAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseForexPremiumAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseForexPremiumAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseForexPremiumAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseForexPremiumAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexPremiumAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexPremiumAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexPremiumAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexPremiumAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexPremiumAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexPremiumAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexPremiumAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexPremiumAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexPremiumAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexPremiumAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexPremiumAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseForexPremiumAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexPremiumAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccount = BaseAccount & BaseForexAccount & BaseForexPremiumAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexPremiumVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  leverageChangedBasedOnEquity: Maybe<Scalars['Boolean']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Premium Account [Vanuatu] */
export type ForexPremiumVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Raw Account */
export type ForexRawAccount = BaseAccount & BaseForexAccount & SwissMarketsForexMt4AccountType & {
  __typename?: 'ForexRawAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Raw Account */
export type ForexRawAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Raw Account */
export type ForexRawAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Raw Account */
export type ForexRawAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Raw Account */
export type ForexRawAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Raw Account */
export type ForexRawAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account */
export type ForexRawAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Raw Account */
export type ForexRawAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account */
export type ForexRawAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account */
export type ForexRawAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Raw Account */
export type ForexRawAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Raw Account */
export type ForexRawAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Raw Account */
export type ForexRawAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account */
export type ForexRawAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account */
export type ForexRawAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account */
export type ForexRawAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Raw Account */
export type ForexRawAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Raw Account */
export type ForexRawAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Raw Account */
export type ForexRawAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccount = BaseAccount & BaseForexAccount & BaseForexRawAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexRawBDSwissAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in fallback group */
  isInFallback: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in the over-the-limit group */
  isInOverTheLimit: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription plan used for Raw account */
  subscription: Maybe<RawSubscriptionType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  /** Volume traded so far */
  volumeTraded: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDSwiss Forex Raw Account */
export type ForexRawBdSwissAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseForexRawAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in fallback group */
  isInFallback: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in the over-the-limit group */
  isInOverTheLimit: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription plan used for Raw account */
  subscription: Maybe<RawSubscriptionType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  /** Volume traded so far */
  volumeTraded: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseForexRawAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseForexRawAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseForexRawAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseForexRawAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseForexRawAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexRawAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexRawAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexRawAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexRawAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexRawAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexRawAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseForexRawAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexRawAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexRawAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseForexRawAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexRawAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseForexRawAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseForexRawAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Raw Subscription Type */
export type RawSubscriptionType = {
  __typename?: 'rawSubscriptionType';
  account: Maybe<Account>;
  billingInfo: Maybe<BillingInfo>;
  cancelledAt: Maybe<Scalars['DateTime']['output']>;
  client: Maybe<Client>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  isExpired: Maybe<Scalars['Boolean']['output']>;
  lastPaymentFailed: Maybe<Scalars['Boolean']['output']>;
  nextPaymentDate: Maybe<Scalars['DateTime']['output']>;
  pendingPlan: Maybe<RawSubscriptionPlanType>;
  plan: Maybe<RawSubscriptionPlanType>;
  requestedChangeAt: Maybe<Scalars['DateTime']['output']>;
  terminatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Volume to trade in order to go to a higher plan */
  volumeToTrade: Maybe<Scalars['Float']['output']>;
};

/** Raw Subscription Plan enum */
export enum RawSubscriptionPlanType {
  MonthlyGrow = 'monthlyGrow',
  MonthlyPro = 'monthlyPro',
  MonthlyTrial = 'monthlyTrial'
}

/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccount = BaseAccount & BaseForexAccount & BaseForexRawAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexRawBDSwissMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in fallback group */
  isInFallback: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in the over-the-limit group */
  isInOverTheLimit: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription plan used for Raw account */
  subscription: Maybe<RawSubscriptionType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  /** Volume traded so far */
  volumeTraded: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDSwiss Forex Raw Account [Mauritius] */
export type ForexRawBdSwissMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccount = BaseAccount & BaseForexAccount & BaseForexRawAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexRawBDSwissVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in fallback group */
  isInFallback: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in the over-the-limit group */
  isInOverTheLimit: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription plan used for Raw account */
  subscription: Maybe<RawSubscriptionType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  /** Volume traded so far */
  volumeTraded: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** BDSwiss Forex Raw Account [Vanuatu] */
export type ForexRawBdSwissVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccount = BaseAccount & BaseForexAccount & BaseForexRawAccount & {
  __typename?: 'ForexRawEquityFlowAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in fallback group */
  isInFallback: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in the over-the-limit group */
  isInOverTheLimit: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription plan used for Raw account */
  subscription: Maybe<RawSubscriptionType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  /** Volume traded so far */
  volumeTraded: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Equity Flow Forex Raw Account */
export type ForexRawEquityFlowAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccount = BaseAccount & BaseForexAccount & SwissMarketsForexMt4AccountType & {
  __typename?: 'ForexRawMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Raw Account [Mauritius] */
export type ForexRawMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccount = BaseAccount & BaseForexAccount & BaseForexRawAccount & {
  __typename?: 'ForexRawTauroMarketsAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in fallback group */
  isInFallback: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if account is in the over-the-limit group */
  isInOverTheLimit: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription plan used for Raw account */
  subscription: Maybe<RawSubscriptionType>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  /** Volume traded so far */
  volumeTraded: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tauro Markets Forex Raw Account */
export type ForexRawTauroMarketsAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccount = BaseAccount & BaseForexAccount & SwissMarketsForexMt4AccountType & {
  __typename?: 'ForexRawVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Raw Account [Vanuatu] */
export type ForexRawVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Account [Vanuatu] */
export type ForexVanuatuAccount = BaseAccount & BaseForexAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Account [Vanuatu] */
export type ForexVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccount = BaseAccount & BaseForexAccount & BdSwissForexMt4AccountType & {
  __typename?: 'ForexVanuatuDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Forex Demo Account [Vanuatu] */
export type ForexVanuatuDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Physical Gold Account */
export type GoldAccount = BaseAccount & BaseGoldAccount & {
  __typename?: 'GoldAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Coins for this account */
  gold: Maybe<Scalars['Float']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  subscriptions: Maybe<Array<Maybe<GoldSubscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Physical Gold Account */
export type GoldAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Physical Gold Account */
export type GoldAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Physical Gold Account */
export type GoldAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Physical Gold Account */
export type GoldAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Physical Gold Account */
export type GoldAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Physical Gold Account */
export type GoldAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Physical Gold Account */
export type GoldAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Physical Gold Account */
export type GoldAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Physical Gold Account */
export type GoldAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseGoldAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Coins for this account */
  gold: Maybe<Scalars['Float']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  subscriptions: Maybe<Array<Maybe<GoldSubscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseGoldAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseGoldAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseGoldAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseGoldAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseGoldAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseGoldAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseGoldAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseGoldAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseGoldAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseGoldAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseGoldAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseGoldAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseGoldAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseGoldAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseGoldAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Gold Subscription Details */
export type GoldSubscription = {
  __typename?: 'GoldSubscription';
  activationDate: Maybe<Scalars['DateTime']['output']>;
  amountCent: Maybe<Scalars['Float']['output']>;
  cancellationDate: Maybe<Scalars['DateTime']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  lastBillingDate: Maybe<Scalars['DateTime']['output']>;
  nextBillingDate: Maybe<Scalars['DateTime']['output']>;
  planName: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
};

/** Physical Gold Account */
export type GoldMauritiusAccount = BaseAccount & BaseGoldAccount & {
  __typename?: 'GoldMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Coins for this account */
  gold: Maybe<Scalars['Float']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  subscriptions: Maybe<Array<Maybe<GoldSubscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Physical Gold Account */
export type GoldMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Physical Gold Account */
export type GoldVanuatuAccount = BaseAccount & BaseGoldAccount & {
  __typename?: 'GoldVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Coins for this account */
  gold: Maybe<Scalars['Float']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  subscriptions: Maybe<Array<Maybe<GoldSubscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Physical Gold Account */
export type GoldVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Introducing Broker Account */
export type IntroducingBrokerAccount = BaseAccount & BaseForexAccount & BaseIntroducingBrokerAccount & {
  __typename?: 'IntroducingBrokerAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IB account approval status */
  approvalStatus: Maybe<Scalars['String']['output']>;
  /** Approved IB account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Enable email notifications about follower actions */
  enablePartnerNotifications: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** IB ID */
  ibId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Ignore IB Transfers */
  ignoreIbTransfers: Maybe<Scalars['Boolean']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  /** parent IB */
  parentIbId: Maybe<Scalars['String']['output']>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseIntroducingBrokerAccount = {
  /** IB account approval status */
  approvalStatus: Maybe<Scalars['String']['output']>;
  /** Approved IB account */
  approved: Maybe<Scalars['Boolean']['output']>;
  /** Enable email notifications about follower actions */
  enablePartnerNotifications: Maybe<Scalars['Boolean']['output']>;
  /** IB ID */
  ibId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Ignore IB Transfers */
  ignoreIbTransfers: Maybe<Scalars['Boolean']['output']>;
  /** parent IB */
  parentIbId: Maybe<Scalars['String']['output']>;
};

/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccount = BaseAccount & BaseForexAccount & BaseIntroducingBrokerAccount & {
  __typename?: 'IntroducingBrokerBDSwissVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IB account approval status */
  approvalStatus: Maybe<Scalars['String']['output']>;
  /** Approved IB account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Enable email notifications about follower actions */
  enablePartnerNotifications: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** IB ID */
  ibId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Ignore IB Transfers */
  ignoreIbTransfers: Maybe<Scalars['Boolean']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  /** parent IB */
  parentIbId: Maybe<Scalars['String']['output']>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerBdSwissVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccount = BaseAccount & BaseForexAccount & BaseIntroducingBrokerAccount & {
  __typename?: 'IntroducingBrokerEquityFlowAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IB account approval status */
  approvalStatus: Maybe<Scalars['String']['output']>;
  /** Approved IB account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Enable email notifications about follower actions */
  enablePartnerNotifications: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** IB ID */
  ibId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Ignore IB Transfers */
  ignoreIbTransfers: Maybe<Scalars['Boolean']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  /** parent IB */
  parentIbId: Maybe<Scalars['String']['output']>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Equity Flow Account */
export type IntroducingBrokerEquityFlowAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccount = BaseAccount & BaseForexAccount & BaseIntroducingBrokerAccount & {
  __typename?: 'IntroducingBrokerMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IB account approval status */
  approvalStatus: Maybe<Scalars['String']['output']>;
  /** Approved IB account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Enable email notifications about follower actions */
  enablePartnerNotifications: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** IB ID */
  ibId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Ignore IB Transfers */
  ignoreIbTransfers: Maybe<Scalars['Boolean']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  /** parent IB */
  parentIbId: Maybe<Scalars['String']['output']>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccount = BaseAccount & BaseForexAccount & BaseIntroducingBrokerAccount & {
  __typename?: 'IntroducingBrokerSwissMarketsAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IB account approval status */
  approvalStatus: Maybe<Scalars['String']['output']>;
  /** Approved IB account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Enable email notifications about follower actions */
  enablePartnerNotifications: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** IB ID */
  ibId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Ignore IB Transfers */
  ignoreIbTransfers: Maybe<Scalars['Boolean']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  /** parent IB */
  parentIbId: Maybe<Scalars['String']['output']>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccount = BaseAccount & BaseForexAccount & BaseIntroducingBrokerAccount & {
  __typename?: 'IntroducingBrokerSwissMarketsMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IB account approval status */
  approvalStatus: Maybe<Scalars['String']['output']>;
  /** Approved IB account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Enable email notifications about follower actions */
  enablePartnerNotifications: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** IB ID */
  ibId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Ignore IB Transfers */
  ignoreIbTransfers: Maybe<Scalars['Boolean']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  /** parent IB */
  parentIbId: Maybe<Scalars['String']['output']>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccount = BaseAccount & BaseForexAccount & BaseIntroducingBrokerAccount & {
  __typename?: 'IntroducingBrokerSwissMarketsVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IB account approval status */
  approvalStatus: Maybe<Scalars['String']['output']>;
  /** Approved IB account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Enable email notifications about follower actions */
  enablePartnerNotifications: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** IB ID */
  ibId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Ignore IB Transfers */
  ignoreIbTransfers: Maybe<Scalars['Boolean']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  /** parent IB */
  parentIbId: Maybe<Scalars['String']['output']>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerSwissMarketsVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccount = BaseAccount & BaseForexAccount & BaseIntroducingBrokerAccount & {
  __typename?: 'IntroducingBrokerTauroMarketsAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IB account approval status */
  approvalStatus: Maybe<Scalars['String']['output']>;
  /** Approved IB account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Enable email notifications about follower actions */
  enablePartnerNotifications: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** IB ID */
  ibId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Ignore IB Transfers */
  ignoreIbTransfers: Maybe<Scalars['Boolean']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  /** parent IB */
  parentIbId: Maybe<Scalars['String']['output']>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccount = BaseAccount & BaseForexAccount & BaseIntroducingBrokerAccount & {
  __typename?: 'IntroducingBrokerTauroMarketsMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** IB account approval status */
  approvalStatus: Maybe<Scalars['String']['output']>;
  /** Approved IB account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Enable email notifications about follower actions */
  enablePartnerNotifications: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** IB ID */
  ibId: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Ignore IB Transfers */
  ignoreIbTransfers: Maybe<Scalars['Boolean']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  /** parent IB */
  parentIbId: Maybe<Scalars['String']['output']>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Introducing Broker Account */
export type IntroducingBrokerTauroMarketsMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** JOLLYcoin */
export type JollYcoin = BaseAccount & BaseCryptoCoinAccount & {
  __typename?: 'JOLLYcoin';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance in Fiat */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonus Balance in Fiat */
  bonusBalance: Maybe<Scalars['Float']['output']>;
  /** Bonus FX Balance in Fiat */
  bonusFXBalance: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Coins for this account */
  coins: Maybe<Scalars['Float']['output']>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Deposit Wallet Address To Credit Coins */
  depositWalletAddress: Maybe<Scalars['String']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Wallet Address To Credit Coins */
  walletAddress: Maybe<Scalars['String']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** JOLLYcoin */
export type JollYcoinBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** JOLLYcoin */
export type JollYcoinBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** JOLLYcoin */
export type JollYcoinCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** JOLLYcoin */
export type JollYcoinCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** JOLLYcoin */
export type JollYcoinCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** JOLLYcoin */
export type JollYcoinCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** JOLLYcoin */
export type JollYcoinDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** JOLLYcoin */
export type JollYcoinDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** JOLLYcoin */
export type JollYcoinSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** JOLLYcoin */
export type JollYcoinTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** JOLLYcoin */
export type JollYcoinTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** JOLLYcoin */
export type JollYcoinTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** JOLLYcoin */
export type JollYcoinTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** JOLLYcoin */
export type JollYcoinWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** JOLLYcoin */
export type JollYcoinWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** MAM Account */
export type MamAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'MAMAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** MAM Account */
export type MamAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** MAM Account */
export type MamAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** MAM Account */
export type MamAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** MAM Account */
export type MamAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** MAM Account */
export type MamAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account */
export type MamAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM Account */
export type MamAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account */
export type MamAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account */
export type MamAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM Account */
export type MamAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM Account */
export type MamAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM Account */
export type MamAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account */
export type MamAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account */
export type MamAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account */
export type MamAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM Account */
export type MamAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** MAM Account */
export type MamAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM Account */
export type MamAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** MAM Account [Mauritius] */
export type MamMauritiusAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'MAMMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM Account [Mauritius] */
export type MamMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'MAMSMMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM SM Account [Mauritius] */
export type MamsmMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'MAMSMVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM SM Account [Vanuatu] */
export type MamsmVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** MAM Account [Vanuatu] */
export type MamVanuatuAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'MAMVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** MAM Account [Vanuatu] */
export type MamVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM Account */
export type PammAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM Account */
export type PammAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Account */
export type PammAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Account */
export type PammAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Account */
export type PammAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Account */
export type PammAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account */
export type PammAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Account */
export type PammAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account */
export type PammAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account */
export type PammAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Account */
export type PammAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Account */
export type PammAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Account */
export type PammAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account */
export type PammAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account */
export type PammAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account */
export type PammAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Account */
export type PammAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM Account */
export type PammAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Account */
export type PammAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM Fund Manager Account */
export type PammFundManagerAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMFundManagerAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Fund Manager Account */
export type PammFundManagerAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMFundManagerMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Fund Manager Account [Mauritius] */
export type PammFundManagerMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMFundManagerVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Fund Manager Account [Vanuatu] */
export type PammFundManagerVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM Account [Mauritius] */
export type PammMauritiusAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Account [Mauritius] */
export type PammMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM SM Account */
export type PammsmAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMSMAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM SM Account */
export type PammsmAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Account */
export type PammsmAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Account */
export type PammsmAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Account */
export type PammsmAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Account */
export type PammsmAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account */
export type PammsmAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Account */
export type PammsmAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account */
export type PammsmAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account */
export type PammsmAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Account */
export type PammsmAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Account */
export type PammsmAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Account */
export type PammsmAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account */
export type PammsmAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account */
export type PammsmAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account */
export type PammsmAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Account */
export type PammsmAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM SM Account */
export type PammsmAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Account */
export type PammsmAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMSMFundManagerAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMSMFundManagerMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Fund Manager Account */
export type PammsmFundManagerMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMSMFundManagerVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Vanuatu Fund Manager Account */
export type PammsmFundManagerVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMSMMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Account [Mauritius] */
export type PammsmMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMSMVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM SM Account [Vanuatu] */
export type PammsmVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccount = BaseAccount & BasePammAccount & {
  __typename?: 'PAMMTauroMarketsAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Approved PAMM account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Approved PAMM investor account */
  isPammInvestorAccountApprovedByMoneyManager: Scalars['Boolean']['output'];
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  /** Money manager info */
  moneyManagerInfo: Maybe<MoneyManagerInfo>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending requests for the investment */
  pendingRequests: Maybe<Array<Maybe<PendingRequest>>>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Unconnected PAMM investor account */
  unconnected: Maybe<Scalars['Boolean']['output']>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarkets Investor Account */
export type PammTauroMarketsAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BasePammAccount = {
  /** Approved PAMM account */
  approved: Maybe<Scalars['Boolean']['output']>;
};

export type MoneyManagerInfo = {
  __typename?: 'MoneyManagerInfo';
  id: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type PendingRequest = {
  __typename?: 'PendingRequest';
  /** ID of the request */
  id: Maybe<Scalars['Int']['output']>;
  /** ID of the investment */
  investmentId: Maybe<Scalars['Int']['output']>;
};

/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccount = BaseAccount & BasePammAccount & {
  __typename?: 'PAMMTauroMarketsManagerAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Approved PAMM account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarkets Money Manager Account */
export type PammTauroMarketsManagerAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccount = BaseAccount & BasePammAccount & {
  __typename?: 'PAMMTauroMarketsMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Approved PAMM account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Approved PAMM investor account */
  isPammInvestorAccountApprovedByMoneyManager: Scalars['Boolean']['output'];
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  /** Money manager info */
  moneyManagerInfo: Maybe<MoneyManagerInfo>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending requests for the investment */
  pendingRequests: Maybe<Array<Maybe<PendingRequest>>>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Unconnected PAMM investor account */
  unconnected: Maybe<Scalars['Boolean']['output']>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMauritius Investor Account */
export type PammTauroMarketsMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccount = BaseAccount & BasePammAccount & {
  __typename?: 'PAMMTauroMarketsMauritiusManagerAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Approved PAMM account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMauritius Money Manager Account */
export type PammTauroMarketsMauritiusManagerAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5Account = BaseAccount & BasePammAccount & {
  __typename?: 'PAMMTauroMarketsMT5Account';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Approved PAMM account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Approved PAMM investor account */
  isPammInvestorAccountApprovedByMoneyManager: Scalars['Boolean']['output'];
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  /** Money manager info */
  moneyManagerInfo: Maybe<MoneyManagerInfo>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending requests for the investment */
  pendingRequests: Maybe<Array<Maybe<PendingRequest>>>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Unconnected PAMM investor account */
  unconnected: Maybe<Scalars['Boolean']['output']>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMT5 Investor Account */
export type PammTauroMarketsMt5AccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccount = BaseAccount & BasePammAccount & {
  __typename?: 'PAMMTauroMarketsMT5ManagerAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  /** Approved PAMM account */
  approved: Maybe<Scalars['Boolean']['output']>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM TauroMarketsMT5 Money Manager Account */
export type PammTauroMarketsMt5ManagerAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** PAMM Account [Vanuatu] */
export type PammVanuatuAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PAMMVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** PAMM Account [Vanuatu] */
export type PammVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Portfolio Management Account */
export type PortfolioManagementAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PortfolioManagementAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Portfolio Management Account */
export type PortfolioManagementAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccount = BaseAccount & BaseForexAccount & {
  __typename?: 'PortfolioManagementMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Account Subtype */
  accountSubtype: Maybe<AccountSubtype>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  allowedLeverages: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  bonus: Maybe<Bonus>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  /** Competition entries of this account */
  competitions: Maybe<Array<Maybe<MemberCompetition>>>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  /** Copy Trading Strategies */
  copyTradingStrategies: Maybe<Array<Maybe<CopyTradingStrategy>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Credit for this account - used for Bonus */
  credit: Maybe<Scalars['Float']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  eligibleBonus: Maybe<Scalars['Boolean']['output']>;
  /** Current Forex Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** External ID on the external product */
  forexId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  forexPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Count of positions of this account */
  forexPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Current Forex Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  hasAccessToBrokereeAdvancedSettings: Maybe<Scalars['Boolean']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  /** Positions of this account */
  hasOpenPositions: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Account Enabled Status */
  isEnabled: Maybe<Scalars['Boolean']['output']>;
  isManaged: Maybe<Scalars['Boolean']['output']>;
  isOnMailingList: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Account ReadOnly Status */
  isReadOnly: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  /** Leverage type */
  leverage: Maybe<Scalars['Int']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Forex Margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** Account margin info */
  marginInfo: Maybe<ForexMarginInfo>;
  /** Current Forex Margin Level */
  marginLevel: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  metaTraderApiUrl: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  /** Pending positions of this account */
  pendingPositions: Maybe<Array<Maybe<ForexPosition>>>;
  /** Pending positions of this account */
  pendingPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Performance Fee for Copy Trading */
  performanceFee: Maybe<Scalars['Float']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Closed Profit&Loss of this account */
  profitAndLossClosed: Maybe<Scalars['Float']['output']>;
  /** Floating Profit&Loss of this account */
  profitAndLossFloating: Maybe<Scalars['Float']['output']>;
  /** Providing Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  provideCopyTradingStartDate: Maybe<Scalars['DateTime']['output']>;
  /** Provider Start Date for Copy Trading */
  providerStartDate: Maybe<Scalars['String']['output']>;
  readOnlyDealer: Maybe<Scalars['Boolean']['output']>;
  readOnlyNote: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** The Server which the account is created on */
  server: Maybe<Mt4Servers>;
  /** Show Brokeree Copy Trading Stats */
  showBrokereeProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Show Copy Trading Stats */
  showProviderStats: Maybe<Scalars['Boolean']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Swap Free account */
  swapFree: Maybe<Scalars['Boolean']['output']>;
  symbolOverrides: Maybe<Array<Maybe<SymbolOverrides>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Closed volume of this account */
  volumeClosed: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Block withdrawals for copy trading account with performance fee */
  withdrawalsBlocked: Maybe<Scalars['Boolean']['output']>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountForexPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountForexPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountHasOpenPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Portfolio Management Mauritius Account */
export type PortfolioManagementMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccount = BaseAccount & BaseSmPrimeWalletAccount & {
  __typename?: 'SMPrimeWalletBDSwissAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Current Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** Current Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Margin */
  margin: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseSmPrimeWalletAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Current Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** Current Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Margin */
  margin: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseSmPrimeWalletAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseSmPrimeWalletAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseSmPrimeWalletAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseSmPrimeWalletAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseSmPrimeWalletAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseSmPrimeWalletAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseSmPrimeWalletAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseSmPrimeWalletAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseSmPrimeWalletAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseSmPrimeWalletAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseSmPrimeWalletAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseSmPrimeWalletAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseSmPrimeWalletAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseSmPrimeWalletAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseSmPrimeWalletAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccount = BaseAccount & BaseSmPrimeWalletAccount & {
  __typename?: 'SMPrimeWalletBDSwissMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Current Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** Current Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Margin */
  margin: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletBdSwissMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccount = BaseAccount & BaseSmPrimeWalletAccount & {
  __typename?: 'SMPrimeWalletMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Current Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** Current Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Margin */
  margin: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Mauritius] */
export type SmPrimeWalletMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccount = BaseAccount & BaseSmPrimeWalletAccount & {
  __typename?: 'SMPrimeWalletVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Account's current balance */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Current Equity */
  equity: Maybe<Scalars['Float']['output']>;
  /** Current Free Margin */
  freeMargin: Maybe<Scalars['Float']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  /** Current Margin */
  margin: Maybe<Scalars['Float']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** SM Prime Wallet [Vanuatu] */
export type SmPrimeWalletVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Binary Options Account */
export type SpotOptionAccount = BaseAccount & BaseOptionAccount & {
  __typename?: 'SpotOptionAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Activated Balance of this account */
  activatedBalance: Maybe<Scalars['Float']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance of this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Profit&Loss of this account */
  profitAndLoss: Maybe<Scalars['Float']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** SpotOption ID */
  spotOptionId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  spotOptionPositions: Maybe<Array<Maybe<SpotOptionPosition>>>;
  /** Count of spot options positions of this account */
  spotOptionPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Closed turnover of this account */
  turnoverClosed: Maybe<Scalars['Float']['output']>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Binary Options Account */
export type SpotOptionAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Account */
export type SpotOptionAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Account */
export type SpotOptionAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Account */
export type SpotOptionAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Account */
export type SpotOptionAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account */
export type SpotOptionAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Account */
export type SpotOptionAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account */
export type SpotOptionAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account */
export type SpotOptionAccountSpotOptionPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Account */
export type SpotOptionAccountSpotOptionPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Account */
export type SpotOptionAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account */
export type SpotOptionAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account */
export type SpotOptionAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account */
export type SpotOptionAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Account */
export type SpotOptionAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Binary Options Account */
export type SpotOptionAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Account */
export type SpotOptionAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseOptionAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Activated Balance of this account */
  activatedBalance: Maybe<Scalars['Float']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance of this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Profit&Loss of this account */
  profitAndLoss: Maybe<Scalars['Float']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** SpotOption ID */
  spotOptionId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  spotOptionPositions: Maybe<Array<Maybe<SpotOptionPosition>>>;
  /** Count of spot options positions of this account */
  spotOptionPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Closed turnover of this account */
  turnoverClosed: Maybe<Scalars['Float']['output']>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseOptionAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseOptionAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseOptionAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseOptionAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseOptionAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseOptionAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseOptionAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseOptionAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseOptionAccountSpotOptionPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseOptionAccountSpotOptionPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseOptionAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseOptionAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseOptionAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseOptionAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseOptionAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseOptionAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseOptionAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Parameters of SpotOption Position */
export type SpotOptionPosition = {
  __typename?: 'SpotOptionPosition';
  /** Trading amount */
  amount: Maybe<Scalars['Int']['output']>;
  /** Close rate */
  closeRate: Maybe<Scalars['Float']['output']>;
  /** Close time */
  closeTime: Maybe<Scalars['DateTime']['output']>;
  /** Currency */
  currency: Maybe<Scalars['String']['output']>;
  /** Format */
  format: Maybe<Scalars['String']['output']>;
  /** Trading ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Trading symbol */
  name: Maybe<Scalars['String']['output']>;
  /** Open rate */
  openRate: Maybe<Scalars['Float']['output']>;
  /** Open time */
  openTime: Maybe<Scalars['DateTime']['output']>;
  /** Payout */
  payout: Maybe<Scalars['Float']['output']>;
  /** Trading position */
  position: Maybe<Scalars['String']['output']>;
  /** Status */
  status: Maybe<Scalars['String']['output']>;
};

/** Binary Options Demo Account */
export type SpotOptionDemoAccount = BaseAccount & BaseOptionAccount & {
  __typename?: 'SpotOptionDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Activated Balance of this account */
  activatedBalance: Maybe<Scalars['Float']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance of this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Profit&Loss of this account */
  profitAndLoss: Maybe<Scalars['Float']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** SpotOption ID */
  spotOptionId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  spotOptionPositions: Maybe<Array<Maybe<SpotOptionPosition>>>;
  /** Count of spot options positions of this account */
  spotOptionPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Closed turnover of this account */
  turnoverClosed: Maybe<Scalars['Float']['output']>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountSpotOptionPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountSpotOptionPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Demo Account */
export type SpotOptionDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccount = BaseAccount & BaseOptionAccount & {
  __typename?: 'SpotOptionMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Activated Balance of this account */
  activatedBalance: Maybe<Scalars['Float']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance of this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Profit&Loss of this account */
  profitAndLoss: Maybe<Scalars['Float']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** SpotOption ID */
  spotOptionId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  spotOptionPositions: Maybe<Array<Maybe<SpotOptionPosition>>>;
  /** Count of spot options positions of this account */
  spotOptionPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Closed turnover of this account */
  turnoverClosed: Maybe<Scalars['Float']['output']>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountSpotOptionPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountSpotOptionPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Account [Mauritius] */
export type SpotOptionMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccount = BaseAccount & BaseOptionAccount & {
  __typename?: 'SpotOptionMauritiusDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Activated Balance of this account */
  activatedBalance: Maybe<Scalars['Float']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance of this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Profit&Loss of this account */
  profitAndLoss: Maybe<Scalars['Float']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** SpotOption ID */
  spotOptionId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  spotOptionPositions: Maybe<Array<Maybe<SpotOptionPosition>>>;
  /** Count of spot options positions of this account */
  spotOptionPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Closed turnover of this account */
  turnoverClosed: Maybe<Scalars['Float']['output']>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountSpotOptionPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountSpotOptionPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Demo Account [Mauritius] */
export type SpotOptionMauritiusDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccount = BaseAccount & BaseOptionAccount & {
  __typename?: 'SpotOptionVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Activated Balance of this account */
  activatedBalance: Maybe<Scalars['Float']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance of this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Profit&Loss of this account */
  profitAndLoss: Maybe<Scalars['Float']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** SpotOption ID */
  spotOptionId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  spotOptionPositions: Maybe<Array<Maybe<SpotOptionPosition>>>;
  /** Count of spot options positions of this account */
  spotOptionPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Closed turnover of this account */
  turnoverClosed: Maybe<Scalars['Float']['output']>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountSpotOptionPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountSpotOptionPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Account [Vanuatu] */
export type SpotOptionVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccount = BaseAccount & BaseOptionAccount & {
  __typename?: 'SpotOptionVanuatuDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Activated Balance of this account */
  activatedBalance: Maybe<Scalars['Float']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance of this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  /** Profit&Loss of this account */
  profitAndLoss: Maybe<Scalars['Float']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** SpotOption ID */
  spotOptionId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  spotOptionPositions: Maybe<Array<Maybe<SpotOptionPosition>>>;
  /** Count of spot options positions of this account */
  spotOptionPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  /** Closed turnover of this account */
  turnoverClosed: Maybe<Scalars['Float']['output']>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountSpotOptionPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountSpotOptionPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Binary Options Demo Account [Vanuatu] */
export type SpotOptionVanuatuDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Tradesmarter Account */
export type TradesmarterAccount = BaseAccount & BaseTradesmarterAccount & {
  __typename?: 'TradesmarterAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** total active bonus for this account */
  totalActiveBonus: Maybe<Scalars['Float']['output']>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Tradesmarter ID on the external product */
  tradesmarterId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  tradesmarterPositions: Maybe<Array<Maybe<TradesmarterPosition>>>;
  /** Positions of this account */
  tradesmarterPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Tradesmarter Account */
export type TradesmarterAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Account */
export type TradesmarterAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Account */
export type TradesmarterAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Account */
export type TradesmarterAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Account */
export type TradesmarterAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account */
export type TradesmarterAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Account */
export type TradesmarterAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account */
export type TradesmarterAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account */
export type TradesmarterAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account */
export type TradesmarterAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account */
export type TradesmarterAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account */
export type TradesmarterAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Account */
export type TradesmarterAccountTradesmarterPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Account */
export type TradesmarterAccountTradesmarterPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Account */
export type TradesmarterAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Tradesmarter Account */
export type TradesmarterAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Account */
export type TradesmarterAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type BaseTradesmarterAccount = {
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** total active bonus for this account */
  totalActiveBonus: Maybe<Scalars['Float']['output']>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Tradesmarter ID on the external product */
  tradesmarterId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  tradesmarterPositions: Maybe<Array<Maybe<TradesmarterPosition>>>;
  /** Positions of this account */
  tradesmarterPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


export type BaseTradesmarterAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseTradesmarterAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


export type BaseTradesmarterAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseTradesmarterAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


export type BaseTradesmarterAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseTradesmarterAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseTradesmarterAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseTradesmarterAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseTradesmarterAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseTradesmarterAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseTradesmarterAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


export type BaseTradesmarterAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseTradesmarterAccountTradesmarterPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseTradesmarterAccountTradesmarterPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


export type BaseTradesmarterAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


export type BaseTradesmarterAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


export type BaseTradesmarterAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Parameters of Tradesmarter Position */
export type TradesmarterPosition = {
  __typename?: 'TradesmarterPosition';
  /** Bonus PnL */
  bonusPnl: Maybe<Scalars['Float']['output']>;
  /** Currency */
  currency: Maybe<Scalars['String']['output']>;
  /** Date */
  date: Maybe<Scalars['String']['output']>;
  /** Direction */
  direction: Maybe<Scalars['Int']['output']>;
  /** Expiry */
  expiry: Maybe<Scalars['String']['output']>;
  /** Expirty Price */
  expiryPrice: Maybe<Scalars['Float']['output']>;
  /** Instrument */
  instrument: Maybe<Scalars['String']['output']>;
  /** Payout */
  payout: Maybe<Scalars['Float']['output']>;
  /** PnL */
  pnl: Maybe<Scalars['Float']['output']>;
  /** Reference Price */
  referencePrice: Maybe<Scalars['Float']['output']>;
  /** Result§ */
  result: Maybe<Scalars['Int']['output']>;
  /** Status */
  status: Maybe<Scalars['String']['output']>;
  /** TradeId */
  tradeId: Maybe<Scalars['String']['output']>;
  /** Type */
  type: Maybe<Scalars['String']['output']>;
  /** Volume */
  volume: Maybe<Scalars['Float']['output']>;
};

/** Tradesmarter Demo Account */
export type TradesmarterDemoAccount = BaseAccount & BaseTradesmarterAccount & {
  __typename?: 'TradesmarterDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** total active bonus for this account */
  totalActiveBonus: Maybe<Scalars['Float']['output']>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Tradesmarter ID on the external product */
  tradesmarterId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  tradesmarterPositions: Maybe<Array<Maybe<TradesmarterPosition>>>;
  /** Positions of this account */
  tradesmarterPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountTradesmarterPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountTradesmarterPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Demo Account */
export type TradesmarterDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccount = BaseAccount & BaseTradesmarterAccount & {
  __typename?: 'TradesmarterMauritiusAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** total active bonus for this account */
  totalActiveBonus: Maybe<Scalars['Float']['output']>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Tradesmarter ID on the external product */
  tradesmarterId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  tradesmarterPositions: Maybe<Array<Maybe<TradesmarterPosition>>>;
  /** Positions of this account */
  tradesmarterPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountTradesmarterPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountTradesmarterPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Account [Mauritius] */
export type TradesmarterMauritiusAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccount = BaseAccount & BaseTradesmarterAccount & {
  __typename?: 'TradesmarterMauritiusDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** total active bonus for this account */
  totalActiveBonus: Maybe<Scalars['Float']['output']>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Tradesmarter ID on the external product */
  tradesmarterId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  tradesmarterPositions: Maybe<Array<Maybe<TradesmarterPosition>>>;
  /** Positions of this account */
  tradesmarterPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountTradesmarterPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountTradesmarterPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Demo Account [Mauritius] */
export type TradesmarterMauritiusDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccount = BaseAccount & BaseTradesmarterAccount & {
  __typename?: 'TradesmarterVanuatuAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** total active bonus for this account */
  totalActiveBonus: Maybe<Scalars['Float']['output']>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Tradesmarter ID on the external product */
  tradesmarterId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  tradesmarterPositions: Maybe<Array<Maybe<TradesmarterPosition>>>;
  /** Positions of this account */
  tradesmarterPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountTradesmarterPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountTradesmarterPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Account [Vanuatu] */
export type TradesmarterVanuatuAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccount = BaseAccount & BaseTradesmarterAccount & {
  __typename?: 'TradesmarterVanuatuDemoAccount';
  /** Changed Name of Account */
  accountName: Maybe<Scalars['String']['output']>;
  /** Active Brokeree Copy Trading offer details for this account */
  activeBrokereeCopyTradingOffer: Maybe<ActiveBrokereeCopyTradingOffer>;
  availableWithdrawalOptions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Balance for this account */
  balance: Maybe<Scalars['Float']['output']>;
  /** Account's current balance [EUR] */
  balanceEur: Maybe<Scalars['Float']['output']>;
  /** Bonuses offered on this account */
  bonusOffers: Maybe<Array<Maybe<BonusOffer>>>;
  /** Count of bonuses offered on this account */
  bonusOffersCount: Maybe<Scalars['Int']['output']>;
  bookType: Maybe<BookType>;
  /** Shows master providers info of BrokereeCT agent */
  brokereeMasterProvidersOfAgent: Maybe<Array<Maybe<BrokereeMasterProviderOfAgent>>>;
  /** Account owner */
  client: Maybe<Client>;
  connectedBrokereeProviderAccount: Maybe<ConnectedBrokereeProviderAccount>;
  /** Copy Trading details for this account */
  copyTrading: Maybe<CopyTrading>;
  /** Cancelled Copy Trading Requests details for this account */
  copyTradingCancelledRequests: Maybe<Array<Maybe<CopyTrading>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Currency in which account is lead */
  currency: Maybe<Currency>;
  /** Deposits made to this account in curent month */
  currentMonthDeposits: Maybe<Scalars['Float']['output']>;
  /** Withdrawals made to this account in curent month */
  currentMonthWithdrawals: Maybe<Scalars['Float']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Deposits made to this account */
  deposits: Maybe<Array<Maybe<Deposit>>>;
  /** Count of deposits made to this account */
  depositsCount: Maybe<Scalars['Int']['output']>;
  /** Flag to check if account has any held deposits */
  hasHeldDeposits: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** Account ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Shows if the account configured as BrokereeCT agent */
  isBrokereeCopyTradingAgent: Maybe<Scalars['Boolean']['output']>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  /** Shows the provider state */
  isProvidingBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  /** Shows the offer subscription state */
  isSubscribedToBrokereeOffer: Maybe<Scalars['Boolean']['output']>;
  isViewOnly: Maybe<Scalars['Boolean']['output']>;
  /** Localized account label */
  label: Maybe<Scalars['String']['output']>;
  latestPerformanceFeeDate: Maybe<Scalars['DateTime']['output']>;
  login: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  /** Minimum Deposit of this account */
  minimumDeposit: Maybe<Scalars['Float']['output']>;
  mobile: Maybe<Scalars['Boolean']['output']>;
  outstandingActivationDeposit: Maybe<Scalars['Float']['output']>;
  pammAgentOffers: Maybe<Array<Maybe<PammOfferType>>>;
  pammOffers: Maybe<Array<Maybe<PammOfferType>>>;
  passwordProtectedStrategies: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  /** Subscription deposits made to this account */
  subscriptionDeposits: Maybe<Array<Maybe<Subscription>>>;
  /** total active bonus for this account */
  totalActiveBonus: Maybe<Scalars['Float']['output']>;
  /** Total bonuses made to this account */
  totalBonuses: Maybe<Scalars['Float']['output']>;
  /** Total deposits made to this account */
  totalDeposits: Maybe<Scalars['Float']['output']>;
  /** Total withdrawals made to this account */
  totalWithdrawals: Maybe<Scalars['Float']['output']>;
  /** Tradesmarter ID on the external product */
  tradesmarterId: Maybe<Scalars['Int']['output']>;
  /** Positions of this account */
  tradesmarterPositions: Maybe<Array<Maybe<TradesmarterPosition>>>;
  /** Positions of this account */
  tradesmarterPositionsCount: Maybe<Scalars['Float']['output']>;
  /** Trading server for related trading PAMM MM account */
  tradingAccountCategory: Maybe<Scalars['String']['output']>;
  /** All transactions made from / to this account */
  transactions: Maybe<Array<Maybe<Transaction>>>;
  unresolvedDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Withdrawable balance for this account */
  withdrawableBalance: Maybe<Scalars['Float']['output']>;
  withdrawablePaymentMethods: Maybe<Array<Maybe<WithdrawablePaymentMethod>>>;
  /** Withdrawal requests made from this account */
  withdrawals: Maybe<Array<Maybe<Withdrawal>>>;
  /** Count of withdrawal requests made from this account */
  withdrawalsCount: Maybe<Scalars['Int']['output']>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountBonusOffersArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountBonusOffersCountArgs = {
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Array<InputMaybe<BonusOfferStatus>>>;
  type: InputMaybe<BonusOfferType>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountCopyTradingArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountCopyTradingCancelledRequestsArgs = {
  accountCopying: InputMaybe<Scalars['Int']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  orphanedCopytradingFollowers: InputMaybe<Scalars['Boolean']['input']>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountCurrentMonthDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountCurrentMonthWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountDepositsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountSubscriptionDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountTotalBonusesArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountTotalDepositsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  conversionStatus: InputMaybe<ConversionStatus>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  currencies: InputMaybe<Array<InputMaybe<Currency>>>;
  includeSubscriptions: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<DepositStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  vendors: InputMaybe<Array<InputMaybe<Scalars['DepositVendorOrString']['input']>>>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountTotalWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountTradesmarterPositionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountTradesmarterPositionsCountArgs = {
  positionsCloseDateFromFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsCloseDateToFilter: InputMaybe<Scalars['DateTime']['input']>;
  positionsSearchFilter: InputMaybe<Scalars['String']['input']>;
  tradingPositionStatus: InputMaybe<TradingPositionStatus>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountTransactionsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  type: InputMaybe<TransactionType>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountWithdrawalsArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};


/** Tradesmarter Demo Account [Vanuatu] */
export type TradesmarterVanuatuDemoAccountWithdrawalsCountArgs = {
  accountTypeSubtype: InputMaybe<AccountTypeSubTypeFilter>;
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  clientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  company: InputMaybe<Company>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  depositVendor: InputMaybe<Scalars['DepositVendorOrString']['input']>;
  estimated: InputMaybe<Scalars['Boolean']['input']>;
  hasPendingFundingDocuments: InputMaybe<Scalars['Boolean']['input']>;
  salesAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<WithdrawalStatus>;
  statuses: InputMaybe<Array<InputMaybe<WithdrawalStatus>>>;
  supportAgentId: InputMaybe<Scalars['ClaimedStatusOrIntOrSalesAgentType']['input']>;
  topVip: InputMaybe<Scalars['Boolean']['input']>;
  types: InputMaybe<Array<InputMaybe<WithdrawalType>>>;
  vendors: InputMaybe<Array<InputMaybe<WithdrawalPaymentVendorsType>>>;
};

export type AddressProposal = {
  __typename?: 'AddressProposal';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  line1: Maybe<Scalars['String']['output']>;
  region: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export enum AgentCommissionsOrderByType {
  CallDuration = 'callDuration',
  CallEffective = 'callEffective',
  CallStarted = 'callStarted',
  Client = 'client',
  Company = 'company',
  FtdAmount = 'ftdAmount',
  FtdBonus = 'ftdBonus',
  FtdDate = 'ftdDate',
  FtdId = 'ftdId',
  FtdQualified = 'ftdQualified'
}

/** Sales Agent commissions after “effective calls” */
export type AgentCommissions = {
  __typename?: 'AgentCommissions';
  /** Client */
  info: Maybe<AgentCommissionsInfo>;
  /** Client */
  rows: Maybe<Array<Maybe<AgentCommissionsRow>>>;
};

/** Pagination information for agent commissions */
export type AgentCommissionsInfo = {
  __typename?: 'AgentCommissionsInfo';
  agentName: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['Int']['output']>;
};

/** Sales Agent commissions after “effective calls” */
export type AgentCommissionsRow = {
  __typename?: 'AgentCommissionsRow';
  /** Call duration */
  callDuration: Maybe<Scalars['Int']['output']>;
  /** Effective Call */
  callEffective: Maybe<Scalars['Boolean']['output']>;
  /** Call started */
  callStarted: Maybe<Scalars['String']['output']>;
  /** Client */
  client: Maybe<Scalars['String']['output']>;
  /** Client Company */
  clientCompany: Maybe<Scalars['String']['output']>;
  /** Client Id */
  clientId: Maybe<Scalars['Int']['output']>;
  /** FTD Amount */
  ftdAmount: Maybe<Scalars['Int']['output']>;
  /** FTD Bonus */
  ftdBonus: Maybe<Scalars['Float']['output']>;
  /** FTD Date */
  ftdDate: Maybe<Scalars['String']['output']>;
  /** FTD Id */
  ftdId: Maybe<Scalars['Int']['output']>;
  /** FTD Qualified */
  ftdQualified: Maybe<Scalars['Boolean']['output']>;
};

export enum AgentsCommissionsOrderByType {
  AgentId = 'agentId',
  AgentName = 'agentName',
  ClientsCount = 'clientsCount',
  CommissionSize = 'commissionSize',
  FtdAmount = 'ftdAmount',
  FtdBonus = 'ftdBonus',
  QualifiedFtDs = 'qualifiedFTDs',
  UnqualifiedFtDs = 'unqualifiedFTDs'
}

/** Sales Agents commission after “effective calls” */
export type AgentsCommissions = {
  __typename?: 'AgentsCommissions';
  info: Maybe<AgentsCommissionsInfo>;
  rows: Maybe<Array<Maybe<AgentsCommissionsRow>>>;
};

/** Pagination information for agent commissions */
export type AgentsCommissionsInfo = {
  __typename?: 'AgentsCommissionsInfo';
  size: Maybe<Scalars['Int']['output']>;
};

/** Sales Agents commission after “effective calls” */
export type AgentsCommissionsRow = {
  __typename?: 'AgentsCommissionsRow';
  /** Agent ID */
  agentId: Maybe<Scalars['Int']['output']>;
  /** Agent Name */
  agentName: Maybe<Scalars['String']['output']>;
  /** Number Of Clients */
  clientsCount: Maybe<Scalars['Int']['output']>;
  /** Commission Size */
  commissionSize: Maybe<Scalars['Float']['output']>;
  /** FTD Amount */
  ftdAmount: Maybe<Scalars['Float']['output']>;
  /** FTD Bonus */
  ftdBonus: Maybe<Scalars['Float']['output']>;
  /** Qualified FTDs */
  qualifiedFTDs: Maybe<Scalars['Int']['output']>;
  /** Unqualified FTDs */
  unqualifiedFTDs: Maybe<Scalars['Int']['output']>;
};

/** Appointments by Day */
export type AppointmentsByDay = {
  __typename?: 'AppointmentsByDay';
  /** Appointment count on day */
  count: Maybe<Scalars['Int']['output']>;
  /** Date, no time */
  day: Maybe<Scalars['DateTime']['output']>;
  /** Dismissed appointment count on day */
  dismissed: Maybe<Scalars['Int']['output']>;
  /** Incomplete appointment count on day */
  new: Maybe<Scalars['Int']['output']>;
};

/** General announcement accessed by all users */
export type Article = {
  __typename?: 'Article';
  /** Article content */
  body: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Article ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Article title */
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** User who created this article */
  user: Maybe<User>;
};

/** Assets from MT4 */
export type Assets = {
  __typename?: 'Assets';
  /** Base */
  base: Maybe<Scalars['String']['output']>;
  /** Currency */
  currency: Maybe<Scalars['String']['output']>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Digits */
  digits: Maybe<Scalars['Int']['output']>;
  /** Point Size */
  pointSize: Maybe<Scalars['Float']['output']>;
  /** Profit Mode */
  profitMode: Maybe<Scalars['String']['output']>;
  /** Quote */
  quote: Maybe<Scalars['String']['output']>;
  /** Security */
  security: Maybe<Scalars['String']['output']>;
  /** Security Index */
  securityIndex: Maybe<Scalars['Int']['output']>;
  /** Sessions */
  sessions: Maybe<Scalars['String']['output']>;
  /** Stops Level */
  stopsLevel: Maybe<Scalars['Int']['output']>;
  /** Symbol */
  symbol: Maybe<Scalars['String']['output']>;
  /** Tick Price */
  tickPrice: Maybe<Scalars['Float']['output']>;
  /** Tick Size */
  tickSize: Maybe<Scalars['Float']['output']>;
  /** Trade Permission */
  tradePermission: Maybe<Scalars['String']['output']>;
};

/** Blacklists for IP, email, phone */
export type Blacklist = {
  __typename?: 'Blacklist';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  /** Blacklist type */
  type: Maybe<BlacklistTypeType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** List of blacklist types */
export enum BlacklistTypeType {
  Country = 'country',
  Email = 'email',
  IpAddress = 'ipAddress',
  Phone = 'phone'
}

/** Book Allocation for clients */
export type BookAllocation = {
  __typename?: 'BookAllocation';
  bookCategory: Maybe<Scalars['String']['output']>;
  /** Book allocation campaigns */
  campaigns: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Countries for ibs */
  countries: Maybe<Array<Maybe<Country>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** ibs of clients */
  ibs: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id: Maybe<Scalars['ID']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Possible types of blacklist objects */
export enum BlacklistTypeEnum {
  Country = 'country',
  Email = 'email',
  IpAddress = 'ipAddress',
  Phone = 'phone'
}

export enum BalanceCurrencyFilter {
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export enum BookTypeFilterType {
  ABook = 'a_book',
  BBook = 'b_book'
}

export enum CopyTradingFilterType {
  AllCopiers = 'allCopiers',
  AllProviders = 'allProviders',
  CopiersPerformanceFee = 'copiersPerformanceFee',
  CopiersRebate = 'copiersRebate',
  ProvidersPerformanceFee = 'providersPerformanceFee',
  ProvidersRebate = 'providersRebate'
}

export enum JobTitleFilterType {
  Accountancy = 'accountancy',
  AdminSecretarial = 'adminSecretarial',
  Agriculture = 'agriculture',
  AirlineServices = 'airlineServices',
  ArmedForces = 'armedForces',
  ArmsArmamentsAmmunition = 'armsArmamentsAmmunition',
  Automotive = 'automotive',
  BarberHairdresser = 'barberHairdresser',
  BrokeringServices = 'brokeringServices',
  BusinessActivitiesLikelyToCauseEnvironmentalDamage = 'businessActivitiesLikelyToCauseEnvironmentalDamage',
  BusinessInvolvingPepMilitaryFigures = 'businessInvolvingPepMilitaryFigures',
  CallCentre = 'callCentre',
  CarDealerVehicleSellers = 'carDealerVehicleSellers',
  CashIncentiveBusiness = 'cashIncentiveBusiness',
  CasinoGamblingOperatorBusinessRelatedToGambling = 'casinoGamblingOperatorBusinessRelatedToGambling',
  Catering = 'catering',
  CateringHospitality = 'cateringHospitality',
  CharityVoluntaryWorkNgo = 'charityVoluntaryWorkNGO',
  CivilServant = 'civilServant',
  CompanyFormationServices = 'companyFormationServices',
  Compliance = 'compliance',
  CreativeMedia = 'creativeMedia',
  Education = 'education',
  EducationTraining = 'educationTraining',
  EmergencyServices = 'emergencyServices',
  EnergyMiningAgriculture = 'energyMiningAgriculture',
  Engineering = 'engineering',
  EngineeringAutomotiveManufacturing = 'engineeringAutomotiveManufacturing',
  Entertainment = 'entertainment',
  FactoryWorker = 'factoryWorker',
  FastFoodOutlet = 'fastFoodOutlet',
  FinancialServices = 'financialServices',
  FintechDigitalCurrencyBrokeringTrading = 'fintechDigitalCurrencyBrokeringTrading',
  FoodAndBeverage = 'foodAndBeverage',
  Gatekeepers = 'gatekeepers',
  Government = 'government',
  HealthcareSocialServices = 'healthcareSocialServices',
  HealthMedicine = 'healthMedicine',
  HighValueGoodsDealers = 'highValueGoodsDealers',
  HospitalityLeisureTourismBusinesses = 'hospitalityLeisureTourismBusinesses',
  HumanResources = 'humanResources',
  InformationTechnologies = 'informationTechnologies',
  InformationTechnologySector = 'informationTechnologySector',
  Insurance = 'insurance',
  InsuranceAccounting = 'insuranceAccounting',
  InsuranceAndRealEstate = 'insuranceAndRealEstate',
  InvestmentAdvisoryAssetManagementServices = 'investmentAdvisoryAssetManagementServices',
  InvestmentAndCommodityAdvisers = 'investmentAndCommodityAdvisers',
  Legal = 'legal',
  LeisureEntertainmentTourism = 'leisureEntertainmentTourism',
  LiveAnimalTesting = 'liveAnimalTesting',
  LocalCouncil = 'localCouncil',
  Manufacturing = 'manufacturing',
  MarketingPrAdvertising = 'marketingPrAdvertising',
  MediaMarketingAdvertisingPr = 'mediaMarketingAdvertisingPR',
  MilitaryEmergencyServicesSecurity = 'militaryEmergencyServicesSecurity',
  MineralOrOilExtractionAndMining = 'mineralOrOilExtractionAndMining',
  MoneyServiceBusinessMoneyRemittersAndMoneyExchangeHouses = 'moneyServiceBusinessMoneyRemittersAndMoneyExchangeHouses',
  NewOrInnovativeTypeOfBusiness = 'newOrInnovativeTypeOfBusiness',
  NonLicensedFinancialServicesBusiness = 'nonLicensedFinancialServicesBusiness',
  Other = 'other',
  OtherIndustry = 'otherIndustry',
  Pharmaceuticals = 'pharmaceuticals',
  PharmaceuticalsScience = 'pharmaceuticalsScience',
  Politics = 'politics',
  PreciousMetalsAndStonesJewellery = 'preciousMetalsAndStonesJewellery',
  PropertyConstructionRealEstateServices = 'propertyConstructionRealEstateServices',
  PropertyConstructionsTrades = 'propertyConstructionsTrades',
  PublicProcurement = 'publicProcurement',
  PubsNightClubsRestaurants = 'pubsNightClubsRestaurants',
  RecruitmentHr = 'recruitmentHr',
  RelegiousOrganizations = 'relegiousOrganizations',
  Retail = 'retail',
  RetailCommerce = 'retailCommerce',
  Sales = 'sales',
  Secretarial = 'secretarial',
  ShopManagerAssistant = 'shopManagerAssistant',
  SocialCareServices = 'socialCareServices',
  Sports = 'sports',
  SportTrainingSportManagement = 'sportTrainingSportManagement',
  SupraNationalOrganisations = 'supraNationalOrganisations',
  TaxiServices = 'taxiServices',
  Telecommunications = 'telecommunications',
  TransportationLogistics = 'transportationLogistics',
  TransportLogistics = 'transportLogistics',
  TravelAgencies = 'travelAgencies',
  TravellersChequesProviders = 'travellersChequesProviders',
  TrustServiceProviders = 'trustServiceProviders',
  UnlicensedMobilePhones = 'unlicensedMobilePhones',
  UtilityServices = 'utilityServices',
  VirtualAssetsCryptocurrencies = 'virtualAssetsCryptocurrencies'
}

export enum NetWorthFilterType {
  Between_0kAnd_50k = 'between_0k_and_50k',
  Between100kAnd300k = 'between100kAnd300k',
  Between50kAnd100k = 'between50kAnd100k',
  LessThan50k = 'lessThan50k',
  MoreThan300k = 'moreThan300k'
}

/** Which field to order the query results by */
export enum ClientsOrderBy {
  AggregatedBalanceEur = 'aggregatedBalanceEur',
  Amount = 'amount',
  CreatedAt = 'createdAt',
  DepositedAmount = 'depositedAmount',
  FtdDate = 'ftdDate',
  Id = 'id',
  LastEffectiveCall = 'lastEffectiveCall',
  LastLogin = 'lastLogin',
  LastNote = 'lastNote',
  NextAppointment = 'nextAppointment',
  Registration = 'registration',
  Threshold = 'threshold'
}

export enum Mt4ServerType {
  Demo = 'demo',
  Real = 'real'
}

/** MT4 Trade */
export type Trade = {
  __typename?: 'trade';
  /** Close Price */
  closePrice: Maybe<Scalars['Float']['output']>;
  /** Close Time */
  closeTime: Maybe<Scalars['DateTime']['output']>;
  /** Comment */
  comment: Maybe<Scalars['String']['output']>;
  /** Commission */
  commission: Maybe<Scalars['Float']['output']>;
  /** Conv Rate1 */
  convRate1: Maybe<Scalars['Float']['output']>;
  /** Conv Rate2 */
  convRate2: Maybe<Scalars['Float']['output']>;
  /** Digits */
  digits: Maybe<Scalars['Int']['output']>;
  /** Expiration */
  expiration: Maybe<Scalars['DateTime']['output']>;
  /** Trading ticket */
  id: Maybe<Scalars['ID']['output']>;
  /** Invested amount */
  investment: Maybe<Scalars['Float']['output']>;
  /** Trade leverage */
  leverage: Maybe<Scalars['Int']['output']>;
  /** Margin Rate */
  marginRate: Maybe<Scalars['Float']['output']>;
  /** Open Price */
  openPrice: Maybe<Scalars['Float']['output']>;
  /** Open Time */
  openTime: Maybe<Scalars['DateTime']['output']>;
  /** Profit */
  profit: Maybe<Scalars['Float']['output']>;
  /** Stop Loss */
  stopLoss: Maybe<Scalars['Float']['output']>;
  /** Swap */
  swaps: Maybe<Scalars['Float']['output']>;
  /** Symbol */
  symbol: Maybe<Scalars['String']['output']>;
  /** Take Profit */
  takeProfit: Maybe<Scalars['Float']['output']>;
  /** Taxes */
  taxes: Maybe<Scalars['Float']['output']>;
  /** type */
  type: Maybe<Scalars['String']['output']>;
  /** Volume */
  volume: Maybe<Scalars['Float']['output']>;
};

/** Leaderboard for competitions */
export type CompetitionsLeaderboard = {
  __typename?: 'CompetitionsLeaderboard';
  /** Selected client account */
  account: Maybe<Account>;
  balance: Maybe<Scalars['Float']['output']>;
  /** Client ID */
  client: Maybe<Client>;
  clientId: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  formulaValue: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  login: Maybe<Scalars['Int']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  rank: Maybe<Scalars['Int']['output']>;
  roi: Maybe<Scalars['Float']['output']>;
  tradesCount: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** App Config */
export type AppConfig = {
  __typename?: 'AppConfig';
  /** AppropTest. Training Period */
  failedAppropTestTrainingPeriod: Maybe<Scalars['Int']['output']>;
  /** Maximum equity default amount */
  maximumAccountEquity: Maybe<Scalars['String']['output']>;
  /** Minimum deposit default amount */
  minimumDepositDefault: Maybe<Scalars['String']['output']>;
  /** Server Weights */
  serversWeights: Maybe<Scalars['String']['output']>;
  /** Text to Speech verification option */
  textToSpeechVerificationEnabled: Maybe<Scalars['Boolean']['output']>;
  /** VPS Dunning Management days */
  vpsDunningManagementDays: Maybe<Scalars['Int']['output']>;
  /** Whitelabels Server Weights */
  whitelabelServersWeights: Maybe<Scalars['String']['output']>;
};

/** Country Payment Option Type */
export type CountryPaymentOptionType = {
  __typename?: 'CountryPaymentOptionType';
  company: Maybe<Scalars['String']['output']>;
  country: Maybe<PaymentOptionCountry>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Country Payment Option Enabled */
  enabled: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  lastUpdatedBy: Maybe<User>;
  /** Payment Option */
  paymentOption: Maybe<PaymentOptionType>;
  /** Country Payment Option Rank */
  rank: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum PaymentOptionCountry {
  Default = '_default',
  DefaultNonEu = '_defaultNonEU',
  Ad = 'ad',
  Ae = 'ae',
  Af = 'af',
  Ag = 'ag',
  Ai = 'ai',
  Al = 'al',
  Am = 'am',
  An = 'an',
  Ao = 'ao',
  Aq = 'aq',
  Ar = 'ar',
  As = 'as',
  At = 'at',
  Au = 'au',
  Aw = 'aw',
  Ax = 'ax',
  Az = 'az',
  Ba = 'ba',
  Bb = 'bb',
  Bd = 'bd',
  Be = 'be',
  Bf = 'bf',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bj = 'bj',
  Bl = 'bl',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Bq = 'bq',
  Br = 'br',
  Bs = 'bs',
  Bt = 'bt',
  Bv = 'bv',
  Bw = 'bw',
  By = 'by',
  Bz = 'bz',
  Ca = 'ca',
  Cc = 'cc',
  Cd = 'cd',
  Cf = 'cf',
  Cg = 'cg',
  Ch = 'ch',
  Ci = 'ci',
  Ck = 'ck',
  Cl = 'cl',
  Cm = 'cm',
  Cn = 'cn',
  Co = 'co',
  Cr = 'cr',
  Cu = 'cu',
  Cv = 'cv',
  Cw = 'cw',
  Cx = 'cx',
  Cy = 'cy',
  Cz = 'cz',
  De = 'de',
  Dj = 'dj',
  Dk = 'dk',
  Dm = 'dm',
  Do = 'do',
  Dz = 'dz',
  Ec = 'ec',
  Ee = 'ee',
  Eg = 'eg',
  Eh = 'eh',
  Er = 'er',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fj = 'fj',
  Fk = 'fk',
  Fm = 'fm',
  Fo = 'fo',
  Fr = 'fr',
  Ga = 'ga',
  Gb = 'gb',
  Gd = 'gd',
  Ge = 'ge',
  Gf = 'gf',
  Gg = 'gg',
  Gh = 'gh',
  Gi = 'gi',
  Gl = 'gl',
  Gm = 'gm',
  Gn = 'gn',
  Gp = 'gp',
  Gq = 'gq',
  Gr = 'gr',
  Gs = 'gs',
  Gt = 'gt',
  Gu = 'gu',
  Gw = 'gw',
  Gy = 'gy',
  Hk = 'hk',
  Hm = 'hm',
  Hn = 'hn',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Id = 'id',
  Ie = 'ie',
  Il = 'il',
  Im = 'im',
  In = 'in',
  Io = 'io',
  Iq = 'iq',
  Ir = 'ir',
  Is = 'is',
  It = 'it',
  Je = 'je',
  Jm = 'jm',
  Jo = 'jo',
  Jp = 'jp',
  Ke = 'ke',
  Kg = 'kg',
  Kh = 'kh',
  Ki = 'ki',
  Km = 'km',
  Kn = 'kn',
  Kp = 'kp',
  Kr = 'kr',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  Kz = 'kz',
  La = 'la',
  Lb = 'lb',
  Lc = 'lc',
  Li = 'li',
  Lk = 'lk',
  Lr = 'lr',
  Ls = 'ls',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Ly = 'ly',
  Ma = 'ma',
  Mc = 'mc',
  Md = 'md',
  Me = 'me',
  Mf = 'mf',
  Mg = 'mg',
  Mh = 'mh',
  Mk = 'mk',
  Ml = 'ml',
  Mm = 'mm',
  Mn = 'mn',
  Mo = 'mo',
  Mp = 'mp',
  Mq = 'mq',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  Mu = 'mu',
  Mv = 'mv',
  Mw = 'mw',
  Mx = 'mx',
  My = 'my',
  Mz = 'mz',
  Na = 'na',
  Nc = 'nc',
  Ne = 'ne',
  Nf = 'nf',
  Ng = 'ng',
  Ni = 'ni',
  Nl = 'nl',
  No = 'no',
  Np = 'np',
  Nr = 'nr',
  Nu = 'nu',
  Nz = 'nz',
  Om = 'om',
  Pa = 'pa',
  Pe = 'pe',
  Pf = 'pf',
  Pg = 'pg',
  Ph = 'ph',
  Pk = 'pk',
  Pl = 'pl',
  Pm = 'pm',
  Pn = 'pn',
  Pr = 'pr',
  Ps = 'ps',
  Pt = 'pt',
  Pw = 'pw',
  Py = 'py',
  Qa = 'qa',
  Re = 're',
  Ro = 'ro',
  Rs = 'rs',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sb = 'sb',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Sh = 'sh',
  Si = 'si',
  Sj = 'sj',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Sv = 'sv',
  Sx = 'sx',
  Sy = 'sy',
  Sz = 'sz',
  Tc = 'tc',
  Td = 'td',
  Tf = 'tf',
  Tg = 'tg',
  Th = 'th',
  Tj = 'tj',
  Tk = 'tk',
  Tl = 'tl',
  Tm = 'tm',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Tt = 'tt',
  Tv = 'tv',
  Tw = 'tw',
  Tz = 'tz',
  Ua = 'ua',
  Ug = 'ug',
  Um = 'um',
  Us = 'us',
  Uy = 'uy',
  Uz = 'uz',
  Va = 'va',
  Vc = 'vc',
  Ve = 've',
  Vg = 'vg',
  Vi = 'vi',
  Vn = 'vn',
  Vu = 'vu',
  Wf = 'wf',
  Ws = 'ws',
  Ye = 'ye',
  Yt = 'yt',
  Za = 'za',
  Zm = 'zm',
  Zw = 'zw'
}

/** Payment Option Type */
export type PaymentOptionType = {
  __typename?: 'PaymentOptionType';
  additionalFields: Maybe<Scalars['String']['output']>;
  androidMinBuildVersion: Maybe<Scalars['Int']['output']>;
  bankDetails: Maybe<Array<Maybe<BankTransferDetails>>>;
  ccPrimary: Maybe<Scalars['Boolean']['output']>;
  ccType: Maybe<Scalars['UnsetOrCardType']['output']>;
  ccVolumeLimit: Maybe<Scalars['Int']['output']>;
  /** Is required to fill client address to make a payment */
  clientAddressRequired: Maybe<Scalars['Boolean']['output']>;
  companies: Maybe<Array<Maybe<Company>>>;
  confluenceLink: Maybe<Scalars['String']['output']>;
  countries: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  flowType: Maybe<DepositFlowType>;
  /** Payment Option Id */
  id: Maybe<Scalars['Int']['output']>;
  iOSMinBuildVersion: Maybe<Scalars['Int']['output']>;
  lastUpdatedBy: Maybe<User>;
  /** Payment Option Name Localization Key */
  localizationKey: Maybe<Scalars['String']['output']>;
  /** Payment Option Name Logo Url */
  logoUrl: Maybe<Scalars['String']['output']>;
  method: Maybe<PaymentOptionMethodsType>;
  /** Payment Option Name */
  name: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  /** Payment Option Provider key */
  paymentKey: Maybe<Scalars['String']['output']>;
  /** Payment Option Provider */
  provider: Maybe<Scalars['String']['output']>;
  /** Payment Option Status */
  status: Maybe<PaymentOptionStatusType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** With KYC Status */
  withKYCStatus: Maybe<WithKycStatusType>;
};

/** Get bank transfer details by account */
export type BankTransferDetails = {
  __typename?: 'BankTransferDetails';
  /** Address */
  address: Maybe<Scalars['String']['output']>;
  /** Bank */
  bank: Maybe<Scalars['String']['output']>;
  /** City */
  city: Maybe<Scalars['String']['output']>;
  /** Client Account Currency */
  clientAccountCurrency: Maybe<Scalars['String']['output']>;
  /** Correspondent Bank */
  correspondentBank: Maybe<Scalars['String']['output']>;
  /** Country */
  country: Maybe<Scalars['String']['output']>;
  /** Crediting Account */
  creditingAccount: Maybe<Scalars['String']['output']>;
  /** Currency */
  currency: Maybe<Scalars['String']['output']>;
  /** IBAN */
  iban: Maybe<Scalars['String']['output']>;
  /** Recipient */
  recipient: Maybe<Scalars['String']['output']>;
  reference: Maybe<Scalars['String']['output']>;
  /** Swift */
  swift: Maybe<Scalars['String']['output']>;
  /** Swift BIC */
  swiftBic: Maybe<Scalars['String']['output']>;
};

export enum DepositFlowType {
  BankWire = 'bankWire',
  CardNative = 'cardNative',
  CryptoAddress = 'cryptoAddress',
  Custom = 'custom',
  DataPost = 'dataPost',
  UrlRedirect = 'urlRedirect'
}

export enum PaymentOptionMethodsType {
  DepositOnly = 'depositOnly',
  InitialDepositOnly = 'initialDepositOnly',
  InitialDepositProfits = 'initialDepositProfits',
  WithdrawalOnly = 'withdrawalOnly'
}

export enum PaymentOptionStatusType {
  /** Payment option is live and enabled to clients */
  Active = 'active',
  /** Payment option is live but disabled to clients */
  Disabled = 'disabled',
  /** Payment option is offline and will no longer be used */
  Terminated = 'terminated'
}

export enum WithKycStatusType {
  /** Eligible for clients with KYC NOT passed */
  KycMissingOnly = 'kyc_missing_only',
  /** Eligible for clients with KYC passed */
  KycPassedOnly = 'kyc_passed_only',
  /** Eligible for any KYC status */
  KycStatusAny = 'kyc_status_any'
}

/** Mapping between Client Countries to Available Sale's Agent Languages */
export type CountryToAgentLanguageMapping = {
  __typename?: 'CountryToAgentLanguageMapping';
  /** Country */
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Associated Language */
  language: Maybe<Language>;
  lastUpdatedBy: Maybe<User>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Affiliate SSO link into external app */
export type AffiliateLink = {
  __typename?: 'AffiliateLink';
  /** SSO link */
  link: Maybe<Scalars['String']['output']>;
};

/** Top Vip count fields */
export type ObjectTopVipCount = {
  __typename?: 'ObjectTopVipCount';
  /** Total objects */
  count: Maybe<Scalars['Int']['output']>;
  /** Status */
  status: Maybe<Scalars['String']['output']>;
};

/** Description of document fields */
export type DocumentDescription = {
  __typename?: 'DocumentDescription';
  /** Document Label */
  label: Maybe<Scalars['String']['output']>;
  /** Document Value */
  value: Maybe<Scalars['String']['output']>;
};

export type DynamicWithdrawalFields = {
  __typename?: 'DynamicWithdrawalFields';
  fields: Maybe<Scalars['String']['output']>;
};

/** Email */
export type Email = {
  __typename?: 'Email';
  attachments: Maybe<Array<Maybe<Attachment>>>;
  bcc: Maybe<Scalars['String']['output']>;
  body: Maybe<Scalars['String']['output']>;
  cc: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  from: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  labelIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  snippet: Maybe<Scalars['String']['output']>;
  subject: Maybe<Scalars['String']['output']>;
  threadId: Maybe<Scalars['ID']['output']>;
  to: Maybe<Scalars['String']['output']>;
};

/** Attachment */
export type Attachment = {
  __typename?: 'Attachment';
  attachmentId: Maybe<Scalars['ID']['output']>;
  data: Maybe<Scalars['String']['output']>;
  filename: Maybe<Scalars['String']['output']>;
};

/** FAQ for the mobile app */
export type Faq = {
  __typename?: 'Faq';
  /** Question body */
  answer: Maybe<Scalars['String']['output']>;
  /** Question category */
  category: Maybe<Scalars['String']['output']>;
  /** Relevant for companies */
  company: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Question content */
  faqContent: Maybe<Scalars['String']['output']>;
  /** Question link */
  faqLink: Maybe<Scalars['String']['output']>;
  /** Question title */
  faqTitle: Maybe<Scalars['String']['output']>;
  /** Question key */
  key: Maybe<Scalars['String']['output']>;
  /** Question title */
  question: Maybe<Scalars['String']['output']>;
};

/** Client search types */
export enum ClientSearchType {
  Affiliate = 'affiliate'
}

/** Response for the client search */
export type FindClient = {
  __typename?: 'FindClient';
  /** Account Id of the client for sending the funds */
  accountId: Maybe<Scalars['Int']['output']>;
  /** Client Id */
  clientId: Maybe<Scalars['Int']['output']>;
  /** Email of the client */
  email: Maybe<Scalars['String']['output']>;
  /** Client First name */
  firstName: Maybe<Scalars['String']['output']>;
  /** Client last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** Remote Id of the client for sending the funds */
  remoteId: Maybe<Scalars['String']['output']>;
};

/** A system wide settings object */
export type Settings = {
  __typename?: 'Settings';
  data: Maybe<Scalars['String']['output']>;
};

export enum CopiersReportOrderByType {
  AccountId = 'account_id',
  IbAccountCopying = 'ib_account_copying',
  MemberId = 'member_id',
  StartRequestedDate = 'start_requested_date',
  StopRequestedDate = 'stop_requested_date'
}

export type CopiersReport = {
  __typename?: 'CopiersReport';
  /** Account ID */
  account_id: Maybe<Scalars['Int']['output']>;
  /** Company */
  company: Maybe<Scalars['String']['output']>;
  /** IB account copying */
  ib_account_copying: Maybe<Scalars['Int']['output']>;
  /** Member ID */
  member_id: Maybe<Scalars['Int']['output']>;
  /** Start requested date */
  start_requested_date: Maybe<Scalars['DateTime']['output']>;
  /** Stop requested date */
  stop_requested_date: Maybe<Scalars['DateTime']['output']>;
};

export enum DepositsReportOrderByType {
  Date = 'date'
}

export type DepositsReport = {
  __typename?: 'DepositsReport';
  /** date */
  date: Maybe<Scalars['DateTime']['output']>;
  /** deposits */
  deposits: Maybe<Scalars['Float']['output']>;
};

export enum FtdReportOrderByType {
  ClientDob = 'clientDOB',
  ClientFullName = 'clientFullName',
  Entity = 'entity',
  Id = 'id'
}

export type FtdReport = {
  __typename?: 'FTDReport';
  /** Date Of Birth */
  dob: Maybe<Scalars['DateTime']['output']>;
  /** Entity */
  entity: Maybe<Scalars['String']['output']>;
  /** Full Name */
  fullName: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Maybe<Scalars['Int']['output']>;
};

export enum RegistrationsReportOrderByType {
  Count = 'count',
  Date = 'date',
  Id = 'id'
}

export type RegistrationsReport = {
  __typename?: 'RegistrationsReport';
  /** Company */
  company: Maybe<Scalars['String']['output']>;
  /** Count */
  count: Maybe<Scalars['Int']['output']>;
  /** Date */
  date: Maybe<Scalars['DateTime']['output']>;
};

/** An IB Client model */
export type IbClientType = {
  __typename?: 'ibClientType';
  /** Account ID */
  accountId: Maybe<Scalars['Int']['output']>;
  /** First name */
  firstName: Maybe<Scalars['String']['output']>;
  /** ibId */
  ibId: Maybe<Scalars['String']['output']>;
  /** Client ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Last name */
  lastName: Maybe<Scalars['String']['output']>;
  /** parentIbId */
  parentIbId: Maybe<Scalars['String']['output']>;
};

export type ThunderxPayOptionsType = {
  __typename?: 'ThunderxPayOptionsType';
  options: Maybe<Scalars['String']['output']>;
};

export enum TradesReportOrderByType {
  Date = 'date',
  Source = 'source',
  Trades = 'trades'
}

export type TradesReport = {
  __typename?: 'TradesReport';
  /** date */
  date: Maybe<Scalars['DateTime']['output']>;
  /** source */
  source: Maybe<Scalars['String']['output']>;
  /** trades */
  trades: Maybe<Scalars['Int']['output']>;
};

export enum TransactionsCommissionsOrderByType {
  Amount = 'amount',
  ClientId = 'clientId',
  Currency = 'currency',
  Ftd = 'ftd',
  TransactionCreatedAt = 'transactionCreatedAt',
  TransactionType = 'transactionType',
  Vendor = 'vendor'
}

/** Net Deposits and withdrawals by the agent */
export type TransactionsCommission = {
  __typename?: 'TransactionsCommission';
  /** Amount */
  amount: Maybe<Scalars['Float']['output']>;
  /** Client ID */
  clientId: Maybe<Scalars['String']['output']>;
  /** Currency */
  currency: Maybe<Scalars['String']['output']>;
  /** Effective Call */
  effectiveCall: Maybe<Scalars['Boolean']['output']>;
  ftd: Maybe<Scalars['Boolean']['output']>;
  /** Deposit/withdrawal created at */
  transactionCreatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Transaction ID */
  transactionId: Maybe<Scalars['Int']['output']>;
  /** Transaction Type */
  transactionType: Maybe<Scalars['String']['output']>;
  /** Transaction Vendor */
  vendor: Maybe<Scalars['String']['output']>;
};

/** Sum deposits and withdrawals by the agent */
export type TransactionsCommissionSum = {
  __typename?: 'TransactionsCommissionSum';
  /** Currency */
  currency: Maybe<Scalars['String']['output']>;
  /** Deposits Count */
  depositCount: Maybe<Scalars['Int']['output']>;
  /** Total amount */
  totalAmount: Maybe<Scalars['Float']['output']>;
  /** Withdrawals Count */
  withdrawalCount: Maybe<Scalars['Int']['output']>;
};

/** VPS Service password */
export type VpsServicePasswordType = {
  __typename?: 'vpsServicePasswordType';
  /** VPS Service password */
  password: Maybe<Scalars['String']['output']>;
};

/** One of the possible ghost copying status types */
export enum GhostCopyTradingStatusType {
  Fixed = 'FIXED',
  New = 'NEW'
}

/** Ghost Copy Trading data */
export type GhostCopyTrading = {
  __typename?: 'GhostCopyTrading';
  /** Copying Account ID */
  copyingRemoteId: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** First date of copy trading */
  firstCopyingDate: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  /** Activity */
  isActive: Maybe<Scalars['Boolean']['output']>;
  /** Last date of copy trading */
  lastCopyingDate: Maybe<Scalars['DateTime']['output']>;
  /** Member ID */
  memberId: Maybe<Scalars['Int']['output']>;
  /** Account ID */
  remoteId: Maybe<Scalars['Int']['output']>;
  /** Status */
  status: Maybe<GhostCopyTradingStatusType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Automated jobs created by authorized users */
export type Job = {
  __typename?: 'Job';
  /** Job action carried out */
  action: Maybe<JobAction>;
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  /** Job ID */
  id: Maybe<Scalars['Int']['output']>;
  meta: Maybe<Scalars['String']['output']>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
  /** Status of this job */
  status: Maybe<JobStatus>;
  /** Type of job */
  type: Maybe<JobType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** One of the possible job actions */
export enum JobAction {
  Apply = 'apply',
  Revert = 'revert'
}

/** One of the possible job statuses */
export enum JobStatus {
  Completed = 'completed',
  CompletedWithError = 'completedWithError',
  Queued = 'queued',
  Running = 'running',
  Stopped = 'stopped'
}

/** One of the possible job types */
export enum JobType {
  AffiliateCommissions = 'affiliateCommissions',
  CuboidDormantFee = 'cuboidDormantFee',
  ForexDormantFee = 'forexDormantFee',
  SpotOptionDormantFee = 'spotOptionDormantFee',
  TradeSmarterDormantFee = 'tradeSmarterDormantFee'
}

/** Total info for competitions leaderboard */
export type CompetitionsLeaderboardTotalInfo = {
  __typename?: 'CompetitionsLeaderboardTotalInfo';
  participants: Maybe<Scalars['Int']['output']>;
  totalAmountOfTrades: Maybe<Scalars['Int']['output']>;
  totalROI: Maybe<Scalars['Float']['output']>;
};

export type BondType = {
  __typename?: 'BondType';
  accruedInterest: Scalars['Float']['output'];
  assetSecurity: Scalars['String']['output'];
  businessDescriptionLong: Scalars['String']['output'];
  businessDescriptionShort: Scalars['String']['output'];
  couponInterestRate: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  establishedYear: Maybe<Scalars['Int']['output']>;
  faceValue: Scalars['Float']['output'];
  firstCouponDate: Scalars['DateTime']['output'];
  industryType: Scalars['String']['output'];
  interestPaymentFrequency: Scalars['Int']['output'];
  isin: Scalars['String']['output'];
  lastCouponDate: Maybe<Scalars['DateTime']['output']>;
  launchDate: Scalars['DateTime']['output'];
  lendingRate: Scalars['Float']['output'];
  leverage: Scalars['Int']['output'];
  logoUrl: Scalars['String']['output'];
  maturityDate: Maybe<Scalars['DateTime']['output']>;
  mt4Symbol: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownershipType: Scalars['String']['output'];
  promoImageUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
  textSections: Scalars['String']['output'];
  websiteUrl: Scalars['String']['output'];
};

/** Enables manually running scripts, workers... */
export type ManualExecutionsType = {
  __typename?: 'ManualExecutionsType';
  /** When the execution started */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Admin who started the execution */
  createdBy: Maybe<Scalars['Int']['output']>;
  /** Execution id */
  id: Maybe<Scalars['Int']['output']>;
  /** File name */
  name: Maybe<Scalars['String']['output']>;
  /** Params needed for script/worker/job to work */
  params: Maybe<Scalars['String']['output']>;
  /** Type of file to run (script, worker, job...) */
  type: Maybe<Scalars['String']['output']>;
};

export type MarketingEmailType = {
  __typename?: 'MarketingEmailType';
  clientCount: Maybe<Scalars['ID']['output']>;
  clientIDs: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  defaultLanguage: Maybe<Language>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  jobId: Maybe<Scalars['Int']['output']>;
  searchParams: Maybe<Scalars['String']['output']>;
  status: Maybe<JobStatus>;
  template: Maybe<Scalars['String']['output']>;
  templateId: Maybe<Scalars['ID']['output']>;
  unsubscribeGroup: Maybe<Scalars['String']['output']>;
  unsubscribeGroupId: Maybe<Scalars['ID']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type MarketingEmailTemplateType = {
  __typename?: 'MarketingEmailTemplateType';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type MarketingEmailUnsubscribeGroupType = {
  __typename?: 'MarketingEmailUnsubscribeGroupType';
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isDefault: Maybe<Scalars['String']['output']>;
  lastEmailSentAt: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  unsubscribes: Maybe<Scalars['String']['output']>;
};

/** Definition of mobile AP test */
export type MobileApTest = {
  __typename?: 'MobileAPTest';
  /** Clients latest AP test answers */
  answers: Maybe<Scalars['String']['output']>;
  /** Enums relevant to questions for evaluating the questions */
  options: Maybe<Scalars['String']['output']>;
  /** AP Test Questions */
  questions: Maybe<Scalars['String']['output']>;
};

/** Configuration for app */
export type Config = {
  __typename?: 'Config';
  /** All Configs variables from web */
  config: Maybe<Scalars['String']['output']>;
};

export type PayretailersPaymentMethod = {
  __typename?: 'PayretailersPaymentMethod';
  channel: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  group: Maybe<Scalars['String']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  paymentMethodId: Maybe<Scalars['ID']['output']>;
};

/** Performance Fees for Copy Trading */
export type PerformanceFee = {
  __typename?: 'PerformanceFee';
  depositAmount: Maybe<Scalars['Float']['output']>;
  depositCurrency: Maybe<Currency>;
  depositDate: Maybe<Scalars['DateTime']['output']>;
  depositId: Maybe<Scalars['Int']['output']>;
  depositStatus: Maybe<DepositStatus>;
  depositVendor: Maybe<Scalars['DepositVendorOrString']['output']>;
  followerId: Maybe<Scalars['Int']['output']>;
  followerName: Maybe<Scalars['String']['output']>;
  providerId: Maybe<Scalars['Int']['output']>;
  providerName: Maybe<Scalars['String']['output']>;
  withdrawalAmount: Maybe<Scalars['Float']['output']>;
  withdrawalCurrency: Maybe<Currency>;
  withdrawalId: Maybe<Scalars['Int']['output']>;
};

/** Clients' phone verifications */
export type PhoneVerification = {
  __typename?: 'PhoneVerification';
  /** Client */
  client: Maybe<Client>;
  /** Code used to verify phone */
  code: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  /** Phone to be verified */
  phone: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** Did the client verify the phone? */
  verified: Maybe<Scalars['Boolean']['output']>;
  /** Datet of verification */
  verifiedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Prize for partner loyality program */
export type Prize = {
  __typename?: 'Prize';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  imageLink: Maybe<Scalars['String']['output']>;
  /** Prize key */
  prizeKey: Maybe<Scalars['String']['output']>;
  /** Prize label */
  prizeLabel: Maybe<Scalars['String']['output']>;
  /** Prize threshold */
  prizeThreshold: Maybe<Scalars['String']['output']>;
};

/** Internal promocode */
export type Promocode = {
  __typename?: 'Promocode';
  /** Amount - either in currency OR percent */
  amount: Maybe<Scalars['Float']['output']>;
  /** Promocode Category */
  category: Maybe<PromocodeCategory>;
  /** Promocode Key */
  code: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Number of times this has been used so far  */
  currentUses: Scalars['Int']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Expiration datetime - not valid after */
  expiration: Maybe<Scalars['DateTime']['output']>;
  /** Is deposit required */
  ftd: Maybe<PromocodeFtd>;
  /** Promocode ID */
  id: Maybe<Scalars['Int']['output']>;
  /** Is the amount a percentage discount or fixed amount  */
  isPercentage: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of uses -1 means unlimited */
  maximumUses: Scalars['Int']['output'];
  /** The minimum amount for the deposit */
  minDepositAmount: Maybe<Scalars['Float']['output']>;
  /** The minimum amount for the first deposit */
  minFtd: Maybe<Scalars['Float']['output']>;
  /** Product that this is valid for */
  product: Maybe<PromocodeProductNameType>;
  /** Promocode Single Usage Switch */
  single: Maybe<PromocodeSingle>;
  /** Current status of this code */
  status: Maybe<PromocodeStatus>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** User who created this promocode */
  user: Maybe<User>;
};

/** List of promocode categories */
export enum PromocodeCategory {
  Deposit = 'deposit',
  Instant = 'instant',
  Onboard = 'onboard'
}

/** List of promocode ftd types */
export enum PromocodeFtd {
  Optional = 'optional',
  Required = 'required'
}

/** List of promocode product names */
export enum PromocodeProductNameType {
  AffiliateAccount = 'AffiliateAccount',
  AffiliateEquityFlowAccount = 'AffiliateEquityFlowAccount',
  AffiliateLydianAccount = 'AffiliateLydianAccount',
  AffiliateMauritiusAccount = 'AffiliateMauritiusAccount',
  AffiliateSkyGroundAccount = 'AffiliateSkyGroundAccount',
  AffiliateTauroMarketsAccount = 'AffiliateTauroMarketsAccount',
  AffiliateTauroMarketsMauritiusAccount = 'AffiliateTauroMarketsMauritiusAccount',
  AffiliateVanuatuAccount = 'AffiliateVanuatuAccount',
  AipammAccount = 'AIPAMMAccount',
  AipammDemoAccount = 'AIPAMMDemoAccount',
  AipammMauritiusAccount = 'AIPAMMMauritiusAccount',
  AipammMauritiusDemoAccount = 'AIPAMMMauritiusDemoAccount',
  BdXcoin = 'BDXcoin',
  BdXcoinMauritius = 'BDXcoinMauritius',
  BdXcoinVanuatu = 'BDXcoinVanuatu',
  BitnukWalletMauritius = 'BitnukWalletMauritius',
  BitnukWalletSwissMarketsMauritius = 'BitnukWalletSwissMarketsMauritius',
  BitnukWalletVanuatu = 'BitnukWalletVanuatu',
  BondAccount = 'BondAccount',
  BondDemoAccount = 'BondDemoAccount',
  BondMauritiusAccount = 'BondMauritiusAccount',
  BondMauritiusDemoAccount = 'BondMauritiusDemoAccount',
  BondVanuatuAccount = 'BondVanuatuAccount',
  BondVanuatuDemoAccount = 'BondVanuatuDemoAccount',
  BrFcoin = 'BRFcoin',
  CentEquityFlowAccount = 'CentEquityFlowAccount',
  CentMauritiusAccount = 'CentMauritiusAccount',
  CentTauroMarketsAccount = 'CentTauroMarketsAccount',
  CentVanuatuAccount = 'CentVanuatuAccount',
  CleaNcoin = 'CLEANcoin',
  CryptoWallet = 'CryptoWallet',
  CuboidAccount = 'CuboidAccount',
  CuboidDemoAccount = 'CuboidDemoAccount',
  CuboidMauritiusAccount = 'CuboidMauritiusAccount',
  CuboidMauritiusDemoAccount = 'CuboidMauritiusDemoAccount',
  CuboidVanuatuAccount = 'CuboidVanuatuAccount',
  CuboidVanuatuDemoAccount = 'CuboidVanuatuDemoAccount',
  ExchangeAccount = 'ExchangeAccount',
  ExchangeBdxAccount = 'ExchangeBDXAccount',
  ExchangeMauritiusAccount = 'ExchangeMauritiusAccount',
  ExchangeVanuatuAccount = 'ExchangeVanuatuAccount',
  FiatWallet = 'FiatWallet',
  ForexAccount = 'ForexAccount',
  ForexAsiaAccount = 'ForexAsiaAccount',
  ForexClassicAccount = 'ForexClassicAccount',
  ForexClassicDemoAccount = 'ForexClassicDemoAccount',
  ForexClassicEquityFlowAccount = 'ForexClassicEquityFlowAccount',
  ForexClassicEquityFlowAsiaAccount = 'ForexClassicEquityFlowAsiaAccount',
  ForexClassicEquityFlowDemoAccount = 'ForexClassicEquityFlowDemoAccount',
  ForexClassicLydianAccount = 'ForexClassicLydianAccount',
  ForexClassicLydianDemoAccount = 'ForexClassicLydianDemoAccount',
  ForexClassicMauritiusAccount = 'ForexClassicMauritiusAccount',
  ForexClassicMauritiusDemoAccount = 'ForexClassicMauritiusDemoAccount',
  ForexClassicSkyGroundAccount = 'ForexClassicSkyGroundAccount',
  ForexClassicSkyGroundDemoAccount = 'ForexClassicSkyGroundDemoAccount',
  ForexClassicTauroMarketsAccount = 'ForexClassicTauroMarketsAccount',
  ForexClassicTauroMarketsAsiaAccount = 'ForexClassicTauroMarketsAsiaAccount',
  ForexClassicTauroMarketsDemoAccount = 'ForexClassicTauroMarketsDemoAccount',
  ForexClassicTauroMarketsMauritiusAccount = 'ForexClassicTauroMarketsMauritiusAccount',
  ForexClassicVanuatuAccount = 'ForexClassicVanuatuAccount',
  ForexClassicVanuatuDemoAccount = 'ForexClassicVanuatuDemoAccount',
  ForexDemoAccount = 'ForexDemoAccount',
  ForexMauritiusAccount = 'ForexMauritiusAccount',
  ForexMauritiusAccountBdx = 'ForexMauritiusAccountBDX',
  ForexMauritiusDemoAccount = 'ForexMauritiusDemoAccount',
  ForexMt5Account = 'ForexMT5Account',
  ForexMt5DemoAccount = 'ForexMT5DemoAccount',
  ForexMt5MauritiusAccount = 'ForexMT5MauritiusAccount',
  ForexMt5MauritiusDemoAccount = 'ForexMT5MauritiusDemoAccount',
  ForexMt5SvgTauromarketsAccount = 'ForexMT5SVGTauromarketsAccount',
  ForexMt5SvgTauromarketsDemoAccount = 'ForexMT5SVGTauromarketsDemoAccount',
  ForexMt5TauromarketsAccount = 'ForexMT5TauromarketsAccount',
  ForexMt5TauromarketsDemoAccount = 'ForexMT5TauromarketsDemoAccount',
  ForexMt5VanuatuAccount = 'ForexMT5VanuatuAccount',
  ForexMt5VanuatuDemoAccount = 'ForexMT5VanuatuDemoAccount',
  ForexPremiumMauritiusAccount = 'ForexPremiumMauritiusAccount',
  ForexPremiumVanuatuAccount = 'ForexPremiumVanuatuAccount',
  ForexRawAccount = 'ForexRawAccount',
  ForexRawBdSwissAccount = 'ForexRawBDSwissAccount',
  ForexRawBdSwissMauritiusAccount = 'ForexRawBDSwissMauritiusAccount',
  ForexRawBdSwissVanuatuAccount = 'ForexRawBDSwissVanuatuAccount',
  ForexRawEquityFlowAccount = 'ForexRawEquityFlowAccount',
  ForexRawMauritiusAccount = 'ForexRawMauritiusAccount',
  ForexRawTauroMarketsAccount = 'ForexRawTauroMarketsAccount',
  ForexRawVanuatuAccount = 'ForexRawVanuatuAccount',
  ForexVanuatuAccount = 'ForexVanuatuAccount',
  ForexVanuatuDemoAccount = 'ForexVanuatuDemoAccount',
  GoldAccount = 'GoldAccount',
  GoldMauritiusAccount = 'GoldMauritiusAccount',
  GoldVanuatuAccount = 'GoldVanuatuAccount',
  IntroducingBrokerAccount = 'IntroducingBrokerAccount',
  IntroducingBrokerBdSwissVanuatuAccount = 'IntroducingBrokerBDSwissVanuatuAccount',
  IntroducingBrokerEquityFlowAccount = 'IntroducingBrokerEquityFlowAccount',
  IntroducingBrokerMauritiusAccount = 'IntroducingBrokerMauritiusAccount',
  IntroducingBrokerSwissMarketsAccount = 'IntroducingBrokerSwissMarketsAccount',
  IntroducingBrokerSwissMarketsMauritiusAccount = 'IntroducingBrokerSwissMarketsMauritiusAccount',
  IntroducingBrokerSwissMarketsVanuatuAccount = 'IntroducingBrokerSwissMarketsVanuatuAccount',
  IntroducingBrokerTauroMarketsAccount = 'IntroducingBrokerTauroMarketsAccount',
  IntroducingBrokerTauroMarketsMauritiusAccount = 'IntroducingBrokerTauroMarketsMauritiusAccount',
  JollYcoin = 'JOLLYcoin',
  MamAccount = 'MAMAccount',
  MamMauritiusAccount = 'MAMMauritiusAccount',
  MamsmMauritiusAccount = 'MAMSMMauritiusAccount',
  MamsmVanuatuAccount = 'MAMSMVanuatuAccount',
  MamVanuatuAccount = 'MAMVanuatuAccount',
  PammAccount = 'PAMMAccount',
  PammFundManagerAccount = 'PAMMFundManagerAccount',
  PammFundManagerMauritiusAccount = 'PAMMFundManagerMauritiusAccount',
  PammFundManagerVanuatuAccount = 'PAMMFundManagerVanuatuAccount',
  PammMauritiusAccount = 'PAMMMauritiusAccount',
  PammsmAccount = 'PAMMSMAccount',
  PammsmFundManagerAccount = 'PAMMSMFundManagerAccount',
  PammsmFundManagerMauritiusAccount = 'PAMMSMFundManagerMauritiusAccount',
  PammsmFundManagerVanuatuAccount = 'PAMMSMFundManagerVanuatuAccount',
  PammsmMauritiusAccount = 'PAMMSMMauritiusAccount',
  PammsmVanuatuAccount = 'PAMMSMVanuatuAccount',
  PammTauroMarketsAccount = 'PAMMTauroMarketsAccount',
  PammTauroMarketsManagerAccount = 'PAMMTauroMarketsManagerAccount',
  PammTauroMarketsMauritiusAccount = 'PAMMTauroMarketsMauritiusAccount',
  PammTauroMarketsMauritiusManagerAccount = 'PAMMTauroMarketsMauritiusManagerAccount',
  PammTauroMarketsMt5Account = 'PAMMTauroMarketsMT5Account',
  PammTauroMarketsMt5ManagerAccount = 'PAMMTauroMarketsMT5ManagerAccount',
  PammVanuatuAccount = 'PAMMVanuatuAccount',
  PortfolioManagementAccount = 'PortfolioManagementAccount',
  PortfolioManagementMauritiusAccount = 'PortfolioManagementMauritiusAccount',
  SmPrimeWalletBdSwissAccount = 'SMPrimeWalletBDSwissAccount',
  SmPrimeWalletBdSwissMauritiusAccount = 'SMPrimeWalletBDSwissMauritiusAccount',
  SmPrimeWalletMauritiusAccount = 'SMPrimeWalletMauritiusAccount',
  SmPrimeWalletVanuatuAccount = 'SMPrimeWalletVanuatuAccount',
  SpotOptionAccount = 'SpotOptionAccount',
  SpotOptionDemoAccount = 'SpotOptionDemoAccount',
  SpotOptionMauritiusAccount = 'SpotOptionMauritiusAccount',
  SpotOptionMauritiusDemoAccount = 'SpotOptionMauritiusDemoAccount',
  SpotOptionVanuatuAccount = 'SpotOptionVanuatuAccount',
  SpotOptionVanuatuDemoAccount = 'SpotOptionVanuatuDemoAccount',
  TradesmarterAccount = 'TradesmarterAccount',
  TradesmarterDemoAccount = 'TradesmarterDemoAccount',
  TradesmarterMauritiusAccount = 'TradesmarterMauritiusAccount',
  TradesmarterMauritiusDemoAccount = 'TradesmarterMauritiusDemoAccount',
  TradesmarterVanuatuAccount = 'TradesmarterVanuatuAccount',
  TradesmarterVanuatuDemoAccount = 'TradesmarterVanuatuDemoAccount'
}

/** List of promocode single types */
export enum PromocodeSingle {
  NonSingle = 'non_single',
  Single = 'single'
}

/** List of promocode statuses */
export enum PromocodeStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type PspReport = {
  __typename?: 'PspReport';
  androidMinBuildVersion: Maybe<Scalars['Int']['output']>;
  ccCurrent: Maybe<Scalars['Boolean']['output']>;
  ccPrimary: Maybe<Scalars['Boolean']['output']>;
  ccType: Maybe<Scalars['String']['output']>;
  ccVolumeLimit: Maybe<Scalars['Int']['output']>;
  companies: Maybe<Array<Maybe<Company>>>;
  failedDeposits: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  iOSMinBuildVersion: Maybe<Scalars['Int']['output']>;
  /** Payment Option Status */
  status: Maybe<PaymentOptionStatusType>;
  totalEur: Maybe<Scalars['Int']['output']>;
  vendor: Maybe<Scalars['String']['output']>;
};

/** Push Notification Type */
export type PushNotificationType = {
  __typename?: 'pushNotificationType';
  body: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  csvLink: Maybe<Scalars['String']['output']>;
  defaultLanguage: Maybe<Language>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  jobId: Maybe<Scalars['Int']['output']>;
  status: Maybe<JobStatus>;
  type: Maybe<PushNotificationsTypesType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Push Notifications Types enum */
export enum PushNotificationsTypesType {
  Marketing = 'marketing',
  MarketingOptimove = 'marketingOptimove',
  Transactional = 'transactional'
}

export type Script = {
  __typename?: 'Script';
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** Seminar event */
export type Seminar = {
  __typename?: 'Seminar';
  /** Seminar city */
  city: Maybe<Scalars['String']['output']>;
  company: Maybe<Company>;
  /** Seminar Country */
  country: Maybe<Country>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  ibSeminar: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  /** Seminar location */
  location: Maybe<Scalars['String']['output']>;
  /** Seminar code */
  seminarCode: Maybe<Scalars['String']['output']>;
  /** Seminar date */
  seminarDate: Maybe<Scalars['DateTime']['output']>;
  /** Seminar link */
  seminarLink: Maybe<Scalars['String']['output']>;
  /** Seminar name */
  seminarName: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Shift allocation for user */
export type Shift = {
  __typename?: 'Shift';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  from: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  to: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  /** User shift */
  user: Maybe<User>;
  weight: Maybe<Scalars['Int']['output']>;
};

/** Strategies Equity Statistics */
export type StrategiesStatisticsType = {
  __typename?: 'StrategiesStatisticsType';
  accountId: Maybe<Scalars['Int']['output']>;
  followersEquity: Maybe<Scalars['Int']['output']>;
  numberOfFollowers: Maybe<Scalars['Int']['output']>;
  numberOfTrades: Maybe<Scalars['Int']['output']>;
  overallPnL: Maybe<Scalars['Int']['output']>;
  pnlSixtyDays: Maybe<Scalars['Int']['output']>;
  remoteId: Maybe<Scalars['Int']['output']>;
  strategyName: Maybe<Scalars['String']['output']>;
  strategyType: Maybe<Scalars['String']['output']>;
  whitelabel: Maybe<Scalars['String']['output']>;
  withdrawalsNinetyDays: Maybe<Scalars['String']['output']>;
  withdrawalsThirtyDays: Maybe<Scalars['String']['output']>;
};

/** Trading alert that is being displayed on the websites, mobile apps and Telegram channel */
export type TradingAlertType = {
  __typename?: 'TradingAlertType';
  action: Maybe<TradingAlertActionsType>;
  closedPrice: Maybe<Scalars['Float']['output']>;
  comments: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  entryPrice: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  pair: Maybe<Scalars['String']['output']>;
  status: Maybe<TradingAlertStatusesType>;
  stopLoss: Maybe<Scalars['Float']['output']>;
  successfulTrade: Maybe<Scalars['String']['output']>;
  takeProfit1: Maybe<Scalars['Float']['output']>;
  takeProfit2: Maybe<Scalars['Float']['output']>;
  takeProfit3: Maybe<Scalars['Float']['output']>;
  timeClosed: Maybe<Scalars['DateTime']['output']>;
  type: Maybe<TradingAlertTypesType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Trading Alert Actions enum */
export enum TradingAlertActionsType {
  Buy = 'buy',
  Sell = 'sell'
}

/** Trading Alert Statuses enum */
export enum TradingAlertStatusesType {
  Active = 'active',
  GetReady = 'getReady'
}

/** Trading Alert Types enum */
export enum TradingAlertTypesType {
  Closed = 'closed',
  Live = 'live'
}

/** Authenticated individual - either a user or a client  */
export type Viewer = Client | DemoClient | ExternalService | User;

/** A Demo client */
export type DemoClient = {
  __typename?: 'DemoClient';
  accounts: Maybe<Array<Maybe<Account>>>;
};

/** An external service able to log into the application */
export type ExternalService = {
  __typename?: 'ExternalService';
  /** Service ID */
  id: Maybe<Scalars['String']['output']>;
  /** Service name */
  name: Maybe<Scalars['String']['output']>;
};

/** Showing workers activity */
export type WorkersActivityType = {
  __typename?: 'WorkersActivityType';
  /** Worker finishing date */
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  /** Worker name */
  name: Maybe<Scalars['String']['output']>;
  /** Worker starting date */
  startedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Available mutations */
export type BdSwissMutations = {
  __typename?: 'BDSwissMutations';
  acknowledgeClientMessage: Maybe<Scalars['Boolean']['output']>;
  addAffiliateCountries: Maybe<AffiliateCountriesType>;
  /** Add bonus */
  addBonus: Maybe<Account>;
  /** Add Notice Acknowledgement */
  addClientNoticeAcknowledgement: Maybe<ClientNoticeAcknowledgementType>;
  addCopyTrading: Maybe<Scalars['Boolean']['output']>;
  addCryptoWalletAddress: Maybe<Account>;
  addMetadataToAccount: Maybe<Scalars['Boolean']['output']>;
  addMetadataToClient: Maybe<Scalars['Boolean']['output']>;
  /** Records walkthrough given to client */
  addWalkthrough: Maybe<Walkthrough>;
  approveAccount: Maybe<Scalars['Boolean']['output']>;
  approveDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  assignClientToAffiliate: Maybe<Scalars['Boolean']['output']>;
  assignDocuments: Maybe<Array<Maybe<Document>>>;
  /** Mark an attempted deposit to incomplete for backoffice efficiency */
  attemptedToIncompleteDeposit: Maybe<Deposit>;
  bdxAcceptedNDA: Maybe<Client>;
  bdxInvestmentChoice: Maybe<Client>;
  bdxInvestmentChoiceFinal: Maybe<Client>;
  bdxWaiverAccepted: Maybe<Client>;
  /** Client only mutation to begin a trx. */
  beginCryptoTransaction: Maybe<CryptoTransaction>;
  /** Client only mutation to begin a deposit; returns necessary details to make payment */
  beginDeposit: Maybe<BeginDepositResponse>;
  /** Cancel a deposit that was incomplete because of partial approval */
  cancelDeposit: Maybe<Deposit>;
  cancelGoldSubscription: Maybe<Account>;
  cancelMarketingEmails: Maybe<MarketingEmailType>;
  /** Cancel pending crypto trx */
  cancelOwnCryptoTransaction: Maybe<CryptoTransaction>;
  cancelPushNotifications: Maybe<PushNotificationType>;
  cancelRawSubscription: Maybe<RawSubscriptionType>;
  cancelVpsSubscription: Maybe<VpsSubscription>;
  cancelWithdrawal: Maybe<Withdrawal>;
  changeAdvancedSettingsToFollowersVisibility: Maybe<Client>;
  changeCompany: Maybe<Client>;
  changeCopyTradingKeepClientBonuses: Maybe<Client>;
  changeCopyTradingSkipClientReadonly: Maybe<Client>;
  changeCurrentCcProvider: Maybe<Scalars['Boolean']['output']>;
  changeDocumentsStatus: Maybe<Array<Maybe<Document>>>;
  changeRawSubscription: Maybe<RawSubscriptionType>;
  changeVpsBillingInfo: Maybe<VpsSubscriptionResponseType>;
  checkProtectedPasswordStrategy: Maybe<Scalars['Boolean']['output']>;
  claimReward: Maybe<RewardsType>;
  /** Clear account cache */
  clearAccountCache: Scalars['Boolean']['output'];
  /** Client start competition */
  clientCompetition: Maybe<Competition>;
  /** Client exit competition */
  clientExitCompetition: Maybe<Competition>;
  clientsExportSearch: Maybe<Scalars['Boolean']['output']>;
  /** Close position from AI Trading */
  closeAIPosition: Scalars['Int']['output'];
  closeAllTrades: Maybe<Scalars['Boolean']['output']>;
  completeAppointment: Maybe<Appointment>;
  /** Complete client crypto trx that was left incomplete because of a service error */
  completeCryptoTransaction: Maybe<CryptoTransaction>;
  /** Complete client deposit that was left incomplete because of a service error */
  completeDeposit: Maybe<Deposit>;
  /** Complete crypto trx that was left pending because of not enough balance */
  completeOwnCryptoTransaction: Maybe<CryptoTransaction>;
  /** Client can complete a partial deposit */
  completeOwnDeposit: Maybe<Deposit>;
  confirmAddressProposal: Maybe<AddressProposal>;
  confirmOwnEmail: Maybe<Client>;
  createAccount: Maybe<Account>;
  createBinaryOptionsAuthKey: Maybe<AuthKey>;
  createClient: Maybe<Client>;
  createCuboidAuthKey: Maybe<AuthKey>;
  createDeposit: Maybe<Deposit>;
  createDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  /** Client only mutation to create a deposit from a new token */
  createDepositWithNewPCT: Maybe<Deposit>;
  /** Client only mutation to create a deposit from an existing token */
  createDepositWithSavedPCT: Maybe<BeginDepositResponse>;
  /** Create Due Diligence */
  createDueDiligence: Maybe<DueDiligence>;
  createGoldSubscription: Maybe<Account>;
  createIBSingleSignOnLink: Maybe<IbLink>;
  /** Client to Client Fund Transfer */
  createInternalTransfer: Maybe<TransferFunds>;
  createLead: Maybe<Client>;
  createManualExecution: Maybe<ManualExecutionsType>;
  createNote: Maybe<Note>;
  createOwnAccount: Maybe<Account>;
  createOwnAppropTest: Maybe<AppropTest>;
  createOwnAppropTestV2: Maybe<AppropTest>;
  createOwnDocument: Maybe<Document>;
  createOwnSupportTicket: Maybe<Scalars['Boolean']['output']>;
  createPAMMSingleSignOnLink: Maybe<PammLink>;
  createRawSubscription: Maybe<SubscriptionResponseType>;
  /** Create Suitability Test */
  createSuitabilityTest: Maybe<SuitabilityTest>;
  createTradesmarterAuthKey: Maybe<AuthKey>;
  /** Inter-Account Fund Transfer */
  createTransferFunds: Maybe<TransferFunds>;
  createVpsSubscription: Maybe<VpsSubscriptionResponseType>;
  createWithdrawal: Maybe<Withdrawal>;
  /** Client only request to withdraw funds */
  createWithdrawalRequest: Maybe<Withdrawal>;
  /** Create multiple withdrawal requests */
  createWithdrawalRequests: Array<Maybe<Withdrawal>>;
  deleteAccount: Maybe<Account>;
  deleteAppointment: Maybe<Appointment>;
  /** Delete Blacklist */
  deleteBlacklist: Maybe<Scalars['Boolean']['output']>;
  deletePaymentOption: Maybe<Scalars['Boolean']['output']>;
  deleteRole: Maybe<Role>;
  /** Delete Shift */
  deleteShift: Maybe<Shift>;
  /** Deletes record of walkthrough given to client */
  deleteWalkthrough: Maybe<Scalars['Boolean']['output']>;
  depositsExportSearch: Maybe<Scalars['Boolean']['output']>;
  diagnosticVpsServer: Maybe<VpsServiceResponseType>;
  dismissAppointmentNotification: Maybe<Scalars['Int']['output']>;
  doClientGBGCheck: Maybe<Client>;
  doElectronicIDVerification: Maybe<ElectronicIdentityVerificationResultType>;
  /** Edit account */
  editAccount: Maybe<Account>;
  editFundingDocument: Maybe<PaymentMethod>;
  enableSwapFree: Maybe<SwapFreeType>;
  exportCompetitionData: Maybe<Scalars['String']['output']>;
  exportPerformanceFees: Maybe<Scalars['String']['output']>;
  exportWithdrawals: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Toggle opt in marketing */
  gdprToggleOptInMarketing: Maybe<Scalars['Boolean']['output']>;
  /** Toggle opt in SMS */
  gdprToggleOptInSms: Maybe<Scalars['Boolean']['output']>;
  /** Delete member */
  gdrpDeleteMember: Maybe<Scalars['String']['output']>;
  /** Delete member record by client request */
  gdrpDeleteOwnMember: Maybe<Scalars['String']['output']>;
  /** Download GDPR data for the viewer */
  gdrpDownloadData: Maybe<Scalars['String']['output']>;
  generateSecurityCode: Maybe<NewSecurityCode>;
  getSignedUrl: Maybe<GetSignedUrlType>;
  /** Starts application of a new deposit commissions on supplied affiliate account list */
  initiateApplyAffiliateCommissionsJob: Maybe<Scalars['Int']['output']>;
  /** Starts application of a new Dormant Fees on supplied account list */
  initiateApplyDormantFeeJob: Maybe<Scalars['Int']['output']>;
  /** Starts revertion of applied Dormant Fees on supplied account list */
  initiateRevertDormantFeeJob: Maybe<Scalars['Int']['output']>;
  linkPartnerWithRetailClient: Maybe<Client>;
  /** Open trade position */
  openTrade: Scalars['Int']['output'];
  postponeAlert: Maybe<Alert>;
  powerOffVpsServer: Maybe<VpsServiceResponseType>;
  powerOnVpsServer: Maybe<VpsServiceResponseType>;
  processAppropTest: Maybe<AppropTest>;
  /** Mutation for deposit queue to complete or reject a deposit */
  processDeposit: Maybe<Scalars['Boolean']['output']>;
  processDocument: Maybe<Document>;
  processProfileChange: Maybe<ProfileChange>;
  processWithdrawal: Maybe<Withdrawal>;
  /** Allow / Disallow Account to Provide Copy Trading */
  provideCopyTrading: Maybe<Scalars['Boolean']['output']>;
  publishSelectedTradingAlerts: Maybe<Scalars['Boolean']['output']>;
  reactivateRawSubscription: Maybe<RawSubscriptionType>;
  readRejectedDepositMethodIssue: Maybe<DepositMethodIssueVerification>;
  /** Reassign Sales Agent of Clients */
  reassignAgentClients: Scalars['Int']['output'];
  rebootVpsServer: Maybe<VpsServiceResponseType>;
  rebuildVpsServer: Maybe<VpsServiceResponseType>;
  /** Refill demo account */
  refillDemoBalance: Maybe<Scalars['Boolean']['output']>;
  refreshVpsServerDetails: Maybe<VpsSubscription>;
  /** Refund a deposit */
  refundDeposit: Maybe<Deposit>;
  reInstallVpsServer: Maybe<VpsServiceResponseType>;
  rejectAccount: Maybe<Scalars['Boolean']['output']>;
  /** Reject client trx from held, incomplete status */
  rejectCryptoTransaction: Maybe<CryptoTransaction>;
  /** Reject client deposit from held, incomplete status */
  rejectDeposit: Maybe<Deposit>;
  rejectDepositMethodIssueVerification: Maybe<DepositMethodIssueVerification>;
  /** Release client deposit that was held because of a missing kyc test */
  releaseDeposit: Maybe<Deposit>;
  /** Reject bonus */
  removeBonus: Maybe<Account>;
  removeDocument: Maybe<Document>;
  /** Remove a BDSwiss Raw account from fallback group */
  removeFromfallback: Maybe<Scalars['Boolean']['output']>;
  /** Client only mutation to remove a saved payment card token */
  removePCT: Maybe<Scalars['Boolean']['output']>;
  removePrize: Maybe<Prize>;
  removeTradingAccounts: Maybe<Scalars['Boolean']['output']>;
  resetClientPassword: Maybe<NewPassword>;
  resetUserPassword: Maybe<Scalars['Boolean']['output']>;
  resetVpsServerPassword: Maybe<VpsSubscription>;
  resolveAlert: Maybe<Alert>;
  resolveOrphanedFollower: Maybe<ClosedOrphanedFollowerType>;
  revealClientEmail: Maybe<Client>;
  revealClientPhone: Maybe<Client>;
  /** Revert a deposit */
  revertDeposit: Maybe<Deposit>;
  revertDocument: Maybe<Document>;
  revertDueDiligence: Maybe<DueDiligence>;
  revertWithdrawal: Maybe<Withdrawal>;
  saveMobileApTest: Maybe<AppropTest>;
  searchTool: Maybe<SearchToolOutputType>;
  sendBDXInfoEmail: Maybe<Scalars['Boolean']['output']>;
  sendDepartmentTemplateEmail: Maybe<Scalars['Boolean']['output']>;
  sendInvitation: Maybe<Scalars['Boolean']['output']>;
  sendMarketingEmails: Maybe<Scalars['Boolean']['output']>;
  sendPushNotifications: Maybe<PushNotificationType>;
  sendSmsVerification: Maybe<PhoneVerification>;
  setClientConversionStatus: Maybe<Client>;
  setClientKycStatus: Maybe<Client>;
  setClientTradingStatus: Maybe<Client>;
  setClientType: Maybe<Client>;
  setDocumentDistributionWeight: Maybe<Scalars['Boolean']['output']>;
  setLeadDistributionWeight: Maybe<Scalars['Boolean']['output']>;
  setMissingDocuments: Maybe<Client>;
  /** custom notice client signature and sign date */
  signClientNotice: Maybe<ClientResult>;
  signCompetitionFileUrl: Maybe<SignedUrl>;
  /** Upload Department Tempalate Email Attachment */
  signDepartmentTemplateEmailFileUrl: Maybe<SendDepartmentTemplateEmailFileUrlType>;
  /** Signs url for job input file */
  signInputFileUrl: Maybe<SignedJobInputUrl>;
  signPaymentLogoFileUrl: Maybe<SignedUrl>;
  signPrizeFileUrl: Maybe<SignedUrl>;
  /** Upload banner input file */
  signPushNotificationFileUrl: Maybe<PushNotificationsInputFileUrlType>;
  /** Upload Accounting Search Tool input file */
  signSearchToolFileUrl: Maybe<SearchToolInputFileUrlType>;
  /** Track Event input file */
  signTrackEventFileUrl: Maybe<TrackEventsInputFileUrlType>;
  signUploadUrl: Maybe<SignedUrl>;
  spoaAuthorize: Scalars['String']['output'];
  startCall: Maybe<CallLog>;
  startCompetitionVolumeTracking: Maybe<Scalars['Boolean']['output']>;
  startVpsServer: Maybe<VpsServiceResponseType>;
  stopVpsServer: Maybe<VpsServiceResponseType>;
  stopWatchingGmail: Maybe<Scalars['String']['output']>;
  /** Subscribe to AI Trading */
  subscribeToAI: Scalars['Int']['output'];
  takeOpenPositionsSnapshot: Maybe<Scalars['Boolean']['output']>;
  terminateGoldSubscription: Maybe<Account>;
  terminateRawSubscription: Maybe<RawSubscriptionType>;
  terminateVpsSubscription: Maybe<VpsSubscription>;
  toggleAdditionalBonus: Maybe<AdditionalBonusType>;
  toggleAllowAccountManually: Maybe<Client>;
  toggleAllowCopyTrading: Maybe<Client>;
  toggleAllowNewAccounts: Maybe<Client>;
  toggleAllowSocialTrading: Maybe<Client>;
  toggleAllowTransfers: Maybe<Client>;
  toggleAutochartist: Maybe<Client>;
  toggleAutochartistTools: Maybe<Client>;
  /** Enable or disable automatic affiliate commission debiting */
  toggleAutomaticCommissions: Maybe<Account>;
  toggleBDXCallCompleted: Maybe<Client>;
  toggleCanGrantSpoa: Maybe<Client>;
  toggleCanIbTransfer: Maybe<Client>;
  toggleDormantReactivation: Maybe<Client>;
  toggleEffectiveFTD: Maybe<Client>;
  toggleEmailConfirmed: Maybe<Client>;
  toggleFundingDocIsThirdPartyVerified: Maybe<PaymentMethod>;
  toggleFundManager: Maybe<Client>;
  toggleHasHotAssets: Maybe<Client>;
  toggleHasOpenComplaint: Maybe<Client>;
  toggleHasPortfolioManagement: Maybe<Client>;
  toggleHasRawAccount: Maybe<Client>;
  toggleHasTelegram: Maybe<Client>;
  toggleHasVipAccount: Maybe<Client>;
  toggleHideWDMethods: Maybe<Client>;
  toggleIgnoreAutoMigration: Maybe<Client>;
  toggleIgnoreIbTermination: Maybe<Client>;
  toggleIsDirectIB: Maybe<Client>;
  toggleIsPhoneVerified: Maybe<Client>;
  toggleManualWithdrawals: Maybe<Client>;
  togglePasswordProtectedStrategies: Maybe<Scalars['Boolean']['output']>;
  togglePasswordStrategy: Maybe<Scalars['Boolean']['output']>;
  toggleShowMasterStrategies: Maybe<Client>;
  toggleSurveys: Maybe<Client>;
  toggleSwapFree: Maybe<SwapFreeType>;
  toggleTopVip: Maybe<Client>;
  toggleTradableBonusPartner: Maybe<Client>;
  toggleTradeCompanion: Maybe<Client>;
  toggleTradingAcademyAccess: Maybe<Client>;
  toggleTradingCentral: Maybe<Client>;
  toggleUnderMonitoring: Maybe<Client>;
  toggleWithdrawalsApproval: Maybe<Client>;
  trackCopyEvent: Maybe<Client>;
  tradeCompanionCloseNotification: Maybe<Scalars['Boolean']['output']>;
  /** Unsubscribe from AI Trading */
  unsubscribeFromAI: Scalars['Int']['output'];
  /** Update the Name of the Account */
  updateAccountName: Maybe<Scalars['Int']['output']>;
  updateAffiliateCountries: Maybe<AffiliateCountriesType>;
  updateAgentCampaignsByLocation: Maybe<Scalars['Boolean']['output']>;
  updateAgentCountryToLanguageMapping: Maybe<Scalars['Boolean']['output']>;
  updateAlertActivityLog: Maybe<Alert>;
  updateCallLog: Maybe<CallLog>;
  updateCallLogNotes: Maybe<CallLog>;
  updateClientAccountChecks: Maybe<Client>;
  updateClientDetails: Maybe<Client>;
  updateClientPhones: Maybe<Client>;
  updateClientsExternalAgent: Maybe<Array<Maybe<Client>>>;
  updateClientsPotentialLevel: Maybe<Client>;
  updateClientsSalesAgent: Maybe<Array<Maybe<Client>>>;
  updateClientsSupportAgent: Maybe<Array<Maybe<Client>>>;
  updateDueDiligence: Maybe<DueDiligence>;
  /** Favourite assets */
  updateFavourites: Maybe<TradingConfigType>;
  updateGoldSubscriptionAmount: Maybe<Account>;
  updateLastEffectiveCall: Maybe<Scalars['Boolean']['output']>;
  updateOwnDetails: Maybe<ProfileChange>;
  updateOwnEmail: Maybe<Client>;
  updateOwnFCMToken: Maybe<Scalars['Boolean']['output']>;
  /** Change Forex account leverage */
  updateOwnLeverage: Scalars['Int']['output'];
  updateOwnLocale: Maybe<Client>;
  /** Change BDSwiss, Binary Options and Forex passwords for the viewer */
  updateOwnPassword: PasswordValidationResult;
  /** Update Performance Fee of the Account */
  updateOwnPerformanceFee: Maybe<Scalars['Int']['output']>;
  updateOwnSignupStep: Maybe<Client>;
  updatePermission: Maybe<Permission>;
  updateRawSubscriptionBillingInfo: Maybe<SubscriptionResponseType>;
  /** Check Event Attendance */
  updateSeminarAttendance: Maybe<Attendance>;
  updateThemePreference: Maybe<Client>;
  /** Update Withdrawal Fields */
  updateWithdrawal: Maybe<Withdrawal>;
  uploadStrategicPartners: Maybe<UploadStrategicPartnersReturnType>;
  upsertAffiliateClientNote: Maybe<Client>;
  upsertAffiliateUserName: Maybe<RegistrationCampaign>;
  upsertAppointment: Maybe<Appointment>;
  upsertArticle: Maybe<Article>;
  /** Edit/Create Blacklist */
  upsertBlacklist: Maybe<Blacklist>;
  /** Edit/Create Book Allocation */
  upsertBookAllocation: Maybe<BookAllocation>;
  upsertCampaign: Maybe<Campaign>;
  /** Edit/Create Client Notice */
  upsertClientNotice: Maybe<ClientNoticeType>;
  /** Edit/Create Competition */
  upsertCompetition: Maybe<Competition>;
  upsertDocument: Maybe<Document>;
  /** Add Document Translation */
  upsertDocumentTranslation: Maybe<DocumentTranslationType>;
  upsertGeneralClientNote: Maybe<Client>;
  upsertGeneralWithdrawalNote: Maybe<Client>;
  upsertPartnerCustomization: Maybe<PartnerCustomizationType>;
  /** Edit/Create Partner Loyalty */
  upsertPartnersLoyalty: Maybe<PartnersLoyalty>;
  /** Inserts/Updates Payment Options */
  upsertPaymentOption: Maybe<PaymentOptionType>;
  upsertPixel: Maybe<Pixel>;
  /** Edit/Create Prize for partner loyalty program */
  upsertPrize: Maybe<Prize>;
  upsertPromocode: Maybe<Promocode>;
  upsertRole: Maybe<Role>;
  upsertSalesClientNote: Maybe<Client>;
  /** Edit/Create Seminar */
  upsertSeminar: Maybe<Seminar>;
  /** Edit/Create Shifts */
  upsertShift: Maybe<Array<Maybe<Shift>>>;
  /** Add Tag */
  upsertTag: Maybe<Tag>;
  upsertTradingAlert: Maybe<TradingAlertType>;
  upsertUser: Maybe<User>;
  userChangeOwnPassword: Maybe<Scalars['Boolean']['output']>;
  verifyClientDetails: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  verifyPhone: Maybe<Scalars['Boolean']['output']>;
  /** Mutation for verifying skrill account */
  verifySkrillAccount: Maybe<Scalars['String']['output']>;
  watchGmail: Maybe<Scalars['String']['output']>;
  /** Register client to webinar */
  webinarUrl: Maybe<Webinar>;
  /** Withdrawals auto process prepare request */
  withdrawalAutoProcess: Maybe<WithdrawalAutoProcessType>;
  withdrawalsExportSearch: Maybe<Scalars['Boolean']['output']>;
};


/** Available mutations */
export type BdSwissMutationsAcknowledgeClientMessageArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsAddAffiliateCountriesArgs = {
  clientId: Scalars['Int']['input'];
  countriesPromoted: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Available mutations */
export type BdSwissMutationsAddBonusArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsAddClientNoticeAcknowledgementArgs = {
  noticeId: Scalars['Int']['input'];
  noticeRef: InputMaybe<Scalars['String']['input']>;
  type: ClientNoticeAcknowlegdementTypeType;
};


/** Available mutations */
export type BdSwissMutationsAddCopyTradingArgs = {
  ghostCopierId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsAddCryptoWalletAddressArgs = {
  accountId: Scalars['Int']['input'];
  depositWalletAddress: InputMaybe<Scalars['String']['input']>;
  walletAddress: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsAddMetadataToAccountArgs = {
  accountId: Scalars['Int']['input'];
  metadata: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsAddMetadataToClientArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
  metadata: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsAddWalkthroughArgs = {
  clientId: Scalars['Int']['input'];
  walkthroughType: WalkthroughType;
};


/** Available mutations */
export type BdSwissMutationsApproveAccountArgs = {
  accountId: Scalars['Int']['input'];
  metadata: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsApproveDepositMethodIssueVerificationArgs = {
  depositMethodIssueVerificationId: Scalars['Int']['input'];
  internalRemark: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsAssignClientToAffiliateArgs = {
  affiliateId: Scalars['Int']['input'];
  campaignId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  trackingCode: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsAssignDocumentsArgs = {
  documentIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  userId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsAttemptedToIncompleteDepositArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsBdxAcceptedNdaArgs = {
  bdxAcceptedNDA: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsBdxInvestmentChoiceArgs = {
  bdxInvestmentChoice: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsBdxInvestmentChoiceFinalArgs = {
  bdxInvestmentChoiceFinal: Scalars['String']['input'];
  clientId: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsBdxWaiverAcceptedArgs = {
  bdxWaiverAccepted: Scalars['Boolean']['input'];
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsBeginCryptoTransactionArgs = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  args: InputMaybe<Scalars['String']['input']>;
  destinationWallet: InputMaybe<Scalars['String']['input']>;
  merchantId: InputMaybe<Scalars['Int']['input']>;
  type: CryptoTransactionTypeType;
};


/** Available mutations */
export type BdSwissMutationsBeginDepositArgs = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  args: InputMaybe<Scalars['String']['input']>;
  ccTempToken: InputMaybe<Scalars['String']['input']>;
  frontend: Frontend;
  vendor: PermittedClientDepositVendor;
};


/** Available mutations */
export type BdSwissMutationsCancelDepositArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCancelGoldSubscriptionArgs = {
  accountId: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsCancelMarketingEmailsArgs = {
  id: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCancelOwnCryptoTransactionArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCancelPushNotificationsArgs = {
  id: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCancelRawSubscriptionArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCancelVpsSubscriptionArgs = {
  clientId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  immediate: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsCancelWithdrawalArgs = {
  withdrawalId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsChangeAdvancedSettingsToFollowersVisibilityArgs = {
  clientId: Scalars['Int']['input'];
  showAdvancedSettingsToFollowers: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsChangeCompanyArgs = {
  clientId: Scalars['Int']['input'];
  newCompany: Company;
};


/** Available mutations */
export type BdSwissMutationsChangeCopyTradingKeepClientBonusesArgs = {
  clientId: Scalars['Int']['input'];
  copyTradingKeepClientBonuses: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsChangeCopyTradingSkipClientReadonlyArgs = {
  clientId: Scalars['Int']['input'];
  copyTradingSkipClientReadonly: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsChangeDocumentsStatusArgs = {
  documentIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status: DocumentStatus;
};


/** Available mutations */
export type BdSwissMutationsChangeRawSubscriptionArgs = {
  accountId: Scalars['Int']['input'];
  forceChange: InputMaybe<Scalars['Boolean']['input']>;
  plan: RawSubscriptionPlanType;
};


/** Available mutations */
export type BdSwissMutationsChangeVpsBillingInfoArgs = {
  clientId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  tokenId: InputMaybe<Scalars['String']['input']>;
  tokenThreeD: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCheckProtectedPasswordStrategyArgs = {
  accountId: Scalars['Int']['input'];
  password: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsClaimRewardArgs = {
  accountId: Scalars['Int']['input'];
  rewardType: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsClearAccountCacheArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsClientCompetitionArgs = {
  acceptTerms: InputMaybe<Scalars['String']['input']>;
  accountId: InputMaybe<Scalars['Int']['input']>;
  competitionId: InputMaybe<Scalars['Int']['input']>;
  memberId: InputMaybe<Scalars['Int']['input']>;
  nickname: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsClientExitCompetitionArgs = {
  accountId: InputMaybe<Scalars['Int']['input']>;
  competitionId: InputMaybe<Scalars['Int']['input']>;
  memberId: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsClientsExportSearchArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  searchArgs: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCloseAiPositionArgs = {
  accountId: Scalars['Int']['input'];
  ticket: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCloseAllTradesArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCompleteAppointmentArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCompleteCryptoTransactionArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCompleteDepositArgs = {
  amount: InputMaybe<Scalars['Float']['input']>;
  bankWireCompletedBank: InputMaybe<Bank>;
  dateReceived: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCompleteOwnCryptoTransactionArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCompleteOwnDepositArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsConfirmAddressProposalArgs = {
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsConfirmOwnEmailArgs = {
  token: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateAccountArgs = {
  accountSubtype: InputMaybe<AccountSubtype>;
  accountType: AccountType;
  affiliateId: InputMaybe<Scalars['Int']['input']>;
  clientId: Scalars['Int']['input'];
  currency: NewAccountCurrency;
  depositWalletAddress: InputMaybe<Scalars['String']['input']>;
  ibId: InputMaybe<Scalars['String']['input']>;
  leverage: InputMaybe<Scalars['Int']['input']>;
  parentIbId: InputMaybe<Scalars['String']['input']>;
  server: InputMaybe<Server>;
  walletAddress: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateBinaryOptionsAuthKeyArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateClientArgs = {
  address: InputMaybe<ClientAddressInput>;
  affiliateId: InputMaybe<Scalars['Int']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  canEditLeverage: InputMaybe<Scalars['Boolean']['input']>;
  company: InputMaybe<Company>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  kycStatus: InputMaybe<KycStatus>;
  lastName: Scalars['String']['input'];
  locale: InputMaybe<Locale>;
  password: InputMaybe<Scalars['String']['input']>;
  phone: InputMaybe<Scalars['String']['input']>;
  whiteLabel: InputMaybe<WhiteLabel>;
};


/** Available mutations */
export type BdSwissMutationsCreateCuboidAuthKeyArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateDepositArgs = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  currency: Currency;
  meta: InputMaybe<Scalars['String']['input']>;
  paymentFields: InputMaybe<DepositPaymentFieldsInputType>;
  productReceipt: InputMaybe<Scalars['String']['input']>;
  receipt: InputMaybe<Scalars['String']['input']>;
  vendor: DepositVendorsType;
};


/** Available mutations */
export type BdSwissMutationsCreateDepositMethodIssueVerificationArgs = {
  accountId: Scalars['Int']['input'];
  cardNumber: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['Int']['input'];
  comment: InputMaybe<Scalars['String']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  paymentMethodOptionId: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateDepositWithNewPctArgs = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  bin: Scalars['String']['input'];
  expiryMonth: Scalars['Int']['input'];
  expiryYear: Scalars['Int']['input'];
  lastFour: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateDepositWithSavedPctArgs = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  args: InputMaybe<Scalars['String']['input']>;
  frontend: Frontend;
  paymentCardTokenId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateDueDiligenceArgs = {
  answers: InputMaybe<DueDiligenceAnswersInputType>;
  clientId: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateGoldSubscriptionArgs = {
  accountId: Scalars['Int']['input'];
  customAmount: InputMaybe<Scalars['Float']['input']>;
  plan: GoldSubscriptionPlan;
  tokenId: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateIbSingleSignOnLinkArgs = {
  accountId: Scalars['Int']['input'];
  ibId: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateInternalTransferArgs = {
  amount: Scalars['Float']['input'];
  args: InputMaybe<Scalars['String']['input']>;
  fromAccountId: Scalars['Int']['input'];
  toAccountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateLeadArgs = {
  address: InputMaybe<ClientAddressInput>;
  bdswissPartner: InputMaybe<Scalars['String']['input']>;
  clientType: InputMaybe<ClientType>;
  company: InputMaybe<Company>;
  email: InputMaybe<Scalars['String']['input']>;
  firstName: InputMaybe<Scalars['String']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  otherCompany: InputMaybe<Scalars['String']['input']>;
  phone: InputMaybe<Scalars['String']['input']>;
  priority: InputMaybe<Scalars['String']['input']>;
  salesAgentId: InputMaybe<Scalars['Int']['input']>;
  skypeId: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  website: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateManualExecutionArgs = {
  createdBy: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  params: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateNoteArgs = {
  bonusOfferId: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  content: InputMaybe<Scalars['String']['input']>;
  depositId: InputMaybe<Scalars['Int']['input']>;
  documentId: InputMaybe<Scalars['Int']['input']>;
  fileKey: InputMaybe<Scalars['String']['input']>;
  fileName: InputMaybe<Scalars['String']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateOwnAccountArgs = {
  accountSubtype: InputMaybe<AccountSubtype>;
  accountType: ClientOpenPermittedAccountTypeType;
  args: InputMaybe<Scalars['String']['input']>;
  bonus: InputMaybe<Scalars['String']['input']>;
  currency: NewAccountCurrency;
  leverage: InputMaybe<Scalars['Int']['input']>;
  password: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateOwnAppropTestArgs = {
  answers: AppropTestAnswersInput;
};


/** Available mutations */
export type BdSwissMutationsCreateOwnAppropTestV2Args = {
  answers: AppropTestAnswersInput;
};


/** Available mutations */
export type BdSwissMutationsCreateOwnDocumentArgs = {
  cardNumber: InputMaybe<Scalars['String']['input']>;
  internalTag: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  paymentMethodId: InputMaybe<Scalars['Int']['input']>;
  type: DocumentType;
};


/** Available mutations */
export type BdSwissMutationsCreateOwnSupportTicketArgs = {
  attachments: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callbackDate: InputMaybe<Scalars['DateTime']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  message: InputMaybe<Scalars['String']['input']>;
  method: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  phone: InputMaybe<Scalars['String']['input']>;
  preferableLanguage: InputMaybe<Scalars['String']['input']>;
  to: InputMaybe<Scalars['String']['input']>;
  topic: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreatePammSingleSignOnLinkArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateRawSubscriptionArgs = {
  accountId: Scalars['Int']['input'];
  plan: RawSubscriptionPlanType;
  tokenId: Scalars['String']['input'];
  tokenThreeD: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateSuitabilityTestArgs = {
  answers: InputMaybe<SuitabilityTestAnswersInputType>;
  currency: InputMaybe<Scalars['String']['input']>;
  subTypeSelection: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateTradesmarterAuthKeyArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsCreateTransferFundsArgs = {
  amount: Scalars['Float']['input'];
  args: InputMaybe<Scalars['String']['input']>;
  fromAccountId: Scalars['Int']['input'];
  fromClientId: InputMaybe<Scalars['Int']['input']>;
  toAccountId: Scalars['Int']['input'];
  toClientId: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateVpsSubscriptionArgs = {
  billingCycle: InputMaybe<VpsSubscriptionBillingCycle>;
  clientId: Scalars['Int']['input'];
  domainName: InputMaybe<Scalars['String']['input']>;
  paymentMethod: InputMaybe<VpsSubscriptionPaymentMethod>;
  planName: Scalars['String']['input'];
  tokenId: InputMaybe<Scalars['String']['input']>;
  tokenThreeD: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateWithdrawalArgs = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  paymentFields: WithdrawalPaymentFieldsInputType;
  paymentVendor: InputMaybe<WithdrawalPaymentVendorsType>;
  type: PermittedWithdrawalType;
  withdrawalReason: InputMaybe<WithdrawalReasonsType>;
  withdrawalReasonText: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateWithdrawalRequestArgs = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  paymentFields: WithdrawalPaymentFieldsInputType;
  paymentVendor: WithdrawalPaymentVendorsType;
  platform: Scalars['String']['input'];
  withdrawalReason: InputMaybe<WithdrawalReasonsType>;
  withdrawalReasonText: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsCreateWithdrawalRequestsArgs = {
  items: Array<InputMaybe<CreateWithdrawalRequestInputType>>;
};


/** Available mutations */
export type BdSwissMutationsDeleteAccountArgs = {
  accountId: Scalars['Int']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
  rejectionReasonCode: InputMaybe<DeleteAccountReasonCode>;
};


/** Available mutations */
export type BdSwissMutationsDeleteAppointmentArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsDeleteBlacklistArgs = {
  id: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsDeletePaymentOptionArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsDeleteRoleArgs = {
  id: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsDeleteShiftArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsDeleteWalkthroughArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsDepositsExportSearchArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  searchArgs: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsDiagnosticVpsServerArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsDismissAppointmentNotificationArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsDoClientGbgCheckArgs = {
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsDoElectronicIdVerificationArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
  nationalId: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsEditAccountArgs = {
  accountId: Scalars['Int']['input'];
  accountName: InputMaybe<Scalars['String']['input']>;
  approved: InputMaybe<Scalars['Boolean']['input']>;
  enablePartnerNotifications: InputMaybe<Scalars['Boolean']['input']>;
  hidden: InputMaybe<Scalars['Boolean']['input']>;
  ibId: InputMaybe<Scalars['String']['input']>;
  leverage: InputMaybe<Scalars['Int']['input']>;
  mobile: InputMaybe<Scalars['Boolean']['input']>;
  parentIbId: InputMaybe<Scalars['String']['input']>;
  performanceFee: InputMaybe<Scalars['Float']['input']>;
  readOnly: InputMaybe<Scalars['Boolean']['input']>;
  readOnlyDealer: InputMaybe<Scalars['Boolean']['input']>;
  readOnlyNote: InputMaybe<Scalars['String']['input']>;
  swapFree: InputMaybe<Scalars['Boolean']['input']>;
};


/** Available mutations */
export type BdSwissMutationsEditFundingDocumentArgs = {
  confirmed: InputMaybe<Scalars['Boolean']['input']>;
  fundingDocId: Scalars['Int']['input'];
  pendingNotes: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsExportCompetitionDataArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsExportPerformanceFeesArgs = {
  amountFrom: InputMaybe<Scalars['Float']['input']>;
  amountTo: InputMaybe<Scalars['Float']['input']>;
  creationTimeFrom: InputMaybe<Scalars['DateTime']['input']>;
  creationTimeTo: InputMaybe<Scalars['DateTime']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsExportWithdrawalsArgs = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  onlyBannedCountries: Scalars['Boolean']['input'];
  statuses: Array<InputMaybe<WithdrawalStatusesType>>;
};


/** Available mutations */
export type BdSwissMutationsGdprToggleOptInMarketingArgs = {
  value: InputMaybe<Scalars['Boolean']['input']>;
};


/** Available mutations */
export type BdSwissMutationsGdprToggleOptInSmsArgs = {
  value: InputMaybe<Scalars['Boolean']['input']>;
};


/** Available mutations */
export type BdSwissMutationsGdrpDeleteMemberArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsGdrpDeleteOwnMemberArgs = {
  password: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsGenerateSecurityCodeArgs = {
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsInitiateApplyAffiliateCommissionsJobArgs = {
  accountType: AccountType;
  executeAsBonus: Scalars['Boolean']['input'];
  inputFileUrl: Scalars['String']['input'];
  type: InputMaybe<InactivityFeeType>;
};


/** Available mutations */
export type BdSwissMutationsInitiateApplyDormantFeeJobArgs = {
  accountType: AccountType;
  executeAsBonus: Scalars['Boolean']['input'];
  inputFileUrl: Scalars['String']['input'];
  type: InputMaybe<InactivityFeeType>;
};


/** Available mutations */
export type BdSwissMutationsInitiateRevertDormantFeeJobArgs = {
  accountType: AccountType;
  executeAsBonus: Scalars['Boolean']['input'];
  inputFileUrl: Scalars['String']['input'];
  type: InputMaybe<InactivityFeeType>;
};


/** Available mutations */
export type BdSwissMutationsLinkPartnerWithRetailClientArgs = {
  clientId: Scalars['Int']['input'];
  linkedClientId: Scalars['UnsetOrInt']['input'];
};


/** Available mutations */
export type BdSwissMutationsOpenTradeArgs = {
  accountId: Scalars['Int']['input'];
  cmd: Scalars['String']['input'];
  symbol: Scalars['String']['input'];
  volume: Scalars['Float']['input'];
};


/** Available mutations */
export type BdSwissMutationsPostponeAlertArgs = {
  activityLog: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  postponeUntil: Scalars['DateTime']['input'];
};


/** Available mutations */
export type BdSwissMutationsPowerOffVpsServerArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsPowerOnVpsServerArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsProcessAppropTestArgs = {
  id: Scalars['Int']['input'];
  rejectionReason: InputMaybe<Scalars['String']['input']>;
  rejectionReasonCode: InputMaybe<AppropTestRejectionReasonCode>;
  result: ProcessAppropTestResult;
};


/** Available mutations */
export type BdSwissMutationsProcessDepositArgs = {
  id: Scalars['Int']['input'];
  receipt: InputMaybe<Scalars['String']['input']>;
  result: ProcessDepositResult;
};


/** Available mutations */
export type BdSwissMutationsProcessDocumentArgs = {
  id: Scalars['Int']['input'];
  rejectionReason: InputMaybe<Scalars['String']['input']>;
  rejectionReasonCode: InputMaybe<DocumentRejectionReasonCode>;
  result: ProcessDocumentResult;
  sendRejectionEmail: InputMaybe<Scalars['Boolean']['input']>;
};


/** Available mutations */
export type BdSwissMutationsProcessProfileChangeArgs = {
  comments: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  rejectionReason: InputMaybe<Scalars['String']['input']>;
  result: ProcessProfileChangeResult;
};


/** Available mutations */
export type BdSwissMutationsProcessWithdrawalArgs = {
  id: Scalars['Int']['input'];
  meta: InputMaybe<Scalars['String']['input']>;
  pendingReasonCode: InputMaybe<WithdrawalPendingReasonCode>;
  rejectionReason: InputMaybe<Scalars['String']['input']>;
  rejectionReasonCode: InputMaybe<WithdrawalRejectionReasonCode>;
  result: ProcessWithdrawalResult;
};


/** Available mutations */
export type BdSwissMutationsProvideCopyTradingArgs = {
  accountId: Scalars['Int']['input'];
  provideCopyTrading: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsPublishSelectedTradingAlertsArgs = {
  tradingAlertIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** Available mutations */
export type BdSwissMutationsReactivateRawSubscriptionArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsReadRejectedDepositMethodIssueArgs = {
  depositMethodIssueVerificationId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsReassignAgentClientsArgs = {
  agentId: InputMaybe<Scalars['Int']['input']>;
  clientIds: InputMaybe<Scalars['String']['input']>;
  currentSalesAgentId: InputMaybe<Scalars['Int']['input']>;
  searchArgs: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<ConversionStatus>;
};


/** Available mutations */
export type BdSwissMutationsRebootVpsServerArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRebuildVpsServerArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRefillDemoBalanceArgs = {
  login: Scalars['String']['input'];
  topUpAmount: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsRefreshVpsServerDetailsArgs = {
  id: Scalars['Int']['input'];
  serviceId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRefundDepositArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsReInstallVpsServerArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRejectAccountArgs = {
  accountId: Scalars['Int']['input'];
  metadata: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsRejectCryptoTransactionArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRejectDepositArgs = {
  id: Scalars['Int']['input'];
  rejectionReason: InputMaybe<Scalars['String']['input']>;
  rejectionReasonKey: InputMaybe<DepositRejectionReasonCode>;
};


/** Available mutations */
export type BdSwissMutationsRejectDepositMethodIssueVerificationArgs = {
  depositMethodIssueVerificationId: Scalars['Int']['input'];
  internalRemark: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsReleaseDepositArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRemoveBonusArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRemoveDocumentArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRemoveFromfallbackArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRemovePctArgs = {
  paymentCardTokenId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRemovePrizeArgs = {
  id: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsRemoveTradingAccountsArgs = {
  accountIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsResetClientPasswordArgs = {
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsResetUserPasswordArgs = {
  userId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsResetVpsServerPasswordArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsResolveAlertArgs = {
  comment: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  reason: ResolveAlertReasonType;
};


/** Available mutations */
export type BdSwissMutationsResolveOrphanedFollowerArgs = {
  clientAccountId: Scalars['Int']['input'];
  providerAccountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRevealClientEmailArgs = {
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRevealClientPhoneArgs = {
  clientId: Scalars['Int']['input'];
  profileChangeId: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsRevertDepositArgs = {
  amount: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRevertDocumentArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRevertDueDiligenceArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsRevertWithdrawalArgs = {
  amount: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsSaveMobileApTestArgs = {
  answers: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsSearchToolArgs = {
  csvLink: InputMaybe<Scalars['String']['input']>;
  inputField: InputMaybe<Scalars['String']['input']>;
  outputFields: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Available mutations */
export type BdSwissMutationsSendBdxInfoEmailArgs = {
  action: Scalars['String']['input'];
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsSendDepartmentTemplateEmailArgs = {
  clientId: Scalars['Int']['input'];
  imageUrl: InputMaybe<Scalars['String']['input']>;
  selectedTemplate: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsSendInvitationArgs = {
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsSendMarketingEmailsArgs = {
  clientCount: InputMaybe<Scalars['Int']['input']>;
  clientIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchParams: InputMaybe<Scalars['String']['input']>;
  template: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  unsubscribeGroup: InputMaybe<Scalars['String']['input']>;
  unsubscribeGroupId: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsSendPushNotificationsArgs = {
  clientIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  csvLink: InputMaybe<Scalars['String']['input']>;
  defaultLanguage: Language;
  messages: Array<InputMaybe<PushNotificationMessageType>>;
  searchParams: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<PushNotificationsTypesType>;
};


/** Available mutations */
export type BdSwissMutationsSendSmsVerificationArgs = {
  phone: Scalars['String']['input'];
  type: InputMaybe<PhoneVerificationType>;
};


/** Available mutations */
export type BdSwissMutationsSetClientConversionStatusArgs = {
  id: Scalars['Int']['input'];
  status: ConversionStatus;
};


/** Available mutations */
export type BdSwissMutationsSetClientKycStatusArgs = {
  id: Scalars['Int']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
  rejectionReasonCode: InputMaybe<KycRejectionReason>;
  status: KycStatus;
};


/** Available mutations */
export type BdSwissMutationsSetClientTradingStatusArgs = {
  id: Scalars['Int']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
  rejectionReasonCode: InputMaybe<TradingStatusRejectionReasonCode>;
  status: TradingStatus;
};


/** Available mutations */
export type BdSwissMutationsSetClientTypeArgs = {
  clientType: InputMaybe<ClientType>;
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsSetDocumentDistributionWeightArgs = {
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
  weight: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsSetLeadDistributionWeightArgs = {
  assigned: InputMaybe<Scalars['Int']['input']>;
  ftdMax: InputMaybe<Scalars['Int']['input']>;
  ftdMin: InputMaybe<Scalars['Int']['input']>;
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
  weight: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsSetMissingDocumentsArgs = {
  clientId: Scalars['Int']['input'];
  documentType: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsSignClientNoticeArgs = {
  noticeId: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  signDate: Scalars['DateTime']['input'];
};


/** Available mutations */
export type BdSwissMutationsSignCompetitionFileUrlArgs = {
  competitionName: Scalars['String']['input'];
  filename: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsSignInputFileUrlArgs = {
  jobType: JobType;
};


/** Available mutations */
export type BdSwissMutationsSignPaymentLogoFileUrlArgs = {
  filename: InputMaybe<Scalars['String']['input']>;
  paymentProvider: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsSignPrizeFileUrlArgs = {
  filename: InputMaybe<Scalars['String']['input']>;
  prizeName: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsSignTrackEventFileUrlArgs = {
  seminarCode: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsSignUploadUrlArgs = {
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsSpoaAuthorizeArgs = {
  acceptedSpoaBonusTerms: InputMaybe<Scalars['Boolean']['input']>;
  isAuthorized: Scalars['Boolean']['input'];
  remoteClientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsStartCallArgs = {
  clientId: Scalars['Int']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<PhoneType>;
};


/** Available mutations */
export type BdSwissMutationsStartCompetitionVolumeTrackingArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsStartVpsServerArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsStopVpsServerArgs = {
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsStopWatchingGmailArgs = {
  userId: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsSubscribeToAiArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsTakeOpenPositionsSnapshotArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsTerminateGoldSubscriptionArgs = {
  accountId: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsTerminateRawSubscriptionArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsTerminateVpsSubscriptionArgs = {
  clientId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleAdditionalBonusArgs = {
  additionalBonus: Scalars['Boolean']['input'];
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleAllowAccountManuallyArgs = {
  accounts: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleAllowCopyTradingArgs = {
  allowCopyTrading: Scalars['Boolean']['input'];
  clientId: Scalars['Int']['input'];
  force: InputMaybe<Scalars['Boolean']['input']>;
};


/** Available mutations */
export type BdSwissMutationsToggleAllowNewAccountsArgs = {
  allowNewAccounts: Scalars['Boolean']['input'];
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleAllowSocialTradingArgs = {
  allowSocialTrading: Scalars['Boolean']['input'];
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleAllowTransfersArgs = {
  allowTransfers: Scalars['Boolean']['input'];
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleAutochartistArgs = {
  clientId: Scalars['Int']['input'];
  toggleAutochartist: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleAutochartistToolsArgs = {
  clientId: Scalars['Int']['input'];
  toggleAutochartist: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistCoelationEmail: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistEmails: InputMaybe<Scalars['Boolean']['input']>;
  toggleAutochartistPlugin: InputMaybe<Scalars['Boolean']['input']>;
};


/** Available mutations */
export type BdSwissMutationsToggleAutomaticCommissionsArgs = {
  accountId: Scalars['Int']['input'];
  automaticCommissions: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleBdxCallCompletedArgs = {
  clientId: Scalars['Int']['input'];
  toggleBDXCallCompleted: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleCanGrantSpoaArgs = {
  canGrantSpoa: Scalars['Boolean']['input'];
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleCanIbTransferArgs = {
  canIbTransfer: Scalars['Boolean']['input'];
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleDormantReactivationArgs = {
  clientId: Scalars['Int']['input'];
  dormantReactivation: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleEffectiveFtdArgs = {
  clientId: Scalars['Int']['input'];
  effectiveFTD: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleEmailConfirmedArgs = {
  clientId: Scalars['Int']['input'];
  emailConfirmed: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleFundingDocIsThirdPartyVerifiedArgs = {
  isThirdPartyVerified: Scalars['Boolean']['input'];
  paymentMethodId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleFundManagerArgs = {
  clientId: Scalars['Int']['input'];
  fundManager: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleHasHotAssetsArgs = {
  clientId: Scalars['Int']['input'];
  hasHotAssets: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleHasOpenComplaintArgs = {
  clientId: Scalars['Int']['input'];
  hasOpenComplaint: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleHasPortfolioManagementArgs = {
  clientId: Scalars['Int']['input'];
  hasPortfolioManagement: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleHasRawAccountArgs = {
  clientId: Scalars['Int']['input'];
  hasRawAccount: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleHasTelegramArgs = {
  clientId: Scalars['Int']['input'];
  hasTelegram: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleHasVipAccountArgs = {
  clientId: Scalars['Int']['input'];
  hasVipAccount: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleHideWdMethodsArgs = {
  clientId: Scalars['Int']['input'];
  hideWDMethods: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleIgnoreAutoMigrationArgs = {
  clientId: Scalars['Int']['input'];
  ignoreAutoMigration: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleIgnoreIbTerminationArgs = {
  clientId: Scalars['Int']['input'];
  ignoreIbTermination: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleIsDirectIbArgs = {
  clientId: Scalars['Int']['input'];
  isDirectIB: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleIsPhoneVerifiedArgs = {
  clientId: Scalars['Int']['input'];
  isPhoneVerified: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleManualWithdrawalsArgs = {
  clientId: Scalars['Int']['input'];
  manualWithdrawals: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsTogglePasswordProtectedStrategiesArgs = {
  clientId: Scalars['Int']['input'];
  togglePasswordProtected: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsTogglePasswordStrategyArgs = {
  accountId: Scalars['Int']['input'];
  password: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsToggleShowMasterStrategiesArgs = {
  clientId: Scalars['Int']['input'];
  showMasterStrategies: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleSurveysArgs = {
  clientId: Scalars['Int']['input'];
  hasPreSurvey: InputMaybe<Scalars['Boolean']['input']>;
  hasSurvey: InputMaybe<Scalars['Boolean']['input']>;
};


/** Available mutations */
export type BdSwissMutationsToggleSwapFreeArgs = {
  clientId: Scalars['Int']['input'];
  swapFree: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleTopVipArgs = {
  clientId: Scalars['Int']['input'];
  topVip: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleTradableBonusPartnerArgs = {
  clientId: Scalars['Int']['input'];
  tradableBonusPartner: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleTradeCompanionArgs = {
  clientId: Scalars['Int']['input'];
  toggleTradeCompanion: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleTradingAcademyAccessArgs = {
  clientId: Scalars['Int']['input'];
  hasTradingAcademyAccess: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleTradingCentralArgs = {
  clientId: Scalars['Int']['input'];
  tradingCentralEnabled: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsToggleUnderMonitoringArgs = {
  clientId: Scalars['Int']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
  underMonitoring: Scalars['Boolean']['input'];
  underMonitoringReasonCode: InputMaybe<UnderMonitoringReason>;
};


/** Available mutations */
export type BdSwissMutationsToggleWithdrawalsApprovalArgs = {
  clientId: Scalars['Int']['input'];
  hasDisabledWithdrawals: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsTrackCopyEventArgs = {
  clientId: Scalars['Int']['input'];
  field: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsUnsubscribeFromAiArgs = {
  accountId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateAccountNameArgs = {
  accountId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateAffiliateCountriesArgs = {
  clientId: Scalars['Int']['input'];
  countriesPromoted: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Available mutations */
export type BdSwissMutationsUpdateAgentCampaignsByLocationArgs = {
  campaigns: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSubCampaign: InputMaybe<Scalars['Boolean']['input']>;
  locationId: InputMaybe<Scalars['Int']['input']>;
  removeAssociation: InputMaybe<Scalars['Boolean']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpdateAgentCountryToLanguageMappingArgs = {
  mappings: Array<InputMaybe<UpdateCountryAgentLanguageMappingInput>>;
};


/** Available mutations */
export type BdSwissMutationsUpdateAlertActivityLogArgs = {
  activityLog: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateCallLogArgs = {
  id: Scalars['Int']['input'];
  monitoring: Scalars['String']['input'];
  needsComplianceCheck: Scalars['Boolean']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateCallLogNotesArgs = {
  id: Scalars['Int']['input'];
  notes: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpdateClientAccountChecksArgs = {
  accountChecks: InputMaybe<AccountChecksInput>;
  canEditLeverage: InputMaybe<YesNo>;
  globalQuestionnaire: InputMaybe<GlobalQuestionnaireInput>;
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateClientDetailsArgs = {
  address: InputMaybe<ClientAddressInput>;
  bdswissPartner: InputMaybe<Scalars['String']['input']>;
  birthday: InputMaybe<Scalars['String']['input']>;
  companyName: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber: InputMaybe<Scalars['String']['input']>;
  correspondenceAddress: InputMaybe<ClientAddressInput>;
  email: InputMaybe<Scalars['String']['input']>;
  firstName: InputMaybe<Scalars['String']['input']>;
  gender: InputMaybe<Gender>;
  globalQuestionnaire: InputMaybe<GlobalQuestionnaireInput>;
  id: Scalars['Int']['input'];
  identityOfTheThirdParty: InputMaybe<EconomicProfileDocumentInput>;
  language: InputMaybe<Language>;
  lastName: InputMaybe<Scalars['String']['input']>;
  locale: InputMaybe<Locale>;
  mifirId: InputMaybe<Scalars['String']['input']>;
  mifirType: InputMaybe<Scalars['String']['input']>;
  nationality: InputMaybe<Nationality>;
  nickname: InputMaybe<Scalars['String']['input']>;
  optInMarketing: InputMaybe<Scalars['Boolean']['input']>;
  optInSms: InputMaybe<Scalars['Boolean']['input']>;
  otherCompany: InputMaybe<Scalars['String']['input']>;
  passportNumber: InputMaybe<Scalars['String']['input']>;
  personalId: InputMaybe<PersonalIdInputType>;
  phone: InputMaybe<Scalars['String']['input']>;
  previousNames: InputMaybe<Scalars['String']['input']>;
  priority: InputMaybe<Scalars['String']['input']>;
  proofsOfIdentityFiamlRegulations: InputMaybe<EconomicProfileDocumentInput>;
  properties: InputMaybe<ClientPropertiesInput>;
  relationshipThirdParty: InputMaybe<EconomicProfileDocumentInput>;
  secondaryEmails: InputMaybe<SecondaryEmailInput>;
  secondaryPhones: InputMaybe<SecondaryPhoneInput>;
  skypeId: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  vps: InputMaybe<Scalars['Boolean']['input']>;
  website: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpdateClientPhonesArgs = {
  id: Scalars['Int']['input'];
  phone: InputMaybe<Scalars['String']['input']>;
  secondaryPhones: InputMaybe<SecondaryPhoneInput>;
};


/** Available mutations */
export type BdSwissMutationsUpdateClientsExternalAgentArgs = {
  agentId: Scalars['UnsetOrInt']['input'];
  clientsIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** Available mutations */
export type BdSwissMutationsUpdateClientsPotentialLevelArgs = {
  clientId: Scalars['Int']['input'];
  potentialLevel: InputMaybe<PotentialLevel>;
};


/** Available mutations */
export type BdSwissMutationsUpdateClientsSalesAgentArgs = {
  agentId: Scalars['UnsetOrInt']['input'];
  clientsIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** Available mutations */
export type BdSwissMutationsUpdateClientsSupportAgentArgs = {
  clientsIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  partnerAgentId: Scalars['UnsetOrInt']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateDueDiligenceArgs = {
  id: Scalars['Int']['input'];
  result: DueDiligenceStatusType;
};


/** Available mutations */
export type BdSwissMutationsUpdateFavouritesArgs = {
  favourites: Array<InputMaybe<Scalars['String']['input']>>;
};


/** Available mutations */
export type BdSwissMutationsUpdateGoldSubscriptionAmountArgs = {
  accountId: Scalars['Int']['input'];
  newAmount: Scalars['Float']['input'];
  subscriptionId: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateLastEffectiveCallArgs = {
  clientId: Scalars['Int']['input'];
  lastEffectiveCall: Scalars['DateTime']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateOwnDetailsArgs = {
  address: InputMaybe<ClientAddressInput>;
  birthday: InputMaybe<Scalars['String']['input']>;
  companyName: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber: InputMaybe<Scalars['String']['input']>;
  correspondenceAddress: InputMaybe<ClientAddressInput>;
  firstName: InputMaybe<Scalars['String']['input']>;
  gender: InputMaybe<Gender>;
  globalQuestionnaire: InputMaybe<GlobalQuestionnaireInput>;
  identityOfTheThirdParty: InputMaybe<EconomicProfileDocumentInput>;
  language: InputMaybe<Language>;
  lastName: InputMaybe<Scalars['String']['input']>;
  mifirId: InputMaybe<Scalars['String']['input']>;
  mifirType: InputMaybe<Scalars['String']['input']>;
  nationality: InputMaybe<Nationality>;
  nickname: InputMaybe<Scalars['String']['input']>;
  optInMarketing: InputMaybe<Scalars['Boolean']['input']>;
  optInSms: InputMaybe<Scalars['Boolean']['input']>;
  passportNumber: InputMaybe<Scalars['String']['input']>;
  personalId: InputMaybe<PersonalIdInputType>;
  phone: InputMaybe<Scalars['String']['input']>;
  previousNames: InputMaybe<Scalars['String']['input']>;
  profileChangeRequestKYC: InputMaybe<Scalars['Boolean']['input']>;
  proofsOfIdentityFiamlRegulations: InputMaybe<EconomicProfileDocumentInput>;
  relationshipThirdParty: InputMaybe<EconomicProfileDocumentInput>;
  secondaryEmails: InputMaybe<SecondaryEmailInput>;
  secondaryPhones: InputMaybe<SecondaryPhoneInput>;
  skypeId: InputMaybe<Scalars['String']['input']>;
  vps: InputMaybe<Scalars['Boolean']['input']>;
  website: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpdateOwnEmailArgs = {
  email: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateOwnFcmTokenArgs = {
  token: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateOwnLeverageArgs = {
  accountId: Scalars['Int']['input'];
  leverage: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateOwnLocaleArgs = {
  locale: Locale;
};


/** Available mutations */
export type BdSwissMutationsUpdateOwnPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateOwnPerformanceFeeArgs = {
  accountId: Scalars['Int']['input'];
  performanceFee: Scalars['Float']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdateOwnSignupStepArgs = {
  signupStep: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpdatePermissionArgs = {
  id: Scalars['String']['input'];
  roles: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Available mutations */
export type BdSwissMutationsUpdateRawSubscriptionBillingInfoArgs = {
  accountId: Scalars['Int']['input'];
  tokenId: Scalars['String']['input'];
  tokenThreeD: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpdateSeminarAttendanceArgs = {
  csvLink: InputMaybe<Scalars['String']['input']>;
  subCampId: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpdateThemePreferenceArgs = {
  themePreference: ThemePreference;
};


/** Available mutations */
export type BdSwissMutationsUpdateWithdrawalArgs = {
  amount: Scalars['Float']['input'];
  comments: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  meta: InputMaybe<Scalars['String']['input']>;
  paymentFields: InputMaybe<WithdrawalPaymentFieldsInputType>;
  status: WithdrawalStatusesType;
};


/** Available mutations */
export type BdSwissMutationsUploadStrategicPartnersArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertAffiliateClientNoteArgs = {
  id: Scalars['Int']['input'];
  note: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertAffiliateUserNameArgs = {
  affUserName: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpsertAppointmentArgs = {
  addToGoogleCalendar: InputMaybe<Scalars['Boolean']['input']>;
  category: InputMaybe<AppointmentCategoryType>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  color: InputMaybe<AppointmentColorType>;
  description: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  isDismissed: InputMaybe<Scalars['Boolean']['input']>;
  isNew: InputMaybe<Scalars['Boolean']['input']>;
  start: InputMaybe<Scalars['DateTime']['input']>;
  userId: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertArticleArgs = {
  body: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertBlacklistArgs = {
  expiresAt: InputMaybe<Scalars['DateTime']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  reason: InputMaybe<Scalars['String']['input']>;
  type: BlacklistTypeType;
  value: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpsertBookAllocationArgs = {
  bookCategory: Scalars['String']['input'];
  campaigns: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  ibs: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertCampaignArgs = {
  accountTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  affiliateGroup: InputMaybe<Scalars['String']['input']>;
  avoidPhoneVerification: InputMaybe<Scalars['Boolean']['input']>;
  budget: InputMaybe<Scalars['Int']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  cookieTimeout: InputMaybe<Scalars['Int']['input']>;
  country: InputMaybe<Scalars['String']['input']>;
  emailVerification: InputMaybe<Scalars['Boolean']['input']>;
  end: InputMaybe<Scalars['DateTime']['input']>;
  ftdBonusCap: InputMaybe<Scalars['Float']['input']>;
  ftdBonusMinimumDeposits: InputMaybe<Array<InputMaybe<FtdBonusMinimumDepositInput>>>;
  ftdBonusMinimumDepositsRAW: InputMaybe<Array<InputMaybe<FtdBonusMinimumDepositRawInput>>>;
  ftdBonusMinimumDepositsVIP: InputMaybe<Array<InputMaybe<FtdBonusMinimumDepositVipInput>>>;
  ftdBonusPercentage: InputMaybe<Scalars['Int']['input']>;
  ftdBonusPercentageRAW: InputMaybe<Scalars['Int']['input']>;
  ftdBonusPercentageVIP: InputMaybe<Scalars['Int']['input']>;
  globalBonusLimit: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  isMt4ClassicVisible: InputMaybe<Scalars['Boolean']['input']>;
  isMt4RawVisible: InputMaybe<Scalars['Boolean']['input']>;
  isMt4VipVisible: InputMaybe<Scalars['Boolean']['input']>;
  isMt5ClassicVisible: InputMaybe<Scalars['Boolean']['input']>;
  isMt5RawVisible: InputMaybe<Scalars['Boolean']['input']>;
  isMt5VipVisible: InputMaybe<Scalars['Boolean']['input']>;
  isTwoFactorAuthenticationEnabled: InputMaybe<Scalars['Boolean']['input']>;
  kycThreshold: InputMaybe<Scalars['Int']['input']>;
  manualWithdrawals: InputMaybe<Scalars['Boolean']['input']>;
  maxBonusCap: InputMaybe<Scalars['Float']['input']>;
  minimumDeposits: InputMaybe<Array<InputMaybe<MinimumDepositInput>>>;
  minimumDepositsAccountType: InputMaybe<Array<InputMaybe<MinimumDepositAccountTypeInput>>>;
  mt5AccountOnSignup: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  noCall: InputMaybe<Scalars['Boolean']['input']>;
  noCallRatio: InputMaybe<Scalars['Int']['input']>;
  pixels: InputMaybe<Array<InputMaybe<PixelInput>>>;
  promoCode: InputMaybe<Scalars['String']['input']>;
  rawDepositMinimum: InputMaybe<Scalars['Int']['input']>;
  redepositBonusMinimumDeposits: InputMaybe<Array<InputMaybe<RedepositBonusMinimumDepositInput>>>;
  redepositBonusMinimumDepositsRAW: InputMaybe<Array<InputMaybe<RedepositBonusMinimumDepositRawInput>>>;
  redepositBonusMinimumDepositsVIP: InputMaybe<Array<InputMaybe<RedepositBonusMinimumDepositVipInput>>>;
  redepositBonusPercentage: InputMaybe<Scalars['Int']['input']>;
  redepositBonusPercentageRAW: InputMaybe<Scalars['Int']['input']>;
  redepositBonusPercentageVIP: InputMaybe<Scalars['Int']['input']>;
  redirectWebTraderFtd: InputMaybe<Scalars['Boolean']['input']>;
  showWelcomePage: InputMaybe<Scalars['Boolean']['input']>;
  start: InputMaybe<Scalars['DateTime']['input']>;
  type: InputMaybe<CampaignType>;
  verifyRequired: InputMaybe<Scalars['Boolean']['input']>;
  vipDepositMinimum: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertClientNoticeArgs = {
  clientId: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  template: InputMaybe<PartnersAppendicesTypeType>;
  type: InputMaybe<ClientNoticeTypeType>;
  values: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertCompetitionArgs = {
  acceptPreviousWinners: InputMaybe<Scalars['Boolean']['input']>;
  allowedAffiliates: InputMaybe<Scalars['String']['input']>;
  applicableClientTypes: InputMaybe<Array<InputMaybe<ClientType>>>;
  applicableCompanies: InputMaybe<Array<InputMaybe<Company>>>;
  applicableCountries: InputMaybe<Array<InputMaybe<Country>>>;
  competitionWinner: InputMaybe<Scalars['String']['input']>;
  endDate: InputMaybe<Scalars['UnsetOrDateTime']['input']>;
  excludedAffiliates: InputMaybe<Scalars['String']['input']>;
  icon: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  limitedSymbols: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  prizes: InputMaybe<Scalars['String']['input']>;
  rules: InputMaybe<Scalars['String']['input']>;
  startDate: InputMaybe<Scalars['UnsetOrDateTime']['input']>;
  termsLink: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertDocumentArgs = {
  assignee: InputMaybe<Scalars['UnsetOrInt']['input']>;
  cardNumber: InputMaybe<Scalars['String']['input']>;
  clientId: InputMaybe<Scalars['Int']['input']>;
  expiration: InputMaybe<Scalars['UnsetOrDateTime']['input']>;
  fileDescription: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  internalTag: InputMaybe<Scalars['String']['input']>;
  key: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: InputMaybe<Scalars['UnsetOrInt']['input']>;
  relatesTo: InputMaybe<Scalars['UnsetOrInt']['input']>;
  status: InputMaybe<DocumentStatus>;
  type: InputMaybe<DocumentType>;
};


/** Available mutations */
export type BdSwissMutationsUpsertDocumentTranslationArgs = {
  documentId: Scalars['Int']['input'];
  id: InputMaybe<Scalars['Int']['input']>;
  meta: InputMaybe<Scalars['String']['input']>;
  translationType: TranslationTypeTypes;
  translator: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertGeneralClientNoteArgs = {
  generalClientNote: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpsertGeneralWithdrawalNoteArgs = {
  generalWithdrawalNote: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpsertPartnerCustomizationArgs = {
  accountTypeCustomizations: InputMaybe<Scalars['String']['input']>;
  affiliateId: InputMaybe<Scalars['String']['input']>;
  autochartist: InputMaybe<Scalars['String']['input']>;
  bonus: InputMaybe<Scalars['String']['input']>;
  campaignId: InputMaybe<Scalars['String']['input']>;
  classicDefaultMT4Server: InputMaybe<Server>;
  depositorSalesAgent: InputMaybe<Scalars['Int']['input']>;
  gdcDisabled: InputMaybe<Scalars['Boolean']['input']>;
  ibId: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  initialDemoDeposit: InputMaybe<Scalars['Float']['input']>;
  leverageCustomizations: InputMaybe<Scalars['String']['input']>;
  minDepositCustomizations: InputMaybe<Scalars['String']['input']>;
  nonDepositorSalesAgent: InputMaybe<Scalars['Int']['input']>;
  spoa: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertPartnersLoyaltyArgs = {
  action: Scalars['String']['input'];
  clientId: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  prize: InputMaybe<Scalars['String']['input']>;
  prizes: InputMaybe<Scalars['String']['input']>;
  redeemedPrizes: InputMaybe<Scalars['String']['input']>;
  turnonverLast12months: InputMaybe<Scalars['Int']['input']>;
  turnoverLifetime: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertPaymentOptionArgs = {
  androidMinBuildVersion: InputMaybe<Scalars['Int']['input']>;
  bankDetails: InputMaybe<Array<InputMaybe<BankTransferDetailsInputType>>>;
  ccPrimary: InputMaybe<Scalars['Boolean']['input']>;
  ccType: InputMaybe<Scalars['UnsetOrCardType']['input']>;
  ccVolumeLimit: InputMaybe<Scalars['Int']['input']>;
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  confluenceLink: InputMaybe<Scalars['String']['input']>;
  flowType: InputMaybe<DepositFlowType>;
  id: InputMaybe<Scalars['Int']['input']>;
  iOSMinBuildVersion: InputMaybe<Scalars['Int']['input']>;
  localizationKey: InputMaybe<Scalars['String']['input']>;
  logoUrl: InputMaybe<Scalars['String']['input']>;
  method: InputMaybe<PaymentOptionMethodsType>;
  name: InputMaybe<Scalars['String']['input']>;
  notes: InputMaybe<Scalars['String']['input']>;
  paymentKey: InputMaybe<Scalars['String']['input']>;
  provider: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<PaymentOptionStatusType>;
  withKYCStatus: InputMaybe<WithKycStatusType>;
};


/** Available mutations */
export type BdSwissMutationsUpsertPixelArgs = {
  baseUrl: InputMaybe<Scalars['String']['input']>;
  campaignId: InputMaybe<Scalars['Int']['input']>;
  eventName: InputMaybe<EventName>;
  id: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  params: InputMaybe<Array<InputMaybe<TrackingParameterInput>>>;
  productName: InputMaybe<ProductNameType>;
  subcampaignKeyName: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<PixelType>;
  userIdKeyName: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertPrizeArgs = {
  id: InputMaybe<Scalars['Int']['input']>;
  imageLink: InputMaybe<Scalars['String']['input']>;
  prizeKey: InputMaybe<Scalars['String']['input']>;
  prizeThreshold: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertPromocodeArgs = {
  amount: InputMaybe<Scalars['Float']['input']>;
  category: InputMaybe<PromocodeCategory>;
  code: InputMaybe<Scalars['String']['input']>;
  expiration: InputMaybe<Scalars['DateTime']['input']>;
  ftd: InputMaybe<PromocodeFtd>;
  id: InputMaybe<Scalars['Int']['input']>;
  isPercentage: InputMaybe<Scalars['Boolean']['input']>;
  maximumUses: InputMaybe<Scalars['Int']['input']>;
  minDepositAmount: InputMaybe<Scalars['Float']['input']>;
  minFtd: InputMaybe<Scalars['Float']['input']>;
  product: InputMaybe<PromocodeProductNameType>;
  single: InputMaybe<PromocodeSingle>;
  status: InputMaybe<PromocodeStatus>;
};


/** Available mutations */
export type BdSwissMutationsUpsertRoleArgs = {
  description: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Available mutations */
export type BdSwissMutationsUpsertSalesClientNoteArgs = {
  id: Scalars['Int']['input'];
  note: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUpsertSeminarArgs = {
  city: Scalars['String']['input'];
  company: InputMaybe<Company>;
  country: Country;
  ibSeminar: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  location: Scalars['String']['input'];
  seminarCode: Scalars['String']['input'];
  seminarDate: InputMaybe<Scalars['UnsetOrDateTime']['input']>;
  seminarLink: InputMaybe<Scalars['String']['input']>;
  seminarName: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpsertShiftArgs = {
  from: InputMaybe<Scalars['UnsetOrDateTime']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  to: InputMaybe<Scalars['UnsetOrDateTime']['input']>;
  toDate: InputMaybe<Scalars['String']['input']>;
  userIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** Available mutations */
export type BdSwissMutationsUpsertTagArgs = {
  id: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  tagCategory: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsUpsertTradingAlertArgs = {
  action: TradingAlertActionsType;
  closedPrice: InputMaybe<Scalars['Float']['input']>;
  comments: InputMaybe<Scalars['String']['input']>;
  entryPrice: Scalars['Float']['input'];
  id: InputMaybe<Scalars['Int']['input']>;
  pair: Scalars['String']['input'];
  status: TradingAlertStatusesType;
  stopLoss: InputMaybe<Scalars['Float']['input']>;
  successfulTrade: InputMaybe<Scalars['String']['input']>;
  takeProfit1: InputMaybe<Scalars['Float']['input']>;
  takeProfit2: InputMaybe<Scalars['Float']['input']>;
  takeProfit3: InputMaybe<Scalars['Float']['input']>;
  timeClosed: InputMaybe<Scalars['DateTime']['input']>;
  type: TradingAlertTypesType;
};


/** Available mutations */
export type BdSwissMutationsUpsertUserArgs = {
  affiliateAssociatedCampaigns: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  affiliateManagerCampaigns: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedIps: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  associatedCampaigns: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  associatedSubCampaigns: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar: InputMaybe<Scalars['String']['input']>;
  bio: InputMaybe<Scalars['String']['input']>;
  companies: InputMaybe<Array<InputMaybe<Company>>>;
  countries: InputMaybe<Array<InputMaybe<Country>>>;
  department: InputMaybe<UserDepartmentType>;
  departmentRoleType: InputMaybe<DepartmentRoleType>;
  email: InputMaybe<Scalars['String']['input']>;
  endDate: InputMaybe<Scalars['DateTime']['input']>;
  firstName: InputMaybe<Scalars['String']['input']>;
  ftdMax: InputMaybe<Scalars['Int']['input']>;
  ftdMin: InputMaybe<Scalars['Int']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  isActive: InputMaybe<Scalars['Boolean']['input']>;
  isPool: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: InputMaybe<Scalars['String']['input']>;
  languages: InputMaybe<Array<InputMaybe<Language>>>;
  lastName: InputMaybe<Scalars['String']['input']>;
  locationId: InputMaybe<Scalars['Int']['input']>;
  managerId: InputMaybe<Scalars['Int']['input']>;
  phone: InputMaybe<Scalars['String']['input']>;
  roles: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesAgentType: InputMaybe<SalesAgentType>;
  selectedPools: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  skype: InputMaybe<Scalars['String']['input']>;
  startDate: InputMaybe<Scalars['DateTime']['input']>;
  telephonyProvider: InputMaybe<TelephonyProviderType>;
  username: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsUserChangeOwnPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsVerifyClientDetailsArgs = {
  birthday: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  phone: InputMaybe<Scalars['String']['input']>;
};


/** Available mutations */
export type BdSwissMutationsVerifyPhoneArgs = {
  code: Scalars['String']['input'];
  phoneVerificationId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsVerifySkrillAccountArgs = {
  depositId: InputMaybe<Scalars['Int']['input']>;
  withdrawalId: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsWatchGmailArgs = {
  userId: InputMaybe<Scalars['Int']['input']>;
};


/** Available mutations */
export type BdSwissMutationsWebinarUrlArgs = {
  locationTrack: InputMaybe<Scalars['String']['input']>;
  webinarId: Scalars['String']['input'];
};


/** Available mutations */
export type BdSwissMutationsWithdrawalAutoProcessArgs = {
  clientId: Scalars['Int']['input'];
  processGroup: InputMaybe<Scalars['Boolean']['input']>;
  withdrawalId: Scalars['Int']['input'];
};


/** Available mutations */
export type BdSwissMutationsWithdrawalsExportSearchArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<OrderBy>;
  orderDirection: InputMaybe<OrderDirection>;
  searchArgs: InputMaybe<Scalars['String']['input']>;
};

export enum Frontend {
  Mobile = 'mobile',
  Web = 'web',
  Web2 = 'web2'
}

/** Payment vendors a client may select */
export enum PermittedClientDepositVendor {
  Appex = 'appex',
  Astropay = 'astropay',
  Azulpay = 'azulpay',
  BankWire = 'bankWire',
  Bitolo = 'bitolo',
  BridgerPay = 'bridgerPay',
  Btcproxy = 'btcproxy',
  Cardpay = 'cardpay',
  Cashu = 'cashu',
  Cfx = 'cfx',
  Checkout = 'checkout',
  Codapay = 'codapay',
  Coinbase = 'coinbase',
  Coinpayments = 'coinpayments',
  Cpay = 'cpay',
  CxIbPayout = 'cxIbPayout',
  Dinpay = 'dinpay',
  Directa24 = 'directa24',
  Divepay = 'divepay',
  Dlocal = 'dlocal',
  Dotpay = 'dotpay',
  Dusupay = 'dusupay',
  Easyeft = 'easyeft',
  Echelonpay = 'echelonpay',
  EnovipayCard = 'enovipayCard',
  EnovipayCoinspaid = 'enovipayCoinspaid',
  EnovipayCrypto = 'enovipayCrypto',
  EnovipayOpay = 'enovipayOpay',
  EnovipayOvo = 'enovipayOvo',
  EnovipayPix = 'enovipayPix',
  EnovipaySpei = 'enovipaySpei',
  Eupaymentz = 'eupaymentz',
  Fasapay = 'fasapay',
  Funtopay = 'funtopay',
  Globepay = 'globepay',
  Help2pay = 'help2pay',
  IbPayout = 'ibPayout',
  Ikajo = 'ikajo',
  Isignthis = 'isignthis',
  JmFinancial = 'jmFinancial',
  Jmfinancialkw = 'jmfinancialkw',
  Kalixa = 'kalixa',
  Klarpay = 'klarpay',
  LionPay = 'lionPay',
  Localpay = 'localpay',
  ManualCrypto = 'manualCrypto',
  Mifinity = 'mifinity',
  Neteller = 'neteller',
  NganLuong = 'nganLuong',
  Openup = 'openup',
  Paycv = 'paycv',
  PaymentAsia = 'paymentAsia',
  Paymentcenter = 'paymentcenter',
  Paypal = 'paypal',
  Paypugs = 'paypugs',
  PayRetailers = 'payRetailers',
  Paytrust = 'paytrust',
  Payzoff = 'payzoff',
  Perfectmoney = 'perfectmoney',
  Powercash21 = 'powercash21',
  Pwclick = 'pwclick',
  Rave = 'rave',
  ReferralReward = 'referralReward',
  Rpnpay = 'rpnpay',
  Safecharge = 'safecharge',
  Skrill = 'skrill',
  Spreedly = 'spreedly',
  Thunderxpay = 'thunderxpay',
  Uobatm = 'uobatm',
  Vaultspay = 'vaultspay',
  Volt = 'volt',
  Wirecard = 'wirecard',
  Zotapay = 'zotapay'
}

/** Response object of beginDeposit mutation */
export type BeginDepositResponse = {
  __typename?: 'BeginDepositResponse';
  deposit: Deposit;
  payment: PaymentResponse;
  vendor: PermittedClientDepositVendor;
};

/** Used for client payments */
export type PaymentResponse = BankWirePaymentType | CreditCardPaymentType | JmFinancialPaymentType | PaymentUrl | WirecardPayment | ZotapayNativePayment;

/** All data for Bank Wire for Dashboard */
export type BankWirePaymentType = {
  __typename?: 'BankWirePaymentType';
  payload: Maybe<Scalars['String']['output']>;
};

/** All data for Credit Card for Dashboard */
export type CreditCardPaymentType = {
  __typename?: 'CreditCardPaymentType';
  payload: Maybe<Scalars['String']['output']>;
};

/** All for the data for JM Financial */
export type JmFinancialPaymentType = {
  __typename?: 'JMFinancialPaymentType';
  payload: Maybe<Scalars['String']['output']>;
};

/** Payment URL to send the client too */
export type PaymentUrl = {
  __typename?: 'PaymentUrl';
  url: Scalars['String']['output'];
};

/** All for the data for Wirecard Embedded Payment Page */
export type WirecardPayment = {
  __typename?: 'WirecardPayment';
  payload: Maybe<Scalars['String']['output']>;
};

/** All data for Zotapay for mobile */
export type ZotapayNativePayment = {
  __typename?: 'ZotapayNativePayment';
  payload: Maybe<Scalars['String']['output']>;
};

/** Response object of createVpsSubscription mutation */
export type VpsSubscriptionResponseType = {
  __typename?: 'vpsSubscriptionResponseType';
  subscription: Maybe<VpsSubscription>;
  tokenThreeD: Maybe<Scalars['String']['output']>;
};

export enum Bank {
  Astrobank = 'astrobank',
  Coutts = 'coutts',
  Eurobank = 'eurobank',
  Handels = 'handels',
  Isignthis = 'isignthis',
  Paystree = 'paystree',
  Sbm = 'sbm',
  Vialet = 'vialet',
  Wirecard = 'wirecard'
}

/** List of supported account types */
export enum AccountType {
  AffiliateAccount = 'AffiliateAccount',
  AffiliateEquityFlowAccount = 'AffiliateEquityFlowAccount',
  AffiliateLydianAccount = 'AffiliateLydianAccount',
  AffiliateMauritiusAccount = 'AffiliateMauritiusAccount',
  AffiliateSkyGroundAccount = 'AffiliateSkyGroundAccount',
  AffiliateTauroMarketsAccount = 'AffiliateTauroMarketsAccount',
  AffiliateTauroMarketsMauritiusAccount = 'AffiliateTauroMarketsMauritiusAccount',
  AffiliateVanuatuAccount = 'AffiliateVanuatuAccount',
  AipammAccount = 'AIPAMMAccount',
  AipammDemoAccount = 'AIPAMMDemoAccount',
  AipammMauritiusAccount = 'AIPAMMMauritiusAccount',
  AipammMauritiusDemoAccount = 'AIPAMMMauritiusDemoAccount',
  BdXcoin = 'BDXcoin',
  BdXcoinMauritius = 'BDXcoinMauritius',
  BdXcoinVanuatu = 'BDXcoinVanuatu',
  BitnukWalletMauritius = 'BitnukWalletMauritius',
  BitnukWalletSwissMarketsMauritius = 'BitnukWalletSwissMarketsMauritius',
  BitnukWalletVanuatu = 'BitnukWalletVanuatu',
  BondAccount = 'BondAccount',
  BondDemoAccount = 'BondDemoAccount',
  BondMauritiusAccount = 'BondMauritiusAccount',
  BondMauritiusDemoAccount = 'BondMauritiusDemoAccount',
  BondVanuatuAccount = 'BondVanuatuAccount',
  BondVanuatuDemoAccount = 'BondVanuatuDemoAccount',
  BrFcoin = 'BRFcoin',
  CentEquityFlowAccount = 'CentEquityFlowAccount',
  CentMauritiusAccount = 'CentMauritiusAccount',
  CentTauroMarketsAccount = 'CentTauroMarketsAccount',
  CentVanuatuAccount = 'CentVanuatuAccount',
  CleaNcoin = 'CLEANcoin',
  CryptoWallet = 'CryptoWallet',
  CuboidAccount = 'CuboidAccount',
  CuboidDemoAccount = 'CuboidDemoAccount',
  CuboidMauritiusAccount = 'CuboidMauritiusAccount',
  CuboidMauritiusDemoAccount = 'CuboidMauritiusDemoAccount',
  CuboidVanuatuAccount = 'CuboidVanuatuAccount',
  CuboidVanuatuDemoAccount = 'CuboidVanuatuDemoAccount',
  ExchangeAccount = 'ExchangeAccount',
  ExchangeBdxAccount = 'ExchangeBDXAccount',
  ExchangeMauritiusAccount = 'ExchangeMauritiusAccount',
  ExchangeVanuatuAccount = 'ExchangeVanuatuAccount',
  FiatWallet = 'FiatWallet',
  ForexAccount = 'ForexAccount',
  ForexAsiaAccount = 'ForexAsiaAccount',
  ForexClassicAccount = 'ForexClassicAccount',
  ForexClassicDemoAccount = 'ForexClassicDemoAccount',
  ForexClassicEquityFlowAccount = 'ForexClassicEquityFlowAccount',
  ForexClassicEquityFlowAsiaAccount = 'ForexClassicEquityFlowAsiaAccount',
  ForexClassicEquityFlowDemoAccount = 'ForexClassicEquityFlowDemoAccount',
  ForexClassicLydianAccount = 'ForexClassicLydianAccount',
  ForexClassicLydianDemoAccount = 'ForexClassicLydianDemoAccount',
  ForexClassicMauritiusAccount = 'ForexClassicMauritiusAccount',
  ForexClassicMauritiusDemoAccount = 'ForexClassicMauritiusDemoAccount',
  ForexClassicSkyGroundAccount = 'ForexClassicSkyGroundAccount',
  ForexClassicSkyGroundDemoAccount = 'ForexClassicSkyGroundDemoAccount',
  ForexClassicTauroMarketsAccount = 'ForexClassicTauroMarketsAccount',
  ForexClassicTauroMarketsAsiaAccount = 'ForexClassicTauroMarketsAsiaAccount',
  ForexClassicTauroMarketsDemoAccount = 'ForexClassicTauroMarketsDemoAccount',
  ForexClassicTauroMarketsMauritiusAccount = 'ForexClassicTauroMarketsMauritiusAccount',
  ForexClassicVanuatuAccount = 'ForexClassicVanuatuAccount',
  ForexClassicVanuatuDemoAccount = 'ForexClassicVanuatuDemoAccount',
  ForexDemoAccount = 'ForexDemoAccount',
  ForexMauritiusAccount = 'ForexMauritiusAccount',
  ForexMauritiusAccountBdx = 'ForexMauritiusAccountBDX',
  ForexMauritiusDemoAccount = 'ForexMauritiusDemoAccount',
  ForexMt5Account = 'ForexMT5Account',
  ForexMt5DemoAccount = 'ForexMT5DemoAccount',
  ForexMt5MauritiusAccount = 'ForexMT5MauritiusAccount',
  ForexMt5MauritiusDemoAccount = 'ForexMT5MauritiusDemoAccount',
  ForexMt5SvgTauromarketsAccount = 'ForexMT5SVGTauromarketsAccount',
  ForexMt5SvgTauromarketsDemoAccount = 'ForexMT5SVGTauromarketsDemoAccount',
  ForexMt5TauromarketsAccount = 'ForexMT5TauromarketsAccount',
  ForexMt5TauromarketsDemoAccount = 'ForexMT5TauromarketsDemoAccount',
  ForexMt5VanuatuAccount = 'ForexMT5VanuatuAccount',
  ForexMt5VanuatuDemoAccount = 'ForexMT5VanuatuDemoAccount',
  ForexPremiumMauritiusAccount = 'ForexPremiumMauritiusAccount',
  ForexPremiumVanuatuAccount = 'ForexPremiumVanuatuAccount',
  ForexRawAccount = 'ForexRawAccount',
  ForexRawBdSwissAccount = 'ForexRawBDSwissAccount',
  ForexRawBdSwissMauritiusAccount = 'ForexRawBDSwissMauritiusAccount',
  ForexRawBdSwissVanuatuAccount = 'ForexRawBDSwissVanuatuAccount',
  ForexRawEquityFlowAccount = 'ForexRawEquityFlowAccount',
  ForexRawMauritiusAccount = 'ForexRawMauritiusAccount',
  ForexRawTauroMarketsAccount = 'ForexRawTauroMarketsAccount',
  ForexRawVanuatuAccount = 'ForexRawVanuatuAccount',
  ForexVanuatuAccount = 'ForexVanuatuAccount',
  ForexVanuatuDemoAccount = 'ForexVanuatuDemoAccount',
  GoldAccount = 'GoldAccount',
  GoldMauritiusAccount = 'GoldMauritiusAccount',
  GoldVanuatuAccount = 'GoldVanuatuAccount',
  IntroducingBrokerAccount = 'IntroducingBrokerAccount',
  IntroducingBrokerBdSwissVanuatuAccount = 'IntroducingBrokerBDSwissVanuatuAccount',
  IntroducingBrokerEquityFlowAccount = 'IntroducingBrokerEquityFlowAccount',
  IntroducingBrokerMauritiusAccount = 'IntroducingBrokerMauritiusAccount',
  IntroducingBrokerSwissMarketsAccount = 'IntroducingBrokerSwissMarketsAccount',
  IntroducingBrokerSwissMarketsMauritiusAccount = 'IntroducingBrokerSwissMarketsMauritiusAccount',
  IntroducingBrokerSwissMarketsVanuatuAccount = 'IntroducingBrokerSwissMarketsVanuatuAccount',
  IntroducingBrokerTauroMarketsAccount = 'IntroducingBrokerTauroMarketsAccount',
  IntroducingBrokerTauroMarketsMauritiusAccount = 'IntroducingBrokerTauroMarketsMauritiusAccount',
  JollYcoin = 'JOLLYcoin',
  MamAccount = 'MAMAccount',
  MamMauritiusAccount = 'MAMMauritiusAccount',
  MamsmMauritiusAccount = 'MAMSMMauritiusAccount',
  MamsmVanuatuAccount = 'MAMSMVanuatuAccount',
  MamVanuatuAccount = 'MAMVanuatuAccount',
  PammAccount = 'PAMMAccount',
  PammFundManagerAccount = 'PAMMFundManagerAccount',
  PammFundManagerMauritiusAccount = 'PAMMFundManagerMauritiusAccount',
  PammFundManagerVanuatuAccount = 'PAMMFundManagerVanuatuAccount',
  PammMauritiusAccount = 'PAMMMauritiusAccount',
  PammsmAccount = 'PAMMSMAccount',
  PammsmFundManagerAccount = 'PAMMSMFundManagerAccount',
  PammsmFundManagerMauritiusAccount = 'PAMMSMFundManagerMauritiusAccount',
  PammsmFundManagerVanuatuAccount = 'PAMMSMFundManagerVanuatuAccount',
  PammsmMauritiusAccount = 'PAMMSMMauritiusAccount',
  PammsmVanuatuAccount = 'PAMMSMVanuatuAccount',
  PammTauroMarketsAccount = 'PAMMTauroMarketsAccount',
  PammTauroMarketsManagerAccount = 'PAMMTauroMarketsManagerAccount',
  PammTauroMarketsMauritiusAccount = 'PAMMTauroMarketsMauritiusAccount',
  PammTauroMarketsMauritiusManagerAccount = 'PAMMTauroMarketsMauritiusManagerAccount',
  PammTauroMarketsMt5Account = 'PAMMTauroMarketsMT5Account',
  PammTauroMarketsMt5ManagerAccount = 'PAMMTauroMarketsMT5ManagerAccount',
  PammVanuatuAccount = 'PAMMVanuatuAccount',
  PortfolioManagementAccount = 'PortfolioManagementAccount',
  PortfolioManagementMauritiusAccount = 'PortfolioManagementMauritiusAccount',
  SmPrimeWalletBdSwissAccount = 'SMPrimeWalletBDSwissAccount',
  SmPrimeWalletBdSwissMauritiusAccount = 'SMPrimeWalletBDSwissMauritiusAccount',
  SmPrimeWalletMauritiusAccount = 'SMPrimeWalletMauritiusAccount',
  SmPrimeWalletVanuatuAccount = 'SMPrimeWalletVanuatuAccount',
  SpotOptionAccount = 'SpotOptionAccount',
  SpotOptionDemoAccount = 'SpotOptionDemoAccount',
  SpotOptionMauritiusAccount = 'SpotOptionMauritiusAccount',
  SpotOptionMauritiusDemoAccount = 'SpotOptionMauritiusDemoAccount',
  SpotOptionVanuatuAccount = 'SpotOptionVanuatuAccount',
  SpotOptionVanuatuDemoAccount = 'SpotOptionVanuatuDemoAccount',
  TradesmarterAccount = 'TradesmarterAccount',
  TradesmarterDemoAccount = 'TradesmarterDemoAccount',
  TradesmarterMauritiusAccount = 'TradesmarterMauritiusAccount',
  TradesmarterMauritiusDemoAccount = 'TradesmarterMauritiusDemoAccount',
  TradesmarterVanuatuAccount = 'TradesmarterVanuatuAccount',
  TradesmarterVanuatuDemoAccount = 'TradesmarterVanuatuDemoAccount'
}

/** Supported currencies for new accounts */
export enum NewAccountCurrency {
  Btc = 'BTC',
  Cud = 'CUD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Pln = 'PLN',
  Usd = 'USD'
}

/** Authentication token into third party systems */
export type AuthKey = {
  __typename?: 'AuthKey';
  /** Expiry datetime */
  expiry: Maybe<Scalars['DateTime']['output']>;
  /** Single use key */
  key: Maybe<Scalars['String']['output']>;
};

export type ClientAddressInput = {
  /** Address: City */
  city: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country: InputMaybe<Country>;
  countryDescription: InputMaybe<Scalars['String']['input']>;
  /** Address: House Number */
  houseNumber: InputMaybe<Scalars['String']['input']>;
  /** Address: Street */
  line1: InputMaybe<Scalars['String']['input']>;
  /** Country */
  oldCountry: InputMaybe<Country>;
  /** Region */
  region: InputMaybe<Scalars['String']['input']>;
  /** Postcode/ZIP code */
  zip: InputMaybe<Scalars['String']['input']>;
};

/** BDSwiss Holdings child companies */
export enum WhiteLabel {
  AccuracyAccounts = 'accuracyAccounts',
  AccuracyAccountsMauritius = 'accuracyAccountsMauritius',
  BdsTrading = 'bdsTrading',
  BdsTradingMauritius = 'bdsTradingMauritius',
  BdsTradingVanuatu = 'bdsTradingVanuatu',
  BdxAccounts = 'bdxAccounts',
  EquityFlow = 'equityFlow',
  Lydian = 'lydian',
  Regalx = 'regalx',
  RegalxMauritius = 'regalxMauritius',
  RegalxVanuatu = 'regalxVanuatu',
  SkyGround = 'skyGround',
  TauroMarkets = 'tauroMarkets',
  TauroMarketsMauritius = 'tauroMarketsMauritius'
}

export type DepositPaymentFieldsInputType = {
  /** Account holder name */
  bankAccountHolderName: InputMaybe<Scalars['String']['input']>;
  /** Account Bank Name */
  bankName: InputMaybe<Scalars['String']['input']>;
  /** Date Received in the bank */
  dateReceived: InputMaybe<Scalars['DateTime']['input']>;
  /** Account number/IBAN */
  iban: InputMaybe<Scalars['String']['input']>;
  /** Account swift code */
  swiftCode: InputMaybe<Scalars['String']['input']>;
  transferToAccount: InputMaybe<Scalars['Float']['input']>;
};

/** One of the possible deposit vendors */
export enum DepositVendorsType {
  AdjustmentCorrection = 'adjustmentCorrection',
  Appex = 'appex',
  Astropay = 'astropay',
  Azulpay = 'azulpay',
  BankWire = 'bankWire',
  BdxBonus = 'bdxBonus',
  BdxManual = 'bdxManual',
  BitnukBuyCrypto = 'bitnukBuyCrypto',
  BitnukCryptoTopup = 'bitnukCryptoTopup',
  Bitolo = 'bitolo',
  Bond = 'bond',
  Bonus = 'bonus',
  BridgerPay = 'bridgerPay',
  Btcproxy = 'btcproxy',
  CampaignFtdCampaignBonus = 'campaignFtdCampaignBonus',
  CampaignRedepositBonus = 'campaignRedepositBonus',
  Cardpay = 'cardpay',
  CashBack = 'cashBack',
  Cashu = 'cashu',
  Cc = 'cc',
  Cdxb = 'cdxb',
  Cfx = 'cfx',
  ChargebackDeposit = 'chargebackDeposit',
  Chargebee = 'chargebee',
  Checkout = 'checkout',
  Codapay = 'codapay',
  Coinbase = 'coinbase',
  Coinpayments = 'coinpayments',
  CopyTradingAgentFee = 'copyTradingAgentFee',
  CopyTradingPerformanceFee = 'copyTradingPerformanceFee',
  Cpay = 'cpay',
  Cqr = 'cqr',
  CreditBonus = 'creditBonus',
  CreditCard = 'creditCard',
  CxIbPayout = 'cxIbPayout',
  DemoFunds = 'demoFunds',
  DepositBonus = 'depositBonus',
  DepositCommisions = 'depositCommisions',
  DepositReturnedFunds = 'depositReturnedFunds',
  Dinpay = 'dinpay',
  Directa24 = 'directa24',
  Divepay = 'divepay',
  Dlocal = 'dlocal',
  Dotpay = 'dotpay',
  Dusupay = 'dusupay',
  Easyeft = 'easyeft',
  Echelonpay = 'echelonpay',
  EnovipayCard = 'enovipayCard',
  EnovipayCoinspaid = 'enovipayCoinspaid',
  EnovipayCrypto = 'enovipayCrypto',
  EnovipayOpay = 'enovipayOpay',
  EnovipayOvo = 'enovipayOvo',
  EnovipayPix = 'enovipayPix',
  EnovipaySpei = 'enovipaySpei',
  Eupaymentz = 'eupaymentz',
  Fasapay = 'fasapay',
  Funtopay = 'funtopay',
  Globepay = 'globepay',
  Help2pay = 'help2pay',
  IbPayout = 'ibPayout',
  Ikajo = 'ikajo',
  Isignthis = 'isignthis',
  JmFinancial = 'jmFinancial',
  Jmfinancialkw = 'jmfinancialkw',
  Kalixa = 'kalixa',
  Klarpay = 'klarpay',
  LionPay = 'lionPay',
  Localpay = 'localpay',
  LoyaltyProgramBonus = 'loyaltyProgramBonus',
  LydianDirect = 'lydianDirect',
  ManagedAccountFee = 'managedAccountFee',
  Manual = 'manual',
  ManualCrypto = 'manualCrypto',
  Mifinity = 'mifinity',
  Moneybookers = 'moneybookers',
  NegativeBalanceCorrection = 'negativeBalanceCorrection',
  Neteller = 'neteller',
  NganLuong = 'nganLuong',
  Openup = 'openup',
  PammAgentFee = 'pammAgentFee',
  Paycv = 'paycv',
  PaymentAsia = 'paymentAsia',
  Paymentcenter = 'paymentcenter',
  Paypal = 'paypal',
  Paypugs = 'paypugs',
  PayRetailers = 'payRetailers',
  Paytrust = 'paytrust',
  Payzoff = 'payzoff',
  Perfectmoney = 'perfectmoney',
  Powercash21 = 'powercash21',
  Pwclick = 'pwclick',
  Qiwi = 'qiwi',
  Rave = 'rave',
  Recurly = 'recurly',
  ReferralReward = 'referralReward',
  ReimbursementSettlement = 'reimbursementSettlement',
  Rpnpay = 'rpnpay',
  Safecharge = 'safecharge',
  Skrill = 'skrill',
  Spreedly = 'spreedly',
  TestMoney = 'testMoney',
  Thunderxpay = 'thunderxpay',
  TradableBonus = 'tradableBonus',
  Transfer = 'transfer',
  Transferb2b = 'transferb2b',
  TransferDepositCommisions = 'transferDepositCommisions',
  TransferSpoab2b = 'transferSpoab2b',
  Uobatm = 'uobatm',
  Vaultspay = 'vaultspay',
  Volt = 'volt',
  Wallet1 = 'wallet1',
  Wire = 'wire',
  Wirecard = 'wirecard',
  Zotapay = 'zotapay'
}

export type DueDiligenceAnswersInputType = {
  existingClients: InputMaybe<ExistingClients>;
  existingClientsDescription: InputMaybe<Scalars['String']['input']>;
  existingClientsUpload: InputMaybe<Scalars['String']['input']>;
  promoteProducts: InputMaybe<Array<InputMaybe<PromoteProducts>>>;
  promoteProductsBusinessPlan: InputMaybe<Scalars['String']['input']>;
  promoteProductsDescription: InputMaybe<Scalars['String']['input']>;
  promoteProductsLinks: InputMaybe<Scalars['String']['input']>;
  relevantLicenses: InputMaybe<RelevantLicenses>;
  relevantLicensesDescription: InputMaybe<Scalars['String']['input']>;
  relevantLicensesUpload: InputMaybe<Scalars['String']['input']>;
  servicesOffer: InputMaybe<Array<InputMaybe<ServicesOffer>>>;
  servicesOfferDescription: InputMaybe<Scalars['String']['input']>;
  servicesOfferUpload: InputMaybe<Scalars['String']['input']>;
  termsConditions: InputMaybe<Array<InputMaybe<TermsConditions>>>;
  yearsOfExperience: InputMaybe<YearsOfExperience>;
};

/** Gold Subscription Plans */
export enum GoldSubscriptionPlan {
  Monthly149 = 'monthly149',
  Monthly199 = 'monthly199',
  Monthly249 = 'monthly249',
  Monthly49 = 'monthly49',
  Monthly99 = 'monthly99'
}

/** IB SSO link into external app */
export type IbLink = {
  __typename?: 'IBLink';
  /** SSO link */
  link: Maybe<Scalars['String']['output']>;
};

/** Transfer Funds requests for this user */
export type TransferFunds = {
  __typename?: 'TransferFunds';
  /** Deposit to the destination account */
  deposit: Maybe<Deposit>;
  /** Withdrawal of the source account */
  withdrawal: Maybe<Withdrawal>;
};

/** List of account types a client is permitted to open himself */
export enum ClientOpenPermittedAccountTypeType {
  AffiliateEquityFlowAccount = 'AffiliateEquityFlowAccount',
  AffiliateMauritiusAccount = 'AffiliateMauritiusAccount',
  AffiliateSkyGroundAccount = 'AffiliateSkyGroundAccount',
  AffiliateTauroMarketsAccount = 'AffiliateTauroMarketsAccount',
  AffiliateTauroMarketsMauritiusAccount = 'AffiliateTauroMarketsMauritiusAccount',
  AffiliateVanuatuAccount = 'AffiliateVanuatuAccount',
  AipammAccount = 'AIPAMMAccount',
  AipammDemoAccount = 'AIPAMMDemoAccount',
  AipammMauritiusAccount = 'AIPAMMMauritiusAccount',
  AipammMauritiusDemoAccount = 'AIPAMMMauritiusDemoAccount',
  BondAccount = 'BondAccount',
  BondDemoAccount = 'BondDemoAccount',
  BondMauritiusAccount = 'BondMauritiusAccount',
  BondMauritiusDemoAccount = 'BondMauritiusDemoAccount',
  BondVanuatuAccount = 'BondVanuatuAccount',
  BondVanuatuDemoAccount = 'BondVanuatuDemoAccount',
  BrFcoin = 'BRFcoin',
  CentEquityFlowAccount = 'CentEquityFlowAccount',
  CentMauritiusAccount = 'CentMauritiusAccount',
  CentTauroMarketsAccount = 'CentTauroMarketsAccount',
  CentVanuatuAccount = 'CentVanuatuAccount',
  CleaNcoin = 'CLEANcoin',
  CryptoWallet = 'CryptoWallet',
  CuboidAccount = 'CuboidAccount',
  CuboidMauritiusAccount = 'CuboidMauritiusAccount',
  CuboidVanuatuAccount = 'CuboidVanuatuAccount',
  ExchangeAccount = 'ExchangeAccount',
  ExchangeBdxAccount = 'ExchangeBDXAccount',
  ExchangeMauritiusAccount = 'ExchangeMauritiusAccount',
  ExchangeVanuatuAccount = 'ExchangeVanuatuAccount',
  FiatWallet = 'FiatWallet',
  ForexAccount = 'ForexAccount',
  ForexAsiaAccount = 'ForexAsiaAccount',
  ForexClassicAccount = 'ForexClassicAccount',
  ForexClassicDemoAccount = 'ForexClassicDemoAccount',
  ForexClassicEquityFlowAccount = 'ForexClassicEquityFlowAccount',
  ForexClassicEquityFlowAsiaAccount = 'ForexClassicEquityFlowAsiaAccount',
  ForexClassicEquityFlowDemoAccount = 'ForexClassicEquityFlowDemoAccount',
  ForexClassicLydianAccount = 'ForexClassicLydianAccount',
  ForexClassicMauritiusAccount = 'ForexClassicMauritiusAccount',
  ForexClassicMauritiusDemoAccount = 'ForexClassicMauritiusDemoAccount',
  ForexClassicSkyGroundAccount = 'ForexClassicSkyGroundAccount',
  ForexClassicTauroMarketsAccount = 'ForexClassicTauroMarketsAccount',
  ForexClassicTauroMarketsAsiaAccount = 'ForexClassicTauroMarketsAsiaAccount',
  ForexClassicTauroMarketsDemoAccount = 'ForexClassicTauroMarketsDemoAccount',
  ForexClassicTauroMarketsMauritiusAccount = 'ForexClassicTauroMarketsMauritiusAccount',
  ForexClassicVanuatuAccount = 'ForexClassicVanuatuAccount',
  ForexClassicVanuatuDemoAccount = 'ForexClassicVanuatuDemoAccount',
  ForexDemoAccount = 'ForexDemoAccount',
  ForexMauritiusAccount = 'ForexMauritiusAccount',
  ForexMauritiusDemoAccount = 'ForexMauritiusDemoAccount',
  ForexMt5Account = 'ForexMT5Account',
  ForexMt5DemoAccount = 'ForexMT5DemoAccount',
  ForexMt5SvgTauromarketsAccount = 'ForexMT5SVGTauromarketsAccount',
  ForexMt5SvgTauromarketsDemoAccount = 'ForexMT5SVGTauromarketsDemoAccount',
  ForexMt5TauromarketsAccount = 'ForexMT5TauromarketsAccount',
  ForexMt5TauromarketsDemoAccount = 'ForexMT5TauromarketsDemoAccount',
  ForexMt5VanuatuAccount = 'ForexMT5VanuatuAccount',
  ForexMt5VanuatuDemoAccount = 'ForexMT5VanuatuDemoAccount',
  ForexPremiumVanuatuAccount = 'ForexPremiumVanuatuAccount',
  ForexRawAccount = 'ForexRawAccount',
  ForexRawBdSwissMauritiusAccount = 'ForexRawBDSwissMauritiusAccount',
  ForexRawEquityFlowAccount = 'ForexRawEquityFlowAccount',
  ForexRawMauritiusAccount = 'ForexRawMauritiusAccount',
  ForexRawTauroMarketsAccount = 'ForexRawTauroMarketsAccount',
  ForexRawVanuatuAccount = 'ForexRawVanuatuAccount',
  ForexVanuatuAccount = 'ForexVanuatuAccount',
  ForexVanuatuDemoAccount = 'ForexVanuatuDemoAccount',
  IntroducingBrokerBdSwissVanuatuAccount = 'IntroducingBrokerBDSwissVanuatuAccount',
  IntroducingBrokerEquityFlowAccount = 'IntroducingBrokerEquityFlowAccount',
  IntroducingBrokerMauritiusAccount = 'IntroducingBrokerMauritiusAccount',
  IntroducingBrokerSwissMarketsVanuatuAccount = 'IntroducingBrokerSwissMarketsVanuatuAccount',
  IntroducingBrokerTauroMarketsAccount = 'IntroducingBrokerTauroMarketsAccount',
  IntroducingBrokerTauroMarketsMauritiusAccount = 'IntroducingBrokerTauroMarketsMauritiusAccount',
  JollYcoin = 'JOLLYcoin',
  PammsmAccount = 'PAMMSMAccount',
  PammsmMauritiusAccount = 'PAMMSMMauritiusAccount',
  PammsmVanuatuAccount = 'PAMMSMVanuatuAccount',
  PammTauroMarketsManagerAccount = 'PAMMTauroMarketsManagerAccount',
  PammTauroMarketsMauritiusManagerAccount = 'PAMMTauroMarketsMauritiusManagerAccount',
  PammTauroMarketsMt5ManagerAccount = 'PAMMTauroMarketsMT5ManagerAccount',
  PammVanuatuAccount = 'PAMMVanuatuAccount',
  PortfolioManagementAccount = 'PortfolioManagementAccount',
  PortfolioManagementMauritiusAccount = 'PortfolioManagementMauritiusAccount',
  SpotOptionAccount = 'SpotOptionAccount',
  SpotOptionDemoAccount = 'SpotOptionDemoAccount',
  SpotOptionMauritiusAccount = 'SpotOptionMauritiusAccount',
  SpotOptionMauritiusDemoAccount = 'SpotOptionMauritiusDemoAccount',
  SpotOptionVanuatuAccount = 'SpotOptionVanuatuAccount',
  SpotOptionVanuatuDemoAccount = 'SpotOptionVanuatuDemoAccount',
  TradesmarterAccount = 'TradesmarterAccount',
  TradesmarterDemoAccount = 'TradesmarterDemoAccount',
  TradesmarterMauritiusAccount = 'TradesmarterMauritiusAccount',
  TradesmarterMauritiusDemoAccount = 'TradesmarterMauritiusDemoAccount',
  TradesmarterVanuatuAccount = 'TradesmarterVanuatuAccount',
  TradesmarterVanuatuDemoAccount = 'TradesmarterVanuatuDemoAccount'
}

export type AppropTestAnswersInput = {
  accountTurnover: InputMaybe<AccountTurnover>;
  acknowledgmentConfirmation: InputMaybe<Scalars['String']['input']>;
  annualIncome: InputMaybe<AppropTestAnnualIncome>;
  appropriatenessWarning: InputMaybe<Scalars['String']['input']>;
  attendedSeminarOrCourse: InputMaybe<AppropTestAttendedSeminarOrCourse>;
  attendedSeminarOrCourseBinary: InputMaybe<AttendedSeminarOrCourseBinary>;
  attendedSeminarOrCourseForex: InputMaybe<AttendedSeminarOrCourseForex>;
  binaryPast2YearsExperience: InputMaybe<AppropTestBinaryPast2YearsExperience>;
  buyFacebookCfdV2: InputMaybe<BuyFacebookCfdV2>;
  cfdTradingV2: InputMaybe<CfdTradingV2>;
  disposableIncomeV2: InputMaybe<DisposableIncomeV2>;
  educatedInFinancialTrading: InputMaybe<AppropTestEducatedInFinancialTrading>;
  educationLevel: InputMaybe<AppropTestEducationLevel>;
  educationLevelV2: InputMaybe<EducationLevelV2>;
  educationOptionInFinancialTrading: InputMaybe<AppropTestEducationOptionInFinancialTrading>;
  employerCategory: InputMaybe<AppropTestEmployerCategory>;
  employmentStatus: InputMaybe<AppropTestEmploymentStatus>;
  expectedDeposit: InputMaybe<AppropTestExpectedDeposit>;
  fieldOfStudyV2: InputMaybe<FieldOfStudyV2>;
  financialDemoPast2YearsExperience: InputMaybe<AppropTestFinancialDemoPast2YearsExp>;
  forexPast2YearsExperience: InputMaybe<AppropTestForexPast2YearsExperience>;
  haveTraded: InputMaybe<AppropTestHaveTraded>;
  haveTradedForexCfd: InputMaybe<AppropTestHaveTradedForexCfd>;
  haveTradingExperience: InputMaybe<AppropTestHaveTradingExperience>;
  howManyTimesHaveTraded: InputMaybe<AppropTestHowManyTimesHaveTraded>;
  ifLoseCapitalV2: InputMaybe<IfLoseCapitalV2>;
  initialInvestment: InputMaybe<InitialInvestment>;
  initialInvestmentV2: InputMaybe<InitialInvestmentV2>;
  isUsReportable: InputMaybe<AppropTestIsUsReportable>;
  jobTitle: InputMaybe<Scalars['String']['input']>;
  largerSizePositions: InputMaybe<AppropTestLargerSizePositions>;
  lostInvestment: InputMaybe<AppropTestLostInvestment>;
  maximumPositionV2: InputMaybe<MaximumPositionV2>;
  netWorth: InputMaybe<AppropTestNetWorth>;
  netWorthV2: InputMaybe<NetWorthV2>;
  past2YearsProductsBdswiss: InputMaybe<Scalars['String']['input']>;
  past2YearsProductsSwissMarkets: InputMaybe<Scalars['String']['input']>;
  past2YearsTradingExperienceV2: InputMaybe<Past2YearsTradingExperienceV2>;
  politicallyExposed: InputMaybe<PoliticallyExposed>;
  professionStatusV2: InputMaybe<ProfessionStatusV2>;
  relevantProfession: InputMaybe<RelevantProfession>;
  relevantQualificationsOrExperience: InputMaybe<RelevantQualificationsOrExperience>;
  riskUnderstanding: InputMaybe<RiskUnderstanding>;
  sourceOfFunds: InputMaybe<AppropTestSourceOfFunds>;
  stockDropsV2: InputMaybe<StockDropsV2>;
  tradingExperienceBinary: InputMaybe<TradingExperienceBinary>;
  tradingExperienceExchange: InputMaybe<TradingExperienceExchange>;
  tradingExperienceForex: InputMaybe<TradingExperienceForex>;
  tradingExperienceOTC: InputMaybe<TradingExperienceOtc>;
  tradingExperienceOTCSwissmarkets: InputMaybe<TradingExperienceOtcSwissmarkets>;
  tradingExperienceSharesBonds: InputMaybe<TradingExperienceSharesBonds>;
  tradingFrequencyLast12Months: InputMaybe<TradingFrequencyLast12Months>;
  tradingTransactionsLast12Months: InputMaybe<TradingTransactionsLast12Months>;
  tradingWithLeverageV2: InputMaybe<TradingWithLeverageV2>;
  transactionNumber: InputMaybe<TransactionNumber>;
  transactionPurpose: InputMaybe<TransactionPurpose>;
  transactionPurposeV2: InputMaybe<TransactionPurposeV2>;
  transactionsInCommoditiesV2: InputMaybe<TransactionsInCommoditiesV2>;
  transactionsInForexV2: InputMaybe<TransactionsInForexV2>;
  usTaxId: InputMaybe<Scalars['String']['input']>;
  volatileMarkets: InputMaybe<AppropTestVolatileMarkets>;
  warning: InputMaybe<AppropTestWarningAcceptance>;
  withLeverageCommoditiesV2: InputMaybe<WithLeverageCommoditiesV2>;
  withLeverageForexV2: InputMaybe<WithLeverageForexV2>;
};

/** PAMM SSO link into external app */
export type PammLink = {
  __typename?: 'PAMMLink';
  /** SSO link */
  link: Maybe<Scalars['String']['output']>;
};

/** Response object of createRawSubscription mutation */
export type SubscriptionResponseType = {
  __typename?: 'subscriptionResponseType';
  subscription: Maybe<RawSubscriptionType>;
  tokenThreeD: Maybe<Scalars['String']['output']>;
};

export type SuitabilityTestAnswersInputType = {
  characterizeInvestment: InputMaybe<Scalars['String']['input']>;
  disposableIncome: InputMaybe<Scalars['String']['input']>;
  educationSuitabilityTest: InputMaybe<EducationSuitabilityTest>;
  fieldOfStudySuitabilityTest: InputMaybe<FieldOfStudySuitabilityTest>;
  incomeSources: InputMaybe<Scalars['String']['input']>;
  investmentFrequency: InputMaybe<Scalars['String']['input']>;
  mostSpecific: InputMaybe<Scalars['String']['input']>;
  past2YearsTradingExperienceSuitabilityTest: InputMaybe<Past2YearsTradingExperienceSuitabilityTest>;
  percentageInvestmentAvailable: InputMaybe<Scalars['String']['input']>;
  primaryInvestmentGoal: InputMaybe<Scalars['String']['input']>;
  primaryInvestmentTerm: InputMaybe<Scalars['String']['input']>;
  riskWillingness: InputMaybe<Scalars['String']['input']>;
  termsConditions: InputMaybe<Array<InputMaybe<TermsConditionsSuitabilityTest>>>;
  transactionsInCommoditiesSuitabilityTest: InputMaybe<TransactionsInCommoditiesSuitabilityTest>;
  transactionsInForexSuitabilityTest: InputMaybe<TransactionsInForexSuitabilityTest>;
  wealth: InputMaybe<Scalars['String']['input']>;
  withLeverageCommoditiesSuitabilityTest: InputMaybe<WithLeverageCommoditiesSuitabilityTest>;
  withLeverageForexSuitabilityTest: InputMaybe<WithLeverageForexSuitabilityTest>;
};

export type WithdrawalPaymentFieldsInputType = {
  accountNumber: InputMaybe<Scalars['String']['input']>;
  bank: InputMaybe<Scalars['String']['input']>;
  bankAccountArea: InputMaybe<Scalars['String']['input']>;
  bankAccountCity: InputMaybe<Scalars['String']['input']>;
  bankAccountHolderName: InputMaybe<Scalars['String']['input']>;
  bankAccountName: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber: InputMaybe<Scalars['String']['input']>;
  bankAccountProvince: InputMaybe<Scalars['String']['input']>;
  bankAccountType: InputMaybe<Scalars['String']['input']>;
  bankBranch: InputMaybe<Scalars['String']['input']>;
  bankCode: InputMaybe<Scalars['String']['input']>;
  bankCodeString: InputMaybe<Scalars['String']['input']>;
  bankName: InputMaybe<Scalars['String']['input']>;
  beneficiaryAddress: InputMaybe<Scalars['String']['input']>;
  beneficiaryEmail: InputMaybe<Scalars['String']['input']>;
  beneficiaryFirstName: InputMaybe<Scalars['String']['input']>;
  beneficiaryLastName: InputMaybe<Scalars['String']['input']>;
  beneficiaryPhone: InputMaybe<Scalars['String']['input']>;
  branchCode: InputMaybe<Scalars['String']['input']>;
  card: InputMaybe<Scalars['String']['input']>;
  cardExpiryMonth: InputMaybe<Scalars['Int']['input']>;
  cardExpiryYear: InputMaybe<Scalars['Int']['input']>;
  cardHolderName: InputMaybe<Scalars['String']['input']>;
  cardNumber: InputMaybe<Scalars['String']['input']>;
  comment: InputMaybe<Scalars['String']['input']>;
  cryptoAmount: InputMaybe<Scalars['Float']['input']>;
  cryptoCurrency: InputMaybe<Scalars['String']['input']>;
  cryptoNetwork: InputMaybe<Scalars['String']['input']>;
  deliveryAdditionalInstructions: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCity: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCountry: InputMaybe<Scalars['String']['input']>;
  deliveryAddressLine1: InputMaybe<Scalars['String']['input']>;
  deliveryAddressLine2: InputMaybe<Scalars['String']['input']>;
  deliveryAddressRegion: InputMaybe<Scalars['String']['input']>;
  deliveryAddressZipCode: InputMaybe<Scalars['String']['input']>;
  destinationTag: InputMaybe<Scalars['String']['input']>;
  document: InputMaybe<Scalars['String']['input']>;
  documentType: InputMaybe<Scalars['String']['input']>;
  emailOrEWalletNumber: InputMaybe<Scalars['String']['input']>;
  enovipayPayoutCryptoNetwork: InputMaybe<Scalars['String']['input']>;
  exchangeAmount: InputMaybe<Scalars['Float']['input']>;
  exchangeRate: InputMaybe<Scalars['Float']['input']>;
  goldValue: InputMaybe<Scalars['Float']['input']>;
  iban: InputMaybe<Scalars['String']['input']>;
  nameOfBank: InputMaybe<Scalars['String']['input']>;
  paymentOption: InputMaybe<Scalars['String']['input']>;
  personalId: InputMaybe<Scalars['String']['input']>;
  provider: InputMaybe<Scalars['String']['input']>;
  swiftCode: InputMaybe<Scalars['String']['input']>;
  taxId: InputMaybe<Scalars['String']['input']>;
  termsAndConditions: InputMaybe<Scalars['String']['input']>;
  transferToAccount: InputMaybe<Scalars['Float']['input']>;
  vendorAccountEmail: InputMaybe<Scalars['String']['input']>;
  vendorAccountId: InputMaybe<Scalars['String']['input']>;
  walletAddress: InputMaybe<Scalars['String']['input']>;
  walletAddressConfirmation: InputMaybe<Scalars['String']['input']>;
  walletResponsibilityConfirmation: InputMaybe<Scalars['String']['input']>;
  withdrawalFee: InputMaybe<Scalars['Float']['input']>;
  withdrawalNetAmount: InputMaybe<Scalars['Float']['input']>;
};

/** Withdrawal types that are allowed to be created via mutation */
export enum PermittedWithdrawalType {
  AdjustmentCorrection = 'adjustmentCorrection',
  BalanceDeduction = 'balanceDeduction',
  Bonus = 'bonus',
  CancellationOfProfits = 'cancellationOfProfits',
  CreditBonus = 'creditBonus',
  Fees = 'fees',
  ManagedAccountFee = 'managedAccountFee',
  PerformanceFee = 'performanceFee',
  ReturnedFunds = 'returnedFunds',
  Transfer = 'transfer',
  Transferb2b = 'transferb2b',
  TransferWithdrawalCommisions = 'transferWithdrawalCommisions',
  Withdrawal = 'withdrawal',
  WithdrawalCommisions = 'withdrawalCommisions'
}

export type CreateWithdrawalRequestInputType = {
  accountId: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  paymentFields: WithdrawalPaymentFieldsInputType;
  paymentVendor: WithdrawalPaymentVendorsType;
  platform: Scalars['String']['input'];
};

/** One of the possible trading statuses rejection reason codes */
export enum DeleteAccountReasonCode {
  ChargebackCase = 'chargebackCase',
  ClientRequest = 'clientRequest',
  ComplianceTerminated = 'complianceTerminated',
  DeclaredPep = 'declaredPep',
  DeclaredUsCitizen = 'declaredUsCitizen',
  DuplicateAccount = 'duplicateAccount',
  DuplicateProfile = 'duplicateProfile',
  Fraud = 'fraud',
  Inactive = 'inactive',
  MissingKycDoc = 'missingKycDoc',
  MissingProofAddress = 'missingProofAddress',
  MissingProofOfId = 'missingProofOfId',
  MissingProofOfPayment = 'missingProofOfPayment',
  NonComplOrReceipt = 'nonComplOrReceipt',
  NotAcceptableCountry = 'notAcceptableCountry',
  Other = 'other',
  ThirdPartyTransaction = 'thirdPartyTransaction',
  UnderagedClient = 'underagedClient',
  WrongCurrency = 'wrongCurrency'
}

/** VPS Service Response Type */
export type VpsServiceResponseType = {
  __typename?: 'vpsServiceResponseType';
  status: Maybe<Scalars['String']['output']>;
};

/** Swap Free response */
export type SwapFreeType = {
  __typename?: 'SwapFreeType';
  /** Client Object */
  client: Maybe<Client>;
  /** Accounts that did not change to Swap Free */
  failedAccountRemoteIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** One of the possible withdrawal status types */
export enum WithdrawalStatusesType {
  Accepted = 'accepted',
  NotProcessed = 'notProcessed',
  OnHold = 'onHold',
  PartiallyReversed = 'partiallyReversed',
  Pending = 'pending',
  Processing = 'processing',
  Rejected = 'rejected',
  Reversed = 'reversed'
}

export type NewSecurityCode = {
  __typename?: 'NewSecurityCode';
  /** New security code */
  newSecurityCode: Maybe<Scalars['String']['output']>;
};

export type GetSignedUrlType = {
  __typename?: 'getSignedUrlType';
  key: Maybe<Scalars['String']['output']>;
  plainUrl: Maybe<Scalars['String']['output']>;
  signedUrl: Maybe<Scalars['String']['output']>;
};

/** List of supported inactivity fees types */
export enum InactivityFeeType {
  Dormant = 'dormant',
  Maintenance = 'maintenance'
}

export enum ProcessAppropTestResult {
  Approve = 'approve',
  Reject = 'reject'
}

export enum ProcessDepositResult {
  Complete = 'complete',
  Fail = 'fail',
  Hold = 'hold',
  Incomplete = 'incomplete',
  Pending = 'pending'
}

export enum ProcessDocumentResult {
  Approve = 'approve',
  Reject = 'reject'
}

export enum ProcessProfileChangeResult {
  Approve = 'approve',
  Reject = 'reject',
  UnderReview = 'underReview'
}

/** One of the possible process withdrawal result types */
export enum ProcessWithdrawalResult {
  Approve = 'approve',
  OnHold = 'onHold',
  Pending = 'pending',
  Process = 'process',
  Reject = 'reject'
}

export type NewPassword = {
  __typename?: 'NewPassword';
  /** New password */
  password: Maybe<Scalars['String']['output']>;
};

/** List of resolve alert reason */
export enum ResolveAlertReasonType {
  AccountClosedRejected = 'accountClosedRejected',
  AutoEmail = 'autoEmail',
  CcIdRequested = 'ccIdRequested',
  NameMatches = 'nameMatches',
  Other = 'other',
  Refunded = 'refunded',
  Verified = 'verified'
}

/** Closed Orphaned Follower Type */
export type ClosedOrphanedFollowerType = {
  __typename?: 'closedOrphanedFollowerType';
  /** Closed action status */
  result: Maybe<Scalars['String']['output']>;
};

export type SearchToolOutputType = {
  __typename?: 'SearchToolOutputType';
  deposits: Maybe<Array<Maybe<SearchToolDepositType>>>;
  status: Maybe<Scalars['String']['output']>;
  withdrawals: Maybe<Array<Maybe<SearchToolWithdrawalType>>>;
};

export type SearchToolDepositType = {
  __typename?: 'SearchToolDepositType';
  company: Maybe<Company>;
  email: Maybe<Scalars['String']['output']>;
  memberId: Maybe<Scalars['Int']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  receiptNumber: Maybe<Scalars['Int']['output']>;
  vendor: Maybe<Scalars['DepositVendorOrString']['output']>;
};

export type SearchToolWithdrawalType = {
  __typename?: 'SearchToolWithdrawalType';
  company: Maybe<Company>;
  email: Maybe<Scalars['String']['output']>;
  memberId: Maybe<Scalars['Int']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  receiptNumber: Maybe<Scalars['Int']['output']>;
  vendor: Maybe<Scalars['DepositVendorOrString']['output']>;
};

export type PushNotificationMessageType = {
  /** Message body */
  body: InputMaybe<Scalars['String']['input']>;
  /** Message language */
  language: InputMaybe<Language>;
  /** Message title */
  title: InputMaybe<Scalars['String']['input']>;
};

export enum PhoneVerificationType {
  Sms = 'sms',
  TextToSpeech = 'textToSpeech'
}

/** One of the possible trading statuses rejection reason codes */
export enum TradingStatusRejectionReasonCode {
  ChargebackCase = 'chargebackCase',
  ClientRequest = 'clientRequest',
  DeclaredPep = 'declaredPep',
  DeclaredUsCitizen = 'declaredUsCitizen',
  DuplicateAccount = 'duplicateAccount',
  DuplicateProfile = 'duplicateProfile',
  Fraud = 'fraud',
  MissingKycDoc = 'missingKycDoc',
  MissingProofAddress = 'missingProofAddress',
  MissingProofOfId = 'missingProofOfId',
  MissingProofOfPayment = 'missingProofOfPayment',
  NonComplOrReceipt = 'nonComplOrReceipt',
  NotAcceptableCountry = 'notAcceptableCountry',
  Other = 'other',
  ThirdPartyTransaction = 'thirdPartyTransaction',
  UnderagedClient = 'underagedClient'
}

/** Client result type */
export type ClientResult = {
  __typename?: 'ClientResult';
  /** Client */
  client: Maybe<Client>;
  /** Status */
  status: Maybe<Scalars['Boolean']['output']>;
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  clientId: Maybe<Scalars['Int']['output']>;
  key: Maybe<Scalars['String']['output']>;
  plainUrl: Maybe<Scalars['String']['output']>;
  signedUrl: Maybe<Scalars['String']['output']>;
};

export type SendDepartmentTemplateEmailFileUrlType = {
  __typename?: 'SendDepartmentTemplateEmailFileUrlType';
  imageKey: Maybe<Scalars['String']['output']>;
  imagePlainUrl: Maybe<Scalars['String']['output']>;
  imageSignedUrl: Maybe<Scalars['String']['output']>;
};

export type SignedJobInputUrl = {
  __typename?: 'SignedJobInputUrl';
  key: Maybe<Scalars['String']['output']>;
  plainUrl: Maybe<Scalars['String']['output']>;
  signedUrl: Maybe<Scalars['String']['output']>;
};

export type PushNotificationsInputFileUrlType = {
  __typename?: 'PushNotificationsInputFileUrlType';
  csvKey: Maybe<Scalars['String']['output']>;
  csvPlainUrl: Maybe<Scalars['String']['output']>;
  csvSignedUrl: Maybe<Scalars['String']['output']>;
};

export type SearchToolInputFileUrlType = {
  __typename?: 'SearchToolInputFileUrlType';
  csvKey: Maybe<Scalars['String']['output']>;
  csvPlainUrl: Maybe<Scalars['String']['output']>;
  csvSignedUrl: Maybe<Scalars['String']['output']>;
};

export type TrackEventsInputFileUrlType = {
  __typename?: 'TrackEventsInputFileUrlType';
  csvKey: Maybe<Scalars['String']['output']>;
  csvPlainUrl: Maybe<Scalars['String']['output']>;
  csvSignedUrl: Maybe<Scalars['String']['output']>;
};

export enum PhoneType {
  Primary = 'primary',
  Secondary = 'secondary'
}

/** Additional Bonus response */
export type AdditionalBonusType = {
  __typename?: 'AdditionalBonusType';
  /** Additional Bonus */
  additionalBonus: Maybe<Scalars['Boolean']['output']>;
  /** Client id */
  clientId: Maybe<Scalars['Int']['output']>;
};

export type UpdateCountryAgentLanguageMappingInput = {
  country: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<Language>;
};

export type AccountChecksInput = {
  /** Client's categorization for internal purposes */
  clientCategory: InputMaybe<ClientCategory>;
  /** Client GBG */
  clientGBG: InputMaybe<ClientGbgType>;
  /** GBG Check Result */
  gbgCheckResult: InputMaybe<Scalars['String']['input']>;
  /** Client in in-house watchlists */
  inWatchlists: InputMaybe<YesNo>;
  /** Client in in-house watchlists date */
  inWatchlistsDate: InputMaybe<Scalars['DateTime']['input']>;
  /** Official Name */
  officialName: InputMaybe<Scalars['String']['input']>;
  /** 15 Days Policy Check */
  policy15Days: InputMaybe<YesNo>;
  /** Is client politically exposed person? */
  politicallyExposedPerson: InputMaybe<YesNo>;
  /** Client's risk categorization for internal purposes */
  riskCategory: InputMaybe<RiskCategory>;
  /** Client's risk sub categorization for internal purposes */
  riskSubCategory: InputMaybe<RiskSubCategory>;
  /** Is client in World-Check database? */
  worldCheck: InputMaybe<YesNo>;
};

export type GlobalQuestionnaireInput = {
  /** Estimated amount to deposit */
  approxExpectedDeposit: InputMaybe<Scalars['String']['input']>;
  /** Approximate Net Worth */
  approxNetWorth: InputMaybe<Scalars['String']['input']>;
  /** Approximate Yearly Income */
  approxYearlyIncome: InputMaybe<Scalars['String']['input']>;
  commercialRationaleForBusinessRelationship: InputMaybe<Scalars['String']['input']>;
  employmentStatus: InputMaybe<Scalars['String']['input']>;
  initialIntendedContribution: InputMaybe<Scalars['String']['input']>;
  /** Job Title/Position */
  jobTitle: InputMaybe<Scalars['String']['input']>;
  /** Nature of transactions */
  natureOfTransactions: InputMaybe<Scalars['String']['input']>;
  /** Nature of transactions Clarification */
  natureOfTransactionsClarify: InputMaybe<Scalars['String']['input']>;
  nomineeStatus: InputMaybe<YesNo>;
  /** Origin of funds */
  originOfFunds: InputMaybe<Scalars['String']['input']>;
  /** Politically Exposed Person */
  politicallyExposed: InputMaybe<YesNo>;
  /** Politically Exposed Person Reason */
  politicallyExposedReason: InputMaybe<Scalars['String']['input']>;
  relevantTradingEducationExperience: InputMaybe<Scalars['String']['input']>;
  riskAwarenessOfCfdTrading: InputMaybe<YesNo>;
  riskToleranceForCfd: InputMaybe<Scalars['String']['input']>;
  /** Source of Funds */
  sourceOfFunds: InputMaybe<Scalars['String']['input']>;
  /** Source of funds Clarification */
  sourceOfFundsClarify: InputMaybe<Scalars['String']['input']>;
  /** Country/Jurisdiction of Tax Residence */
  taxJurisdictionCountry: InputMaybe<Country>;
  /** Taxpayer Identification Number (TIN) */
  tin: InputMaybe<Scalars['String']['input']>;
  /** Tin Clarification */
  tinClarify: InputMaybe<Scalars['String']['input']>;
  /** If TIN is not available, please enter reason:  */
  tinReason: InputMaybe<Scalars['String']['input']>;
  /** Purpose of transactions */
  transactionPurpose: InputMaybe<Scalars['String']['input']>;
  /** Transaction purpose Clarification */
  transactionPurposeClarify: InputMaybe<Scalars['String']['input']>;
  /** US Citizen/Resident */
  usCitizen: InputMaybe<YesNo>;
};

export type EconomicProfileDocumentInput = {
  fileName: InputMaybe<Scalars['String']['input']>;
  key: InputMaybe<Scalars['String']['input']>;
};

export type PersonalIdInputType = {
  documentNumber: InputMaybe<Scalars['String']['input']>;
  documentType: PersonalIdDocumentType;
};

export type ClientPropertiesInput = {
  /** Merchant's destination crypto wallet */
  destinationWallet: InputMaybe<Scalars['String']['input']>;
  /** Unique ID */
  id: InputMaybe<Scalars['Int']['input']>;
  /** Merchant's unique IPN */
  ipn: InputMaybe<Scalars['String']['input']>;
};

export type SecondaryEmailInput = {
  /** Secondary Emails: Secondary Email 1 */
  secondaryEmail1: InputMaybe<Scalars['String']['input']>;
  /** Secondary Emails: Secondary Email 2 */
  secondaryEmail2: InputMaybe<Scalars['String']['input']>;
  /** Secondary Emails: Secondary Email 3 */
  secondaryEmail3: InputMaybe<Scalars['String']['input']>;
};

export type SecondaryPhoneInput = {
  /** Secondary Phones: Secondary Phone 1 */
  secondaryPhone1: InputMaybe<Scalars['String']['input']>;
};

/** Password validation result */
export type PasswordValidationResult = {
  __typename?: 'PasswordValidationResult';
  /** Password validation configurations for the whitelabel. */
  config: PasswordValidationConfig;
  /** Password validation errors, if any. */
  errors: Maybe<PasswordValidationErrors>;
  /** Is password valid? */
  isValid: Scalars['Boolean']['output'];
};

/** Password validation configuration */
export type PasswordValidationConfig = {
  __typename?: 'PasswordValidationConfig';
  /** If at least 1 lowercase letter is required. */
  lowercase: Maybe<Scalars['Boolean']['output']>;
  /** Maximum password length. */
  maxLength: Maybe<Scalars['Int']['output']>;
  /** Minimum password length. */
  minLength: Maybe<Scalars['Int']['output']>;
  /** If at least 1 number is required. */
  numbers: Maybe<Scalars['Boolean']['output']>;
  /** If at least 1 special character is required. */
  symbols: Maybe<Scalars['Boolean']['output']>;
  /** If at least 1 uppercase letter is required. */
  uppercase: Maybe<Scalars['Boolean']['output']>;
};

/** Password validation errors */
export type PasswordValidationErrors = {
  __typename?: 'PasswordValidationErrors';
  /** Is password contains at least one lowercase letter? */
  lowercase: Maybe<Scalars['Boolean']['output']>;
  /** Is password maximum length requirements met? */
  maxLength: Maybe<Scalars['Boolean']['output']>;
  /** Is password minimum length requirements met? */
  minLength: Maybe<Scalars['Boolean']['output']>;
  /** Is password contains at least one number? */
  numbers: Maybe<Scalars['Boolean']['output']>;
  /** Is password and confirmation match? */
  passwordsMatch: Maybe<Scalars['Boolean']['output']>;
  /** Is password contains at least one special character? */
  symbols: Maybe<Scalars['Boolean']['output']>;
  /** Is password contains at least one uppercase letter? */
  uppercase: Maybe<Scalars['Boolean']['output']>;
};

/** Attendance results */
export type Attendance = {
  __typename?: 'Attendance';
  logs: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unsuccessful: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated: Maybe<Scalars['Int']['output']>;
};

export type UploadStrategicPartnersReturnType = {
  __typename?: 'uploadStrategicPartnersReturnType';
  /** List of errors */
  errors: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rowsFailed: Maybe<Scalars['Int']['output']>;
  rowsInserted: Maybe<Scalars['Int']['output']>;
};

export type FtdBonusMinimumDepositInput = {
  /** Amount of minimum deposit */
  amount: Scalars['Float']['input'];
  /** Currency of minimum deposit */
  currency: InputMaybe<Currency>;
};

export type FtdBonusMinimumDepositRawInput = {
  /** Amount of minimum deposit */
  amount: Scalars['Float']['input'];
  /** Currency of minimum deposit */
  currency: InputMaybe<Currency>;
};

export type FtdBonusMinimumDepositVipInput = {
  /** Amount of minimum deposit */
  amount: Scalars['Float']['input'];
  /** Currency of minimum deposit */
  currency: InputMaybe<Currency>;
};

export type MinimumDepositInput = {
  /** Amount of minimum deposit */
  amount: Scalars['Float']['input'];
  /** Currency of minimum deposit */
  currency: InputMaybe<Currency>;
};

export type MinimumDepositAccountTypeInput = {
  /** Account Type of minimum deposit */
  accountType: Scalars['String']['input'];
  /** Amount of minimum deposit */
  amount: Scalars['Float']['input'];
};

export type PixelInput = {
  baseUrl: InputMaybe<Scalars['String']['input']>;
  eventName: InputMaybe<EventName>;
  id: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  params: InputMaybe<Array<InputMaybe<TrackingParameterInput>>>;
  productName: InputMaybe<ProductNameType>;
  subcampaignKeyName: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<PixelType>;
  userIdKeyName: InputMaybe<Scalars['String']['input']>;
};

export type TrackingParameterInput = {
  /** Name of the tracking param. Eg. account_id */
  key: Scalars['String']['input'];
  /** Type of the tracking param. */
  type: TrackingParameterType;
  /** Value of the tracking param. Eg.123 */
  value: InputMaybe<Scalars['String']['input']>;
};

export type RedepositBonusMinimumDepositInput = {
  /** Amount of minimum deposit */
  amount: Scalars['Float']['input'];
  /** Currency of minimum deposit */
  currency: InputMaybe<Currency>;
};

export type RedepositBonusMinimumDepositRawInput = {
  /** Amount of minimum deposit */
  amount: Scalars['Float']['input'];
  /** Currency of minimum deposit */
  currency: InputMaybe<Currency>;
};

export type RedepositBonusMinimumDepositVipInput = {
  /** Amount of minimum deposit */
  amount: Scalars['Float']['input'];
  /** Currency of minimum deposit */
  currency: InputMaybe<Currency>;
};

export type BankTransferDetailsInputType = {
  /** Address */
  address: InputMaybe<Scalars['String']['input']>;
  /** Bank */
  bank: InputMaybe<Scalars['String']['input']>;
  /** City */
  city: InputMaybe<Scalars['String']['input']>;
  /** Client Account Currency */
  clientAccountCurrency: InputMaybe<Scalars['String']['input']>;
  /** Correspondent Bank */
  correspondentBank: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country: InputMaybe<Scalars['String']['input']>;
  /** Crediting Account */
  creditingAccount: InputMaybe<Scalars['String']['input']>;
  /** Currency */
  currency: InputMaybe<Scalars['String']['input']>;
  /** IBAN */
  iban: InputMaybe<Scalars['String']['input']>;
  /** Recipient */
  recipient: InputMaybe<Scalars['String']['input']>;
  reference: InputMaybe<Scalars['String']['input']>;
  /** Swift */
  swift: InputMaybe<Scalars['String']['input']>;
  /** Swift BIC */
  swiftBic: InputMaybe<Scalars['String']['input']>;
};

/** Webinar event */
export type Webinar = {
  __typename?: 'Webinar';
  /** Webinar join url */
  joinUrl: Maybe<Scalars['String']['output']>;
  /** Webinar client registration status */
  status: Maybe<Scalars['String']['output']>;
};

/** Withdrawal requests for this user */
export type WithdrawalAutoProcessType = {
  __typename?: 'WithdrawalAutoProcessType';
  /** Service response */
  response: Maybe<Scalars['String']['output']>;
};
